import { NgModule, EventEmitter, Component, Input, Output, ViewEncapsulation, ChangeDetectionStrategy, ElementRef, Renderer2, HostBinding, forwardRef, ChangeDetectorRef, ViewChild, HostListener, ContentChildren, Directive, InjectionToken, ViewContainerRef, Injector, Injectable, ComponentFactoryResolver, ApplicationRef, RendererFactory2, Inject, Pipe, Optional, Self, PLATFORM_ID, TemplateRef, NgZone, SkipSelf } from '@angular/core';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { Validators, FormBuilder, ReactiveFormsModule, FormGroupDirective, NG_VALUE_ACCESSOR, FormsModule, ControlContainer, NgControl, FormControl } from '@angular/forms';
import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { BehaviorSubject, Subject, combineLatest, merge, fromEvent, defer } from 'rxjs';
import { v4 } from 'uuid';
import { startWith, tap, takeUntil, filter, switchMap, share, debounceTime, switchMapTo, take, distinctUntilChanged } from 'rxjs/operators';
import { TemplatePortal, PortalInjector, ComponentPortal, PortalModule, BasePortalOutlet, CdkPortalOutlet } from '@angular/cdk/portal';
import isEmpty from 'lodash.isempty';
import isEqual from 'lodash.isequal';
import { DomSanitizer } from '@angular/platform-browser';
import { startWith as startWith$1 } from 'rxjs/internal/operators';
import { FlexDirective, LayoutDirective, LayoutGapDirective, LayoutAlignDirective, FlexAlignDirective, FlexOrderDirective, ShowHideDirective, FlexOffsetDirective } from '@angular/flex-layout';
import { RouterModule, ActivatedRoute, Router } from '@angular/router';
import isString from 'lodash.isstring';
import template from 'lodash.template';
import { MatIconModule } from '@angular/material/icon';
import { CdkCell, CdkColumnDef, CdkCellDef, CdkHeaderCell, CdkHeaderCellDef, CdkHeaderRowDef, CdkRowDef, CdkHeaderRow, CDK_ROW_TEMPLATE, CdkRow, CdkTable, CDK_TABLE_TEMPLATE, CdkTableModule } from '@angular/cdk/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ConnectionPositionPair, CdkConnectedOverlay, OverlayModule, Overlay, OverlayPositionBuilder, ScrollDispatcher, OverlayConfig } from '@angular/cdk/overlay';
import { Platform, normalizePassiveListenerOptions } from '@angular/cdk/platform';
import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';
import { FocusMonitor, FocusTrapFactory } from '@angular/cdk/a11y';
import { hasModifierKey } from '@angular/cdk/keycodes';
import { ScrollingModule } from '@angular/cdk/scrolling';
import isArray from 'lodash.isarray';
import get from 'lodash.get';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@metromarkets/sdk';
import * as ɵngcc4 from '@uiowa/digit-only';
import * as ɵngcc5 from '@angular/cdk/portal';
import * as ɵngcc6 from '@angular/platform-browser';
import * as ɵngcc7 from '@angular/router';
import * as ɵngcc8 from '@angular/material/icon';
import * as ɵngcc9 from '@angular/material/progress-spinner';
import * as ɵngcc10 from '@angular/cdk/table';
import * as ɵngcc11 from 'angular-svg-icon';
import * as ɵngcc12 from '@angular/cdk/overlay';
import * as ɵngcc13 from '@angular/cdk/platform';
import * as ɵngcc14 from '@angular/cdk/a11y';
import * as ɵngcc15 from '@angular/cdk/scrolling';

function MmQuantityPickerComponent_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.labels.inStock, " ");
} }
function MmQuantityPickerComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, MmQuantityPickerComponent_div_1_span_3_Template, 2, 1, "span", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.labels.quantity, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.availableAmount > 0);
} }
const _c0 = ["mm-button", ""];
function MmButtonComponent__svg_svg_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 4);
    ɵngcc0.ɵɵelement(1, "circle", 5);
    ɵngcc0.ɵɵelementEnd();
} }
const _c1 = [[["mat-icon"], ["mm-icon"], ["", 8, "mm-icon"]], "*"];
const _c2 = function (a0) { return { "mm-button__icon-hidden": a0 }; };
const _c3 = function (a0) { return { "mm-button__content-hidden": a0 }; };
const _c4 = ["mat-icon, mm-icon, .mm-icon", "*"];
const _c5 = ["*"];
function MmRadioComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 6);
} }
const _c6 = ["radioElement"];
const _c7 = [[["label"]], "*", [["mm-error"]]];
const _c8 = ["label", "*", "mm-error"];
const _c9 = ["toggleElement"];
function MmAlertComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 10);
    ɵngcc0.ɵɵelement(2, "path", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function MmAlertComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 10);
    ɵngcc0.ɵɵelement(2, "path", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function MmAlertComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 10);
    ɵngcc0.ɵɵelement(2, "path", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function MmAlertComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 10);
    ɵngcc0.ɵɵelement(2, "path", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function MmAlertComponent_ng_container_10_ng_template_2_Template(rf, ctx) { }
function MmAlertComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 15);
    ɵngcc0.ɵɵtemplate(2, MmAlertComponent_ng_container_10_ng_template_2_Template, 0, 0, "ng-template", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("cdkPortalOutlet", ctx_r4.portalComponent);
} }
function MmAlertComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵlistener("click", function MmAlertComponent_div_11_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onClose(); });
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 18);
    ɵngcc0.ɵɵelement(2, "path", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("mmTestTarget", "alert-close");
} }
function MmAlertComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 20);
    ɵngcc0.ɵɵpipe(1, "sanitize");
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("mmTestTarget", "alert-message")("innerHtml", ɵngcc0.ɵɵpipeBind1(1, 2, ctx_r7.alertConfig.message), ɵngcc0.ɵɵsanitizeHtml);
} }
const _c10 = ["alertWrapper"];
const _c11 = ["mmLabel"];
const _c12 = [[["mm-label"]], "*", [["mm-hint"]], [["mm-error"]]];
const _c13 = ["mm-label", "*", "mm-hint", "mm-error"];
function MmChipComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 4);
    ɵngcc0.ɵɵlistener("click", function MmChipComponent_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); const _r0 = ɵngcc0.ɵɵreference(2); return ctx_r2.remove(_r0.innerText); });
    ɵngcc0.ɵɵelement(1, "img", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("mmTestTarget", "chip-remove-button");
} }
const _c14 = function (a0) { return { "mm-chip--removable": a0 }; };
function MmPaginatorComponent_div_0_div_1_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 7);
    ɵngcc0.ɵɵlistener("click", function MmPaginatorComponent_div_0_div_1_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(3); return ctx_r6.onLoadMore(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("mmTestTarget", "paginator-load-more-button");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.loadMoreLabel, " ");
} }
function MmPaginatorComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵtemplate(1, MmPaginatorComponent_div_0_div_1_button_1_Template, 2, 2, "button", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("mmTestTarget", "paginator-load-more");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.isLoadMoreVisible);
} }
const _c15 = function (a0, a1) { return { offset: a0, limit: a1 }; };
function MmPaginatorComponent_div_0_ng_container_2_a_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 11);
    ɵngcc0.ɵɵelement(1, "span", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("queryParams", ɵngcc0.ɵɵpureFunction2(2, _c15, ctx_r8.defaultLimit * (ctx_r8.currentPage - 2), ctx_r8.defaultLimit))("mmTestTarget", "paginator-facet-left");
} }
const _c16 = function (a0) { return { "mm-paginator__page--active": a0 }; };
function MmPaginatorComponent_div_0_ng_container_2_ng_container_3_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 15);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const page_r11 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r14 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("queryParams", ɵngcc0.ɵɵpureFunction2(4, _c15, ctx_r14.defaultLimit * (page_r11 - 1), ctx_r14.defaultLimit))("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c16, page_r11 === ctx_r14.currentPage))("mmTestTarget", "paginator-page");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", page_r11, " ");
} }
const _c17 = function (a0, a1) { return { "mm-paginator__page--active": a0, "mm-paginator__ellipses": a1 }; };
function MmPaginatorComponent_div_0_ng_container_2_ng_container_3_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 16);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const page_r11 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r16 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(2, _c17, page_r11 === ctx_r16.currentPage, !page_r11));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", page_r11 || "...", " ");
} }
function MmPaginatorComponent_div_0_ng_container_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MmPaginatorComponent_div_0_ng_container_2_ng_container_3_a_1_Template, 2, 9, "a", 13);
    ɵngcc0.ɵɵtemplate(2, MmPaginatorComponent_div_0_ng_container_2_ng_container_3_ng_template_2_Template, 2, 5, "ng-template", null, 14, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const page_r11 = ctx.$implicit;
    const _r15 = ɵngcc0.ɵɵreference(3);
    const ctx_r9 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", page_r11 && page_r11 !== ctx_r9.currentPage)("ngIfElse", _r15);
} }
function MmPaginatorComponent_div_0_ng_container_2_a_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 11);
    ɵngcc0.ɵɵelement(1, "span", 17);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("queryParams", ɵngcc0.ɵɵpureFunction2(2, _c15, ctx_r10.defaultLimit * ctx_r10.currentPage, ctx_r10.defaultLimit))("mmTestTarget", "paginator-facet-right");
} }
function MmPaginatorComponent_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵtemplate(2, MmPaginatorComponent_div_0_ng_container_2_a_2_Template, 2, 5, "a", 9);
    ɵngcc0.ɵɵtemplate(3, MmPaginatorComponent_div_0_ng_container_2_ng_container_3_Template, 4, 2, "ng-container", 10);
    ɵngcc0.ɵɵtemplate(4, MmPaginatorComponent_div_0_ng_container_2_a_4_Template, 2, 5, "a", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("mmTestTarget", "paginator-pages");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.currentPage !== ctx_r2.pages[0] && !ctx_r2.useOnlyPaginatorLinks);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.pages);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.currentPage !== ctx_r2.pages[ctx_r2.pages.length - 1] && !ctx_r2.useOnlyPaginatorLinks);
} }
function MmPaginatorComponent_div_0_ng_template_3_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function MmPaginatorComponent_div_0_ng_template_3_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r22 = ɵngcc0.ɵɵnextContext(3); return ctx_r22.onPreviousPage(); });
    ɵngcc0.ɵɵelement(1, "span", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("mmTestTarget", "paginator-facet-left");
} }
function MmPaginatorComponent_div_0_ng_template_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 21);
    ɵngcc0.ɵɵlistener("click", function MmPaginatorComponent_div_0_ng_template_3_ng_container_2_Template_span_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r28); const page_r24 = ctx.$implicit; const ctx_r27 = ɵngcc0.ɵɵnextContext(3); return ctx_r27.onSelectPage(page_r24); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const page_r24 = ctx.$implicit;
    const ctx_r20 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(3, _c17, page_r24 === ctx_r20.currentPage, !page_r24))("mmTestTarget", "paginator-page");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", page_r24 ? page_r24 : "...", " ");
} }
function MmPaginatorComponent_div_0_ng_template_3_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function MmPaginatorComponent_div_0_ng_template_3_button_3_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r29 = ɵngcc0.ɵɵnextContext(3); return ctx_r29.onNextPage(); });
    ɵngcc0.ɵɵelement(1, "span", 17);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("mmTestTarget", "paginator-facet-right");
} }
const _c18 = function (a0) { return { "links-only": a0 }; };
function MmPaginatorComponent_div_0_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵtemplate(1, MmPaginatorComponent_div_0_ng_template_3_button_1_Template, 2, 1, "button", 19);
    ɵngcc0.ɵɵtemplate(2, MmPaginatorComponent_div_0_ng_template_3_ng_container_2_Template, 3, 6, "ng-container", 10);
    ɵngcc0.ɵɵtemplate(3, MmPaginatorComponent_div_0_ng_template_3_button_3_Template, 2, 1, "button", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("mmTestTarget", "paginator-pages")("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c18, ctx_r4.useOnlyPaginatorLinks));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.useOnlyPaginatorLinks);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.pages);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.useOnlyPaginatorLinks);
} }
function MmPaginatorComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, MmPaginatorComponent_div_0_div_1_Template, 2, 2, "div", 2);
    ɵngcc0.ɵɵtemplate(2, MmPaginatorComponent_div_0_ng_container_2_Template, 5, 4, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(3, MmPaginatorComponent_div_0_ng_template_3_Template, 4, 7, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r3 = ɵngcc0.ɵɵreference(4);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c18, ctx_r0.useOnlyPaginatorLinks))("mmTestTarget", "paginator");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.enableLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isBot)("ngIfElse", _r3);
} }
const _c19 = function (a0) { return { "mm-accordion__item--active": a0 }; };
const _c20 = ["mm-sort-header", ""];
const _c21 = [[["caption"]], [["colgroup"], ["col"]]];
const _c22 = ["caption", "colgroup, col"];
function MmTablePaginationComponent_div_1_div_3_option_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 16);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const pageSizeOption_r8 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("mmTestTarget", "table-pagination-option")("value", pageSizeOption_r8);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", pageSizeOption_r8, " ");
} }
function MmTablePaginationComponent_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "select", 14);
    ɵngcc0.ɵɵlistener("ngModelChange", function MmTablePaginationComponent_div_1_div_3_Template_select_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.pageSizeSelectedOption = $event; })("change", function MmTablePaginationComponent_div_1_div_3_Template_select_change_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.changePageSize($event == null ? null : $event.target == null ? null : $event.target.value); });
    ɵngcc0.ɵɵtemplate(2, MmTablePaginationComponent_div_1_div_3_option_2_Template, 2, 3, "option", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("mmTestTarget", "table-pagination-select")("ngModel", ctx_r5.pageSizeSelectedOption)("disabled", ctx_r5.disabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.displayedPageSizeOptions);
} }
function MmTablePaginationComponent_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("mmTestTarget", "table-pagination-selected-option");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.pageSizeSelectedOption);
} }
function MmTablePaginationComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, MmTablePaginationComponent_div_1_div_3_Template, 3, 4, "div", 10);
    ɵngcc0.ɵɵtemplate(4, MmTablePaginationComponent_div_1_div_4_Template, 2, 2, "div", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("mmTestTarget", "table-pagination-items-label");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.itemsPerPageLabel, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.displayedPageSizeOptions.length > 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.displayedPageSizeOptions.length <= 1);
} }
function MmTablePaginationComponent_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 6);
    ɵngcc0.ɵɵlistener("click", function MmTablePaginationComponent_button_6_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.firstPage(); });
    ɵngcc0.ɵɵelement(1, "mm-icon", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("mmTestTarget", "table-pagination-first-page")("disabled", ctx_r1.previousButtonsDisabled);
} }
function MmTablePaginationComponent_mm_paginator_9_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mm-paginator", 19);
    ɵngcc0.ɵɵlistener("paginationChange", function MmTablePaginationComponent_mm_paginator_9_Template_mm_paginator_paginationChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.pageSelect($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("queryParams", ctx_r2.queryParams)("enableLabel", false)("defaultLimit", ctx_r2.pageSizeSelectedOption)("totalCount", ctx_r2.pageSizeTotal)("showLastPage", true)("useOnlyPaginatorLinks", true);
} }
function MmTablePaginationComponent_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 6);
    ɵngcc0.ɵɵlistener("click", function MmTablePaginationComponent_button_12_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.lastPage(); });
    ɵngcc0.ɵɵelement(1, "mm-icon", 20);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("mmTestTarget", "table-pagination-last-page")("disabled", ctx_r3.nextButtonsDisabled);
} }
function MmTablePaginationComponent_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "form", 21);
    ɵngcc0.ɵɵlistener("ngSubmit", function MmTablePaginationComponent_ng_container_13_Template_form_ngSubmit_1_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.onGotoPageSubmit(); });
    ɵngcc0.ɵɵelementStart(2, "mm-field", 22);
    ɵngcc0.ɵɵelement(3, "input", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "button", 24);
    ɵngcc0.ɵɵtext(5, " Go ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r4.gotoPageForm);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r4.gotoPageForm.invalid);
} }
const _c23 = ["overlay"];
function MmMenuComponent_ng_template_0_Template(rf, ctx) { }
function MmContextualMenuComponent_ng_template_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.mmContent, " ");
} }
function MmContextualMenuComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵlistener("click", function MmContextualMenuComponent_ng_template_0_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.closeContextualMenu(); });
    ɵngcc0.ɵɵelement(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵtemplate(3, MmContextualMenuComponent_ng_template_0_ng_container_3_Template, 2, 1, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("mmTestTarget", "contextual-menu")("ngClass", ctx_r1.classMap)("ngStyle", ctx_r1.mmOverlayStyle);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("mmTestTarget", "contextual-menu-content");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("mmTemplateOutlet", ctx_r1.mmContent);
} }
function MmHeaderMenuComponent_ng_template_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.mmContent, " ");
} }
function MmHeaderMenuComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵlistener("click", function MmHeaderMenuComponent_ng_template_0_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.closeHeaderMenu(); });
    ɵngcc0.ɵɵelement(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵtemplate(3, MmHeaderMenuComponent_ng_template_0_ng_container_3_Template, 2, 1, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("mmTestTarget", "header-menu")("ngClass", ctx_r1.classMap)("ngStyle", ctx_r1.mmOverlayStyle);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("mmTestTarget", "header-menu-content");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("mmTemplateOutlet", ctx_r1.mmContent);
} }
const _c24 = ["blankTemplate"];
function MmTooltipComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.message, " ");
} }
function MmTooltipComponent_ng_template_2_Template(rf, ctx) { }
function MmDialogContainerComponent_ng_template_0_Template(rf, ctx) { }
function MmDialogTitleComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "button", 4);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(2, "svg", 5);
    ɵngcc0.ɵɵelement(3, "path", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("mmTestTarget", "dialog-button-close");
} }
function PopoverComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 4);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r0.content, ɵngcc0.ɵɵsanitizeHtml);
} }
function PopoverComponent_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function PopoverComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, PopoverComponent_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.content)("ngTemplateOutletContext", ctx_r1.context);
} }
function PopoverComponent_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function PopoverComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, PopoverComponent_ng_container_4_ng_container_1_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngComponentOutlet", ctx_r2.content);
} }
const _c25 = function (a0) { return { "popover__text-content": a0 }; };
const _c26 = ["inputElement"];
function MmSelectComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "span", 9);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "viewValue");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "button", 10);
    ɵngcc0.ɵɵlistener("click", function MmSelectComponent_div_2_Template_button_click_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const tag_r3 = ctx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onTagRemove($event, tag_r3); });
    ɵngcc0.ɵɵelement(5, "mm-icon", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tag_r3 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("mmTestTarget", "select-tag");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(3, 4, tag_r3, ctx_r0.displayedProperty));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("mmTestTarget", "remove-tag-button");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("name", "cross");
} }
function MmSelectComponent_div_7_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r6.noResultsText, " ");
} }
function MmSelectComponent_div_7_div_4_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
    ɵngcc0.ɵɵpipe(1, "viewValue");
} if (rf & 2) {
    const option_r8 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(1, 1, option_r8, ctx_r10.displayedProperty));
} }
function MmSelectComponent_div_7_div_4_2_ng_template_0_Template(rf, ctx) { }
function MmSelectComponent_div_7_div_4_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MmSelectComponent_div_7_div_4_2_ng_template_0_Template, 0, 0, "ng-template");
} }
const _c27 = function (a0) { return { "mm-option--selected": a0 }; };
const _c28 = function (a0) { return { $implicit: a0 }; };
function MmSelectComponent_div_7_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵlistener("click", function MmSelectComponent_div_7_div_4_Template_div_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const option_r8 = ctx.$implicit; const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.onSelect($event, option_r8); });
    ɵngcc0.ɵɵtemplate(1, MmSelectComponent_div_7_div_4_ng_template_1_Template, 2, 4, "ng-template", 19);
    ɵngcc0.ɵɵtemplate(2, MmSelectComponent_div_7_div_4_2_Template, 1, 0, undefined, 20);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r8 = ctx.$implicit;
    const i_r9 = ctx.index;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("mmTestTarget", "select-option")("id", "mm-option-" + (option_r8.id || i_r9))("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c27, ctx_r7.isOptionSelected(option_r8)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r7.optionTmpl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r7.optionTmpl)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(8, _c28, option_r8));
} }
function MmSelectComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵelementStart(1, "div", 13);
    ɵngcc0.ɵɵtemplate(2, MmSelectComponent_div_7_div_2_Template, 2, 1, "div", 14);
    ɵngcc0.ɵɵelementStart(3, "cdk-virtual-scroll-viewport", 15);
    ɵngcc0.ɵɵtemplate(4, MmSelectComponent_div_7_div_4_Template, 3, 10, "div", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r2.options == null ? null : ctx_r2.options.length));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("height", ctx_r2.visibleOptions * 47, "px");
    ɵngcc0.ɵɵproperty("itemSize", 30);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cdkVirtualForOf", ctx_r2.options);
} }
const _c29 = function (a0, a1) { return { className: a0, disabled: a1 }; };
const _c30 = function (a0) { return { "mm-select-control__input--small": a0 }; };
const _c31 = function (a0) { return { "mm-select-control__icon--chevron-up": a0 }; };
class SharedModule {
}
SharedModule.ɵfac = function SharedModule_Factory(t) { return new (t || SharedModule)(); };
SharedModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SharedModule });
SharedModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SharedModule, [{
        type: NgModule,
        args: [{
                imports: [],
                exports: []
            }]
    }], null, null); })();

const INTERACTION_BUTTON = 'button';
const INTERACTION_INPUT = 'input';

class MmQuantityPickerComponent {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.showLabels = false;
        this.labels = {
            quantity: 'Quantity',
            inStock: 'In stock'
        };
        this.isDisabled = false;
        this.amount = 1;
        this.minAmount = 1;
        this.stepping = 1;
        this.quantityChanged = new EventEmitter();
        this.quantityChangeInteraction = new EventEmitter();
        this.quantityPrettified = new EventEmitter();
        this.disabledDecreaseTriggered = new EventEmitter();
        this.disabledIncreaseTriggered = new EventEmitter();
        this.fieldName = 'quantity';
        this.quantityPickerFrom = this.formBuilder.group({
            quantity: [this.amount, [Validators.required]]
        });
    }
    get quantity() {
        const fieldValue = +this.quantityPickerFrom.get(this.fieldName).value;
        return fieldValue >= this.minAmount
            ? fieldValue
            : this.minAmount;
    }
    set quantity(value) {
        this.quantityPickerFrom.get(this.fieldName).setValue(value);
    }
    get isDecreasePossible() {
        return (this.quantity - this.stepping) >= this.minAmount;
    }
    get isIncreasePossible() {
        return (this.quantity + this.stepping) <= this.availableAmount;
    }
    get isIncreaseEnabled() {
        return this.isIncreasePossible && !this.isDisabled;
    }
    ngOnChanges(changes) {
        if (changes['amount'] && changes['amount'].currentValue) {
            this.quantity = changes['amount'].currentValue;
            this.quantityChanged.emit(this.quantity);
        }
        if (changes['availableAmount'] && changes['availableAmount'].currentValue) {
            this.onMaxAmountChanged();
        }
        if (changes['isDisabled'] && changes['isDisabled'].currentValue) {
            this.quantityPickerFrom.get(this.fieldName).disable();
        }
        else {
            this.quantityPickerFrom.get(this.fieldName).enable();
        }
    }
    changeQuantity(value) {
        const currentValue = this.quantity;
        const changedValue = currentValue + (value * this.stepping);
        if ((changedValue <= this.availableAmount) && (changedValue >= this.minAmount)) {
            this.quantity = changedValue;
        }
        else if (!this.availableAmount && (changedValue >= this.minAmount)) {
            this.quantity = changedValue;
        }
        this.quantityChanged.emit(this.quantity);
        this.quantityChangeInteraction.emit(INTERACTION_BUTTON);
    }
    onBlur() {
        const currentValue = this.quantity;
        const nearestValue = Math.round(currentValue / this.stepping) * this.stepping;
        this.quantity = nearestValue < this.minAmount
            ? this.minAmount
            : nearestValue;
        this.quantityChanged.emit(this.quantity);
    }
    onChanges() {
        const inputValue = this.quantityPickerFrom.get(this.fieldName).value;
        if ((this.quantity < this.minAmount) && inputValue) {
            this.quantity = this.minAmount;
        }
        else if (this.availableAmount && (this.quantity > this.availableAmount)) {
            this.quantity = this.availableAmount;
            this.quantityPrettified.emit();
        }
        if (inputValue) {
            this.quantityChanged.emit(this.quantity);
            this.quantityChangeInteraction.emit(INTERACTION_INPUT);
        }
    }
    onMaxAmountChanged() {
        if (this.quantity > this.availableAmount) {
            this.quantity = this.availableAmount;
        }
    }
    onSubmit() {
        if (this.quantityPickerFrom.valid) {
            this.quantityChanged.emit(this.quantity);
        }
    }
    onDisabledDecrease() {
        this.disabledDecreaseTriggered.emit();
    }
    onDisabledIncrease() {
        this.disabledIncreaseTriggered.emit();
    }
}
MmQuantityPickerComponent.ɵfac = function MmQuantityPickerComponent_Factory(t) { return new (t || MmQuantityPickerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.FormBuilder)); };
MmQuantityPickerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmQuantityPickerComponent, selectors: [["mm-quantity-picker"]], inputs: { showLabels: "showLabels", labels: "labels", isDisabled: "isDisabled", amount: "amount", minAmount: "minAmount", stepping: "stepping", availableAmount: "availableAmount" }, outputs: { quantityChanged: "quantityChanged", quantityChangeInteraction: "quantityChangeInteraction", quantityPrettified: "quantityPrettified", disabledDecreaseTriggered: "disabledDecreaseTriggered", disabledIncreaseTriggered: "disabledIncreaseTriggered" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 10, vars: 7, consts: [["novalidate", "", 1, "form", 3, "formGroup", "submit"], ["class", "info", 4, "ngIf"], [1, "picker"], ["color", "ghost", "type", "button", "mm-button", "", 1, "picker__controls", "picker__controls--decrease", 3, "disabled", "mmTestTarget", "click"], [1, "picker__trigger", 3, "click"], ["digitOnly", "", "type", "text", "formControlName", "quantity", 1, "picker__field", 3, "mmTestTarget", "blur", "input"], ["color", "ghost", "type", "button", "mm-button", "", 1, "picker__controls", "picker__controls--increase", 3, "disabled", "mmTestTarget", "click"], [1, "info"], ["class", "info__stock", 4, "ngIf"], [1, "info__stock"]], template: function MmQuantityPickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵlistener("submit", function MmQuantityPickerComponent_Template_form_submit_0_listener() { return ctx.onSubmit(); });
        ɵngcc0.ɵɵtemplate(1, MmQuantityPickerComponent_div_1_Template, 4, 2, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "button", 3);
        ɵngcc0.ɵɵlistener("click", function MmQuantityPickerComponent_Template_button_click_3_listener() { return ctx.changeQuantity(-1); });
        ɵngcc0.ɵɵtext(4, " - ");
        ɵngcc0.ɵɵelementStart(5, "span", 4);
        ɵngcc0.ɵɵlistener("click", function MmQuantityPickerComponent_Template_span_click_5_listener() { return !ctx.isDecreasePossible && ctx.onDisabledDecrease(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "input", 5);
        ɵngcc0.ɵɵlistener("blur", function MmQuantityPickerComponent_Template_input_blur_6_listener() { return ctx.onBlur(); })("input", function MmQuantityPickerComponent_Template_input_input_6_listener() { return ctx.onChanges(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "button", 6);
        ɵngcc0.ɵɵlistener("click", function MmQuantityPickerComponent_Template_button_click_7_listener() { return ctx.changeQuantity(1); });
        ɵngcc0.ɵɵtext(8, " + ");
        ɵngcc0.ɵɵelementStart(9, "span", 4);
        ɵngcc0.ɵɵlistener("click", function MmQuantityPickerComponent_Template_span_click_9_listener() { return !ctx.isIncreasePossible && ctx.onDisabledIncrease(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.quantityPickerFrom);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showLabels);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", !ctx.isDecreasePossible)("mmTestTarget", "picker-decrease-button");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("mmTestTarget", "picker-input");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", !ctx.isIncreaseEnabled)("mmTestTarget", "picker-increase-button");
    } }, directives: function () { return [ɵngcc1.ɵangular_packages_forms_forms_ba, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc2.NgIf, MmButtonComponent, ɵngcc3.ɵf, ɵngcc1.DefaultValueAccessor, ɵngcc4.DigitOnlyDirective, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName]; }, styles: [".mat-badge-content[_ngcontent-%COMP%]{font-family:Lato,sans-serif;font-size:12px;font-weight:600}.mat-badge-small[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{font-size:9px}.mat-badge-large[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{font-size:24px}.mat-h1[_ngcontent-%COMP%], .mat-headline[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font:900 64px/1.33 Lato,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h2[_ngcontent-%COMP%], .mat-title[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{font:900 32px/1.25 Lato,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h3[_ngcontent-%COMP%], .mat-subheading-2[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font:900 20px/1.3 Lato,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h4[_ngcontent-%COMP%], .mat-subheading-1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{font:900 16px/1.375 Lato,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h5[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{font:400 13.28px/1.375 Lato,sans-serif;margin:0 0 12px}.mat-h6[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font:400 10.72px/1.375 Lato,sans-serif;margin:0 0 12px}.mat-body-2[_ngcontent-%COMP%], .mat-body-strong[_ngcontent-%COMP%]{font:400 14px/1.7 Lato,sans-serif;letter-spacing:normal}.mat-body[_ngcontent-%COMP%], .mat-body-1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]{font:400 16px/1.375 Lato,sans-serif;letter-spacing:normal}.mat-body-1[_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .mat-body[_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0 0 12px}.mat-caption[_ngcontent-%COMP%], .mat-small[_ngcontent-%COMP%]{font:400 14px/1.7 Lato,sans-serif;letter-spacing:normal}.mat-display-4[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-display-4[_ngcontent-%COMP%]{font:900 64px/1.25 Lato,sans-serif;letter-spacing:normal;margin:0 0 56px}.mat-display-3[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-display-3[_ngcontent-%COMP%]{font:900 32px/1.25 Lato,sans-serif;letter-spacing:normal;margin:0 0 64px}.mat-display-2[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-display-2[_ngcontent-%COMP%]{font:900 20px/1.3 Lato,sans-serif;letter-spacing:normal;margin:0 0 64px}.mat-display-1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-display-1[_ngcontent-%COMP%]{font:900 16px/1.375 Lato,sans-serif;letter-spacing:normal;margin:0 0 64px}.mat-bottom-sheet-container[_ngcontent-%COMP%]{font:400 16px/1.375 Lato,sans-serif;letter-spacing:normal}.mat-button[_ngcontent-%COMP%], .mat-fab[_ngcontent-%COMP%], .mat-flat-button[_ngcontent-%COMP%], .mat-icon-button[_ngcontent-%COMP%], .mat-mini-fab[_ngcontent-%COMP%], .mat-raised-button[_ngcontent-%COMP%], .mat-stroked-button[_ngcontent-%COMP%]{font-family:Lato,sans-serif;font-size:16px;font-weight:700}.mat-button-toggle[_ngcontent-%COMP%], .mat-card[_ngcontent-%COMP%]{font-family:Lato,sans-serif}.mat-card-title[_ngcontent-%COMP%]{font-size:64px;font-weight:900}.mat-card-header[_ngcontent-%COMP%]   .mat-card-title[_ngcontent-%COMP%]{font-size:32px}.mat-card-content[_ngcontent-%COMP%], .mat-card-subtitle[_ngcontent-%COMP%]{font-size:16px}.mat-checkbox[_ngcontent-%COMP%]{font-family:Lato,sans-serif}.mat-checkbox-layout[_ngcontent-%COMP%]   .mat-checkbox-label[_ngcontent-%COMP%]{line-height:1.7}.mat-chip[_ngcontent-%COMP%]{font-size:14px;font-weight:400}.mat-chip[_ngcontent-%COMP%]   .mat-chip-remove.mat-icon[_ngcontent-%COMP%], .mat-chip[_ngcontent-%COMP%]   .mat-chip-trailing-icon.mat-icon[_ngcontent-%COMP%]{font-size:18px}.mat-table[_ngcontent-%COMP%]{font-family:Lato,sans-serif}.mat-header-cell[_ngcontent-%COMP%]{font-size:14px;font-weight:400}.mat-cell[_ngcontent-%COMP%], .mat-footer-cell[_ngcontent-%COMP%]{font-size:16px}.mat-calendar[_ngcontent-%COMP%]{font-family:Lato,sans-serif}.mat-calendar-body[_ngcontent-%COMP%]{font-size:13px}.mat-calendar-body-label[_ngcontent-%COMP%], .mat-calendar-period-button[_ngcontent-%COMP%]{font-size:16px;font-weight:700}.mat-calendar-table-header[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{font-size:11px;font-weight:400}.mat-dialog-title[_ngcontent-%COMP%]{font:900 32px/1.25 Lato,sans-serif;letter-spacing:normal}.mat-expansion-panel-header[_ngcontent-%COMP%]{font-family:Lato,sans-serif;font-size:16px;font-weight:900}.mat-expansion-panel-content[_ngcontent-%COMP%]{font:400 16px/1.375 Lato,sans-serif;letter-spacing:normal}.mat-form-field[_ngcontent-%COMP%]{font:400 14px/1.7 Lato,sans-serif;letter-spacing:normal}.mat-form-field-wrapper[_ngcontent-%COMP%]{padding-bottom:1.775em}.mat-form-field-prefix[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], .mat-form-field-suffix[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{font-size:150%;line-height:1.7}.mat-form-field-prefix[_ngcontent-%COMP%]   .mat-icon-button[_ngcontent-%COMP%], .mat-form-field-suffix[_ngcontent-%COMP%]   .mat-icon-button[_ngcontent-%COMP%]{height:1.5em;width:1.5em}.mat-form-field-prefix[_ngcontent-%COMP%]   .mat-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], .mat-form-field-suffix[_ngcontent-%COMP%]   .mat-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{height:1.7em;line-height:1.7}.mat-form-field-infix[_ngcontent-%COMP%]{border-top:1.275em solid transparent;padding:.5em 0}.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.775em) scale(.75);width:133.33333%}.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.77499em) scale(.75);width:133.33334%}.mat-form-field-label-wrapper[_ngcontent-%COMP%]{padding-top:1.275em;top:-1.275em}.mat-form-field-label[_ngcontent-%COMP%]{top:1.775em}.mat-form-field-underline[_ngcontent-%COMP%]{bottom:1.775em}.mat-form-field-subscript-wrapper[_ngcontent-%COMP%]{font-size:75%;margin-top:.66667em;top:calc(100% - 2.36667em)}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-wrapper[_ngcontent-%COMP%]{padding-bottom:1.25em}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-infix[_ngcontent-%COMP%]{padding:.15em 0}.mat-form-field-appearance-legacy.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{-ms-transform:translateY(-1.425em) scale(.75);transform:translateY(-1.425em) scale(.75) perspective(100px) translateZ(.001px);width:133.33333%}.mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-form-field-autofill-control[_ngcontent-%COMP%]:-webkit-autofill + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{-ms-transform:translateY(-1.42499em) scale(.75);transform:translateY(-1.425em) scale(.75) perspective(100px) translateZ(.00101px);width:133.33334%}.mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{-ms-transform:translateY(-1.42498em) scale(.75);transform:translateY(-1.425em) scale(.75) perspective(100px) translateZ(.00102px);width:133.33335%}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{top:1.425em}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-underline[_ngcontent-%COMP%]{bottom:1.25em}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-subscript-wrapper[_ngcontent-%COMP%]{margin-top:-.03333em;top:calc(100% - 1.66667em)}@media print{.mat-form-field-appearance-legacy.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.42497em) scale(.75)}.mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-form-field-autofill-control[_ngcontent-%COMP%]:-webkit-autofill + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.42496em) scale(.75)}.mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.42495em) scale(.75)}}.mat-form-field-appearance-fill[_ngcontent-%COMP%]   .mat-form-field-infix[_ngcontent-%COMP%]{padding:.25em 0 .75em}.mat-form-field-appearance-fill[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{margin-top:-.5em;top:1.525em}.mat-form-field-appearance-fill.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-appearance-fill.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.025em) scale(.75);width:133.33333%}.mat-form-field-appearance-fill.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.02499em) scale(.75);width:133.33334%}.mat-form-field-appearance-outline[_ngcontent-%COMP%]   .mat-form-field-infix[_ngcontent-%COMP%]{padding:1em 0}.mat-form-field-appearance-outline[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{margin-top:-.25em;top:2.275em}.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-appearance-outline.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-2.025em) scale(.75);width:133.33333%}.mat-form-field-appearance-outline.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-2.02499em) scale(.75);width:133.33334%}.mat-grid-tile-footer[_ngcontent-%COMP%], .mat-grid-tile-header[_ngcontent-%COMP%]{font-size:16px}.mat-grid-tile-footer[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%], .mat-grid-tile-header[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]{box-sizing:border-box;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.mat-grid-tile-footer[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]:nth-child(n+2), .mat-grid-tile-header[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]:nth-child(n+2){font-size:14px}input.mat-input-element[_ngcontent-%COMP%]{margin-top:-.35em}.mat-menu-item[_ngcontent-%COMP%]{font-family:Lato,sans-serif;font-size:16px;font-weight:400}.mat-paginator[_ngcontent-%COMP%], .mat-paginator-page-size[_ngcontent-%COMP%]   .mat-select-trigger[_ngcontent-%COMP%]{font-family:Lato,sans-serif;font-size:14px}.mat-radio-button[_ngcontent-%COMP%], .mat-select[_ngcontent-%COMP%]{font-family:Lato,sans-serif}.mat-select-trigger[_ngcontent-%COMP%]{height:1.7em}.mat-slide-toggle-content[_ngcontent-%COMP%]{font-family:Lato,sans-serif}.mat-slider-thumb-label-text[_ngcontent-%COMP%]{font-family:Lato,sans-serif;font-size:14px;font-weight:400}.mat-stepper-horizontal[_ngcontent-%COMP%], .mat-stepper-vertical[_ngcontent-%COMP%]{font-family:Lato,sans-serif}.mat-step-label[_ngcontent-%COMP%]{font-size:16px;font-weight:400}.mat-step-sub-label-error[_ngcontent-%COMP%]{font-weight:400}.mat-step-label-error[_ngcontent-%COMP%]{font-size:14px}.mat-step-label-selected[_ngcontent-%COMP%]{font-size:14px;font-weight:400}.mat-tab-group[_ngcontent-%COMP%]{font-family:Lato,sans-serif}.mat-tab-label[_ngcontent-%COMP%], .mat-tab-link[_ngcontent-%COMP%]{font-family:Lato,sans-serif;font-size:16px;font-weight:700}.mat-toolbar[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font:900 32px/1.25 Lato,sans-serif;letter-spacing:normal;margin:0}.mat-tooltip[_ngcontent-%COMP%]{font-family:Lato,sans-serif;font-size:10px;padding-bottom:6px;padding-top:6px}.mat-tooltip-handset[_ngcontent-%COMP%]{font-size:14px;padding-bottom:8px;padding-top:8px}.mat-list-item[_ngcontent-%COMP%], .mat-list-option[_ngcontent-%COMP%]{font-family:Lato,sans-serif}.mat-list-base[_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]{font-size:20px}.mat-list-base[_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]{box-sizing:border-box;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.mat-list-base[_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]:nth-child(n+2){font-size:16px}.mat-list-base[_ngcontent-%COMP%]   .mat-list-option[_ngcontent-%COMP%]{font-size:20px}.mat-list-base[_ngcontent-%COMP%]   .mat-list-option[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]{box-sizing:border-box;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.mat-list-base[_ngcontent-%COMP%]   .mat-list-option[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]:nth-child(n+2){font-size:16px}.mat-list-base[_ngcontent-%COMP%]   .mat-subheader[_ngcontent-%COMP%]{font-family:Lato,sans-serif;font-size:14px;font-weight:400}.mat-list-base[dense][_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]{font-size:14px}.mat-list-base[dense][_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]{box-sizing:border-box;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.mat-list-base[dense][_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]:nth-child(n+2), .mat-list-base[dense][_ngcontent-%COMP%]   .mat-list-option[_ngcontent-%COMP%]{font-size:14px}.mat-list-base[dense][_ngcontent-%COMP%]   .mat-list-option[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]{box-sizing:border-box;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.mat-list-base[dense][_ngcontent-%COMP%]   .mat-list-option[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]:nth-child(n+2){font-size:14px}.mat-list-base[dense][_ngcontent-%COMP%]   .mat-subheader[_ngcontent-%COMP%]{font-family:Lato,sans-serif;font-size:14px;font-weight:400}.mat-option[_ngcontent-%COMP%]{font-family:Lato,sans-serif;font-size:20px}.mat-optgroup-label[_ngcontent-%COMP%]{font:400 14px/1.7 Lato,sans-serif;letter-spacing:normal}.mat-simple-snackbar[_ngcontent-%COMP%]{font-family:Lato,sans-serif;font-size:16px}.mat-simple-snackbar-action[_ngcontent-%COMP%]{font-family:inherit;font-size:inherit;font-weight:700;line-height:1}.mat-tree[_ngcontent-%COMP%]{font-family:Lato,sans-serif}.mat-nested-tree-node[_ngcontent-%COMP%], .mat-tree-node[_ngcontent-%COMP%]{font-size:16px;font-weight:400}.mat-ripple[_ngcontent-%COMP%]{overflow:hidden;position:relative}.mat-ripple[_ngcontent-%COMP%]:not(:empty){transform:translateZ(0)}.mat-ripple.mat-ripple-unbounded[_ngcontent-%COMP%]{overflow:visible}.mat-ripple-element[_ngcontent-%COMP%]{border-radius:50%;pointer-events:none;position:absolute;transform:scale(0);transition:opacity,transform 0ms cubic-bezier(0,0,.2,1)}.cdk-high-contrast-active[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{display:none}.cdk-visually-hidden[_ngcontent-%COMP%]{-moz-appearance:none;-webkit-appearance:none;border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;outline:0;overflow:hidden;padding:0;position:absolute;width:1px}.cdk-global-overlay-wrapper[_ngcontent-%COMP%], .cdk-overlay-container[_ngcontent-%COMP%]{height:100%;left:0;pointer-events:none;top:0;width:100%}.cdk-overlay-container[_ngcontent-%COMP%]{position:fixed;z-index:1000}.cdk-overlay-container[_ngcontent-%COMP%]:empty{display:none}.cdk-global-overlay-wrapper[_ngcontent-%COMP%], .cdk-overlay-pane[_ngcontent-%COMP%]{display:flex;position:absolute;z-index:1000}.cdk-overlay-pane[_ngcontent-%COMP%]{box-sizing:border-box;max-height:100%;max-width:100%;pointer-events:auto}.cdk-overlay-backdrop[_ngcontent-%COMP%]{-webkit-tap-highlight-color:transparent;bottom:0;left:0;opacity:0;pointer-events:auto;position:absolute;right:0;top:0;transition:opacity .4s cubic-bezier(.25,.8,.25,1);z-index:1000}.cdk-overlay-backdrop.cdk-overlay-backdrop-showing[_ngcontent-%COMP%]{opacity:1}@media screen and (-ms-high-contrast:active){.cdk-overlay-backdrop.cdk-overlay-backdrop-showing[_ngcontent-%COMP%]{opacity:.6}}.cdk-overlay-dark-backdrop[_ngcontent-%COMP%]{background:rgba(0,0,0,.32)}.cdk-overlay-transparent-backdrop[_ngcontent-%COMP%], .cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing[_ngcontent-%COMP%]{opacity:0}.cdk-overlay-connected-position-bounding-box[_ngcontent-%COMP%]{display:flex;flex-direction:column;min-height:1px;min-width:1px;position:absolute;z-index:1000}.cdk-global-scrollblock[_ngcontent-%COMP%]{overflow-y:scroll;position:fixed;width:100%}@-webkit-keyframes cdk-text-field-autofill-start{\n  }@keyframes cdk-text-field-autofill-start{\n  }@-webkit-keyframes cdk-text-field-autofill-end{\n  }@keyframes cdk-text-field-autofill-end{\n  }.cdk-text-field-autofill-monitored[_ngcontent-%COMP%]:-webkit-autofill{-webkit-animation:cdk-text-field-autofill-start 0s 1ms;animation:cdk-text-field-autofill-start 0s 1ms}.cdk-text-field-autofill-monitored[_ngcontent-%COMP%]:not(:-webkit-autofill){-webkit-animation:cdk-text-field-autofill-end 0s 1ms;animation:cdk-text-field-autofill-end 0s 1ms}textarea.cdk-textarea-autosize[_ngcontent-%COMP%]{resize:none}textarea.cdk-textarea-autosize-measuring[_ngcontent-%COMP%]{box-sizing:content-box!important;height:auto!important;overflow:hidden!important;padding:2px 0!important}textarea.cdk-textarea-autosize-measuring-firefox[_ngcontent-%COMP%]{box-sizing:content-box!important;height:0!important;padding:2px 0!important}.mat-focus-indicator[_ngcontent-%COMP%], .mat-mdc-focus-indicator[_ngcontent-%COMP%]{position:relative}.form[_ngcontent-%COMP%]{flex-flow:row wrap;justify-content:space-between}.form[_ngcontent-%COMP%], .picker[_ngcontent-%COMP%]{align-items:stretch;display:flex;width:100%}.picker[_ngcontent-%COMP%]{border:1px solid #ccd0d6;border-radius:2px;flex-flow:row nowrap}.picker__field[_ngcontent-%COMP%]{border:none;color:#002d72;flex:1 1 60%;font-family:Lato,sans-serif;font-size:16px;font-weight:900;min-width:60px;outline:none;padding:15px 0;text-align:center;width:100%}.picker__field[_ngcontent-%COMP%]:disabled{color:#ccd0d6}.picker__trigger[_ngcontent-%COMP%]{height:100%;left:0;position:absolute;top:0;width:100%}.picker__controls[_ngcontent-%COMP%]{align-items:center;border-left:1px solid #ccd0d6;border-radius:0;border-right:1px solid #ccd0d6;color:#002d72;display:flex;flex:1 1 20%;font-family:Lato,sans-serif;font-size:16px;font-weight:900;height:auto!important;justify-content:center;line-height:1.5;margin:0;max-width:48px;min-width:auto}.picker__controls--decrease[_ngcontent-%COMP%]{border-left:0}.picker__controls--increase[_ngcontent-%COMP%]{border-right:0}.picker__controls[_ngcontent-%COMP%]   mm-icon[_ngcontent-%COMP%]{width:15px}.picker__controls[_ngcontent-%COMP%]     .mm-button__icon{display:flex;margin-right:0}.info[_ngcontent-%COMP%]{color:#002d72;display:flex;font-size:13px;justify-content:space-between;line-height:1.08;margin-bottom:12px;width:100%}.info__stock[_ngcontent-%COMP%]{color:#47556b;font-size:14px}"] });
MmQuantityPickerComponent.ctorParameters = () => [
    { type: FormBuilder }
];
MmQuantityPickerComponent.propDecorators = {
    showLabels: [{ type: Input }],
    labels: [{ type: Input }],
    isDisabled: [{ type: Input }],
    amount: [{ type: Input }],
    availableAmount: [{ type: Input }],
    minAmount: [{ type: Input }],
    stepping: [{ type: Input }],
    quantityChanged: [{ type: Output }],
    quantityChangeInteraction: [{ type: Output }],
    quantityPrettified: [{ type: Output }],
    disabledDecreaseTriggered: [{ type: Output }],
    disabledIncreaseTriggered: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmQuantityPickerComponent, [{
        type: Component,
        args: [{
                selector: 'mm-quantity-picker',
                template: "<form (submit)=\"onSubmit()\"\n      class=\"form\"\n      [formGroup]=\"quantityPickerFrom\"\n      novalidate>\n    <div *ngIf=\"showLabels\"\n         class=\"info\">\n        <span>\n            {{ labels.quantity }}\n        </span>\n        <span class=\"info__stock\"\n              *ngIf=\"availableAmount > 0\">\n             {{ labels.inStock }}\n        </span>\n    </div>\n    <div class=\"picker\">\n        <button [disabled]=\"!isDecreasePossible\"\n                [mmTestTarget]=\"'picker-decrease-button'\"\n                class=\"picker__controls picker__controls--decrease\"\n                color=\"ghost\"\n                type=\"button\"\n                mm-button\n                (click)=\"changeQuantity(-1)\">\n            -\n            <span (click)=\"!isDecreasePossible && onDisabledDecrease()\"\n                  class=\"picker__trigger\">\n            </span>\n        </button>\n        <input (blur)=\"onBlur()\"\n               [mmTestTarget]=\"'picker-input'\"\n               digitOnly\n               (input)=\"onChanges()\"\n               class=\"picker__field\"\n               type=\"text\"\n               formControlName=\"quantity\">\n        <button [disabled]=\"!isIncreaseEnabled\"\n                [mmTestTarget]=\"'picker-increase-button'\"\n                class=\"picker__controls picker__controls--increase\"\n                color=\"ghost\"\n                type=\"button\"\n                mm-button\n                (click)=\"changeQuantity(1)\">\n            +\n            <span (click)=\"!isIncreasePossible && onDisabledIncrease()\"\n                  class=\"picker__trigger\">\n            </span>\n        </button>\n    </div>\n</form>\n",
                styles: [".mat-badge-content{font-family:Lato,sans-serif;font-size:12px;font-weight:600}.mat-badge-small .mat-badge-content{font-size:9px}.mat-badge-large .mat-badge-content{font-size:24px}.mat-h1,.mat-headline,.mat-typography h1{font:900 64px/1.33 Lato,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h2,.mat-title,.mat-typography h2{font:900 32px/1.25 Lato,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h3,.mat-subheading-2,.mat-typography h3{font:900 20px/1.3 Lato,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h4,.mat-subheading-1,.mat-typography h4{font:900 16px/1.375 Lato,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h5,.mat-typography h5{font:400 13.28px/1.375 Lato,sans-serif;margin:0 0 12px}.mat-h6,.mat-typography h6{font:400 10.72px/1.375 Lato,sans-serif;margin:0 0 12px}.mat-body-2,.mat-body-strong{font:400 14px/1.7 Lato,sans-serif;letter-spacing:normal}.mat-body,.mat-body-1,.mat-typography{font:400 16px/1.375 Lato,sans-serif;letter-spacing:normal}.mat-body-1 p,.mat-body p,.mat-typography p{margin:0 0 12px}.mat-caption,.mat-small{font:400 14px/1.7 Lato,sans-serif;letter-spacing:normal}.mat-display-4,.mat-typography .mat-display-4{font:900 64px/1.25 Lato,sans-serif;letter-spacing:normal;margin:0 0 56px}.mat-display-3,.mat-typography .mat-display-3{font:900 32px/1.25 Lato,sans-serif;letter-spacing:normal;margin:0 0 64px}.mat-display-2,.mat-typography .mat-display-2{font:900 20px/1.3 Lato,sans-serif;letter-spacing:normal;margin:0 0 64px}.mat-display-1,.mat-typography .mat-display-1{font:900 16px/1.375 Lato,sans-serif;letter-spacing:normal;margin:0 0 64px}.mat-bottom-sheet-container{font:400 16px/1.375 Lato,sans-serif;letter-spacing:normal}.mat-button,.mat-fab,.mat-flat-button,.mat-icon-button,.mat-mini-fab,.mat-raised-button,.mat-stroked-button{font-family:Lato,sans-serif;font-size:16px;font-weight:700}.mat-button-toggle,.mat-card{font-family:Lato,sans-serif}.mat-card-title{font-size:64px;font-weight:900}.mat-card-header .mat-card-title{font-size:32px}.mat-card-content,.mat-card-subtitle{font-size:16px}.mat-checkbox{font-family:Lato,sans-serif}.mat-checkbox-layout .mat-checkbox-label{line-height:1.7}.mat-chip{font-size:14px;font-weight:400}.mat-chip .mat-chip-remove.mat-icon,.mat-chip .mat-chip-trailing-icon.mat-icon{font-size:18px}.mat-table{font-family:Lato,sans-serif}.mat-header-cell{font-size:14px;font-weight:400}.mat-cell,.mat-footer-cell{font-size:16px}.mat-calendar{font-family:Lato,sans-serif}.mat-calendar-body{font-size:13px}.mat-calendar-body-label,.mat-calendar-period-button{font-size:16px;font-weight:700}.mat-calendar-table-header th{font-size:11px;font-weight:400}.mat-dialog-title{font:900 32px/1.25 Lato,sans-serif;letter-spacing:normal}.mat-expansion-panel-header{font-family:Lato,sans-serif;font-size:16px;font-weight:900}.mat-expansion-panel-content{font:400 16px/1.375 Lato,sans-serif;letter-spacing:normal}.mat-form-field{font:400 14px/1.7 Lato,sans-serif;letter-spacing:normal}.mat-form-field-wrapper{padding-bottom:1.775em}.mat-form-field-prefix .mat-icon,.mat-form-field-suffix .mat-icon{font-size:150%;line-height:1.7}.mat-form-field-prefix .mat-icon-button,.mat-form-field-suffix .mat-icon-button{height:1.5em;width:1.5em}.mat-form-field-prefix .mat-icon-button .mat-icon,.mat-form-field-suffix .mat-icon-button .mat-icon{height:1.7em;line-height:1.7}.mat-form-field-infix{border-top:1.275em solid transparent;padding:.5em 0}.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.775em) scale(.75);width:133.33333%}.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.77499em) scale(.75);width:133.33334%}.mat-form-field-label-wrapper{padding-top:1.275em;top:-1.275em}.mat-form-field-label{top:1.775em}.mat-form-field-underline{bottom:1.775em}.mat-form-field-subscript-wrapper{font-size:75%;margin-top:.66667em;top:calc(100% - 2.36667em)}.mat-form-field-appearance-legacy .mat-form-field-wrapper{padding-bottom:1.25em}.mat-form-field-appearance-legacy .mat-form-field-infix{padding:.15em 0}.mat-form-field-appearance-legacy.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{-ms-transform:translateY(-1.425em) scale(.75);transform:translateY(-1.425em) scale(.75) perspective(100px) translateZ(.001px);width:133.33333%}.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-form-field-autofill-control:-webkit-autofill+.mat-form-field-label-wrapper .mat-form-field-label{-ms-transform:translateY(-1.42499em) scale(.75);transform:translateY(-1.425em) scale(.75) perspective(100px) translateZ(.00101px);width:133.33334%}.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{-ms-transform:translateY(-1.42498em) scale(.75);transform:translateY(-1.425em) scale(.75) perspective(100px) translateZ(.00102px);width:133.33335%}.mat-form-field-appearance-legacy .mat-form-field-label{top:1.425em}.mat-form-field-appearance-legacy .mat-form-field-underline{bottom:1.25em}.mat-form-field-appearance-legacy .mat-form-field-subscript-wrapper{margin-top:-.03333em;top:calc(100% - 1.66667em)}@media print{.mat-form-field-appearance-legacy.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.42497em) scale(.75)}.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-form-field-autofill-control:-webkit-autofill+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.42496em) scale(.75)}.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.42495em) scale(.75)}}.mat-form-field-appearance-fill .mat-form-field-infix{padding:.25em 0 .75em}.mat-form-field-appearance-fill .mat-form-field-label{margin-top:-.5em;top:1.525em}.mat-form-field-appearance-fill.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-appearance-fill.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.025em) scale(.75);width:133.33333%}.mat-form-field-appearance-fill.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.02499em) scale(.75);width:133.33334%}.mat-form-field-appearance-outline .mat-form-field-infix{padding:1em 0}.mat-form-field-appearance-outline .mat-form-field-label{margin-top:-.25em;top:2.275em}.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-appearance-outline.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-2.025em) scale(.75);width:133.33333%}.mat-form-field-appearance-outline.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-2.02499em) scale(.75);width:133.33334%}.mat-grid-tile-footer,.mat-grid-tile-header{font-size:16px}.mat-grid-tile-footer .mat-line,.mat-grid-tile-header .mat-line{box-sizing:border-box;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.mat-grid-tile-footer .mat-line:nth-child(n+2),.mat-grid-tile-header .mat-line:nth-child(n+2){font-size:14px}input.mat-input-element{margin-top:-.35em}.mat-menu-item{font-family:Lato,sans-serif;font-size:16px;font-weight:400}.mat-paginator,.mat-paginator-page-size .mat-select-trigger{font-family:Lato,sans-serif;font-size:14px}.mat-radio-button,.mat-select{font-family:Lato,sans-serif}.mat-select-trigger{height:1.7em}.mat-slide-toggle-content{font-family:Lato,sans-serif}.mat-slider-thumb-label-text{font-family:Lato,sans-serif;font-size:14px;font-weight:400}.mat-stepper-horizontal,.mat-stepper-vertical{font-family:Lato,sans-serif}.mat-step-label{font-size:16px;font-weight:400}.mat-step-sub-label-error{font-weight:400}.mat-step-label-error{font-size:14px}.mat-step-label-selected{font-size:14px;font-weight:400}.mat-tab-group{font-family:Lato,sans-serif}.mat-tab-label,.mat-tab-link{font-family:Lato,sans-serif;font-size:16px;font-weight:700}.mat-toolbar,.mat-toolbar h1,.mat-toolbar h2,.mat-toolbar h3,.mat-toolbar h4,.mat-toolbar h5,.mat-toolbar h6{font:900 32px/1.25 Lato,sans-serif;letter-spacing:normal;margin:0}.mat-tooltip{font-family:Lato,sans-serif;font-size:10px;padding-bottom:6px;padding-top:6px}.mat-tooltip-handset{font-size:14px;padding-bottom:8px;padding-top:8px}.mat-list-item,.mat-list-option{font-family:Lato,sans-serif}.mat-list-base .mat-list-item{font-size:20px}.mat-list-base .mat-list-item .mat-line{box-sizing:border-box;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.mat-list-base .mat-list-item .mat-line:nth-child(n+2){font-size:16px}.mat-list-base .mat-list-option{font-size:20px}.mat-list-base .mat-list-option .mat-line{box-sizing:border-box;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.mat-list-base .mat-list-option .mat-line:nth-child(n+2){font-size:16px}.mat-list-base .mat-subheader{font-family:Lato,sans-serif;font-size:14px;font-weight:400}.mat-list-base[dense] .mat-list-item{font-size:14px}.mat-list-base[dense] .mat-list-item .mat-line{box-sizing:border-box;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.mat-list-base[dense] .mat-list-item .mat-line:nth-child(n+2),.mat-list-base[dense] .mat-list-option{font-size:14px}.mat-list-base[dense] .mat-list-option .mat-line{box-sizing:border-box;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.mat-list-base[dense] .mat-list-option .mat-line:nth-child(n+2){font-size:14px}.mat-list-base[dense] .mat-subheader{font-family:Lato,sans-serif;font-size:14px;font-weight:400}.mat-option{font-family:Lato,sans-serif;font-size:20px}.mat-optgroup-label{font:400 14px/1.7 Lato,sans-serif;letter-spacing:normal}.mat-simple-snackbar{font-family:Lato,sans-serif;font-size:16px}.mat-simple-snackbar-action{font-family:inherit;font-size:inherit;font-weight:700;line-height:1}.mat-tree{font-family:Lato,sans-serif}.mat-nested-tree-node,.mat-tree-node{font-size:16px;font-weight:400}.mat-ripple{overflow:hidden;position:relative}.mat-ripple:not(:empty){transform:translateZ(0)}.mat-ripple.mat-ripple-unbounded{overflow:visible}.mat-ripple-element{border-radius:50%;pointer-events:none;position:absolute;transform:scale(0);transition:opacity,transform 0ms cubic-bezier(0,0,.2,1)}.cdk-high-contrast-active .mat-ripple-element{display:none}.cdk-visually-hidden{-moz-appearance:none;-webkit-appearance:none;border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;outline:0;overflow:hidden;padding:0;position:absolute;width:1px}.cdk-global-overlay-wrapper,.cdk-overlay-container{height:100%;left:0;pointer-events:none;top:0;width:100%}.cdk-overlay-container{position:fixed;z-index:1000}.cdk-overlay-container:empty{display:none}.cdk-global-overlay-wrapper,.cdk-overlay-pane{display:flex;position:absolute;z-index:1000}.cdk-overlay-pane{box-sizing:border-box;max-height:100%;max-width:100%;pointer-events:auto}.cdk-overlay-backdrop{-webkit-tap-highlight-color:transparent;bottom:0;left:0;opacity:0;pointer-events:auto;position:absolute;right:0;top:0;transition:opacity .4s cubic-bezier(.25,.8,.25,1);z-index:1000}.cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:1}@media screen and (-ms-high-contrast:active){.cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:.6}}.cdk-overlay-dark-backdrop{background:rgba(0,0,0,.32)}.cdk-overlay-transparent-backdrop,.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing{opacity:0}.cdk-overlay-connected-position-bounding-box{display:flex;flex-direction:column;min-height:1px;min-width:1px;position:absolute;z-index:1000}.cdk-global-scrollblock{overflow-y:scroll;position:fixed;width:100%}@-webkit-keyframes cdk-text-field-autofill-start{\n  /*!*/}@keyframes cdk-text-field-autofill-start{\n  /*!*/}@-webkit-keyframes cdk-text-field-autofill-end{\n  /*!*/}@keyframes cdk-text-field-autofill-end{\n  /*!*/}.cdk-text-field-autofill-monitored:-webkit-autofill{-webkit-animation:cdk-text-field-autofill-start 0s 1ms;animation:cdk-text-field-autofill-start 0s 1ms}.cdk-text-field-autofill-monitored:not(:-webkit-autofill){-webkit-animation:cdk-text-field-autofill-end 0s 1ms;animation:cdk-text-field-autofill-end 0s 1ms}textarea.cdk-textarea-autosize{resize:none}textarea.cdk-textarea-autosize-measuring{box-sizing:content-box!important;height:auto!important;overflow:hidden!important;padding:2px 0!important}textarea.cdk-textarea-autosize-measuring-firefox{box-sizing:content-box!important;height:0!important;padding:2px 0!important}.mat-focus-indicator,.mat-mdc-focus-indicator{position:relative}.form{flex-flow:row wrap;justify-content:space-between}.form,.picker{align-items:stretch;display:flex;width:100%}.picker{border:1px solid #ccd0d6;border-radius:2px;flex-flow:row nowrap}.picker__field{border:none;color:#002d72;flex:1 1 60%;font-family:Lato,sans-serif;font-size:16px;font-weight:900;min-width:60px;outline:none;padding:15px 0;text-align:center;width:100%}.picker__field:disabled{color:#ccd0d6}.picker__trigger{height:100%;left:0;position:absolute;top:0;width:100%}.picker__controls{align-items:center;border-left:1px solid #ccd0d6;border-radius:0;border-right:1px solid #ccd0d6;color:#002d72;display:flex;flex:1 1 20%;font-family:Lato,sans-serif;font-size:16px;font-weight:900;height:auto!important;justify-content:center;line-height:1.5;margin:0;max-width:48px;min-width:auto}.picker__controls--decrease{border-left:0}.picker__controls--increase{border-right:0}.picker__controls mm-icon{width:15px}.picker__controls ::ng-deep .mm-button__icon{display:flex;margin-right:0}.info{color:#002d72;display:flex;font-size:13px;justify-content:space-between;line-height:1.08;margin-bottom:12px;width:100%}.info__stock{color:#47556b;font-size:14px}"]
            }]
    }], function () { return [{ type: ɵngcc1.FormBuilder }]; }, { showLabels: [{
            type: Input
        }], labels: [{
            type: Input
        }], isDisabled: [{
            type: Input
        }], amount: [{
            type: Input
        }], minAmount: [{
            type: Input
        }], stepping: [{
            type: Input
        }], quantityChanged: [{
            type: Output
        }], quantityChangeInteraction: [{
            type: Output
        }], quantityPrettified: [{
            type: Output
        }], disabledDecreaseTriggered: [{
            type: Output
        }], disabledIncreaseTriggered: [{
            type: Output
        }], availableAmount: [{
            type: Input
        }] }); })();

var MmButtonType;
(function (MmButtonType) {
    MmButtonType["submit"] = "submit";
    MmButtonType["button"] = "button";
    MmButtonType["reset"] = "reset";
})(MmButtonType || (MmButtonType = {}));
var MmButtonSize;
(function (MmButtonSize) {
    MmButtonSize["large"] = "large";
    MmButtonSize["small"] = "small";
    MmButtonSize["medium"] = "medium";
})(MmButtonSize || (MmButtonSize = {}));
var MmButtonColor;
(function (MmButtonColor) {
    MmButtonColor["primary"] = "primary";
    MmButtonColor["secondary"] = "secondary";
    MmButtonColor["ghost"] = "ghost";
    MmButtonColor["ghostMute"] = "ghost-mute";
    MmButtonColor["ghostWarning"] = "ghost-warning";
    MmButtonColor["warning"] = "warning";
    MmButtonColor["default"] = "default";
})(MmButtonColor || (MmButtonColor = {}));

class MmButtonComponent {
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.type = MmButtonType.button;
        this.size = MmButtonSize.medium;
        this.raised = false;
        this.iconButton = false;
        this.iconOffset = false;
        this.fluid = false;
        this.color = MmButtonColor.primary;
        this.base = true;
        this.preffix = 'mm-button';
        this.isLoading = new BehaviorSubject(false);
    }
    set loading(value) {
        this.isLoading.next(value);
    }
    get loading() {
        return this.isLoading.getValue();
    }
    ngOnInit() {
        const buttonElement = this.elementRef.nativeElement;
        this.renderer.setAttribute(buttonElement, 'type', this.type);
        this.renderer.addClass(buttonElement, `${this.preffix}--${this.color}`);
        if (this.size) {
            this.renderer.addClass(buttonElement, `${this.preffix}--${this.size}`);
        }
        if (this.raised) {
            this.renderer.addClass(buttonElement, `${this.preffix}--raised`);
        }
        if (this.iconButton) {
            this.renderer.addClass(buttonElement, `${this.preffix}--icon-button`);
        }
        if (this.fluid) {
            this.renderer.addClass(buttonElement, `${this.preffix}--fluid`);
        }
        if (this.bordered) {
            this.renderer.addClass(buttonElement, `${this.preffix}--bordered`);
        }
        this.isLoading.subscribe((value) => {
            if (value) {
                this.renderer.addClass(buttonElement, `${this.preffix}__spinner`);
            }
            else {
                this.renderer.removeClass(buttonElement, `${this.preffix}__spinner`);
            }
        });
    }
    ngOnDestroy() {
        this.isLoading.unsubscribe();
    }
}
MmButtonComponent.ɵfac = function MmButtonComponent_Factory(t) { return new (t || MmButtonComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
MmButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmButtonComponent, selectors: [["button", "mm-button", ""]], hostVars: 2, hostBindings: function MmButtonComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mm-button", ctx.base);
    } }, inputs: { type: "type", size: "size", raised: "raised", iconButton: "iconButton", iconOffset: "iconOffset", fluid: "fluid", color: "color", loading: "loading", bordered: "bordered" }, attrs: _c0, ngContentSelectors: _c4, decls: 6, vars: 10, consts: [[1, "mm-button__container", 3, "mmTestTarget"], ["class", "mm-button__spinner", "viewBox", "0 0 42 42", 4, "ngIf"], [1, "mm-button__icon", 3, "ngClass", "mmTestTarget"], [1, "mm-button__content", 3, "ngClass", "mmTestTarget"], ["viewBox", "0 0 42 42", 1, "mm-button__spinner"], ["cx", "50%", "cy", "50%", "r", "20", "fill", "none", "stroke-width", "5"]], template: function MmButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c1);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, MmButtonComponent__svg_svg_1_Template, 2, 0, "svg", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵprojection(5, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("mmTestTarget", "button-container");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c2, ctx.loading))("mmTestTarget", "button-icon");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(8, _c3, ctx.loading))("mmTestTarget", "button-content");
    } }, directives: [ɵngcc3.ɵf, ɵngcc2.NgIf, ɵngcc2.NgClass], styles: [".mm-button{-webkit-tap-highlight-color:transparent;border:0;border-radius:2px;box-sizing:border-box;font-family:Lato,sans-serif;font-size:1.14rem;font-weight:700;height:40px;line-height:1;min-width:32px;outline:none;padding:0;position:relative;vertical-align:middle;width:auto}.mm-button:active,.mm-button:hover{cursor:pointer}.mm-button[disabled]:active,.mm-button[disabled]:hover{cursor:default}.mm-button .mm-icon,.mm-button mat-icon{font-size:24px;height:24px;line-height:24px;width:24px}.mm-button__container{align-items:center;display:flex;justify-content:center}.mm-button__content-hidden,.mm-button__icon-hidden{visibility:hidden}.mm-button.mm-button--fluid{width:100%}.mm-button:not(.mm-button--icon-button){padding:0 26px}.mm-button:not(.mm-button--icon-button) .mm-button__icon{margin-right:8px}.mm-button,.mm-button--primary{background:#0064fe;color:#fff}.mm-button--primary:active,.mm-button--primary:hover,.mm-button:active,.mm-button:hover{background:#0050cb}.mm-button--secondary{background:#e6f0ff;color:#002d72}.mm-button--secondary:active,.mm-button--secondary:hover{background:#cce0ff}.mm-button--ghost,.mm-button--ghost-mute,.mm-button--ghost-warning{background:#fff;color:#0064fe}.mm-button--ghost-mute:active,.mm-button--ghost-mute:hover,.mm-button--ghost-warning:active,.mm-button--ghost-warning:hover,.mm-button--ghost:active,.mm-button--ghost:hover{background:#f2f7ff}.mm-button--ghost-mute{color:#001432;text-decoration:underline}.mm-button--ghost-mute[disabled]{text-decoration:none}.mm-button--warning{background:#de351a;color:#fff}.mm-button--warning:active,.mm-button--warning:hover{background:#b22a16}.mm-button--ghost-warning{color:#de351a}.mm-button--ghost-warning:active,.mm-button--ghost-warning:hover{background:#fff;text-decoration:underline}.mm-button--raised{box-shadow:0 5px 6px 0 #d9dce0}.mm-button--small{font-size:14px;font-weight:700;height:32px;line-height:1}.mm-button--small .mm-icon,.mm-button--small mat-icon{font-size:20px;height:20px;line-height:20px;width:20px}.mm-button--large{font-size:1.28rem;font-weight:700;height:48px;line-height:1}.mm-button--bordered{box-shadow:0 0 0 2px currentColor}.mm-button__spinner{pointer-events:none}.mm-button__spinner svg.mm-button__spinner{-webkit-animation:rotate 1.8s linear infinite;animation:rotate 1.8s linear infinite;height:21px;left:50%;margin:-10.5px 0 0 -10.5px;position:absolute;top:50%;width:21px;z-index:2}.mm-button__spinner svg.mm-button__spinner>circle{-webkit-animation:dash 1.3s ease-in-out infinite;animation:dash 1.3s ease-in-out infinite;stroke:#f2f7ff;stroke-linecap:round;stroke-width:2px}@-webkit-keyframes rotate{to{transform:rotate(1turn)}}@keyframes rotate{to{transform:rotate(1turn)}}@-webkit-keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}to{stroke-dasharray:90,150;stroke-dashoffset:-124}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}to{stroke-dasharray:90,150;stroke-dashoffset:-124}}.mm-button--ghost-mute svg.mm-button__spinner circle,.mm-button--ghost-warning svg.mm-button__spinner circle,.mm-button--ghost svg.mm-button__spinner circle,.mm-button--secondary svg.mm-button__spinner circle,.mm-button[disabled] svg.mm-button__spinner circle{stroke:#002d72}.mm-button--disabled,.mm-button--primary[disabled],.mm-button--secondary[disabled],.mm-button[disabled]{background:repeating-linear-gradient(45deg,#e9eaed,#e9eaed 9px,#d7d8db 0,#d7d8db 10px);color:#667284}.mm-button--disabled:active,.mm-button--disabled:hover,.mm-button--primary:active[disabled],.mm-button--primary:hover[disabled],.mm-button--secondary:active[disabled],.mm-button--secondary:hover[disabled],.mm-button:active[disabled],.mm-button:hover[disabled]{background:repeating-linear-gradient(45deg,#e9eaed,#e9eaed 9px,#d7d8db 0,#d7d8db 10px)}.mm-button--ghost-mute[disabled],.mm-button--ghost-warning[disabled],.mm-button--ghost[disabled],.mm-button-ghost--disabled{background:#fff!important;color:#667284!important}.mm-button--ghost-mute:active[disabled],.mm-button--ghost-mute:hover[disabled],.mm-button--ghost-warning:active[disabled],.mm-button--ghost-warning:hover[disabled],.mm-button--ghost:active[disabled],.mm-button--ghost:hover[disabled],.mm-button-ghost--disabled:active,.mm-button-ghost--disabled:hover{background:#fff;color:#667284}"], encapsulation: 2, changeDetection: 0 });
MmButtonComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
MmButtonComponent.propDecorators = {
    type: [{ type: Input }],
    size: [{ type: Input }],
    raised: [{ type: Input }],
    iconButton: [{ type: Input }],
    iconOffset: [{ type: Input }],
    fluid: [{ type: Input }],
    color: [{ type: Input }],
    bordered: [{ type: Input }],
    loading: [{ type: Input }],
    base: [{ type: HostBinding, args: ['class.mm-button',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmButtonComponent, [{
        type: Component,
        args: [{
                selector: 'button[mm-button]',
                template: "<div class=\"mm-button__container\"\n     [mmTestTarget]=\"'button-container'\">\n    <svg class=\"mm-button__spinner\"\n         *ngIf=\"loading\"\n         viewBox=\"0 0 42 42\">\n        <circle cx=\"50%\"\n                cy=\"50%\"\n                r=\"20\"\n                fill=\"none\"\n                stroke-width=\"5\"></circle>\n    </svg>\n    <div class=\"mm-button__icon\"\n         [ngClass]=\"{ 'mm-button__icon-hidden': loading }\"\n         [mmTestTarget]=\"'button-icon'\">\n        <ng-content select=\"mat-icon, mm-icon, .mm-icon\"></ng-content>\n    </div>\n    <div class=\"mm-button__content\"\n         [ngClass]=\"{ 'mm-button__content-hidden': loading }\"\n         [mmTestTarget]=\"'button-content'\">\n        <ng-content></ng-content>\n    </div>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".mm-button{-webkit-tap-highlight-color:transparent;border:0;border-radius:2px;box-sizing:border-box;font-family:Lato,sans-serif;font-size:1.14rem;font-weight:700;height:40px;line-height:1;min-width:32px;outline:none;padding:0;position:relative;vertical-align:middle;width:auto}.mm-button:active,.mm-button:hover{cursor:pointer}.mm-button[disabled]:active,.mm-button[disabled]:hover{cursor:default}.mm-button .mm-icon,.mm-button mat-icon{font-size:24px;height:24px;line-height:24px;width:24px}.mm-button__container{align-items:center;display:flex;justify-content:center}.mm-button__content-hidden,.mm-button__icon-hidden{visibility:hidden}.mm-button.mm-button--fluid{width:100%}.mm-button:not(.mm-button--icon-button){padding:0 26px}.mm-button:not(.mm-button--icon-button) .mm-button__icon{margin-right:8px}.mm-button,.mm-button--primary{background:#0064fe;color:#fff}.mm-button--primary:active,.mm-button--primary:hover,.mm-button:active,.mm-button:hover{background:#0050cb}.mm-button--secondary{background:#e6f0ff;color:#002d72}.mm-button--secondary:active,.mm-button--secondary:hover{background:#cce0ff}.mm-button--ghost,.mm-button--ghost-mute,.mm-button--ghost-warning{background:#fff;color:#0064fe}.mm-button--ghost-mute:active,.mm-button--ghost-mute:hover,.mm-button--ghost-warning:active,.mm-button--ghost-warning:hover,.mm-button--ghost:active,.mm-button--ghost:hover{background:#f2f7ff}.mm-button--ghost-mute{color:#001432;text-decoration:underline}.mm-button--ghost-mute[disabled]{text-decoration:none}.mm-button--warning{background:#de351a;color:#fff}.mm-button--warning:active,.mm-button--warning:hover{background:#b22a16}.mm-button--ghost-warning{color:#de351a}.mm-button--ghost-warning:active,.mm-button--ghost-warning:hover{background:#fff;text-decoration:underline}.mm-button--raised{box-shadow:0 5px 6px 0 #d9dce0}.mm-button--small{font-size:14px;font-weight:700;height:32px;line-height:1}.mm-button--small .mm-icon,.mm-button--small mat-icon{font-size:20px;height:20px;line-height:20px;width:20px}.mm-button--large{font-size:1.28rem;font-weight:700;height:48px;line-height:1}.mm-button--bordered{box-shadow:0 0 0 2px currentColor}.mm-button__spinner{pointer-events:none}.mm-button__spinner svg.mm-button__spinner{-webkit-animation:rotate 1.8s linear infinite;animation:rotate 1.8s linear infinite;height:21px;left:50%;margin:-10.5px 0 0 -10.5px;position:absolute;top:50%;width:21px;z-index:2}.mm-button__spinner svg.mm-button__spinner>circle{-webkit-animation:dash 1.3s ease-in-out infinite;animation:dash 1.3s ease-in-out infinite;stroke:#f2f7ff;stroke-linecap:round;stroke-width:2px}@-webkit-keyframes rotate{to{transform:rotate(1turn)}}@keyframes rotate{to{transform:rotate(1turn)}}@-webkit-keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}to{stroke-dasharray:90,150;stroke-dashoffset:-124}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}to{stroke-dasharray:90,150;stroke-dashoffset:-124}}.mm-button--ghost-mute svg.mm-button__spinner circle,.mm-button--ghost-warning svg.mm-button__spinner circle,.mm-button--ghost svg.mm-button__spinner circle,.mm-button--secondary svg.mm-button__spinner circle,.mm-button[disabled] svg.mm-button__spinner circle{stroke:#002d72}.mm-button--disabled,.mm-button--primary[disabled],.mm-button--secondary[disabled],.mm-button[disabled]{background:repeating-linear-gradient(45deg,#e9eaed,#e9eaed 9px,#d7d8db 0,#d7d8db 10px);color:#667284}.mm-button--disabled:active,.mm-button--disabled:hover,.mm-button--primary:active[disabled],.mm-button--primary:hover[disabled],.mm-button--secondary:active[disabled],.mm-button--secondary:hover[disabled],.mm-button:active[disabled],.mm-button:hover[disabled]{background:repeating-linear-gradient(45deg,#e9eaed,#e9eaed 9px,#d7d8db 0,#d7d8db 10px)}.mm-button--ghost-mute[disabled],.mm-button--ghost-warning[disabled],.mm-button--ghost[disabled],.mm-button-ghost--disabled{background:#fff!important;color:#667284!important}.mm-button--ghost-mute:active[disabled],.mm-button--ghost-mute:hover[disabled],.mm-button--ghost-warning:active[disabled],.mm-button--ghost-warning:hover[disabled],.mm-button--ghost:active[disabled],.mm-button--ghost:hover[disabled],.mm-button-ghost--disabled:active,.mm-button-ghost--disabled:hover{background:#fff;color:#667284}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { type: [{
            type: Input
        }], size: [{
            type: Input
        }], raised: [{
            type: Input
        }], iconButton: [{
            type: Input
        }], iconOffset: [{
            type: Input
        }], fluid: [{
            type: Input
        }], color: [{
            type: Input
        }], base: [{
            type: HostBinding,
            args: ['class.mm-button']
        }], loading: [{
            type: Input
        }], bordered: [{
            type: Input
        }] }); })();

class MmButtonModule {
}
MmButtonModule.ɵfac = function MmButtonModule_Factory(t) { return new (t || MmButtonModule)(); };
MmButtonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmButtonModule });
MmButtonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            QaLocatorsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmButtonModule, { declarations: function () { return [MmButtonComponent]; }, imports: function () { return [CommonModule,
        QaLocatorsModule]; }, exports: function () { return [MmButtonComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmButtonModule, [{
        type: NgModule,
        args: [{
                declarations: [MmButtonComponent],
                exports: [MmButtonComponent],
                imports: [
                    CommonModule,
                    QaLocatorsModule,
                ]
            }]
    }], null, null); })();

class MmQuantityPickerModule {
}
MmQuantityPickerModule.ɵfac = function MmQuantityPickerModule_Factory(t) { return new (t || MmQuantityPickerModule)(); };
MmQuantityPickerModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmQuantityPickerModule });
MmQuantityPickerModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            DigitOnlyModule,
            ReactiveFormsModule,
            MmButtonModule,
            QaLocatorsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmQuantityPickerModule, { declarations: function () { return [MmQuantityPickerComponent]; }, imports: function () { return [CommonModule,
        DigitOnlyModule,
        ReactiveFormsModule, MmButtonModule, QaLocatorsModule]; }, exports: function () { return [MmQuantityPickerComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmQuantityPickerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    DigitOnlyModule,
                    ReactiveFormsModule,
                    MmButtonModule,
                    QaLocatorsModule,
                ],
                exports: [MmQuantityPickerComponent],
                declarations: [MmQuantityPickerComponent]
            }]
    }], null, null); })();

class MmCheckboxComponent {
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.value = null;
        this.className = '';
        this.labelType = 'composite';
        this.change = new EventEmitter();
        this.componentUniqueId = v4();
        this.checkboxIndeterminateClassName = 'mm-checkbox--indeterminate';
        this.base = true;
        this.onTouched = () => { };
        this.propagateChange = (_) => { };
    }
    set id(value) {
        this._id = `mm-checkbox-${value}`;
    }
    get id() {
        return this._id || `mm-checkbox-${this.componentUniqueId}`;
    }
    ngOnInit() {
        this.name = this.name || this.formControlName;
    }
    ngOnChanges(changes) {
        const indeterminateChanges = changes.indeterminate;
        if (indeterminateChanges && indeterminateChanges.previousValue !== indeterminateChanges.currentValue) {
            this.updateIndeterminateState();
        }
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    writeValue(value) {
        this.checked = !!value;
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    onChange(event) {
        if (!this.disabled) {
            this.checked = !this.checked;
            this.propagateChange(this.checked);
        }
    }
    updateIndeterminateState() {
        if (this.indeterminate) {
            this.renderer.addClass(this.elementRef.nativeElement, this.checkboxIndeterminateClassName);
        }
        else {
            this.renderer.removeClass(this.elementRef.nativeElement, this.checkboxIndeterminateClassName);
        }
    }
}
MmCheckboxComponent.ɵfac = function MmCheckboxComponent_Factory(t) { return new (t || MmCheckboxComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
MmCheckboxComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmCheckboxComponent, selectors: [["mm-checkbox"]], hostVars: 6, hostBindings: function MmCheckboxComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mm-checkbox--disabled", ctx.disabled)("mm-checkbox--checked", ctx.checked)("mm-checkbox", ctx.base);
    } }, inputs: { value: "value", className: "className", labelType: "labelType", id: "id", name: "name", disabled: "disabled", checked: "checked", formControlName: "formControlName", required: "required", indeterminate: "indeterminate", short: "short" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵProvidersFeature([
            FormGroupDirective,
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: MmCheckboxComponent,
                multi: true
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c5, decls: 5, vars: 17, consts: [[3, "ngClass"], ["type", "checkbox", 1, "mm-checkbox__input", 3, "mmTestTarget", "id", "value", "name", "required", "checked", "disabled", "indeterminate", "change"], [1, "mm-checkbox__label", 3, "mmTestTarget"], [1, "mm-checkbox__checkmark"]], template: function MmCheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "input", 1);
        ɵngcc0.ɵɵlistener("change", function MmCheckboxComponent_Template_input_change_1_listener($event) { return ctx.onChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "label", 2);
        ɵngcc0.ɵɵelement(3, "span", 3);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.className);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("mmTestTarget", "input-" + ctx.name)("id", ctx.id)("value", ctx.value)("name", ctx.name)("required", ctx.required)("checked", ctx.checked)("disabled", ctx.disabled)("indeterminate", ctx.indeterminate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("mm-checkbox__label--composite", ctx.labelType === "composite")("mm-checkbox__label--short", ctx.labelType === "short")("mm-checkbox__label--public", ctx.labelType === "public");
        ɵngcc0.ɵɵproperty("mmTestTarget", "input-label-" + ctx.name);
        ɵngcc0.ɵɵattribute("for", ctx.id);
    } }, directives: [ɵngcc2.NgClass, ɵngcc3.ɵf], styles: [".mm-checkbox{-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;display:inline-block;font-size:1.14rem;line-height:1.53;position:relative;user-select:none}.mm-checkbox[disabled]{cursor:default}.mm-checkbox:active,.mm-checkbox:focus,.mm-checkbox:hover{outline:none}.mm-checkbox:active .mm-checkbox__checkmark,.mm-checkbox:focus .mm-checkbox__checkmark,.mm-checkbox:hover .mm-checkbox__checkmark{border:1px solid #0064fe;box-shadow:0 0 0 1px #0064fe,0 0 0 6px #cce0ff}.mm-checkbox .mm-checkbox__label{cursor:pointer;font-family:Lato,sans-serif;font-size:1.14rem;font-weight:700;line-height:1.53;padding:8px 0 8px 30px}.mm-checkbox .mm-checkbox__label,.mm-checkbox .mm-checkbox__label--composite{color:#002866;font-weight:700}.mm-checkbox .mm-checkbox__label--short{color:#33435b;font-weight:400}.mm-checkbox .mm-checkbox__label--public{color:#0064fe;font-weight:400}.mm-checkbox .mm-checkbox__input{cursor:pointer;height:0;margin:0;opacity:0;position:absolute;width:0}.mm-checkbox .mm-checkbox__input[disabled]{cursor:default}.mm-checkbox .mm-checkbox__checkmark{background-color:#fff;border:1px solid #99a1ad;border-radius:2px;box-shadow:0 0 0 1px #99a1ad;box-sizing:border-box;height:20px;left:0;position:absolute;top:8px;width:20px}.mm-checkbox .mm-checkbox__checkmark:after{border:solid #fff;border-width:0 2px 2px 0;content:\"\";display:none;height:12px;left:6px;position:absolute;top:0;transform:rotate(45deg);width:5px}.mm-checkbox--indeterminate .mm-checkbox__checkmark:after{border-width:0 2px 0 0;transform:rotate(90deg)}.mm-checkbox.mm-checkbox--checked .mm-checkbox__checkmark{background-color:#0064fe;border:1px solid #0064fe;box-shadow:0 0 0 1px #0064fe}.mm-checkbox.mm-checkbox--checked .mm-checkbox__checkmark:after{display:block}.mm-checkbox.mm-checkbox--disabled .mm-checkbox__label{color:#ccd0d6;cursor:default}.mm-checkbox.mm-checkbox--disabled .mm-checkbox__checkmark{background-color:#f2f3f5;border:1px solid #ccd0d6;box-shadow:0 0 0 1px #ccd0d6}.mm-checkbox.mm-checkbox--disabled.mm-checkbox--checked .mm-checkbox__checkmark{background-color:#ccd0d6}.mm-field--error .mm-checkbox:active .mm-checkbox__checkmark,.mm-field--error .mm-checkbox:focus .mm-checkbox__checkmark,.mm-field--error .mm-checkbox:hover .mm-checkbox__checkmark{border:1px solid #eb8676;box-shadow:0 0 0 1px #eb8676,0 0 0 6px #fcebe8}.mm-field--error .mm-checkbox__checkmark{border:1px solid #eb8676;box-shadow:0 0 0 1px #eb8676,0 0 0 1px #fcebe8}"], encapsulation: 2, changeDetection: 0 });
MmCheckboxComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
MmCheckboxComponent.propDecorators = {
    formControlName: [{ type: Input }],
    name: [{ type: Input }],
    value: [{ type: Input }],
    className: [{ type: Input }],
    id: [{ type: Input }],
    required: [{ type: Input }],
    checked: [{ type: Input }],
    indeterminate: [{ type: Input }],
    disabled: [{ type: Input }],
    short: [{ type: Input }],
    labelType: [{ type: Input }],
    change: [{ type: Output }],
    base: [{ type: HostBinding, args: ['class.mm-checkbox',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmCheckboxComponent, [{
        type: Component,
        args: [{
                selector: 'mm-checkbox',
                template: "<div [ngClass]=\"className\">\n    <input\n        type=\"checkbox\"\n        class=\"mm-checkbox__input\"\n        [mmTestTarget]=\"'input-' + name\"\n        [id]=\"id\"\n        [value]=\"value\"\n        [name]=\"name\"\n        [required]=\"required\"\n        [checked]=\"checked\"\n        [disabled]=\"disabled\"\n        [indeterminate]=\"indeterminate\"\n        (change)=\"onChange($event)\">\n    <label [attr.for]=\"id\"\n           [mmTestTarget]=\"'input-label-' + name\"\n           class=\"mm-checkbox__label\"\n           [class.mm-checkbox__label--composite]=\"labelType === 'composite'\"\n           [class.mm-checkbox__label--short]=\"labelType === 'short'\"\n           [class.mm-checkbox__label--public]=\"labelType === 'public'\">\n        <span class=\"mm-checkbox__checkmark\"></span>\n        <ng-content></ng-content>\n    </label>\n</div>\n",
                host: {
                    '[class.mm-checkbox--disabled]': 'disabled',
                    '[class.mm-checkbox--checked]': 'checked'
                },
                providers: [
                    FormGroupDirective,
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: MmCheckboxComponent,
                        multi: true
                    }
                ],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".mm-checkbox{-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;display:inline-block;font-size:1.14rem;line-height:1.53;position:relative;user-select:none}.mm-checkbox[disabled]{cursor:default}.mm-checkbox:active,.mm-checkbox:focus,.mm-checkbox:hover{outline:none}.mm-checkbox:active .mm-checkbox__checkmark,.mm-checkbox:focus .mm-checkbox__checkmark,.mm-checkbox:hover .mm-checkbox__checkmark{border:1px solid #0064fe;box-shadow:0 0 0 1px #0064fe,0 0 0 6px #cce0ff}.mm-checkbox .mm-checkbox__label{cursor:pointer;font-family:Lato,sans-serif;font-size:1.14rem;font-weight:700;line-height:1.53;padding:8px 0 8px 30px}.mm-checkbox .mm-checkbox__label,.mm-checkbox .mm-checkbox__label--composite{color:#002866;font-weight:700}.mm-checkbox .mm-checkbox__label--short{color:#33435b;font-weight:400}.mm-checkbox .mm-checkbox__label--public{color:#0064fe;font-weight:400}.mm-checkbox .mm-checkbox__input{cursor:pointer;height:0;margin:0;opacity:0;position:absolute;width:0}.mm-checkbox .mm-checkbox__input[disabled]{cursor:default}.mm-checkbox .mm-checkbox__checkmark{background-color:#fff;border:1px solid #99a1ad;border-radius:2px;box-shadow:0 0 0 1px #99a1ad;box-sizing:border-box;height:20px;left:0;position:absolute;top:8px;width:20px}.mm-checkbox .mm-checkbox__checkmark:after{border:solid #fff;border-width:0 2px 2px 0;content:\"\";display:none;height:12px;left:6px;position:absolute;top:0;transform:rotate(45deg);width:5px}.mm-checkbox--indeterminate .mm-checkbox__checkmark:after{border-width:0 2px 0 0;transform:rotate(90deg)}.mm-checkbox.mm-checkbox--checked .mm-checkbox__checkmark{background-color:#0064fe;border:1px solid #0064fe;box-shadow:0 0 0 1px #0064fe}.mm-checkbox.mm-checkbox--checked .mm-checkbox__checkmark:after{display:block}.mm-checkbox.mm-checkbox--disabled .mm-checkbox__label{color:#ccd0d6;cursor:default}.mm-checkbox.mm-checkbox--disabled .mm-checkbox__checkmark{background-color:#f2f3f5;border:1px solid #ccd0d6;box-shadow:0 0 0 1px #ccd0d6}.mm-checkbox.mm-checkbox--disabled.mm-checkbox--checked .mm-checkbox__checkmark{background-color:#ccd0d6}.mm-field--error .mm-checkbox:active .mm-checkbox__checkmark,.mm-field--error .mm-checkbox:focus .mm-checkbox__checkmark,.mm-field--error .mm-checkbox:hover .mm-checkbox__checkmark{border:1px solid #eb8676;box-shadow:0 0 0 1px #eb8676,0 0 0 6px #fcebe8}.mm-field--error .mm-checkbox__checkmark{border:1px solid #eb8676;box-shadow:0 0 0 1px #eb8676,0 0 0 1px #fcebe8}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { value: [{
            type: Input
        }], className: [{
            type: Input
        }], labelType: [{
            type: Input
        }], change: [{
            type: Output
        }], base: [{
            type: HostBinding,
            args: ['class.mm-checkbox']
        }], id: [{
            type: Input
        }], name: [{
            type: Input
        }], disabled: [{
            type: Input
        }], checked: [{
            type: Input
        }], formControlName: [{
            type: Input
        }], required: [{
            type: Input
        }], indeterminate: [{
            type: Input
        }], short: [{
            type: Input
        }] }); })();

class MmCheckboxModule {
}
MmCheckboxModule.ɵfac = function MmCheckboxModule_Factory(t) { return new (t || MmCheckboxModule)(); };
MmCheckboxModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmCheckboxModule });
MmCheckboxModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            QaLocatorsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmCheckboxModule, { declarations: function () { return [MmCheckboxComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        QaLocatorsModule]; }, exports: function () { return [MmCheckboxComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmCheckboxModule, [{
        type: NgModule,
        args: [{
                declarations: [MmCheckboxComponent],
                exports: [MmCheckboxComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    QaLocatorsModule,
                ]
            }]
    }], null, null); })();

class MmSwitchComponent {
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.value = null;
        this.className = '';
        this.change = new EventEmitter();
        this.componentUniqueId = v4();
        this.switchIndeterminateClassName = 'mm-switch--indeterminate';
        this.base = true;
        this.onTouched = () => { };
        this.propagateChange = (_) => { };
    }
    set id(value) {
        this._id = `mm-switch-${value}`;
    }
    get id() {
        return this._id || `mm-switch-${this.componentUniqueId}`;
    }
    ngOnInit() {
        this.name = this.name || this.formControlName;
    }
    ngOnChanges(changes) {
        const indeterminateChanges = changes.indeterminate;
        if (indeterminateChanges && indeterminateChanges.previousValue !== indeterminateChanges.currentValue) {
            this.updateIndeterminateState();
        }
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    writeValue(value) {
        this.checked = !!value;
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    onChange(event) {
        if (!this.disabled) {
            this.checked = !this.checked;
            this.propagateChange(this.checked);
        }
    }
    updateIndeterminateState() {
        if (this.indeterminate) {
            this.renderer.addClass(this.elementRef.nativeElement, this.switchIndeterminateClassName);
        }
        else {
            this.renderer.removeClass(this.elementRef.nativeElement, this.switchIndeterminateClassName);
        }
    }
}
MmSwitchComponent.ɵfac = function MmSwitchComponent_Factory(t) { return new (t || MmSwitchComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
MmSwitchComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmSwitchComponent, selectors: [["mm-switch"]], hostVars: 6, hostBindings: function MmSwitchComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mm-switch--disabled", ctx.disabled)("mm-switch--checked", ctx.checked)("mm-switch", ctx.base);
    } }, inputs: { value: "value", className: "className", id: "id", name: "name", disabled: "disabled", checked: "checked", formControlName: "formControlName", required: "required", indeterminate: "indeterminate", short: "short" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵProvidersFeature([
            FormGroupDirective,
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: MmSwitchComponent,
                multi: true
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 9, consts: [[3, "ngClass"], [1, "switch"], ["type", "checkbox", 1, "mm-switch__input", 3, "mmTestTarget", "id", "value", "name", "required", "checked", "disabled", "indeterminate", "change"], [1, "mm-switch__slider", "round"]], template: function MmSwitchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "label", 1);
        ɵngcc0.ɵɵelementStart(2, "input", 2);
        ɵngcc0.ɵɵlistener("change", function MmSwitchComponent_Template_input_change_2_listener($event) { return ctx.onChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(3, "span", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.className);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("mmTestTarget", "input-" + ctx.name)("id", ctx.id)("value", ctx.value)("name", ctx.name)("required", ctx.required)("checked", ctx.checked)("disabled", ctx.disabled)("indeterminate", ctx.indeterminate);
    } }, directives: [ɵngcc2.NgClass, ɵngcc3.ɵf], styles: [".mm-switch .switch{display:inline-block;height:40px;position:relative;width:70px}.mm-switch .switch input{height:0;opacity:0;width:0}.mm-switch .mm-switch__slider{background-color:#fff;border:1px solid #0064fe;bottom:0;box-shadow:0 0 0 1px #0064fe;cursor:pointer;left:0;position:absolute;right:0;top:0;transition:.4s}.mm-switch .mm-switch__slider:before{background-color:#0064fe;bottom:4px;content:\"\";height:30px;left:4px;position:absolute;transition:.4s;width:30px}.mm-switch input:checked+.mm-switch__slider{background-color:#fff}.mm-switch input:checked+.mm-switch__slider:before{transform:translateX(30px)}.mm-switch .mm-switch__slider.round{border-radius:34px}.mm-switch .mm-switch__slider.round:before{border-radius:50%}.mm-switch--indeterminate .mm-switch__slider:after{border-width:0 2px 0 0;transform:rotate(90deg)}.mm-switch.mm-switch--disabled .mm-switch__slider{background-color:#f2f3f5;border:1px solid #ccd0d6;box-shadow:0 0 0 1px #ccd0d6}.mm-switch.mm-switch--disabled.mm-switch--checked .mm-switch__slider{background-color:#ccd0d6}.mm-field--error .mm-switch:active .mm-switch__slider,.mm-field--error .mm-switch:focus .mm-switch__slider,.mm-field--error .mm-switch:hover .mm-switch__slider{border:1px solid #eb8676;box-shadow:0 0 0 1px #eb8676,0 0 0 6px #fcebe8}.mm-field--error .mm-switch__slider{border:1px solid #eb8676;box-shadow:0 0 0 1px #eb8676,0 0 0 1px #fcebe8}"], encapsulation: 2, changeDetection: 0 });
MmSwitchComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
MmSwitchComponent.propDecorators = {
    formControlName: [{ type: Input }],
    name: [{ type: Input }],
    value: [{ type: Input }],
    className: [{ type: Input }],
    id: [{ type: Input }],
    required: [{ type: Input }],
    checked: [{ type: Input }],
    indeterminate: [{ type: Input }],
    disabled: [{ type: Input }],
    short: [{ type: Input }],
    change: [{ type: Output }],
    base: [{ type: HostBinding, args: ['class.mm-switch',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmSwitchComponent, [{
        type: Component,
        args: [{
                selector: 'mm-switch',
                template: "<div [ngClass]=\"className\">\n    <label class=\"switch\">\n        <input\n            type=\"checkbox\"\n            class=\"mm-switch__input\"\n            [mmTestTarget]=\"'input-' + name\"\n            [id]=\"id\"\n            [value]=\"value\"\n            [name]=\"name\"\n            [required]=\"required\"\n            [checked]=\"checked\"\n            [disabled]=\"disabled\"\n            [indeterminate]=\"indeterminate\"\n            (change)=\"onChange($event)\">  \n        <span class=\"mm-switch__slider round\"></span>\n      </label>\n</div>\n\n",
                host: {
                    '[class.mm-switch--disabled]': 'disabled',
                    '[class.mm-switch--checked]': 'checked'
                },
                providers: [
                    FormGroupDirective,
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: MmSwitchComponent,
                        multi: true
                    }
                ],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".mm-switch .switch{display:inline-block;height:40px;position:relative;width:70px}.mm-switch .switch input{height:0;opacity:0;width:0}.mm-switch .mm-switch__slider{background-color:#fff;border:1px solid #0064fe;bottom:0;box-shadow:0 0 0 1px #0064fe;cursor:pointer;left:0;position:absolute;right:0;top:0;transition:.4s}.mm-switch .mm-switch__slider:before{background-color:#0064fe;bottom:4px;content:\"\";height:30px;left:4px;position:absolute;transition:.4s;width:30px}.mm-switch input:checked+.mm-switch__slider{background-color:#fff}.mm-switch input:checked+.mm-switch__slider:before{transform:translateX(30px)}.mm-switch .mm-switch__slider.round{border-radius:34px}.mm-switch .mm-switch__slider.round:before{border-radius:50%}.mm-switch--indeterminate .mm-switch__slider:after{border-width:0 2px 0 0;transform:rotate(90deg)}.mm-switch.mm-switch--disabled .mm-switch__slider{background-color:#f2f3f5;border:1px solid #ccd0d6;box-shadow:0 0 0 1px #ccd0d6}.mm-switch.mm-switch--disabled.mm-switch--checked .mm-switch__slider{background-color:#ccd0d6}.mm-field--error .mm-switch:active .mm-switch__slider,.mm-field--error .mm-switch:focus .mm-switch__slider,.mm-field--error .mm-switch:hover .mm-switch__slider{border:1px solid #eb8676;box-shadow:0 0 0 1px #eb8676,0 0 0 6px #fcebe8}.mm-field--error .mm-switch__slider{border:1px solid #eb8676;box-shadow:0 0 0 1px #eb8676,0 0 0 1px #fcebe8}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { value: [{
            type: Input
        }], className: [{
            type: Input
        }], change: [{
            type: Output
        }], base: [{
            type: HostBinding,
            args: ['class.mm-switch']
        }], id: [{
            type: Input
        }], name: [{
            type: Input
        }], disabled: [{
            type: Input
        }], checked: [{
            type: Input
        }], formControlName: [{
            type: Input
        }], required: [{
            type: Input
        }], indeterminate: [{
            type: Input
        }], short: [{
            type: Input
        }] }); })();

class MmSwitchModule {
}
MmSwitchModule.ɵfac = function MmSwitchModule_Factory(t) { return new (t || MmSwitchModule)(); };
MmSwitchModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmSwitchModule });
MmSwitchModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            QaLocatorsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmSwitchModule, { declarations: function () { return [MmSwitchComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        QaLocatorsModule]; }, exports: function () { return [MmSwitchComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmSwitchModule, [{
        type: NgModule,
        args: [{
                declarations: [MmSwitchComponent],
                exports: [MmSwitchComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    QaLocatorsModule,
                ]
            }]
    }], null, null); })();

class MmRadioComponent {
    constructor() {
        this.type = 'normal';
        this.labelType = 'composite';
        this.selected = false;
        this.className = '';
        this.componentUniqueId = v4();
        this.onTouched = () => { };
        this.propagateChange = (_) => { };
    }
    set id(value) {
        this._id = `mm-radio-${value}`;
    }
    get id() {
        return this._id || `mm-radio-${this.componentUniqueId}`;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    writeValue(value) {
        this.selected = this.value === value;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    onChange(event) {
        if (!this.disabled) {
            this.propagateChange(this.selected);
        }
    }
}
MmRadioComponent.ɵfac = function MmRadioComponent_Factory(t) { return new (t || MmRadioComponent)(); };
MmRadioComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmRadioComponent, selectors: [["mm-radio"]], hostVars: 2, hostBindings: function MmRadioComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mm-radio--disabled", ctx.disabled);
    } }, inputs: { type: "type", labelType: "labelType", selected: "selected", className: "className", id: "id", disabled: "disabled", formControlName: "formControlName", required: "required", value: "value" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => MmRadioComponent),
                multi: true
            }
        ], [{ provide: ControlContainer, useExisting: FormGroupDirective }])], ngContentSelectors: _c5, decls: 8, vars: 21, consts: [[1, "mm-radio", 3, "ngClass"], ["type", "radio", 1, "mm-radio__input", 3, "mmTestTarget", "id", "value", "checked", "required", "disabled", "formControlName"], ["mmRadio", ""], [1, "mm-radio__label", 3, "mmTestTarget"], [3, "ngClass", "mmTestTarget"], ["class", "mm-radio__dot__bullet", 4, "ngIf"], [1, "mm-radio__dot__bullet"]], template: function MmRadioComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "input", 1, 2);
        ɵngcc0.ɵɵelementStart(3, "label", 3);
        ɵngcc0.ɵɵelementStart(4, "span");
        ɵngcc0.ɵɵelementStart(5, "span", 4);
        ɵngcc0.ɵɵtemplate(6, MmRadioComponent_span_6_Template, 1, 0, "span", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.className);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("formControlName", ctx.formControlName);
        ɵngcc0.ɵɵproperty("mmTestTarget", "radio-input")("id", ctx.id)("value", ctx.value)("checked", ctx.selected)("required", ctx.required)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("mm-radio__label--composite", ctx.labelType === "composite")("mm-radio__label--public", ctx.labelType === "public")("mm-radio__label--short", ctx.labelType === "short")("mm-radio__label--flat", ctx.labelType === "flat");
        ɵngcc0.ɵɵproperty("mmTestTarget", "radio-label");
        ɵngcc0.ɵɵattribute("for", ctx.id);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.type === "flat" ? "mm-radio__line" : "mm-radio__dot")("mmTestTarget", "radio-dot");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "normal");
    } }, directives: [ɵngcc2.NgClass, ɵngcc1.RadioControlValueAccessor, ɵngcc1.DefaultValueAccessor, ɵngcc3.ɵf, ɵngcc1.RequiredValidator, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName, ɵngcc2.NgIf], styles: [".mm-radio{-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;align-items:center;box-sizing:border-box;display:flex;flex-direction:row;padding:8px 0;place-content:center flex-start;user-select:none}.mm-radio[disabled]{cursor:default}.mm-radio__input{cursor:pointer;height:0;margin:0;opacity:0;width:0}.mm-radio__input[disabled]{cursor:default}.mm-radio__label{align-items:center;cursor:pointer;display:flex;font-family:Lato,sans-serif;font-size:1.14rem;font-weight:700;line-height:1.53;place-content:center flex-start}.mm-radio__label,.mm-radio__label--composite{color:#002866;font-weight:700}.mm-radio__label--short{color:#33435b;font-weight:400}.mm-radio__label--public{color:#0064fe;font-weight:400}.mm-radio__label--flat{color:#001432;font-weight:400}.mm-radio__label--flat:hover{color:#0064fe;font-weight:900}.mm-radio__line{border-left:4px solid #002d72;height:24px;padding-right:10px;visibility:hidden;width:0}.mm-radio__dot{align-items:center;background-color:#fff;border:1px solid #99a1ad;border-radius:10px;box-shadow:0 0 0 1px #99a1ad;display:flex;height:18px;justify-content:center;margin-right:10px;width:18px}.mm-radio__dot__bullet{background-color:#0064fe;border:1px solid #0064fe;border-radius:6px;display:none;height:8px;width:8px}.mm-radio:active,.mm-radio:focus,.mm-radio:hover{outline:none}.mm-radio:active .mm-radio__dot,.mm-radio:focus .mm-radio__dot,.mm-radio:hover .mm-radio__dot{border:1px solid #0064fe;box-shadow:0 0 0 1px #0064fe,0 0 0 6px #cce0ff}.mm-radio__input:checked+.mm-radio__label--flat{font-weight:900}.mm-radio__input:checked+.mm-radio__label--flat:hover{color:#001432}.mm-radio__input:checked+.mm-radio__label .mm-radio__line{visibility:visible}.mm-radio__input:checked+.mm-radio__label .mm-radio__dot{border:1px solid #0064fe;box-shadow:0 0 0 1px #0064fe}.mm-radio__input:checked+.mm-radio__label .mm-radio__dot__bullet{display:inline-block}.mm-radio--disabled{pointer-events:none}.mm-radio--disabled .mm-radio__label{color:#ccd0d6;cursor:default}.mm-radio--disabled .mm-radio__line{border-left:4px solid #ccd0d6}.mm-radio--disabled .mm-radio__dot{background-color:#f2f3f5;border:1px solid #ccd0d6;box-shadow:0 0 0 1px #ccd0d6}.mm-radio--disabled .mm-radio__dot__bullet{background-color:#ccd0d6;border:1px solid #ccd0d6}.mm-radio--disabled .mm-radio__input:checked+.mm-radio__label--flat{font-weight:900}.mm-radio--disabled .mm-radio__input:checked+.mm-radio__label--flat:hover{color:#001432}.mm-radio--disabled .mm-radio__input:checked+.mm-radio__label .mm-radio__dot{border:1px solid #ccd0d6;box-shadow:0 0 0 1px #ccd0d6}.mm-radio--disabled .mm-radio__input:checked+.mm-radio__label .mm-radio__dot__bullet{background-color:#ccd0d6;border:1px solid #ccd0d6;display:inline-block}.mm-field--error .mm-radio:active .mm-radio__dot,.mm-field--error .mm-radio:focus .mm-radio__dot,.mm-field--error .mm-radio:hover .mm-radio__dot{border:1px solid #eb8676;box-shadow:0 0 0 1px #eb8676,0 0 0 6px #fcebe8}.mm-field--error .mm-radio__dot{border:1px solid #eb8676;box-shadow:0 0 0 1px #eb8676,0 0 0 1px #fcebe8}"], encapsulation: 2, changeDetection: 0 });
MmRadioComponent.ctorParameters = () => [];
MmRadioComponent.propDecorators = {
    type: [{ type: Input }],
    labelType: [{ type: Input }],
    formControlName: [{ type: Input }],
    disabled: [{ type: Input }],
    required: [{ type: Input }],
    selected: [{ type: Input }],
    className: [{ type: Input }],
    value: [{ type: Input }],
    id: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmRadioComponent, [{
        type: Component,
        args: [{
                selector: 'mm-radio',
                template: "<div class=\"mm-radio\" [ngClass]=\"className\">\n  <input\n    #mmRadio\n    type=\"radio\"\n    class=\"mm-radio__input\"\n    [mmTestTarget]=\"'radio-input'\"\n    [id]=\"id\"\n    [value]=\"value\"\n    [checked]=\"selected\"\n    [required]=\"required\"\n    [disabled]=\"disabled\"\n    formControlName=\"{{ formControlName }}\"\n  />\n  <label\n    [attr.for]=\"id\"\n    [mmTestTarget]=\"'radio-label'\"\n    class=\"mm-radio__label\"\n    [class.mm-radio__label--composite]=\"labelType === 'composite'\"\n    [class.mm-radio__label--public]=\"labelType === 'public'\"\n    [class.mm-radio__label--short]=\"labelType === 'short'\"\n    [class.mm-radio__label--flat]=\"labelType === 'flat'\"\n  >\n    <span>\n      <span\n        [ngClass]=\"type === 'flat' ? 'mm-radio__line' : 'mm-radio__dot'\"\n        [mmTestTarget]=\"'radio-dot'\"\n      >\n        <span\n          *ngIf=\"type === 'normal'\"\n          class=\"mm-radio__dot__bullet\"\n        ></span> </span\n    ></span>\n    <ng-content></ng-content>\n  </label>\n</div>\n",
                host: {
                    '[class.mm-radio--disabled]': 'disabled'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => MmRadioComponent),
                        multi: true
                    }
                ],
                viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".mm-radio{-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;align-items:center;box-sizing:border-box;display:flex;flex-direction:row;padding:8px 0;place-content:center flex-start;user-select:none}.mm-radio[disabled]{cursor:default}.mm-radio__input{cursor:pointer;height:0;margin:0;opacity:0;width:0}.mm-radio__input[disabled]{cursor:default}.mm-radio__label{align-items:center;cursor:pointer;display:flex;font-family:Lato,sans-serif;font-size:1.14rem;font-weight:700;line-height:1.53;place-content:center flex-start}.mm-radio__label,.mm-radio__label--composite{color:#002866;font-weight:700}.mm-radio__label--short{color:#33435b;font-weight:400}.mm-radio__label--public{color:#0064fe;font-weight:400}.mm-radio__label--flat{color:#001432;font-weight:400}.mm-radio__label--flat:hover{color:#0064fe;font-weight:900}.mm-radio__line{border-left:4px solid #002d72;height:24px;padding-right:10px;visibility:hidden;width:0}.mm-radio__dot{align-items:center;background-color:#fff;border:1px solid #99a1ad;border-radius:10px;box-shadow:0 0 0 1px #99a1ad;display:flex;height:18px;justify-content:center;margin-right:10px;width:18px}.mm-radio__dot__bullet{background-color:#0064fe;border:1px solid #0064fe;border-radius:6px;display:none;height:8px;width:8px}.mm-radio:active,.mm-radio:focus,.mm-radio:hover{outline:none}.mm-radio:active .mm-radio__dot,.mm-radio:focus .mm-radio__dot,.mm-radio:hover .mm-radio__dot{border:1px solid #0064fe;box-shadow:0 0 0 1px #0064fe,0 0 0 6px #cce0ff}.mm-radio__input:checked+.mm-radio__label--flat{font-weight:900}.mm-radio__input:checked+.mm-radio__label--flat:hover{color:#001432}.mm-radio__input:checked+.mm-radio__label .mm-radio__line{visibility:visible}.mm-radio__input:checked+.mm-radio__label .mm-radio__dot{border:1px solid #0064fe;box-shadow:0 0 0 1px #0064fe}.mm-radio__input:checked+.mm-radio__label .mm-radio__dot__bullet{display:inline-block}.mm-radio--disabled{pointer-events:none}.mm-radio--disabled .mm-radio__label{color:#ccd0d6;cursor:default}.mm-radio--disabled .mm-radio__line{border-left:4px solid #ccd0d6}.mm-radio--disabled .mm-radio__dot{background-color:#f2f3f5;border:1px solid #ccd0d6;box-shadow:0 0 0 1px #ccd0d6}.mm-radio--disabled .mm-radio__dot__bullet{background-color:#ccd0d6;border:1px solid #ccd0d6}.mm-radio--disabled .mm-radio__input:checked+.mm-radio__label--flat{font-weight:900}.mm-radio--disabled .mm-radio__input:checked+.mm-radio__label--flat:hover{color:#001432}.mm-radio--disabled .mm-radio__input:checked+.mm-radio__label .mm-radio__dot{border:1px solid #ccd0d6;box-shadow:0 0 0 1px #ccd0d6}.mm-radio--disabled .mm-radio__input:checked+.mm-radio__label .mm-radio__dot__bullet{background-color:#ccd0d6;border:1px solid #ccd0d6;display:inline-block}.mm-field--error .mm-radio:active .mm-radio__dot,.mm-field--error .mm-radio:focus .mm-radio__dot,.mm-field--error .mm-radio:hover .mm-radio__dot{border:1px solid #eb8676;box-shadow:0 0 0 1px #eb8676,0 0 0 6px #fcebe8}.mm-field--error .mm-radio__dot{border:1px solid #eb8676;box-shadow:0 0 0 1px #eb8676,0 0 0 1px #fcebe8}"]
            }]
    }], function () { return []; }, { type: [{
            type: Input
        }], labelType: [{
            type: Input
        }], selected: [{
            type: Input
        }], className: [{
            type: Input
        }], id: [{
            type: Input
        }], disabled: [{
            type: Input
        }], formControlName: [{
            type: Input
        }], required: [{
            type: Input
        }], value: [{
            type: Input
        }] }); })();

class MmRadioModule {
}
MmRadioModule.ɵfac = function MmRadioModule_Factory(t) { return new (t || MmRadioModule)(); };
MmRadioModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmRadioModule });
MmRadioModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            ReactiveFormsModule,
            QaLocatorsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmRadioModule, { declarations: function () { return [MmRadioComponent]; }, imports: function () { return [CommonModule,
        ReactiveFormsModule,
        QaLocatorsModule]; }, exports: function () { return [MmRadioComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmRadioModule, [{
        type: NgModule,
        args: [{
                declarations: [MmRadioComponent],
                exports: [MmRadioComponent],
                imports: [
                    CommonModule,
                    ReactiveFormsModule,
                    QaLocatorsModule,
                ]
            }]
    }], null, null); })();

class MmRadioItemCommonComponent {
    constructor(elementRef, renderer, changeDetectorRef) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.changeDetectorRef = changeDetectorRef;
        this.select$ = new Subject();
        this.checked = false;
        this.disabled = false;
        this.componentUniqueId = v4();
        this.onChange = () => null;
        this.onTouched = () => null;
    }
    set id(value) {
        this._id = `mm-radio-${value}`;
    }
    get id() {
        return this._id || `mm-radio-${this.componentUniqueId}`;
    }
    onClick(event) {
        event.stopPropagation();
        event.preventDefault();
        if (!this.disabled && !this.checked) {
            this.select$.next(this);
            this.checked = true;
            this.onChange(true);
        }
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.changeDetectorRef.markForCheck();
    }
    markForCheck() {
        this.changeDetectorRef.markForCheck();
    }
    writeValue(value) {
        this.checked = value;
        this.changeDetectorRef.markForCheck();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
}
MmRadioItemCommonComponent.ɵfac = function MmRadioItemCommonComponent_Factory(t) { return new (t || MmRadioItemCommonComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
MmRadioItemCommonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmRadioItemCommonComponent, selectors: [["mm-radio-item-common"]], viewQuery: function MmRadioItemCommonComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c6, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.radioElement = _t.first);
    } }, hostBindings: function MmRadioItemCommonComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function MmRadioItemCommonComponent_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } }, inputs: { disabled: "disabled", id: "id", value: "value" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => MmRadioItemCommonComponent),
                multi: true
            }
        ])], ngContentSelectors: _c5, decls: 4, vars: 5, consts: [["type", "radio", 3, "id", "disabled", "checked"], ["radioElement", ""]], template: function MmRadioItemCommonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelement(0, "input", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.id)("disabled", ctx.disabled)("checked", ctx.checked);
        ɵngcc0.ɵɵattribute("name", ctx.name);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("for", ctx.id);
    } }, encapsulation: 2, changeDetection: 0 });
MmRadioItemCommonComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: ChangeDetectorRef }
];
MmRadioItemCommonComponent.propDecorators = {
    value: [{ type: Input }],
    disabled: [{ type: Input }],
    id: [{ type: Input }],
    radioElement: [{ type: ViewChild, args: ['radioElement',] }],
    onClick: [{ type: HostListener, args: ['click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmRadioItemCommonComponent, [{
        type: Component,
        args: [{
                selector: 'mm-radio-item-common',
                template: "<input #radioElement\n       type=\"radio\"\n       [id]=\"id\"\n       [disabled]=\"disabled\"\n       [checked]=\"checked\"\n       [attr.name]=\"name\">\n<label [attr.for]=\"id\">\n    <ng-content></ng-content>\n</label>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => MmRadioItemCommonComponent),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }]; }, { disabled: [{
            type: Input
        }], id: [{
            type: Input
        }], onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], value: [{
            type: Input
        }], radioElement: [{
            type: ViewChild,
            args: ['radioElement']
        }] }); })();

class MmRadioGroupItemComponent extends MmRadioItemCommonComponent {
    constructor() {
        super(...arguments);
        this.base = true;
        this.checked = false;
        this.disabled = false;
    }
}
MmRadioGroupItemComponent.ɵfac = function MmRadioGroupItemComponent_Factory(t) { return ɵMmRadioGroupItemComponent_BaseFactory(t || MmRadioGroupItemComponent); };
MmRadioGroupItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmRadioGroupItemComponent, selectors: [["mm-radio-group-item"]], viewQuery: function MmRadioGroupItemComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c6, 3);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.radioElement = _t.first);
    } }, hostVars: 6, hostBindings: function MmRadioGroupItemComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mm-radio-group-item__wrapper", ctx.base)("mm-radio-group-item--checked", ctx.checked)("mm-radio-group-item--disabled", ctx.disabled);
    } }, inputs: { value: "value" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => MmRadioGroupItemComponent),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c5, decls: 4, vars: 7, consts: [["type", "radio", 1, "mm-radio-group-item", 3, "mmTestTarget", "id", "disabled", "checked"], ["radioElement", ""], [1, "mm-radio-group-item-label", 3, "mmTestTarget"]], template: function MmRadioGroupItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelement(0, "input", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "label", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("mmTestTarget", "radio-group-item")("id", ctx.id)("disabled", ctx.disabled)("checked", ctx.checked);
        ɵngcc0.ɵɵattribute("name", ctx.name);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("mmTestTarget", "radio-group-item-label");
        ɵngcc0.ɵɵattribute("for", ctx.id);
    } }, directives: [ɵngcc3.ɵf], encapsulation: 2, changeDetection: 0 });
MmRadioGroupItemComponent.propDecorators = {
    value: [{ type: Input }],
    radioElement: [{ type: ViewChild, args: ['radioElement', { static: true },] }],
    base: [{ type: HostBinding, args: ['class.mm-radio-group-item__wrapper',] }],
    checked: [{ type: HostBinding, args: ['class.mm-radio-group-item--checked',] }],
    disabled: [{ type: HostBinding, args: ['class.mm-radio-group-item--disabled',] }]
};
const ɵMmRadioGroupItemComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MmRadioGroupItemComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmRadioGroupItemComponent, [{
        type: Component,
        args: [{
                selector: 'mm-radio-group-item',
                template: "<input #radioElement\n       [mmTestTarget]=\"'radio-group-item'\"\n       type=\"radio\"\n       class=\"mm-radio-group-item\"\n       [id]=\"id\"\n       [disabled]=\"disabled\"\n       [checked]=\"checked\"\n       [attr.name]=\"name\">\n<label [attr.for]=\"id\"\n       class=\"mm-radio-group-item-label\"\n       [mmTestTarget]=\"'radio-group-item-label'\">\n    <ng-content></ng-content>\n</label>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => MmRadioGroupItemComponent),
                        multi: true
                    }
                ]
            }]
    }], null, { base: [{
            type: HostBinding,
            args: ['class.mm-radio-group-item__wrapper']
        }], checked: [{
            type: HostBinding,
            args: ['class.mm-radio-group-item--checked']
        }], disabled: [{
            type: HostBinding,
            args: ['class.mm-radio-group-item--disabled']
        }], value: [{
            type: Input
        }], radioElement: [{
            type: ViewChild,
            args: ['radioElement', { static: true }]
        }] }); })();

class MmRadioGroupCommonComponent {
    constructor(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.className = '';
        this.componentUniqueId = v4();
        this.destroy$ = new Subject();
        this.onChange = () => null;
        this.onTouched = () => { };
    }
    set id(value) {
        this._id = `mm-radio-${value}`;
    }
    get id() {
        return this._id || `mm-radio-${this.componentUniqueId}`;
    }
    ngAfterContentInit() {
        const radiosChanges$ = this.radios.changes.pipe(startWith(null), tap(() => this.updateChildrenStatus()));
        combineLatest(radiosChanges$, merge(...this.radios.map(radio => radio.select$)))
            .pipe(takeUntil(this.destroy$)).subscribe(([_, radio]) => {
            if (this.value !== radio.value) {
                this.value = radio.value;
                this.updateChildrenStatus();
                this.onChange(this.value);
            }
        });
    }
    ngOnChanges(changes) {
        if (changes.disabled || changes.name) {
            this.updateChildrenStatus();
        }
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    writeValue(value) {
        this.value = value;
        this.updateChildrenStatus();
        this.changeDetectorRef.markForCheck();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.changeDetectorRef.markForCheck();
    }
    updateChildrenStatus() {
        if (this.radios) {
            this.radios.forEach(radio => {
                radio.checked = radio.value === this.value;
                if (this.disabled) {
                    radio.disabled = this.disabled;
                }
                if (this.name) {
                    radio.name = this.name;
                }
                this.changeDetectorRef.detectChanges();
            });
        }
    }
}
MmRadioGroupCommonComponent.ɵfac = function MmRadioGroupCommonComponent_Factory(t) { return new (t || MmRadioGroupCommonComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
MmRadioGroupCommonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmRadioGroupCommonComponent, selectors: [["mm-radio-group-common"]], contentQueries: function MmRadioGroupCommonComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MmRadioItemCommonComponent, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.radios = _t);
    } }, inputs: { className: "className", id: "id", disabled: "disabled", name: "name" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => MmRadioGroupCommonComponent),
                multi: true
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c8, decls: 6, vars: 2, consts: [[3, "ngClass", "id"], [1, "mm-radio-state__container"]], template: function MmRadioGroupCommonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c7);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementStart(2, "div");
        ɵngcc0.ɵɵprojection(3, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 1);
        ɵngcc0.ɵɵprojection(5, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.className)("id", ctx.id);
    } }, directives: [ɵngcc2.NgClass], encapsulation: 2, changeDetection: 0 });
MmRadioGroupCommonComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
MmRadioGroupCommonComponent.propDecorators = {
    disabled: [{ type: Input }],
    name: [{ type: Input }],
    className: [{ type: Input }],
    id: [{ type: Input }],
    radios: [{ type: ContentChildren, args: [forwardRef(() => MmRadioItemCommonComponent),
                { descendants: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmRadioGroupCommonComponent, [{
        type: Component,
        args: [{
                selector: 'mm-radio-group-common',
                template: "<div [ngClass]=\"className\"\n     [id]=\"id\">\n    <ng-content select=\"label\"></ng-content>\n    <div>\n        <ng-content></ng-content>\n    </div>\n    <div class=\"mm-radio-state__container\">\n        <ng-content select=\"mm-error\"></ng-content>\n    </div>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => MmRadioGroupCommonComponent),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { className: [{
            type: Input
        }], id: [{
            type: Input
        }], disabled: [{
            type: Input
        }], name: [{
            type: Input
        }], radios: [{
            type: ContentChildren,
            args: [forwardRef(() => MmRadioItemCommonComponent),
                { descendants: true }]
        }] }); })();

class MmRadioGroupComponent extends MmRadioGroupCommonComponent {
    constructor() {
        super(...arguments);
        this.className = '';
        this.labelType = 'heavy';
        this.base = true;
    }
    ngOnInit() {
        this.labelClassMap = {
            [`mm-radio-group__label--${this.labelType}`]: this.labelType
        };
    }
}
MmRadioGroupComponent.ɵfac = function MmRadioGroupComponent_Factory(t) { return ɵMmRadioGroupComponent_BaseFactory(t || MmRadioGroupComponent); };
MmRadioGroupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmRadioGroupComponent, selectors: [["mm-radio-group"]], contentQueries: function MmRadioGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MmRadioGroupItemComponent, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.radios = _t);
    } }, hostVars: 2, hostBindings: function MmRadioGroupComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mm-radio-group", ctx.base);
    } }, inputs: { className: "className", labelType: "labelType", disabled: "disabled", name: "name" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => MmRadioGroupComponent),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c8, decls: 6, vars: 5, consts: [[3, "ngClass", "id"], [1, "mm-radio-group__container", 3, "ngClass", "mmTestTarget"], [1, "mm-radio-state__container", 3, "mmTestTarget"]], template: function MmRadioGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c7);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵprojection(3, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵprojection(5, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.className)("id", ctx.id);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.labelClassMap)("mmTestTarget", "radio-group-container");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("mmTestTarget", "radio-state-container");
    } }, directives: [ɵngcc2.NgClass, ɵngcc3.ɵf], styles: [".mm-radio-group-item__wrapper{display:flex;justify-content:flex-start;padding:0 6px 0 20px;position:relative}.mm-radio-group-item__wrapper:active:before,.mm-radio-group-item__wrapper:focus:before,.mm-radio-group-item__wrapper:hover:before{border:1px solid #0064fe;box-shadow:0 0 0 1px #0064fe,0 0 0 6px #cce0ff}.mm-radio-group-item__wrapper:before{border:1px solid #99a1ad;border-radius:10px;box-shadow:0 0 0 1px #99a1ad;content:\"\";cursor:pointer;display:block;height:18px;left:0;position:absolute;top:10px;width:18px}.mm-radio-group-item__wrapper:after{background-color:#0064fe;border:1px solid #0064fe;border-radius:6px;content:\"\";cursor:pointer;display:none;height:8px;left:5px;position:absolute;top:15px;width:8px}.mm-radio-group-item__wrapper.mm-radio-group-item--checked:before{border:1px solid #0064fe;box-shadow:0 0 0 1px #0064fe}.mm-radio-group-item__wrapper.mm-radio-group-item--checked:after{display:block}.mm-radio-group-item__wrapper.mm-radio-group-item--disabled{pointer-events:none}.mm-radio-group-item__wrapper.mm-radio-group-item--disabled:before{background-color:#f2f3f5;border:1px solid #ccd0d6;box-shadow:0 0 0 1px #ccd0d6;cursor:default}.mm-radio-group-item__wrapper.mm-radio-group-item--disabled:after{background-color:#ccd0d6;border:1px solid #ccd0d6;cursor:default}.mm-radio-group-item__wrapper.mm-radio-group-item--disabled .mm-radio-group-item-label{color:#ccd0d6;cursor:default}.mm-radio-group-item__wrapper .mm-radio-group-item{height:0;opacity:0;width:0}.mm-radio-group-item__wrapper .mm-radio-group-item-label{cursor:pointer;font-family:Lato,sans-serif;font-size:1.14rem;font-weight:700;line-height:40px}.mm-radio-group__container{display:flex}.mm-radio-group__container:active,.mm-radio-group__container:focus,.mm-radio-group__container:hover{outline:none}.mm-radio-group__label--heavy .mm-radio-group-item-label,.mm-radio-group__label .mm-radio-group-item-label{color:#002866;font-weight:700}.mm-radio-group__label--regular .mm-radio-group-item-label{color:#33435b;font-weight:400}.mm-radio-group__label--azure .mm-radio-group-item-label{color:#0064fe;font-weight:400}"], encapsulation: 2, changeDetection: 0 });
MmRadioGroupComponent.propDecorators = {
    disabled: [{ type: Input }],
    name: [{ type: Input }],
    className: [{ type: Input }],
    labelType: [{ type: Input }],
    base: [{ type: HostBinding, args: ['class.mm-radio-group',] }],
    radios: [{ type: ContentChildren, args: [forwardRef(() => MmRadioGroupItemComponent),
                { descendants: true },] }]
};
const ɵMmRadioGroupComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MmRadioGroupComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmRadioGroupComponent, [{
        type: Component,
        args: [{
                selector: 'mm-radio-group',
                template: "<div [ngClass]=\"className\"\n     [id]=\"id\">\n    <ng-content select=\"label\"></ng-content>\n    <div class=\"mm-radio-group__container\"\n         [ngClass]=\"labelClassMap\"\n         [mmTestTarget]=\"'radio-group-container'\">\n        <ng-content></ng-content>\n    </div>\n    <div class=\"mm-radio-state__container\"\n         [mmTestTarget]=\"'radio-state-container'\">\n        <ng-content select=\"mm-error\"></ng-content>\n    </div>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => MmRadioGroupComponent),
                        multi: true
                    }
                ],
                styles: [".mm-radio-group-item__wrapper{display:flex;justify-content:flex-start;padding:0 6px 0 20px;position:relative}.mm-radio-group-item__wrapper:active:before,.mm-radio-group-item__wrapper:focus:before,.mm-radio-group-item__wrapper:hover:before{border:1px solid #0064fe;box-shadow:0 0 0 1px #0064fe,0 0 0 6px #cce0ff}.mm-radio-group-item__wrapper:before{border:1px solid #99a1ad;border-radius:10px;box-shadow:0 0 0 1px #99a1ad;content:\"\";cursor:pointer;display:block;height:18px;left:0;position:absolute;top:10px;width:18px}.mm-radio-group-item__wrapper:after{background-color:#0064fe;border:1px solid #0064fe;border-radius:6px;content:\"\";cursor:pointer;display:none;height:8px;left:5px;position:absolute;top:15px;width:8px}.mm-radio-group-item__wrapper.mm-radio-group-item--checked:before{border:1px solid #0064fe;box-shadow:0 0 0 1px #0064fe}.mm-radio-group-item__wrapper.mm-radio-group-item--checked:after{display:block}.mm-radio-group-item__wrapper.mm-radio-group-item--disabled{pointer-events:none}.mm-radio-group-item__wrapper.mm-radio-group-item--disabled:before{background-color:#f2f3f5;border:1px solid #ccd0d6;box-shadow:0 0 0 1px #ccd0d6;cursor:default}.mm-radio-group-item__wrapper.mm-radio-group-item--disabled:after{background-color:#ccd0d6;border:1px solid #ccd0d6;cursor:default}.mm-radio-group-item__wrapper.mm-radio-group-item--disabled .mm-radio-group-item-label{color:#ccd0d6;cursor:default}.mm-radio-group-item__wrapper .mm-radio-group-item{height:0;opacity:0;width:0}.mm-radio-group-item__wrapper .mm-radio-group-item-label{cursor:pointer;font-family:Lato,sans-serif;font-size:1.14rem;font-weight:700;line-height:40px}.mm-radio-group__container{display:flex}.mm-radio-group__container:active,.mm-radio-group__container:focus,.mm-radio-group__container:hover{outline:none}.mm-radio-group__label--heavy .mm-radio-group-item-label,.mm-radio-group__label .mm-radio-group-item-label{color:#002866;font-weight:700}.mm-radio-group__label--regular .mm-radio-group-item-label{color:#33435b;font-weight:400}.mm-radio-group__label--azure .mm-radio-group-item-label{color:#0064fe;font-weight:400}"]
            }]
    }], null, { className: [{
            type: Input
        }], labelType: [{
            type: Input
        }], base: [{
            type: HostBinding,
            args: ['class.mm-radio-group']
        }], disabled: [{
            type: Input
        }], name: [{
            type: Input
        }], radios: [{
            type: ContentChildren,
            args: [forwardRef(() => MmRadioGroupItemComponent),
                { descendants: true }]
        }] }); })();

class MmRadioGroupCommonModule {
}
MmRadioGroupCommonModule.ɵfac = function MmRadioGroupCommonModule_Factory(t) { return new (t || MmRadioGroupCommonModule)(); };
MmRadioGroupCommonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmRadioGroupCommonModule });
MmRadioGroupCommonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            QaLocatorsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmRadioGroupCommonModule, { declarations: function () { return [MmRadioItemCommonComponent, MmRadioGroupCommonComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        QaLocatorsModule]; }, exports: function () { return [MmRadioItemCommonComponent, MmRadioGroupCommonComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmRadioGroupCommonModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    QaLocatorsModule,
                ],
                exports: [MmRadioItemCommonComponent, MmRadioGroupCommonComponent],
                declarations: [MmRadioItemCommonComponent, MmRadioGroupCommonComponent]
            }]
    }], null, null); })();

class MmRadioGroupModule {
}
MmRadioGroupModule.ɵfac = function MmRadioGroupModule_Factory(t) { return new (t || MmRadioGroupModule)(); };
MmRadioGroupModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmRadioGroupModule });
MmRadioGroupModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            QaLocatorsModule,
            MmRadioGroupCommonModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmRadioGroupModule, { declarations: function () { return [MmRadioGroupItemComponent, MmRadioGroupComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        QaLocatorsModule, MmRadioGroupCommonModule]; }, exports: function () { return [MmRadioGroupItemComponent, MmRadioGroupComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmRadioGroupModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    QaLocatorsModule,
                    MmRadioGroupCommonModule,
                ],
                exports: [MmRadioGroupItemComponent, MmRadioGroupComponent],
                declarations: [MmRadioGroupItemComponent, MmRadioGroupComponent]
            }]
    }], null, null); })();

class MmListDirective {
    constructor() {
        this.base = true;
    }
}
MmListDirective.ɵfac = function MmListDirective_Factory(t) { return new (t || MmListDirective)(); };
MmListDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmListDirective, selectors: [["ul", "mmList", ""]], hostVars: 2, hostBindings: function MmListDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mm-list", ctx.base);
    } } });
MmListDirective.propDecorators = {
    base: [{ type: HostBinding, args: ['class.mm-list',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmListDirective, [{
        type: Directive,
        args: [{
                selector: 'ul[mmList]'
            }]
    }], function () { return []; }, { base: [{
            type: HostBinding,
            args: ['class.mm-list']
        }] }); })();

class MmListModule {
}
MmListModule.ɵfac = function MmListModule_Factory(t) { return new (t || MmListModule)(); };
MmListModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmListModule });
MmListModule.ɵinj = ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmListModule, { declarations: [MmListDirective], exports: [MmListDirective] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmListModule, [{
        type: NgModule,
        args: [{
                declarations: [MmListDirective],
                exports: [MmListDirective]
            }]
    }], null, null); })();

class MmToggleComponent extends MmRadioItemCommonComponent {
    constructor() {
        super(...arguments);
        this.base = true;
        this.checked = false;
        this.disabled = false;
    }
}
MmToggleComponent.ɵfac = function MmToggleComponent_Factory(t) { return ɵMmToggleComponent_BaseFactory(t || MmToggleComponent); };
MmToggleComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmToggleComponent, selectors: [["mm-toggle"]], viewQuery: function MmToggleComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c9, 3);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.toggleElement = _t.first);
    } }, hostVars: 6, hostBindings: function MmToggleComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mm-toggle__wrapper", ctx.base)("mm-toggle--checked", ctx.checked)("mm-toggle--disabled", ctx.disabled);
    } }, inputs: { value: "value" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => MmToggleComponent),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c5, decls: 4, vars: 5, consts: [["type", "radio", 1, "mm-toggle__input", 3, "mmTestTarget", "disabled", "checked"], ["toggleElement", ""], [1, "mm-toggle__label", 3, "mmTestTarget"]], template: function MmToggleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelement(0, "input", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "label", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("mmTestTarget", "toggle-input")("disabled", ctx.disabled)("checked", ctx.checked);
        ɵngcc0.ɵɵattribute("name", ctx.name);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("mmTestTarget", "toggle-label");
    } }, directives: [ɵngcc3.ɵf], encapsulation: 2, changeDetection: 0 });
MmToggleComponent.propDecorators = {
    value: [{ type: Input }],
    toggleElement: [{ type: ViewChild, args: ['toggleElement', { static: true },] }],
    base: [{ type: HostBinding, args: ['class.mm-toggle__wrapper',] }],
    checked: [{ type: HostBinding, args: ['class.mm-toggle--checked',] }],
    disabled: [{ type: HostBinding, args: ['class.mm-toggle--disabled',] }]
};
const ɵMmToggleComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MmToggleComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmToggleComponent, [{
        type: Component,
        args: [{
                selector: 'mm-toggle',
                template: "<input #toggleElement\n       [mmTestTarget]=\"'toggle-input'\"\n       type=\"radio\"\n       class=\"mm-toggle__input\"\n       [disabled]=\"disabled\"\n       [checked]=\"checked\"\n       [attr.name]=\"name\">\n<label class=\"mm-toggle__label\"\n       [mmTestTarget]=\"'toggle-label'\">\n    <ng-content></ng-content>\n</label>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => MmToggleComponent),
                        multi: true
                    }
                ]
            }]
    }], null, { base: [{
            type: HostBinding,
            args: ['class.mm-toggle__wrapper']
        }], checked: [{
            type: HostBinding,
            args: ['class.mm-toggle--checked']
        }], disabled: [{
            type: HostBinding,
            args: ['class.mm-toggle--disabled']
        }], value: [{
            type: Input
        }], toggleElement: [{
            type: ViewChild,
            args: ['toggleElement', { static: true }]
        }] }); })();

class MmToggleGroupComponent extends MmRadioGroupCommonComponent {
    constructor() {
        super(...arguments);
        this.className = '';
        this.base = true;
    }
}
MmToggleGroupComponent.ɵfac = function MmToggleGroupComponent_Factory(t) { return ɵMmToggleGroupComponent_BaseFactory(t || MmToggleGroupComponent); };
MmToggleGroupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmToggleGroupComponent, selectors: [["mm-toggle-group"]], contentQueries: function MmToggleGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MmToggleComponent, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.radios = _t);
    } }, hostVars: 2, hostBindings: function MmToggleGroupComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mm-toggle-group", ctx.base);
    } }, inputs: { className: "className", disabled: "disabled", name: "name" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => MmToggleGroupComponent),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c8, decls: 6, vars: 3, consts: [[3, "ngClass"], [1, "mm-toggle__container", 3, "mmTestTarget"], [1, "mm-toggle-state__container", 3, "mmTestTarget"]], template: function MmToggleGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c7);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵprojection(3, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵprojection(5, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.className);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("mmTestTarget", "toggle-container");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("mmTestTarget", "toggle-state-container");
    } }, directives: [ɵngcc2.NgClass, ɵngcc3.ɵf], styles: [".mm-toggle__label{background:#fff;border:1px solid #ccd0d6;box-sizing:border-box;color:#002866;cursor:pointer;display:inline-block;font-family:Lato,sans-serif;font-size:1.14rem;font-weight:400;height:40px;line-height:1.53;min-width:84px;padding:5px 10px 6px;text-align:center}.mm-toggle--checked .mm-toggle__label{background:#0064fe;color:#fff}.mm-toggle__input{height:0;margin:0;opacity:0;width:0}.mm-toggle-group,.mm-toggle__wrapper{display:inline-block}.mm-toggle__wrapper{height:40px}.mm-toggle__container .mm-toggle__wrapper:first-child .mm-toggle__label{border-radius:2px 0 0 2px;border-width:1px 0 1px 1px}.mm-toggle__container .mm-toggle__wrapper:nth-child(2) .mm-toggle__label{border-radius:0 2px 2px 0;margin-left:-1px}.mm-toggle-state__container{line-height:0;position:relative}"], encapsulation: 2, changeDetection: 0 });
MmToggleGroupComponent.propDecorators = {
    disabled: [{ type: Input }],
    name: [{ type: Input }],
    className: [{ type: Input }],
    base: [{ type: HostBinding, args: ['class.mm-toggle-group',] }],
    radios: [{ type: ContentChildren, args: [forwardRef(() => MmToggleComponent), { descendants: true },] }]
};
const ɵMmToggleGroupComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MmToggleGroupComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmToggleGroupComponent, [{
        type: Component,
        args: [{
                selector: 'mm-toggle-group',
                template: "<div [ngClass]=\"className\">\n    <ng-content select=\"label\"></ng-content>\n    <div class=\"mm-toggle__container\"\n         [mmTestTarget]=\"'toggle-container'\">\n        <ng-content></ng-content>\n    </div>\n    <div class=\"mm-toggle-state__container\"\n         [mmTestTarget]=\"'toggle-state-container'\">\n        <ng-content select=\"mm-error\"></ng-content>\n    </div>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => MmToggleGroupComponent),
                        multi: true
                    }
                ],
                styles: [".mm-toggle__label{background:#fff;border:1px solid #ccd0d6;box-sizing:border-box;color:#002866;cursor:pointer;display:inline-block;font-family:Lato,sans-serif;font-size:1.14rem;font-weight:400;height:40px;line-height:1.53;min-width:84px;padding:5px 10px 6px;text-align:center}.mm-toggle--checked .mm-toggle__label{background:#0064fe;color:#fff}.mm-toggle__input{height:0;margin:0;opacity:0;width:0}.mm-toggle-group,.mm-toggle__wrapper{display:inline-block}.mm-toggle__wrapper{height:40px}.mm-toggle__container .mm-toggle__wrapper:first-child .mm-toggle__label{border-radius:2px 0 0 2px;border-width:1px 0 1px 1px}.mm-toggle__container .mm-toggle__wrapper:nth-child(2) .mm-toggle__label{border-radius:0 2px 2px 0;margin-left:-1px}.mm-toggle-state__container{line-height:0;position:relative}"]
            }]
    }], null, { className: [{
            type: Input
        }], base: [{
            type: HostBinding,
            args: ['class.mm-toggle-group']
        }], disabled: [{
            type: Input
        }], name: [{
            type: Input
        }], radios: [{
            type: ContentChildren,
            args: [forwardRef(() => MmToggleComponent), { descendants: true }]
        }] }); })();

class MmToggleModule {
}
MmToggleModule.ɵfac = function MmToggleModule_Factory(t) { return new (t || MmToggleModule)(); };
MmToggleModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmToggleModule });
MmToggleModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            MmRadioGroupCommonModule,
            QaLocatorsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmToggleModule, { declarations: function () { return [MmToggleComponent, MmToggleGroupComponent]; }, imports: function () { return [CommonModule,
        FormsModule, MmRadioGroupCommonModule, QaLocatorsModule]; }, exports: function () { return [MmToggleComponent, MmToggleGroupComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmToggleModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    MmRadioGroupCommonModule,
                    QaLocatorsModule,
                ],
                exports: [MmToggleComponent, MmToggleGroupComponent],
                declarations: [MmToggleComponent, MmToggleGroupComponent]
            }]
    }], null, null); })();

var MmAlertType;
(function (MmAlertType) {
    MmAlertType["success"] = "success";
    MmAlertType["info"] = "info";
    MmAlertType["warning"] = "warning";
    MmAlertType["error"] = "error";
})(MmAlertType || (MmAlertType = {}));
var MmAlertSize;
(function (MmAlertSize) {
    MmAlertSize["small"] = "small";
    MmAlertSize["large"] = "large";
})(MmAlertSize || (MmAlertSize = {}));
var MmAlertMode;
(function (MmAlertMode) {
    MmAlertMode["banner"] = "banner";
    MmAlertMode["alert"] = "alert";
})(MmAlertMode || (MmAlertMode = {}));
var MmAlertContentAlign;
(function (MmAlertContentAlign) {
    MmAlertContentAlign["left"] = "left";
    MmAlertContentAlign["center"] = "center";
})(MmAlertContentAlign || (MmAlertContentAlign = {}));

const ALERT_CONTEXT_DATA = new InjectionToken('AlertContextData');

class MmAlertComponent {
    constructor(viewContainerRef, changeDetector, injector) {
        this.viewContainerRef = viewContainerRef;
        this.changeDetector = changeDetector;
        this.injector = injector;
        this.mmAlertType = MmAlertType;
        this.close = new EventEmitter();
        this.base = true;
        this.defaultAlertConfig = {
            mode: MmAlertMode.alert,
            type: MmAlertType.info,
            target: '',
            message: '',
            contentAlign: MmAlertContentAlign.left,
            disableCloseIcon: false,
            duration: 5000
        };
        this._alertConfig = Object.assign({}, this.defaultAlertConfig);
    }
    get alertConfig() {
        return this._alertConfig;
    }
    set alertConfig(config) {
        this._alertConfig = Object.assign(Object.assign({}, this.defaultAlertConfig), config);
    }
    ngOnInit() {
        this.alertClassMap = {
            'mm-alert-general': (!this.alertConfig.target || this.alertConfig.target === 'body'),
            [`mm-alert--${this.alertConfig.type}`]: this.alertConfig.type,
            [`mm-alert--${this.alertConfig.size}`]: this.alertConfig.size
        };
        this.alertContentClassMap = {
            [`mm-alert__content-${this.alertConfig.contentAlign}`]: this.alertConfig.contentAlign
        };
    }
    ngAfterViewInit() {
        const { component, template } = this.alertConfig;
        if (component) {
            this.portalComponent = this.createAlertPortalComponent(component);
            this.changeDetector.detectChanges();
        }
        else if (template) {
            this.portalComponent = new TemplatePortal(template, this.viewContainerRef);
            this.changeDetector.detectChanges();
        }
    }
    onClose() {
        this.close.emit();
    }
    createPortalInjector(data) {
        const injectorTokens = new WeakMap([
            [ALERT_CONTEXT_DATA, data],
        ]);
        return new PortalInjector(this.injector, injectorTokens);
    }
    createAlertPortalComponent(component) {
        const { alertContextData } = this.alertConfig;
        if (!isEmpty(alertContextData)) {
            return new ComponentPortal(component, null, this.createPortalInjector(Object.assign({}, alertContextData)));
        }
        return new ComponentPortal(component);
    }
}
MmAlertComponent.ɵfac = function MmAlertComponent_Factory(t) { return new (t || MmAlertComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
MmAlertComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmAlertComponent, selectors: [["mm-alert"]], hostVars: 2, hostBindings: function MmAlertComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mm-alert", ctx.base);
    } }, inputs: { alertConfig: "alertConfig" }, outputs: { close: "close" }, decls: 14, vars: 15, consts: [[1, "mm-alert__container", 3, "mmTestTarget", "ngClass"], [1, "mm-alert__content-wrapper", 3, "ngClass"], [1, "mm-alert--type", 3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], [1, "mm-alert__content", 3, "mmTestTarget"], [1, "mm-alert__title", 3, "mmTestTarget", "innerHtml"], [4, "ngIf", "ngIfElse"], ["class", "mm-alert__close", 3, "mmTestTarget", "click", 4, "ngIf"], ["messageTemplate", ""], ["xmlns", "http://www.w3.org/2000/svg", "width", "18", "height", "18", "viewBox", "0 0 18 18", 1, "mm-alert__icon"], ["id", "a", "d", "M9 0c4.963 0 9 4.037 9 9s-4.037 9-9 9-9-4.037-9-9 4.037-9 9-9zm0 16.363c4.06 0 7.363-3.302 7.363-7.364 0-4.06-3.303-7.362-7.363-7.362-4.06 0-7.363 3.302-7.363 7.362 0 4.062 3.302 7.364 7.363 7.364zm3.026-10.455a.844.844 0 1 1 1.26 1.121l-4.5 5.063a.844.844 0 0 1-1.226.036L4.747 9.315A.844.844 0 1 1 5.94 8.122l2.18 2.18 3.906-4.394z"], ["id", "a", "d", "M15.331 2.534c1.678 1.66 2.625 3.9 2.668 6.308.086 4.96-3.944 9.067-8.984 9.157l-.16.001C3.962 18 .088 14.145 0 9.156-.04 6.757.885 4.48 2.605 2.741A9.156 9.156 0 0 1 8.986 0c2.437-.046 4.653.858 6.345 2.533zM8.986 16.363c4.138-.075 7.447-3.434 7.376-7.492-.034-1.98-.81-3.816-2.182-5.174a7.1 7.1 0 0 0-5.165-2.059 7.53 7.53 0 0 0-5.246 2.253C2.36 5.314 1.604 7.173 1.638 9.127c.07 4.083 3.23 7.237 7.219 7.237l.13-.001zm.015-4.836a1.191 1.191 0 1 1-.002 2.382 1.191 1.191 0 0 1 .002-2.382zM8.172 9.54l.01-4.635a.818.818 0 0 1 1.637.003l-.01 4.636a.819.819 0 0 1-.818.817h-.002a.819.819 0 0 1-.817-.82z"], ["id", "a", "d", "M17.878 17.61a.819.819 0 0 1-.696.39H.818a.82.82 0 0 1-.731-1.186L8.267.417c.278-.556 1.188-.556 1.465 0l8.182 16.397a.823.823 0 0 1-.036.797zm-2.02-1.25L9 2.617 2.142 16.36h13.716zM9 12.285a1.192 1.192 0 0 1 0 2.386 1.193 1.193 0 0 1 0-2.386zm0-6.617a.82.82 0 0 1 .818.82v4.133a.82.82 0 1 1-1.636 0V6.488A.82.82 0 0 1 9 5.668z"], ["id", "a", "d", "M9 0c4.963 0 9 4.037 9 9s-4.037 9-9 9-9-4.037-9-9 4.037-9 9-9zm0 16.363c4.06 0 7.363-3.302 7.363-7.364 0-4.06-3.303-7.362-7.363-7.362-4.06 0-7.363 3.302-7.363 7.362 0 4.062 3.302 7.364 7.363 7.364zM7.808 5.128a1.191 1.191 0 1 1 2.382.001 1.191 1.191 0 0 1-2.382-.001zm3.852 8.309a.819.819 0 0 1-.819.818H7.568a.819.819 0 0 1 0-1.636h1.18v-3.67h-.59a.819.819 0 0 1 0-1.636h1.41c.45 0 .817.366.817.818v4.488h.456c.452 0 .819.366.819.818z"], [1, "mm-alert__message"], [3, "cdkPortalOutlet"], [1, "mm-alert__close", 3, "mmTestTarget", "click"], ["xmlns", "http://www.w3.org/2000/svg", "width", "32", "height", "32", "viewBox", "0 0 32 32", 1, "mm-alert__close-icon"], ["id", "a", "d", "M17.885 16l9.724-9.724a1.332 1.332 0 0 0 0-1.885 1.332 1.332 0 0 0-1.885 0L16 14.115 6.276 4.39a1.332 1.332 0 0 0-1.885 0 1.332 1.332 0 0 0 0 1.885L14.115 16 4.39 25.724A1.332 1.332 0 0 0 5.334 28c.341 0 .682-.13.942-.39L16 17.884l9.724 9.724a1.33 1.33 0 0 0 1.885 0 1.332 1.332 0 0 0 0-1.885L17.885 16z"], [1, "mm-alert__message", 3, "mmTestTarget", "innerHtml"]], template: function MmAlertComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, MmAlertComponent_span_3_Template, 3, 0, "span", 3);
        ɵngcc0.ɵɵtemplate(4, MmAlertComponent_span_4_Template, 3, 0, "span", 3);
        ɵngcc0.ɵɵtemplate(5, MmAlertComponent_span_5_Template, 3, 0, "span", 3);
        ɵngcc0.ɵɵtemplate(6, MmAlertComponent_span_6_Template, 3, 0, "span", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵelement(8, "div", 6);
        ɵngcc0.ɵɵpipe(9, "sanitize");
        ɵngcc0.ɵɵtemplate(10, MmAlertComponent_ng_container_10_Template, 3, 1, "ng-container", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, MmAlertComponent_div_11_Template, 3, 1, "div", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, MmAlertComponent_ng_template_12_Template, 2, 4, "ng-template", null, 9, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r6 = ɵngcc0.ɵɵreference(13);
        ɵngcc0.ɵɵproperty("mmTestTarget", "alert-container")("ngClass", ctx.alertClassMap);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.alertContentClassMap);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.alertConfig.type);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.mmAlertType.success);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.mmAlertType.warning);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.mmAlertType.error);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("mmTestTarget", "alert-content");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("mmTestTarget", "alert-title")("innerHtml", ɵngcc0.ɵɵpipeBind1(9, 13, ctx.alertConfig.title), ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.alertConfig.component || ctx.alertConfig.template)("ngIfElse", _r6);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.alertConfig.disableCloseIcon);
    } }, directives: function () { return [ɵngcc3.ɵf, ɵngcc2.NgClass, ɵngcc2.NgSwitch, ɵngcc2.NgSwitchCase, ɵngcc2.NgSwitchDefault, ɵngcc2.NgIf, ɵngcc5.CdkPortalOutlet]; }, pipes: function () { return [SanitizePipe]; }, styles: [".mm-alert__container[_ngcontent-%COMP%]{border-radius:4px;box-sizing:border-box;color:#33435b;display:flex;font-family:Lato,sans-serif;font-size:1.14rem;font-weight:400;justify-content:space-between;line-height:1.25;min-height:40px;padding:8px 14px 5px 16px;width:100%}.mm-alert__container.mm-alert-general[_ngcontent-%COMP%]{border:4px solid #fff;box-shadow:0 2px 20px 0 rgba(0,45,114,.15);margin-bottom:10px}.mm-alert__container.mm-alert--success[_ngcontent-%COMP%]{background-color:#d6f2e6}.mm-alert__container.mm-alert--info[_ngcontent-%COMP%]{background-color:#cce0ff}.mm-alert__container.mm-alert--warning[_ngcontent-%COMP%]{background-color:#fffbcc}.mm-alert__container.mm-alert--error[_ngcontent-%COMP%]{background-color:#f8d7d1}.mm-alert__container.mm-alert--small[_ngcontent-%COMP%]{font-size:.92rem;line-height:1.38;min-height:32px;padding:8px 9px 4px 10px}.mm-alert__container.mm-alert--small[_ngcontent-%COMP%]   .mm-alert__content[_ngcontent-%COMP%]{padding-top:0}.mm-alert__container.mm-alert--small[_ngcontent-%COMP%]   .mm-alert--type[_ngcontent-%COMP%]{height:13px;margin:1px 8px 0 0;width:13px}.mm-alert__container.mm-alert--small[_ngcontent-%COMP%]   .mm-alert__close[_ngcontent-%COMP%]{margin-top:0}.mm-alert__container.mm-alert--small[_ngcontent-%COMP%]   .mm-alert__icon[_ngcontent-%COMP%]{font-size:13px;height:13px;line-height:13px;width:13px}.mm-alert__container.mm-alert--large[_ngcontent-%COMP%]{font-size:1.14rem;line-height:1.25;min-height:56px;padding:15px 16px 15px 12px}.mm-alert__container.mm-alert--large[_ngcontent-%COMP%]   .mm-alert__content[_ngcontent-%COMP%]{display:flex;width:100%;word-break:break-word}.mm-alert__container.mm-alert--large[_ngcontent-%COMP%]   .mm-alert__title[_ngcontent-%COMP%]{display:block;font-size:1.14rem;font-weight:700;line-height:1.38}.mm-alert__container.mm-alert--large[_ngcontent-%COMP%]   .mm-alert__message[_ngcontent-%COMP%]{padding:1px 0 0 10px}.mm-alert__container.mm-alert--large[_ngcontent-%COMP%]   .mm-alert__icon[_ngcontent-%COMP%]{margin-right:12px}.mm-alert__content-wrapper[_ngcontent-%COMP%]{align-items:flex-start;display:flex;width:calc(100% - 32px)}.mm-alert__content-wrapper.mm-alert__content-left[_ngcontent-%COMP%]{justify-content:flex-start}.mm-alert__content-wrapper.mm-alert__content-center[_ngcontent-%COMP%]{justify-content:center}.mm-alert__content[_ngcontent-%COMP%]{padding:2px 0}.mm-alert__title[_ngcontent-%COMP%]{display:none}.mm-alert__message[_ngcontent-%COMP%]     a, .mm-alert__title[_ngcontent-%COMP%]     a{color:#33435b}.mm-alert--type[_ngcontent-%COMP%]{height:18px;margin:2px 9px 0 0;width:18px}.mm-alert__icon[_ngcontent-%COMP%]{fill:#33435b;font-size:18px;height:18px;line-height:18px;width:18px}.mm-alert__close[_ngcontent-%COMP%]{display:flex;margin:2px 0 0 4px;width:16px}.mm-alert__close-icon[_ngcontent-%COMP%]{cursor:pointer;fill:#33435b;font-size:16px;height:16px;line-height:16px;width:16px}@media only screen and (max-width:768px){.mm-alert--large[_ngcontent-%COMP%]   .mm-alert__title[_ngcontent-%COMP%]{margin-bottom:2px}.mm-alert--large[_ngcontent-%COMP%]   .mm-alert__content[_ngcontent-%COMP%]{flex-direction:column}.mm-alert--large[_ngcontent-%COMP%]   .mm-alert__message[_ngcontent-%COMP%]{padding-left:0!important}}"] });
MmAlertComponent.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: ChangeDetectorRef },
    { type: Injector }
];
MmAlertComponent.propDecorators = {
    alertConfig: [{ type: Input }],
    close: [{ type: Output }],
    base: [{ type: HostBinding, args: ['class.mm-alert',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmAlertComponent, [{
        type: Component,
        args: [{
                selector: 'mm-alert',
                template: "<div class=\"mm-alert__container\"\n     [mmTestTarget]=\"'alert-container'\"\n     [ngClass]=\"alertClassMap\">\n    <div [ngClass]=\"alertContentClassMap\"\n         class=\"mm-alert__content-wrapper\">\n        <div class=\"mm-alert--type\"\n             [ngSwitch]=\"alertConfig.type\">\n        <span *ngSwitchCase=\"mmAlertType.success\">\n            <svg class=\"mm-alert__icon\"\n                 xmlns=\"http://www.w3.org/2000/svg\"\n                 width=\"18\"\n                 height=\"18\"\n                 viewBox=\"0 0 18 18\">\n                <path id=\"a\"\n                      d=\"M9 0c4.963 0 9 4.037 9 9s-4.037 9-9 9-9-4.037-9-9 4.037-9 9-9zm0 16.363c4.06 0 7.363-3.302 7.363-7.364 0-4.06-3.303-7.362-7.363-7.362-4.06 0-7.363 3.302-7.363 7.362 0 4.062 3.302 7.364 7.363 7.364zm3.026-10.455a.844.844 0 1 1 1.26 1.121l-4.5 5.063a.844.844 0 0 1-1.226.036L4.747 9.315A.844.844 0 1 1 5.94 8.122l2.18 2.18 3.906-4.394z\"/>\n            </svg>\n        </span>\n            <span *ngSwitchCase=\"mmAlertType.warning\">\n            <svg class=\"mm-alert__icon\" xmlns=\"http://www.w3.org/2000/svg\"\n                 width=\"18\"\n                 height=\"18\"\n                 viewBox=\"0 0 18 18\">\n                <path id=\"a\"\n                      d=\"M15.331 2.534c1.678 1.66 2.625 3.9 2.668 6.308.086 4.96-3.944 9.067-8.984 9.157l-.16.001C3.962 18 .088 14.145 0 9.156-.04 6.757.885 4.48 2.605 2.741A9.156 9.156 0 0 1 8.986 0c2.437-.046 4.653.858 6.345 2.533zM8.986 16.363c4.138-.075 7.447-3.434 7.376-7.492-.034-1.98-.81-3.816-2.182-5.174a7.1 7.1 0 0 0-5.165-2.059 7.53 7.53 0 0 0-5.246 2.253C2.36 5.314 1.604 7.173 1.638 9.127c.07 4.083 3.23 7.237 7.219 7.237l.13-.001zm.015-4.836a1.191 1.191 0 1 1-.002 2.382 1.191 1.191 0 0 1 .002-2.382zM8.172 9.54l.01-4.635a.818.818 0 0 1 1.637.003l-.01 4.636a.819.819 0 0 1-.818.817h-.002a.819.819 0 0 1-.817-.82z\"/>\n            </svg>\n        </span>\n            <span *ngSwitchCase=\"mmAlertType.error\">\n            <svg class=\"mm-alert__icon\" xmlns=\"http://www.w3.org/2000/svg\"\n                 width=\"18\"\n                 height=\"18\"\n                 viewBox=\"0 0 18 18\">\n                <path id=\"a\"\n                      d=\"M17.878 17.61a.819.819 0 0 1-.696.39H.818a.82.82 0 0 1-.731-1.186L8.267.417c.278-.556 1.188-.556 1.465 0l8.182 16.397a.823.823 0 0 1-.036.797zm-2.02-1.25L9 2.617 2.142 16.36h13.716zM9 12.285a1.192 1.192 0 0 1 0 2.386 1.193 1.193 0 0 1 0-2.386zm0-6.617a.82.82 0 0 1 .818.82v4.133a.82.82 0 1 1-1.636 0V6.488A.82.82 0 0 1 9 5.668z\"/>\n            </svg>\n        </span>\n            <span *ngSwitchDefault>\n            <svg class=\"mm-alert__icon\" xmlns=\"http://www.w3.org/2000/svg\"\n                 width=\"18\"\n                 height=\"18\"\n                 viewBox=\"0 0 18 18\">\n                <path id=\"a\"\n                      d=\"M9 0c4.963 0 9 4.037 9 9s-4.037 9-9 9-9-4.037-9-9 4.037-9 9-9zm0 16.363c4.06 0 7.363-3.302 7.363-7.364 0-4.06-3.303-7.362-7.363-7.362-4.06 0-7.363 3.302-7.363 7.362 0 4.062 3.302 7.364 7.363 7.364zM7.808 5.128a1.191 1.191 0 1 1 2.382.001 1.191 1.191 0 0 1-2.382-.001zm3.852 8.309a.819.819 0 0 1-.819.818H7.568a.819.819 0 0 1 0-1.636h1.18v-3.67h-.59a.819.819 0 0 1 0-1.636h1.41c.45 0 .817.366.817.818v4.488h.456c.452 0 .819.366.819.818z\"/>\n            </svg>\n        </span>\n        </div>\n        <div class=\"mm-alert__content\"\n             [mmTestTarget]=\"'alert-content'\">\n            <div [mmTestTarget]=\"'alert-title'\"\n                 [innerHtml]=\"alertConfig.title | sanitize\"\n                 class=\"mm-alert__title\">\n            </div>\n            <ng-container *ngIf=\"alertConfig.component || alertConfig.template; else messageTemplate\">\n               <div class=\"mm-alert__message\">\n                 <ng-template [cdkPortalOutlet]=\"portalComponent\"></ng-template>\n               </div>\n            </ng-container>\n        </div>\n    </div>\n    <div class=\"mm-alert__close\"\n         *ngIf=\"!alertConfig.disableCloseIcon\"\n         [mmTestTarget]=\"'alert-close'\"\n         (click)=\"onClose()\">\n        <svg class=\"mm-alert__close-icon\"\n             xmlns=\"http://www.w3.org/2000/svg\"\n             width=\"32\"\n             height=\"32\"\n             viewBox=\"0 0 32 32\">\n            <path id=\"a\"\n                  d=\"M17.885 16l9.724-9.724a1.332 1.332 0 0 0 0-1.885 1.332 1.332 0 0 0-1.885 0L16 14.115 6.276 4.39a1.332 1.332 0 0 0-1.885 0 1.332 1.332 0 0 0 0 1.885L14.115 16 4.39 25.724A1.332 1.332 0 0 0 5.334 28c.341 0 .682-.13.942-.39L16 17.884l9.724 9.724a1.33 1.33 0 0 0 1.885 0 1.332 1.332 0 0 0 0-1.885L17.885 16z\"/>\n        </svg>\n    </div>\n</div>\n\n<ng-template #messageTemplate>\n     <div [mmTestTarget]=\"'alert-message'\"\n       [innerHtml]=\"alertConfig.message | sanitize\"\n       class=\"mm-alert__message\">\n     </div>\n</ng-template>\n",
                styles: [".mm-alert__container{border-radius:4px;box-sizing:border-box;color:#33435b;display:flex;font-family:Lato,sans-serif;font-size:1.14rem;font-weight:400;justify-content:space-between;line-height:1.25;min-height:40px;padding:8px 14px 5px 16px;width:100%}.mm-alert__container.mm-alert-general{border:4px solid #fff;box-shadow:0 2px 20px 0 rgba(0,45,114,.15);margin-bottom:10px}.mm-alert__container.mm-alert--success{background-color:#d6f2e6}.mm-alert__container.mm-alert--info{background-color:#cce0ff}.mm-alert__container.mm-alert--warning{background-color:#fffbcc}.mm-alert__container.mm-alert--error{background-color:#f8d7d1}.mm-alert__container.mm-alert--small{font-size:.92rem;line-height:1.38;min-height:32px;padding:8px 9px 4px 10px}.mm-alert__container.mm-alert--small .mm-alert__content{padding-top:0}.mm-alert__container.mm-alert--small .mm-alert--type{height:13px;margin:1px 8px 0 0;width:13px}.mm-alert__container.mm-alert--small .mm-alert__close{margin-top:0}.mm-alert__container.mm-alert--small .mm-alert__icon{font-size:13px;height:13px;line-height:13px;width:13px}.mm-alert__container.mm-alert--large{font-size:1.14rem;line-height:1.25;min-height:56px;padding:15px 16px 15px 12px}.mm-alert__container.mm-alert--large .mm-alert__content{display:flex;width:100%;word-break:break-word}.mm-alert__container.mm-alert--large .mm-alert__title{display:block;font-size:1.14rem;font-weight:700;line-height:1.38}.mm-alert__container.mm-alert--large .mm-alert__message{padding:1px 0 0 10px}.mm-alert__container.mm-alert--large .mm-alert__icon{margin-right:12px}.mm-alert__content-wrapper{align-items:flex-start;display:flex;width:calc(100% - 32px)}.mm-alert__content-wrapper.mm-alert__content-left{justify-content:flex-start}.mm-alert__content-wrapper.mm-alert__content-center{justify-content:center}.mm-alert__content{padding:2px 0}.mm-alert__title{display:none}.mm-alert__message ::ng-deep a,.mm-alert__title ::ng-deep a{color:#33435b}.mm-alert--type{height:18px;margin:2px 9px 0 0;width:18px}.mm-alert__icon{fill:#33435b;font-size:18px;height:18px;line-height:18px;width:18px}.mm-alert__close{display:flex;margin:2px 0 0 4px;width:16px}.mm-alert__close-icon{cursor:pointer;fill:#33435b;font-size:16px;height:16px;line-height:16px;width:16px}@media only screen and (max-width:768px){.mm-alert--large .mm-alert__title{margin-bottom:2px}.mm-alert--large .mm-alert__content{flex-direction:column}.mm-alert--large .mm-alert__message{padding-left:0!important}}"]
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.Injector }]; }, { close: [{
            type: Output
        }], base: [{
            type: HostBinding,
            args: ['class.mm-alert']
        }], alertConfig: [{
            type: Input
        }] }); })();

class MmAlertService {
    constructor(injector, componentFactoryResolver, applicationRef, rendererFactory) {
        this.injector = injector;
        this.componentFactoryResolver = componentFactoryResolver;
        this.applicationRef = applicationRef;
        this.alertRefs = new Array();
        this.onClose = new EventEmitter();
        this.wrapperNodeClass = '.mm-alert-wrapper__content';
        this.alertLimit = 3;
        this.renderer = rendererFactory.createRenderer(null, null);
    }
    addAlert(alertConfig) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(MmAlertComponent);
        const alertRef = componentFactory.create(this.injector);
        alertRef.instance.alertConfig = alertConfig;
        this.alertRefs.push(alertRef);
        this.limitAlertLength();
        this.onClose = alertRef.instance.close;
        this.applicationRef.attachView(alertRef.hostView);
        const container = alertConfig.target ?
            document.querySelector(alertConfig.target) : document.querySelector(this.wrapperNodeClass);
        if (!container) {
            throw new Error('Please provide container for mm-alert component');
        }
        container.appendChild(alertRef.location.nativeElement);
        if (alertConfig.mode === MmAlertMode.banner) {
            setTimeout(() => this.removeAlert(alertRef), this.getTimeout(alertConfig));
        }
        this.onClose.subscribe(() => {
            this.removeAlert(alertRef);
        });
        alertRef.instance.componentRef = alertRef;
        return alertRef;
    }
    removeAlert(alertRef) {
        if (alertRef) {
            this.applicationRef.detachView(alertRef.hostView);
            this.alertRefs = this.alertRefs.filter((item) => {
                if (!isEqual(item, alertRef)) {
                    return item;
                }
            });
            alertRef.destroy();
        }
    }
    limitAlertLength() {
        const isAlertLimitExceeded = this.alertRefs.length > this.alertLimit;
        if (isAlertLimitExceeded) {
            this.removeAlert(this.alertRefs[0]);
        }
    }
    getTimeout(alertConfig) {
        const timeout = 5000;
        return alertConfig.duration || timeout;
    }
    ngOnDestroy() {
        if (this.alertRefs.length > 0) {
            this.alertRefs.forEach((alertRef) => {
                this.applicationRef.detachView(alertRef.hostView);
                alertRef.destroy();
            });
            this.alertRefs.length = 0;
        }
    }
}
MmAlertService.ɵfac = function MmAlertService_Factory(t) { return new (t || MmAlertService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(ɵngcc0.RendererFactory2)); };
MmAlertService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: MmAlertService, factory: MmAlertService.ɵfac });
MmAlertService.ctorParameters = () => [
    { type: Injector },
    { type: ComponentFactoryResolver },
    { type: ApplicationRef },
    { type: RendererFactory2 }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmAlertService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Injector }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ApplicationRef }, { type: ɵngcc0.RendererFactory2 }]; }, null); })();

class MmAlertWrapperComponent {
    constructor(document, renderer) {
        this.document = document;
        this.renderer = renderer;
        this.isPositionDynamic = false;
        this.dynamicOffset = 140;
        this.alertContainerClassName = 'mm-alert__container-dynamic-offset';
        this.window = this.document.defaultView;
    }
    onWindowScroll() {
        const topOffset = this.window.pageYOffset || 0;
        this.isPositionDynamic = topOffset >= this.dynamicOffset;
        if (this.isPositionDynamic) {
            this.renderer.addClass(this.alertWrapper.nativeElement, this.alertContainerClassName);
        }
        else {
            this.renderer.removeClass(this.alertWrapper.nativeElement, this.alertContainerClassName);
        }
    }
}
MmAlertWrapperComponent.ɵfac = function MmAlertWrapperComponent_Factory(t) { return new (t || MmAlertWrapperComponent)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
MmAlertWrapperComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmAlertWrapperComponent, selectors: [["mm-alert-wrapper"]], viewQuery: function MmAlertWrapperComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c10, 3);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.alertWrapper = _t.first);
    } }, hostBindings: function MmAlertWrapperComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("scroll", function MmAlertWrapperComponent_scroll_HostBindingHandler() { return ctx.onWindowScroll(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, decls: 3, vars: 0, consts: [[1, "mm-alert-wrapper"], [1, "mm-alert-wrapper__content"], ["alertWrapper", ""]], template: function MmAlertWrapperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "div", 1, 2);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [".mm-alert-wrapper[_ngcontent-%COMP%]{position:relative}.mm-alert-wrapper__content[_ngcontent-%COMP%]{box-sizing:border-box;left:0;margin-left:auto;margin-right:auto;max-width:1400px;padding:0 16px;position:absolute;right:0;top:15px;width:100%;z-index:100}.mm-alert-wrapper__content.mm-alert__container-dynamic-offset[_ngcontent-%COMP%]{position:fixed;top:25px}"], changeDetection: 0 });
MmAlertWrapperComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: Renderer2 }
];
MmAlertWrapperComponent.propDecorators = {
    alertWrapper: [{ type: ViewChild, args: ['alertWrapper', { static: true },] }],
    onWindowScroll: [{ type: HostListener, args: ['window:scroll', [],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmAlertWrapperComponent, [{
        type: Component,
        args: [{
                selector: 'mm-alert-wrapper',
                template: "<div class=\"mm-alert-wrapper\">\n    <div #alertWrapper class=\"mm-alert-wrapper__content\"></div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".mm-alert-wrapper{position:relative}.mm-alert-wrapper__content{box-sizing:border-box;left:0;margin-left:auto;margin-right:auto;max-width:1400px;padding:0 16px;position:absolute;right:0;top:15px;width:100%;z-index:100}.mm-alert-wrapper__content.mm-alert__container-dynamic-offset{position:fixed;top:25px}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.Renderer2 }]; }, { onWindowScroll: [{
            type: HostListener,
            args: ['window:scroll', []]
        }], alertWrapper: [{
            type: ViewChild,
            args: ['alertWrapper', { static: true }]
        }] }); })();

class SanitizePipe {
    constructor(sanitized) {
        this.sanitized = sanitized;
    }
    transform(value) {
        return value ? this.sanitized.bypassSecurityTrustHtml(value) : '';
    }
}
SanitizePipe.ɵfac = function SanitizePipe_Factory(t) { return new (t || SanitizePipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.DomSanitizer)); };
SanitizePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "sanitize", type: SanitizePipe, pure: true });
SanitizePipe.ctorParameters = () => [
    { type: DomSanitizer }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SanitizePipe, [{
        type: Pipe,
        args: [{ name: 'sanitize' }]
    }], function () { return [{ type: ɵngcc6.DomSanitizer }]; }, null); })();

class MmAlertModule {
}
MmAlertModule.ɵfac = function MmAlertModule_Factory(t) { return new (t || MmAlertModule)(); };
MmAlertModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmAlertModule });
MmAlertModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [MmAlertService], imports: [[
            CommonModule,
            PortalModule,
            QaLocatorsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmAlertModule, { declarations: function () { return [MmAlertComponent, MmAlertWrapperComponent, SanitizePipe]; }, imports: function () { return [CommonModule,
        PortalModule,
        QaLocatorsModule]; }, exports: function () { return [MmAlertComponent, MmAlertWrapperComponent, SanitizePipe]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmAlertModule, [{
        type: NgModule,
        args: [{
                declarations: [MmAlertComponent, MmAlertWrapperComponent, SanitizePipe],
                exports: [MmAlertComponent, MmAlertWrapperComponent, SanitizePipe],
                entryComponents: [MmAlertComponent],
                imports: [
                    CommonModule,
                    PortalModule,
                    QaLocatorsModule
                ],
                providers: [MmAlertService]
            }]
    }], null, null); })();

class MmInputBase {
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
    }
    handleAttribute(element, property, value, hasAttribute) {
        if (hasAttribute) {
            this.renderer.setAttribute(element, property, value);
        }
        else {
            this.renderer.removeAttribute(element, property);
        }
    }
}

class MmInputDirective extends MmInputBase {
    constructor(ngControl, elementRef, renderer) {
        super(elementRef, renderer);
        this.ngControl = ngControl;
        this.type = 'text';
        this.baseClass = true;
        this.componentUniqueId = v4();
        this.inputStateProperty = {
            disabled: 'disabled',
            readonly: 'readonly',
            required: 'required'
        };
        this.inputStateValue = {
            disabled: 'disabled',
            readonly: 'readonly',
            required: 'required'
        };
    }
    set name(value) {
        this._name = value;
    }
    get name() {
        return this._name || this.formControlName;
    }
    set id(value) {
        this._id = `mm-input-${value}`;
    }
    get id() {
        return this._id || `mm-input-${this.componentUniqueId}`;
    }
    set disabled(value) {
        this._disabled = value;
    }
    get disabled() {
        return this.getDisabled();
    }
    ngOnInit() {
        const inputElement = this.elementRef.nativeElement;
        super.handleAttribute(inputElement, this.inputStateProperty.disabled, this.inputStateValue.disabled, this.disabled);
        super.handleAttribute(inputElement, this.inputStateProperty.readonly, this.inputStateValue.readonly, this.readonly);
        super.handleAttribute(inputElement, this.inputStateProperty.required, this.inputStateValue.required, this.required);
    }
    getDisabled() {
        if (this.ngControl && this.ngControl.disabled !== null) {
            return this.ngControl.disabled;
        }
        return this._disabled;
    }
}
MmInputDirective.ɵfac = function MmInputDirective_Factory(t) { return new (t || MmInputDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
MmInputDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmInputDirective, selectors: [["input", "mmInput", ""]], hostVars: 7, hostBindings: function MmInputDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("autocomplete", ctx.autocomplete)("placeholder", ctx.placeholder)("id", ctx.id)("name", ctx.name)("type", ctx.type);
        ɵngcc0.ɵɵclassProp("mm-input", ctx.baseClass);
    } }, inputs: { type: "type", name: "name", id: "id", disabled: "disabled", required: "required", readonly: "readonly", autocomplete: "autocomplete", placeholder: "placeholder", formControlName: "formControlName" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
MmInputDirective.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Optional }, { type: Self }] },
    { type: ElementRef },
    { type: Renderer2 }
];
MmInputDirective.propDecorators = {
    required: [{ type: Input }],
    readonly: [{ type: Input }],
    autocomplete: [{ type: Input }],
    placeholder: [{ type: Input }],
    type: [{ type: Input }],
    formControlName: [{ type: Input }],
    name: [{ type: Input }],
    id: [{ type: Input }],
    disabled: [{ type: Input }],
    baseClass: [{ type: HostBinding, args: ['class.mm-input',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmInputDirective, [{
        type: Directive,
        args: [{
                selector: 'input[mmInput]',
                host: {
                    '[attr.autocomplete]': 'autocomplete',
                    '[attr.placeholder]': 'placeholder',
                    '[attr.id]': 'id',
                    '[attr.name]': 'name',
                    '[attr.type]': 'type'
                }
            }]
    }], function () { return [{ type: ɵngcc1.NgControl, decorators: [{
                type: Optional
            }, {
                type: Self
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { type: [{
            type: Input
        }], baseClass: [{
            type: HostBinding,
            args: ['class.mm-input']
        }], name: [{
            type: Input
        }], id: [{
            type: Input
        }], disabled: [{
            type: Input
        }], required: [{
            type: Input
        }], readonly: [{
            type: Input
        }], autocomplete: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], formControlName: [{
            type: Input
        }] }); })();

class MmTextareaDirective extends MmInputBase {
    constructor(ngControl, elementRef, renderer) {
        super(elementRef, renderer);
        this.ngControl = ngControl;
        this.baseClass = true;
        this.componentUniqueId = v4();
        this.stateProperty = {
            disabled: 'disabled',
            readonly: 'readonly',
            required: 'required'
        };
        this.stateValue = {
            disabled: 'disabled',
            readonly: 'readonly',
            required: 'required'
        };
    }
    set name(value) {
        this._name = value;
    }
    get name() {
        return this._name || this.formControlName;
    }
    set id(value) {
        this._id = value ? `mm-textarea-${value}` : `mm-textarea-${this.componentUniqueId}`;
    }
    get id() {
        return this._id;
    }
    set disabled(value) {
        this._disabled = value;
    }
    get disabled() {
        return this.getDisabled();
    }
    ngOnInit() {
        const textareaElement = this.elementRef.nativeElement;
        super.handleAttribute(textareaElement, this.stateProperty.disabled, this.stateValue.disabled, this.disabled);
        super.handleAttribute(textareaElement, this.stateProperty.readonly, this.stateValue.readonly, this.readonly);
        super.handleAttribute(textareaElement, this.stateProperty.required, this.stateValue.required, this.required);
    }
    getDisabled() {
        if (this.ngControl && this.ngControl.disabled !== null) {
            return this.ngControl.disabled;
        }
        return this._disabled;
    }
}
MmTextareaDirective.ɵfac = function MmTextareaDirective_Factory(t) { return new (t || MmTextareaDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
MmTextareaDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmTextareaDirective, selectors: [["textarea", "mmTextarea", ""]], hostVars: 5, hostBindings: function MmTextareaDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("placeholder", ctx.placeholder)("id", ctx.id)("name", ctx.name);
        ɵngcc0.ɵɵclassProp("mm-textarea", ctx.baseClass);
    } }, inputs: { name: "name", id: "id", disabled: "disabled", required: "required", readonly: "readonly", placeholder: "placeholder", formControlName: "formControlName" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
MmTextareaDirective.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Optional }, { type: Self }] },
    { type: ElementRef },
    { type: Renderer2 }
];
MmTextareaDirective.propDecorators = {
    required: [{ type: Input }],
    readonly: [{ type: Input }],
    placeholder: [{ type: Input }],
    formControlName: [{ type: Input }],
    name: [{ type: Input }],
    id: [{ type: Input }],
    disabled: [{ type: Input }],
    baseClass: [{ type: HostBinding, args: ['class.mm-textarea',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmTextareaDirective, [{
        type: Directive,
        args: [{
                selector: 'textarea[mmTextarea]',
                host: {
                    '[attr.placeholder]': 'placeholder',
                    '[attr.id]': 'id',
                    '[attr.name]': 'name'
                }
            }]
    }], function () { return [{ type: ɵngcc1.NgControl, decorators: [{
                type: Optional
            }, {
                type: Self
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { baseClass: [{
            type: HostBinding,
            args: ['class.mm-textarea']
        }], name: [{
            type: Input
        }], id: [{
            type: Input
        }], disabled: [{
            type: Input
        }], required: [{
            type: Input
        }], readonly: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], formControlName: [{
            type: Input
        }] }); })();

class MmLabelComponent {
    constructor(renderer, platformId) {
        this.renderer = renderer;
        this.platformId = platformId;
        this.labelStateProperty = {
            for: 'for',
            id: 'id'
        };
        this.labelStateValue = {
            id: this.id
        };
        this.base = true;
    }
    set for(value) {
        this.id = value;
    }
    get for() {
        return this.id;
    }
    ngOnInit() {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        this.observer = new MutationObserver(this.observerSubscriber.bind(this));
        this.renderer.setAttribute(this.mmLabel.nativeElement, this.labelStateProperty.for, this.labelStateValue.id);
        this.setIdAttribute();
    }
    setIdAttribute() {
        const target = this.mmLabel.nativeElement.parentNode.nextSibling;
        const config = {
            attributes: true,
            childList: false,
            subtree: false
        };
        this.observer.observe(target, config);
    }
    observerSubscriber(mutations) {
        mutations.forEach((mutation) => {
            if (mutation.target.getAttribute(this.labelStateProperty.id)) {
                this.id = this.id || mutation.target.getAttribute(this.labelStateProperty.id);
                this.observer.disconnect();
                this.renderer.setAttribute(this.mmLabel.nativeElement, this.labelStateProperty.for, this.id);
            }
        });
    }
}
MmLabelComponent.ɵfac = function MmLabelComponent_Factory(t) { return new (t || MmLabelComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID)); };
MmLabelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmLabelComponent, selectors: [["mm-label"]], viewQuery: function MmLabelComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c11, 3);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.mmLabel = _t.first);
    } }, hostVars: 2, hostBindings: function MmLabelComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mm-label", ctx.base);
    } }, inputs: { for: "for" }, ngContentSelectors: _c5, decls: 3, vars: 1, consts: [[1, "mm-label__content", 3, "for"], ["mmLabel", ""]], template: function MmLabelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "label", 0, 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("for", ctx.for);
    } }, encapsulation: 2, changeDetection: 0 });
MmLabelComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: Object, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
MmLabelComponent.propDecorators = {
    for: [{ type: Input }],
    base: [{ type: HostBinding, args: ['class.mm-label',] }],
    mmLabel: [{ type: ViewChild, args: ['mmLabel', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmLabelComponent, [{
        type: Component,
        args: [{
                selector: 'mm-label',
                template: "<label #mmLabel\n       [for]=\"for\"\n       class=\"mm-label__content\">\n    <ng-content></ng-content>\n</label>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: Object, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, { base: [{
            type: HostBinding,
            args: ['class.mm-label']
        }], for: [{
            type: Input
        }], mmLabel: [{
            type: ViewChild,
            args: ['mmLabel', { static: true }]
        }] }); })();

class MmFieldComponent {
    constructor() {
        this.className = '';
        this.base = true;
    }
}
MmFieldComponent.ɵfac = function MmFieldComponent_Factory(t) { return new (t || MmFieldComponent)(); };
MmFieldComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmFieldComponent, selectors: [["mm-field"]], hostVars: 2, hostBindings: function MmFieldComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mm-field", ctx.base);
    } }, inputs: { className: "className", zeroOffsetBottom: "zeroOffsetBottom" }, features: [ɵngcc0.ɵɵProvidersFeature([], [{ provide: ControlContainer, useExisting: FormGroupDirective }])], ngContentSelectors: _c13, decls: 6, vars: 1, consts: [[1, "mm-field__wrapper", 3, "ngClass"], [1, "mm-field__container"]], template: function MmFieldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c12);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵprojection(3, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(4, 2);
        ɵngcc0.ɵɵprojection(5, 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.className);
    } }, directives: [ɵngcc2.NgClass], styles: ["input[type=number]{-moz-appearance:textfield}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input:-webkit-autofill,input:-webkit-autofill:focus,input:-webkit-autofill:hover,textarea:-webkit-autofill,textarea:-webkit-autofill:focus,textarea:-webkit-autofill:hover{-webkit-text-fill-color:#002d72;-webkit-transition:background-color 1000s ease-in-out 0s;transition:background-color 1000s ease-in-out 0s}.mm-input,.mm-input--base,.mm-textarea{background-color:#fff;border:1px solid #ccd0d6;border-radius:2px;box-shadow:none!important;box-sizing:border-box;caret-color:#33435b;color:#002d72;font-family:Lato,sans-serif;font-size:1.14rem;font-weight:400;outline:none;padding:1px 12px;vertical-align:middle;width:100%}.mm-input--base:active,.mm-input--base:focus,.mm-input--base:hover,.mm-input:active,.mm-input:focus,.mm-input:hover,.mm-textarea:active,.mm-textarea:focus,.mm-textarea:hover{border:2px solid #66a2fe;box-shadow:0 0 0 1px #66a2fe;padding:0 11px}.mm-input--base[disabled]:active,.mm-input--base[disabled]:focus,.mm-input--base[disabled]:hover,.mm-input--base[readonly]:active,.mm-input--base[readonly]:focus,.mm-input--base[readonly]:hover,.mm-input[disabled]:active,.mm-input[disabled]:focus,.mm-input[disabled]:hover,.mm-input[readonly]:active,.mm-input[readonly]:focus,.mm-input[readonly]:hover,.mm-textarea[disabled]:active,.mm-textarea[disabled]:focus,.mm-textarea[disabled]:hover,.mm-textarea[readonly]:active,.mm-textarea[readonly]:focus,.mm-textarea[readonly]:hover{border:1px solid #ccd0d6;box-shadow:none;padding:1px 12px}.mm-input--base[disabled],.mm-input[disabled],.mm-textarea[disabled]{background-color:#f2f3f5;color:#667284}.mm-input--base::-moz-placeholder,.mm-input::-moz-placeholder,.mm-textarea::-moz-placeholder{font-style:italic}.mm-input--base::-ms-input-placeholder,.mm-input::-ms-input-placeholder,.mm-textarea::-ms-input-placeholder{font-style:italic}.mm-input--base::placeholder,.mm-input::placeholder,.mm-textarea::placeholder{font-style:italic}.mm-input{height:40px}.mm-input.ng-touched.ng-invalid{border:2px solid #eb8676;box-shadow:0 0 0 1px #eb8676;padding:0 11px}.mm-textarea{height:160px;padding:13px 12px}.mm-textarea:active,.mm-textarea:focus,.mm-textarea:hover,.mm-textarea[disabled]:active,.mm-textarea[disabled]:focus,.mm-textarea[disabled]:hover,.mm-textarea[readonly]:active,.mm-textarea[readonly]:focus,.mm-textarea[readonly]:hover{padding:12px 11px}.mm-textarea.ng-touched.ng-invalid{border:2px solid #eb8676;box-shadow:0 0 0 1px #eb8676;padding:12px 11px}.mm-field--error .mm-input{border:2px solid #eb8676;box-shadow:0 0 0 1px #eb8676;padding:0 11px}.mm-field--error .mm-textarea{border:2px solid #eb8676;box-shadow:0 0 0 1px #eb8676;padding:12px 11px}.mm-field--error .mm-select .mm-select-control{border:2px solid #eb8676}.mm-label{color:#001432;display:block;font-family:Lato,sans-serif;font-size:.92rem;font-weight:400;line-height:1.38;margin-bottom:4px}.mm-field__container{position:relative}.mm-field__container .mm-icon,.mm-field__container mat-icon{position:absolute;right:12px;top:10px}.mm-error{color:#de351b;margin-top:3px;z-index:5}.mm-error,.mm-hint{font-family:Lato,sans-serif;font-size:.92rem;font-weight:400;line-height:1.38}.mm-hint{background-color:#cce0ff;border-radius:2px;color:#003c98;display:block;margin-top:10px;padding:7px 12px 7px 29px;position:relative}.mm-hint:after{border-color:transparent transparent #cce0ff;border-style:solid;border-width:0 4px 4px;content:\"\";height:0;position:absolute;right:12px;top:-4px;width:0}.mm-field{display:block}"], encapsulation: 2, changeDetection: 0 });
MmFieldComponent.propDecorators = {
    className: [{ type: Input }],
    zeroOffsetBottom: [{ type: Input }],
    base: [{ type: HostBinding, args: ['class.mm-field',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmFieldComponent, [{
        type: Component,
        args: [{
                selector: 'mm-field',
                template: "<div class=\"mm-field__wrapper\" [ngClass]=\"className\">\n    <ng-content select=\"mm-label\"></ng-content>\n    <div class=\"mm-field__container\">\n        <ng-content></ng-content>\n    </div>\n    <ng-content select=\"mm-hint\"></ng-content>\n    <ng-content select=\"mm-error\"></ng-content>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
                styles: ["input[type=number]{-moz-appearance:textfield}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input:-webkit-autofill,input:-webkit-autofill:focus,input:-webkit-autofill:hover,textarea:-webkit-autofill,textarea:-webkit-autofill:focus,textarea:-webkit-autofill:hover{-webkit-text-fill-color:#002d72;-webkit-transition:background-color 1000s ease-in-out 0s;transition:background-color 1000s ease-in-out 0s}.mm-input,.mm-input--base,.mm-textarea{background-color:#fff;border:1px solid #ccd0d6;border-radius:2px;box-shadow:none!important;box-sizing:border-box;caret-color:#33435b;color:#002d72;font-family:Lato,sans-serif;font-size:1.14rem;font-weight:400;outline:none;padding:1px 12px;vertical-align:middle;width:100%}.mm-input--base:active,.mm-input--base:focus,.mm-input--base:hover,.mm-input:active,.mm-input:focus,.mm-input:hover,.mm-textarea:active,.mm-textarea:focus,.mm-textarea:hover{border:2px solid #66a2fe;box-shadow:0 0 0 1px #66a2fe;padding:0 11px}.mm-input--base[disabled]:active,.mm-input--base[disabled]:focus,.mm-input--base[disabled]:hover,.mm-input--base[readonly]:active,.mm-input--base[readonly]:focus,.mm-input--base[readonly]:hover,.mm-input[disabled]:active,.mm-input[disabled]:focus,.mm-input[disabled]:hover,.mm-input[readonly]:active,.mm-input[readonly]:focus,.mm-input[readonly]:hover,.mm-textarea[disabled]:active,.mm-textarea[disabled]:focus,.mm-textarea[disabled]:hover,.mm-textarea[readonly]:active,.mm-textarea[readonly]:focus,.mm-textarea[readonly]:hover{border:1px solid #ccd0d6;box-shadow:none;padding:1px 12px}.mm-input--base[disabled],.mm-input[disabled],.mm-textarea[disabled]{background-color:#f2f3f5;color:#667284}.mm-input--base::-moz-placeholder,.mm-input::-moz-placeholder,.mm-textarea::-moz-placeholder{font-style:italic}.mm-input--base::-ms-input-placeholder,.mm-input::-ms-input-placeholder,.mm-textarea::-ms-input-placeholder{font-style:italic}.mm-input--base::placeholder,.mm-input::placeholder,.mm-textarea::placeholder{font-style:italic}.mm-input{height:40px}.mm-input.ng-touched.ng-invalid{border:2px solid #eb8676;box-shadow:0 0 0 1px #eb8676;padding:0 11px}.mm-textarea{height:160px;padding:13px 12px}.mm-textarea:active,.mm-textarea:focus,.mm-textarea:hover,.mm-textarea[disabled]:active,.mm-textarea[disabled]:focus,.mm-textarea[disabled]:hover,.mm-textarea[readonly]:active,.mm-textarea[readonly]:focus,.mm-textarea[readonly]:hover{padding:12px 11px}.mm-textarea.ng-touched.ng-invalid{border:2px solid #eb8676;box-shadow:0 0 0 1px #eb8676;padding:12px 11px}.mm-field--error .mm-input{border:2px solid #eb8676;box-shadow:0 0 0 1px #eb8676;padding:0 11px}.mm-field--error .mm-textarea{border:2px solid #eb8676;box-shadow:0 0 0 1px #eb8676;padding:12px 11px}.mm-field--error .mm-select .mm-select-control{border:2px solid #eb8676}.mm-label{color:#001432;display:block;font-family:Lato,sans-serif;font-size:.92rem;font-weight:400;line-height:1.38;margin-bottom:4px}.mm-field__container{position:relative}.mm-field__container .mm-icon,.mm-field__container mat-icon{position:absolute;right:12px;top:10px}.mm-error{color:#de351b;margin-top:3px;z-index:5}.mm-error,.mm-hint{font-family:Lato,sans-serif;font-size:.92rem;font-weight:400;line-height:1.38}.mm-hint{background-color:#cce0ff;border-radius:2px;color:#003c98;display:block;margin-top:10px;padding:7px 12px 7px 29px;position:relative}.mm-hint:after{border-color:transparent transparent #cce0ff;border-style:solid;border-width:0 4px 4px;content:\"\";height:0;position:absolute;right:12px;top:-4px;width:0}.mm-field{display:block}"]
            }]
    }], function () { return []; }, { className: [{
            type: Input
        }], base: [{
            type: HostBinding,
            args: ['class.mm-field']
        }], zeroOffsetBottom: [{
            type: Input
        }] }); })();

class MmHintComponent {
    constructor() {
        this.base = true;
    }
}
MmHintComponent.ɵfac = function MmHintComponent_Factory(t) { return new (t || MmHintComponent)(); };
MmHintComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmHintComponent, selectors: [["mm-hint"]], hostVars: 2, hostBindings: function MmHintComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mm-hint", ctx.base);
    } }, ngContentSelectors: _c5, decls: 1, vars: 0, template: function MmHintComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
MmHintComponent.propDecorators = {
    base: [{ type: HostBinding, args: ['class.mm-hint',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmHintComponent, [{
        type: Component,
        args: [{
                selector: 'mm-hint',
                template: '<ng-content></ng-content>',
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { base: [{
            type: HostBinding,
            args: ['class.mm-hint']
        }] }); })();

class MmErrorComponent {
    constructor(changeDetectorRef, formGroupDirective, elementRef, renderer) {
        this.changeDetectorRef = changeDetectorRef;
        this.formGroupDirective = formGroupDirective;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.base = true;
        this.styleProperty = {
            display: 'display'
        };
        this.styleValue = {
            block: 'block',
            none: 'none'
        };
        this.elementClassName = {
            error: 'mm-field--error'
        };
    }
    ngOnInit() {
        this.renderer.setStyle(this.elementRef.nativeElement, this.styleProperty.display, this.styleValue.none);
        this.validateControl = this.formGroupDirective.control.get(this.fieldName);
        this.watchControl();
        this.formSubmitSubscription = this.formGroupDirective.ngSubmit.subscribe(() => {
            this.getFieldControlError();
        });
        this.observeDomChanges();
    }
    ngOnDestroy() {
        this.removeSubscribe();
        if (this.observer) {
            this.observer.disconnect();
        }
    }
    observeDomChanges() {
        const config = { attributes: true };
        const targetNode = this.elementRef.nativeElement.parentElement.children[1]
            && this.elementRef.nativeElement.parentElement.children[1].firstChild;
        if (targetNode) {
            const callback = (mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'attributes') {
                        if (this.validateControl && (this.validateControl.touched || this.validateControl.dirty)) {
                            this.getFieldControlError();
                        }
                    }
                }
            };
            this.observer = new MutationObserver(callback);
            this.observer.observe(targetNode, config);
        }
    }
    getFieldControlError() {
        const hasError = this.validateControl && this.validateControl.errors && Object.keys(this.validateControl.errors)[0];
        this.renderer.setStyle(this.elementRef.nativeElement, this.styleProperty.display, hasError ? this.styleValue.block : this.styleValue.none);
        if (hasError) {
            this.renderer.addClass(this.elementRef.nativeElement.parentElement.parentElement, this.elementClassName.error);
        }
        else {
            this.renderer.removeClass(this.elementRef.nativeElement.parentElement.parentElement, this.elementClassName.error);
        }
    }
    removeSubscribe() {
        if (this.validateChanges) {
            this.validateChanges.unsubscribe();
            this.validateChanges = null;
        }
        if (this.formSubmitSubscription) {
            this.formSubmitSubscription.unsubscribe();
            this.formSubmitSubscription = null;
        }
    }
    watchControl() {
        this.removeSubscribe();
        if (this.validateControl && this.validateControl.statusChanges) {
            this.validateChanges = this.validateControl.statusChanges
                .pipe(startWith$1(null)).subscribe(() => {
                if (!this.validateControl.pristine) {
                    this.getFieldControlError();
                }
                this.changeDetectorRef.markForCheck();
            });
        }
    }
}
MmErrorComponent.ɵfac = function MmErrorComponent_Factory(t) { return new (t || MmErrorComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.FormGroupDirective), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
MmErrorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmErrorComponent, selectors: [["mm-error"]], hostVars: 2, hostBindings: function MmErrorComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mm-error", ctx.base);
    } }, inputs: { fieldName: "fieldName" }, ngContentSelectors: _c5, decls: 1, vars: 0, template: function MmErrorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
MmErrorComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: FormGroupDirective },
    { type: ElementRef },
    { type: Renderer2 }
];
MmErrorComponent.propDecorators = {
    fieldName: [{ type: Input }],
    base: [{ type: HostBinding, args: ['class.mm-error',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmErrorComponent, [{
        type: Component,
        args: [{
                selector: 'mm-error',
                template: '<ng-content></ng-content>',
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc1.FormGroupDirective }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { base: [{
            type: HostBinding,
            args: ['class.mm-error']
        }], fieldName: [{
            type: Input
        }] }); })();

class MmFormFieldModule {
}
MmFormFieldModule.ɵfac = function MmFormFieldModule_Factory(t) { return new (t || MmFormFieldModule)(); };
MmFormFieldModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmFormFieldModule });
MmFormFieldModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            QaLocatorsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmFormFieldModule, { declarations: function () { return [MmInputDirective, MmTextareaDirective, MmLabelComponent, MmHintComponent, MmErrorComponent, MmFieldComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        QaLocatorsModule]; }, exports: function () { return [MmInputDirective, MmTextareaDirective, MmLabelComponent, MmHintComponent, MmErrorComponent, MmFieldComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmFormFieldModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    MmInputDirective,
                    MmTextareaDirective,
                    MmLabelComponent,
                    MmHintComponent,
                    MmErrorComponent,
                    MmFieldComponent
                ],
                exports: [
                    MmInputDirective,
                    MmTextareaDirective,
                    MmLabelComponent,
                    MmHintComponent,
                    MmErrorComponent,
                    MmFieldComponent
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    QaLocatorsModule,
                ]
            }]
    }], null, null); })();

const selector = `[fxFlex], [fxFlex.mm-mobile], [fxFlex.mm-gt-mobile],
  [fxFlex.mm-tablet], [fxFlex.mm-gt-tablet], [fxFlex.mm-lt-tablet-landscape],
  [fxFlex.mm-tablet-landscape], [fxFlex.mm-desktop]`;
const inputs = ['fxFlex', 'fxFlex.mm-mobile', 'fxFlex.mm-gt-mobile',
    'fxFlex.mm-tablet', 'fxFlex.mm-gt-tablet', 'fxFlex.mm-lt-tablet-landscape',
    'fxFlex.mm-tablet-landscape', 'fxFlex.mm-desktop'];
/* tslint:disable */
class MmFlexDirective extends FlexDirective {
    constructor() {
        super(...arguments);
        this.inputs = inputs;
    }
}
MmFlexDirective.ɵfac = function MmFlexDirective_Factory(t) { return ɵMmFlexDirective_BaseFactory(t || MmFlexDirective); };
MmFlexDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmFlexDirective, selectors: [["", "fxFlex", ""], ["", "fxFlex.mm-mobile", ""], ["", "fxFlex.mm-gt-mobile", ""], ["", "fxFlex.mm-tablet", ""], ["", "fxFlex.mm-gt-tablet", ""], ["", "fxFlex.mm-lt-tablet-landscape", ""], ["", "fxFlex.mm-tablet-landscape", ""], ["", "fxFlex.mm-desktop", ""]], inputs: { fxFlex: "fxFlex", "fxFlex.mm-mobile": "fxFlex.mm-mobile", "fxFlex.mm-gt-mobile": "fxFlex.mm-gt-mobile", "fxFlex.mm-tablet": "fxFlex.mm-tablet", "fxFlex.mm-gt-tablet": "fxFlex.mm-gt-tablet", "fxFlex.mm-lt-tablet-landscape": "fxFlex.mm-lt-tablet-landscape", "fxFlex.mm-tablet-landscape": "fxFlex.mm-tablet-landscape", "fxFlex.mm-desktop": "fxFlex.mm-desktop" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
const ɵMmFlexDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MmFlexDirective);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmFlexDirective, [{
        type: Directive,
        args: [{ selector, inputs }]
    }], null, null); })();

const selector$1 = `[fxLayout], [fxLayout.mm-mobile], [fxLayout.mm-gt-mobile], [fxLayout.mm-tablet],
  [fxLayout.mm-gt-tablet], [fxLayout.mm-lt-tablet-landscape],
  [fxLayout.mm-tablet-landscape], [fxLayout.mm-desktop]`;
const inputs$1 = ['fxLayout', 'fxLayout.mm-mobile', 'fxLayout.mm-gt-mobile',
    'fxLayout.mm-tablet', 'fxLayout.mm-gt-tablet', 'fxLayout.mm-lt-tablet-landscape',
    'fxLayout.mm-tablet-landscape', 'fxLayout.mm-desktop'];
/* tslint:disable */
class MmLayoutDirective extends LayoutDirective {
    constructor() {
        super(...arguments);
        this.inputs = inputs$1;
    }
}
MmLayoutDirective.ɵfac = function MmLayoutDirective_Factory(t) { return ɵMmLayoutDirective_BaseFactory(t || MmLayoutDirective); };
MmLayoutDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmLayoutDirective, selectors: [["", "fxLayout", ""], ["", "fxLayout.mm-mobile", ""], ["", "fxLayout.mm-gt-mobile", ""], ["", "fxLayout.mm-tablet", ""], ["", "fxLayout.mm-gt-tablet", ""], ["", "fxLayout.mm-lt-tablet-landscape", ""], ["", "fxLayout.mm-tablet-landscape", ""], ["", "fxLayout.mm-desktop", ""]], inputs: { fxLayout: "fxLayout", "fxLayout.mm-mobile": "fxLayout.mm-mobile", "fxLayout.mm-gt-mobile": "fxLayout.mm-gt-mobile", "fxLayout.mm-tablet": "fxLayout.mm-tablet", "fxLayout.mm-gt-tablet": "fxLayout.mm-gt-tablet", "fxLayout.mm-lt-tablet-landscape": "fxLayout.mm-lt-tablet-landscape", "fxLayout.mm-tablet-landscape": "fxLayout.mm-tablet-landscape", "fxLayout.mm-desktop": "fxLayout.mm-desktop" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
const ɵMmLayoutDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MmLayoutDirective);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmLayoutDirective, [{
        type: Directive,
        args: [{ selector: selector$1, inputs: inputs$1 }]
    }], null, null); })();

const selector$2 = `[fxLayoutGap], [fxLayoutGap.mm-mobile], [fxLayoutGap.mm-gt-mobile],
  [fxLayoutGap.mm-tablet], [fxLayoutGap.mm-gt-tablet], [fxLayoutGap.mm-lt-tablet-landscape],
  [fxLayoutGap.mm-tablet-landscape], [fxLayoutGap.mm-desktop]`;
const inputs$2 = ['fxLayoutGap', 'fxLayoutGap.mm-mobile', 'fxLayoutGap.mm-gt-mobile',
    'fxLayoutGap.mm-tablet', 'fxLayoutGap.mm-gt-tablet', 'fxLayoutGap.mm-lt-tablet-landscape',
    'fxLayoutGap.mm-tablet-landscape', 'fxLayoutGap.mm-desktop'];
/* tslint:disable */
class MmLayoutGapDirective extends LayoutGapDirective {
    constructor() {
        super(...arguments);
        this.inputs = inputs$2;
    }
}
MmLayoutGapDirective.ɵfac = function MmLayoutGapDirective_Factory(t) { return ɵMmLayoutGapDirective_BaseFactory(t || MmLayoutGapDirective); };
MmLayoutGapDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmLayoutGapDirective, selectors: [["", "fxLayoutGap", ""], ["", "fxLayoutGap.mm-mobile", ""], ["", "fxLayoutGap.mm-gt-mobile", ""], ["", "fxLayoutGap.mm-tablet", ""], ["", "fxLayoutGap.mm-gt-tablet", ""], ["", "fxLayoutGap.mm-lt-tablet-landscape", ""], ["", "fxLayoutGap.mm-tablet-landscape", ""], ["", "fxLayoutGap.mm-desktop", ""]], inputs: { fxLayoutGap: "fxLayoutGap", "fxLayoutGap.mm-mobile": "fxLayoutGap.mm-mobile", "fxLayoutGap.mm-gt-mobile": "fxLayoutGap.mm-gt-mobile", "fxLayoutGap.mm-tablet": "fxLayoutGap.mm-tablet", "fxLayoutGap.mm-gt-tablet": "fxLayoutGap.mm-gt-tablet", "fxLayoutGap.mm-lt-tablet-landscape": "fxLayoutGap.mm-lt-tablet-landscape", "fxLayoutGap.mm-tablet-landscape": "fxLayoutGap.mm-tablet-landscape", "fxLayoutGap.mm-desktop": "fxLayoutGap.mm-desktop" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
const ɵMmLayoutGapDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MmLayoutGapDirective);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmLayoutGapDirective, [{
        type: Directive,
        args: [{ selector: selector$2, inputs: inputs$2 }]
    }], null, null); })();

const selector$3 = `[fxLayoutAlign], [fxLayoutAlign.mm-mobile], [fxLayoutAlign.mm-gt-mobile],
  [fxLayoutAlign.mm-tablet], [fxLayoutAlign.mm-gt-tablet], [fxLayoutAlign.mm-lt-tablet-landscape],
  [fxLayoutAlign.mm-tablet-landscape], [fxLayoutAlign.mm-desktop]`;
const inputs$3 = ['fxLayoutAlign', 'fxLayoutAlign.mm-mobile', 'fxLayoutAlign.mm-gt-mobile',
    'fxLayoutAlign.mm-tablet', 'fxLayoutAlign.mm-gt-tablet', 'fxLayoutAlign.mm-lt-tablet-landscape',
    'fxLayoutAlign.mm-tablet-landscape', 'fxLayoutAlign.mm-desktop'];
/* tslint:disable */
class MmLayoutAlignDirective extends LayoutAlignDirective {
    constructor() {
        super(...arguments);
        this.inputs = inputs$3;
    }
}
MmLayoutAlignDirective.ɵfac = function MmLayoutAlignDirective_Factory(t) { return ɵMmLayoutAlignDirective_BaseFactory(t || MmLayoutAlignDirective); };
MmLayoutAlignDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmLayoutAlignDirective, selectors: [["", "fxLayoutAlign", ""], ["", "fxLayoutAlign.mm-mobile", ""], ["", "fxLayoutAlign.mm-gt-mobile", ""], ["", "fxLayoutAlign.mm-tablet", ""], ["", "fxLayoutAlign.mm-gt-tablet", ""], ["", "fxLayoutAlign.mm-lt-tablet-landscape", ""], ["", "fxLayoutAlign.mm-tablet-landscape", ""], ["", "fxLayoutAlign.mm-desktop", ""]], inputs: { fxLayoutAlign: "fxLayoutAlign", "fxLayoutAlign.mm-mobile": "fxLayoutAlign.mm-mobile", "fxLayoutAlign.mm-gt-mobile": "fxLayoutAlign.mm-gt-mobile", "fxLayoutAlign.mm-tablet": "fxLayoutAlign.mm-tablet", "fxLayoutAlign.mm-gt-tablet": "fxLayoutAlign.mm-gt-tablet", "fxLayoutAlign.mm-lt-tablet-landscape": "fxLayoutAlign.mm-lt-tablet-landscape", "fxLayoutAlign.mm-tablet-landscape": "fxLayoutAlign.mm-tablet-landscape", "fxLayoutAlign.mm-desktop": "fxLayoutAlign.mm-desktop" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
const ɵMmLayoutAlignDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MmLayoutAlignDirective);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmLayoutAlignDirective, [{
        type: Directive,
        args: [{ selector: selector$3, inputs: inputs$3 }]
    }], null, null); })();

const selector$4 = `[fxFlexAlign], [fxFlexAlign.mm-mobile], [fxFlexAlign.mm-gt-mobile],
  [fxFlexAlign.mm-tablet], [fxFlexAlign.mm-gt-tablet], [fxFlexAlign.mm-lt-tablet-landscape],
  [fxFlexAlign.mm-tablet-landscape], [fxFlexAlign.mm-desktop]`;
const inputs$4 = ['fxFlexAlign', 'fxFlexAlign.mm-mobile', 'fxFlexAlign.mm-gt-mobile',
    'fxFlexAlign.mm-tablet', 'fxFlexAlign.mm-gt-tablet', 'fxFlexAlign.mm-lt-tablet-landscape',
    'fxFlexAlign.mm-tablet-landscape', 'fxFlexAlign.mm-desktop'];
/* tslint:disable */
class MmFlexAlignDirective extends FlexAlignDirective {
    constructor() {
        super(...arguments);
        this.inputs = inputs$4;
    }
}
MmFlexAlignDirective.ɵfac = function MmFlexAlignDirective_Factory(t) { return ɵMmFlexAlignDirective_BaseFactory(t || MmFlexAlignDirective); };
MmFlexAlignDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmFlexAlignDirective, selectors: [["", "fxFlexAlign", ""], ["", "fxFlexAlign.mm-mobile", ""], ["", "fxFlexAlign.mm-gt-mobile", ""], ["", "fxFlexAlign.mm-tablet", ""], ["", "fxFlexAlign.mm-gt-tablet", ""], ["", "fxFlexAlign.mm-lt-tablet-landscape", ""], ["", "fxFlexAlign.mm-tablet-landscape", ""], ["", "fxFlexAlign.mm-desktop", ""]], inputs: { fxFlexAlign: "fxFlexAlign", "fxFlexAlign.mm-mobile": "fxFlexAlign.mm-mobile", "fxFlexAlign.mm-gt-mobile": "fxFlexAlign.mm-gt-mobile", "fxFlexAlign.mm-tablet": "fxFlexAlign.mm-tablet", "fxFlexAlign.mm-gt-tablet": "fxFlexAlign.mm-gt-tablet", "fxFlexAlign.mm-lt-tablet-landscape": "fxFlexAlign.mm-lt-tablet-landscape", "fxFlexAlign.mm-tablet-landscape": "fxFlexAlign.mm-tablet-landscape", "fxFlexAlign.mm-desktop": "fxFlexAlign.mm-desktop" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
const ɵMmFlexAlignDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MmFlexAlignDirective);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmFlexAlignDirective, [{
        type: Directive,
        args: [{ selector: selector$4, inputs: inputs$4 }]
    }], null, null); })();

const selector$5 = `[fxFlexOrder], [fxFlexOrder.mm-mobile], [fxFlexOrder.mm-gt-mobile],
  [fxFlexOrder.mm-tablet], [fxFlexOrder.mm-gt-tablet], [fxFlexOrder.mm-lt-tablet-landscape],
  [fxFlexOrder.mm-tablet-landscape], [fxFlexOrder.mm-desktop]`;
const inputs$5 = ['fxFlexOrder', 'fxFlexOrder.mm-mobile', 'fxFlexOrder.mm-gt-mobile',
    'fxFlexOrder.mm-tablet', 'fxFlexOrder.mm-gt-tablet', 'fxFlexOrder.mm-lt-tablet-landscape',
    'fxFlexOrder.mm-tablet-landscape', 'fxFlexOrder.mm-desktop'];
/* tslint:disable */
class MmFlexOrderDirective extends FlexOrderDirective {
    constructor() {
        super(...arguments);
        this.inputs = inputs$5;
    }
}
MmFlexOrderDirective.ɵfac = function MmFlexOrderDirective_Factory(t) { return ɵMmFlexOrderDirective_BaseFactory(t || MmFlexOrderDirective); };
MmFlexOrderDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmFlexOrderDirective, selectors: [["", "fxFlexOrder", ""], ["", "fxFlexOrder.mm-mobile", ""], ["", "fxFlexOrder.mm-gt-mobile", ""], ["", "fxFlexOrder.mm-tablet", ""], ["", "fxFlexOrder.mm-gt-tablet", ""], ["", "fxFlexOrder.mm-lt-tablet-landscape", ""], ["", "fxFlexOrder.mm-tablet-landscape", ""], ["", "fxFlexOrder.mm-desktop", ""]], inputs: { fxFlexOrder: "fxFlexOrder", "fxFlexOrder.mm-mobile": "fxFlexOrder.mm-mobile", "fxFlexOrder.mm-gt-mobile": "fxFlexOrder.mm-gt-mobile", "fxFlexOrder.mm-tablet": "fxFlexOrder.mm-tablet", "fxFlexOrder.mm-gt-tablet": "fxFlexOrder.mm-gt-tablet", "fxFlexOrder.mm-lt-tablet-landscape": "fxFlexOrder.mm-lt-tablet-landscape", "fxFlexOrder.mm-tablet-landscape": "fxFlexOrder.mm-tablet-landscape", "fxFlexOrder.mm-desktop": "fxFlexOrder.mm-desktop" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
const ɵMmFlexOrderDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MmFlexOrderDirective);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmFlexOrderDirective, [{
        type: Directive,
        args: [{ selector: selector$5, inputs: inputs$5 }]
    }], null, null); })();

const selector$6 = `[fxShow], [fxShow.mm-mobile], [fxShow.mm-gt-mobile],
  [fxShow.mm-tablet], [fxShow.mm-gt-tablet], [fxShow.mm-lt-tablet-landscape],
  [fxShow.mm-tablet-landscape], [fxShow.mm-desktop], [fxHide], [fxHide.mm-mobile], [fxHide.mm-gt-mobile],
  [fxHide.mm-tablet], [fxHide.mm-gt-tablet], [fxHide.mm-lt-tablet-landscape],
  [fxHide.mm-tablet-landscape], [fxHide.mm-desktop]`;
const inputs$6 = ['fxShow', 'fxShow.mm-mobile', 'fxShow.mm-gt-mobile',
    'fxShow.mm-tablet', 'fxShow.mm-gt-tablet', 'fxShow.mm-lt-tablet-landscape',
    'fxShow.mm-tablet-landscape', 'fxShow.mm-desktop', 'fxHide', 'fxHide.mm-mobile', 'fxHide.mm-gt-mobile',
    'fxHide.mm-tablet', 'fxHide.mm-gt-tablet', 'fxHide.mm-lt-tablet-landscape',
    'fxHide.mm-tablet-landscape', 'fxHide.mm-desktop'];
/* tslint:disable */
class MmShowHideDirective extends ShowHideDirective {
    constructor() {
        super(...arguments);
        this.inputs = inputs$6;
    }
}
MmShowHideDirective.ɵfac = function MmShowHideDirective_Factory(t) { return ɵMmShowHideDirective_BaseFactory(t || MmShowHideDirective); };
MmShowHideDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmShowHideDirective, selectors: [["", "fxShow", ""], ["", "fxShow.mm-mobile", ""], ["", "fxShow.mm-gt-mobile", ""], ["", "fxShow.mm-tablet", ""], ["", "fxShow.mm-gt-tablet", ""], ["", "fxShow.mm-lt-tablet-landscape", ""], ["", "fxShow.mm-tablet-landscape", ""], ["", "fxShow.mm-desktop", ""], ["", "fxHide", ""], ["", "fxHide.mm-mobile", ""], ["", "fxHide.mm-gt-mobile", ""], ["", "fxHide.mm-tablet", ""], ["", "fxHide.mm-gt-tablet", ""], ["", "fxHide.mm-lt-tablet-landscape", ""], ["", "fxHide.mm-tablet-landscape", ""], ["", "fxHide.mm-desktop", ""]], inputs: { fxShow: "fxShow", "fxShow.mm-mobile": "fxShow.mm-mobile", "fxShow.mm-gt-mobile": "fxShow.mm-gt-mobile", "fxShow.mm-tablet": "fxShow.mm-tablet", "fxShow.mm-gt-tablet": "fxShow.mm-gt-tablet", "fxShow.mm-lt-tablet-landscape": "fxShow.mm-lt-tablet-landscape", "fxShow.mm-tablet-landscape": "fxShow.mm-tablet-landscape", "fxShow.mm-desktop": "fxShow.mm-desktop", fxHide: "fxHide", "fxHide.mm-mobile": "fxHide.mm-mobile", "fxHide.mm-gt-mobile": "fxHide.mm-gt-mobile", "fxHide.mm-tablet": "fxHide.mm-tablet", "fxHide.mm-gt-tablet": "fxHide.mm-gt-tablet", "fxHide.mm-lt-tablet-landscape": "fxHide.mm-lt-tablet-landscape", "fxHide.mm-tablet-landscape": "fxHide.mm-tablet-landscape", "fxHide.mm-desktop": "fxHide.mm-desktop" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
const ɵMmShowHideDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MmShowHideDirective);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmShowHideDirective, [{
        type: Directive,
        args: [{ selector: selector$6, inputs: inputs$6 }]
    }], null, null); })();

const selector$7 = `[fxFlexOffset], [fxFlexOffset.mm-mobile], [fxFlexOffset.mm-gt-mobile],
  [fxFlexOffset.mm-tablet], [fxFlexOffset.mm-gt-tablet], [fxFlexOffset.mm-lt-tablet-landscape],
  [fxFlexOffset.mm-tablet-landscape], [fxFlexOffset.mm-desktop]`;
const inputs$7 = ['fxFlexOffset', 'fxFlexOffset.mm-mobile', 'fxFlexOffset.mm-gt-mobile',
    'fxFlexOffset.mm-tablet', 'fxFlexOffset.mm-gt-tablet', 'fxFlexOffset.mm-lt-tablet-landscape',
    'fxFlexOffset.mm-tablet-landscape', 'fxFlexOffset.mm-desktop'];
/* tslint:disable */
class MmFlexOffsetDirective extends FlexOffsetDirective {
    constructor() {
        super(...arguments);
        this.inputs = inputs$7;
    }
}
MmFlexOffsetDirective.ɵfac = function MmFlexOffsetDirective_Factory(t) { return ɵMmFlexOffsetDirective_BaseFactory(t || MmFlexOffsetDirective); };
MmFlexOffsetDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmFlexOffsetDirective, selectors: [["", "fxFlexOffset", ""], ["", "fxFlexOffset.mm-mobile", ""], ["", "fxFlexOffset.mm-gt-mobile", ""], ["", "fxFlexOffset.mm-tablet", ""], ["", "fxFlexOffset.mm-gt-tablet", ""], ["", "fxFlexOffset.mm-lt-tablet-landscape", ""], ["", "fxFlexOffset.mm-tablet-landscape", ""], ["", "fxFlexOffset.mm-desktop", ""]], inputs: { fxFlexOffset: "fxFlexOffset", "fxFlexOffset.mm-mobile": "fxFlexOffset.mm-mobile", "fxFlexOffset.mm-gt-mobile": "fxFlexOffset.mm-gt-mobile", "fxFlexOffset.mm-tablet": "fxFlexOffset.mm-tablet", "fxFlexOffset.mm-gt-tablet": "fxFlexOffset.mm-gt-tablet", "fxFlexOffset.mm-lt-tablet-landscape": "fxFlexOffset.mm-lt-tablet-landscape", "fxFlexOffset.mm-tablet-landscape": "fxFlexOffset.mm-tablet-landscape", "fxFlexOffset.mm-desktop": "fxFlexOffset.mm-desktop" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
const ɵMmFlexOffsetDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MmFlexOffsetDirective);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmFlexOffsetDirective, [{
        type: Directive,
        args: [{ selector: selector$7, inputs: inputs$7 }]
    }], null, null); })();

const MM_BREAKPOINTS_MAP = {
    'mm-mobile': 'screen and (max-width: 767px)',
    'mm-gt-mobile': 'screen and (min-width: 768px)',
    'mm-tablet': 'screen and (min-width: 768px) and (max-width: 1023px)',
    'mm-gt-tablet': 'screen and (min-width: 1024px)',
    'mm-lt-tablet-landscape': 'screen and (max-width: 1023px)',
    'mm-tablet-landscape': 'screen and (min-width: 1024px) and (max-width: 1439px)',
    'mm-desktop': 'screen and (min-width: 1440px)',
};
const ɵ0 = ([key, value]) => ({
    alias: key,
    mediaQuery: value,
    overlapping: false,
});
const MM_BREAKPOINTS = Object.entries(MM_BREAKPOINTS_MAP).map(ɵ0);
const MM_GUTTERS = {
    xs: '16px',
    sm: '16px',
    md: '24px',
    lg: '24px',
    xl: '24px',
};

class MmFlexLayoutModule {
}
MmFlexLayoutModule.ɵfac = function MmFlexLayoutModule_Factory(t) { return new (t || MmFlexLayoutModule)(); };
MmFlexLayoutModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmFlexLayoutModule });
MmFlexLayoutModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmFlexLayoutModule, { declarations: function () { return [MmFlexDirective, MmLayoutDirective, MmLayoutGapDirective, MmLayoutAlignDirective, MmFlexAlignDirective, MmFlexOrderDirective, MmShowHideDirective, MmFlexOffsetDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [MmFlexDirective, MmLayoutDirective, MmLayoutGapDirective, MmLayoutAlignDirective, MmFlexAlignDirective, MmFlexOrderDirective, MmShowHideDirective, MmFlexOffsetDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmFlexLayoutModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    MmFlexDirective,
                    MmLayoutDirective,
                    MmLayoutGapDirective,
                    MmLayoutAlignDirective,
                    MmFlexAlignDirective,
                    MmFlexOrderDirective,
                    MmShowHideDirective,
                    MmFlexOffsetDirective
                ],
                imports: [CommonModule],
                exports: [
                    MmFlexDirective,
                    MmLayoutDirective,
                    MmLayoutGapDirective,
                    MmLayoutAlignDirective,
                    MmFlexAlignDirective,
                    MmFlexOrderDirective,
                    MmShowHideDirective,
                    MmFlexOffsetDirective
                ],
                providers: []
            }]
    }], null, null); })();

class MmChipComponent {
    constructor() {
        this.removed = new EventEmitter();
    }
    remove(content) {
        this.removed.emit({ value: content });
    }
}
MmChipComponent.ɵfac = function MmChipComponent_Factory(t) { return new (t || MmChipComponent)(); };
MmChipComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmChipComponent, selectors: [["mm-chip"]], inputs: { removable: "removable" }, outputs: { removed: "removed" }, ngContentSelectors: _c5, decls: 5, vars: 6, consts: [[1, "mm-chip", 3, "mmTestTarget", "ngClass"], [1, "mm-chip__content", 3, "mmTestTarget"], ["content", ""], ["class", "mm-chip__remove-button", 3, "mmTestTarget", "click", 4, "ngIf"], [1, "mm-chip__remove-button", 3, "mmTestTarget", "click"], ["src", "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiI+ICAgIDxkZWZzPiAgICAgICAgPHBhdGggaWQ9ImEiIGQ9Ik0yMi43MDcgMjEuMjkzYS45OTkuOTk5IDAgMSAxLTEuNDE0IDEuNDE0TDE2IDE3LjQxNGwtNS4yOTMgNS4yOTNhLjk5Ny45OTcgMCAwIDEtMS40MTQgMCAuOTk5Ljk5OSAwIDAgMSAwLTEuNDE0TDE0LjU4NiAxNmwtNS4yOTMtNS4yOTNhLjk5OS45OTkgMCAxIDEgMS40MTQtMS40MTRMMTYgMTQuNTg2bDUuMjkzLTUuMjkzYS45OTkuOTk5IDAgMSAxIDEuNDE0IDEuNDE0TDE3LjQxNCAxNmw1LjI5MyA1LjI5M3oiLz4gICAgPC9kZWZzPiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPHBhdGggZD0iTTAgMGgzMnYzMkgweiIvPiAgICAgICAgPG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPiAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2EiLz4gICAgICAgIDwvbWFzaz4gICAgICAgIDx1c2UgZmlsbD0iIzAwM2M5OCIgeGxpbms6aHJlZj0iI2EiLz4gICAgICAgIDxnIGZpbGw9IiMwMDNjOTgiIG1hc2s9InVybCgjYikiPiAgICAgICAgICAgIDxwYXRoIGQ9Ik0wIDBoMzJ2MzJIMHoiLz4gICAgICAgIDwvZz4gICAgPC9nPjwvc3ZnPg==", "role", "presentation", 1, "mm-chip__icon"]], template: function MmChipComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "span", 1, 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, MmChipComponent_button_4_Template, 2, 1, "button", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("mmTestTarget", "chip")("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c14, ctx.removable));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("mmTestTarget", "chip-content");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.removable);
    } }, directives: [ɵngcc3.ɵf, ɵngcc2.NgClass, ɵngcc2.NgIf], styles: [".mm-chip[_ngcontent-%COMP%]{background-color:inherit;border-radius:20px;overflow:hidden;padding:4px 12px;position:relative}.mm-chip--removable[_ngcontent-%COMP%]{padding-right:40px}.mm-chip__content[_ngcontent-%COMP%]{color:#003c98;display:inline-block;font-size:1.14rem;line-height:1.38}.mm-chip__remove-button[_ngcontent-%COMP%]{-moz-user-select:none;-ms-user-select:none;-webkit-tap-highlight-color:transparent;-webkit-user-select:none;background-color:transparent;border:0;border-radius:50%;cursor:pointer;height:20px;outline:none;padding:0;position:absolute;right:10px;top:calc(50% - 10px);user-select:none;width:20px}.mm-chip__remove-button[_ngcontent-%COMP%]:focus{background-color:#f3f7ff}.mm-chip__icon[_ngcontent-%COMP%]{height:100%;width:100%}"] });
MmChipComponent.propDecorators = {
    removable: [{ type: Input }],
    removed: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmChipComponent, [{
        type: Component,
        args: [{
                selector: 'mm-chip',
                template: "<div class=\"mm-chip\"\n     [mmTestTarget]=\"'chip'\"\n     [ngClass]=\"{'mm-chip--removable': removable}\">\n  <span class=\"mm-chip__content\"\n        [mmTestTarget]=\"'chip-content'\"\n        #content>\n    <ng-content></ng-content>\n  </span>\n    <button class=\"mm-chip__remove-button\"\n            [mmTestTarget]=\"'chip-remove-button'\"\n            *ngIf=\"removable\"\n            (click)=\"remove(content.innerText)\">\n        <img src=\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiI+ICAgIDxkZWZzPiAgICAgICAgPHBhdGggaWQ9ImEiIGQ9Ik0yMi43MDcgMjEuMjkzYS45OTkuOTk5IDAgMSAxLTEuNDE0IDEuNDE0TDE2IDE3LjQxNGwtNS4yOTMgNS4yOTNhLjk5Ny45OTcgMCAwIDEtMS40MTQgMCAuOTk5Ljk5OSAwIDAgMSAwLTEuNDE0TDE0LjU4NiAxNmwtNS4yOTMtNS4yOTNhLjk5OS45OTkgMCAxIDEgMS40MTQtMS40MTRMMTYgMTQuNTg2bDUuMjkzLTUuMjkzYS45OTkuOTk5IDAgMSAxIDEuNDE0IDEuNDE0TDE3LjQxNCAxNmw1LjI5MyA1LjI5M3oiLz4gICAgPC9kZWZzPiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPHBhdGggZD0iTTAgMGgzMnYzMkgweiIvPiAgICAgICAgPG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPiAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2EiLz4gICAgICAgIDwvbWFzaz4gICAgICAgIDx1c2UgZmlsbD0iIzAwM2M5OCIgeGxpbms6aHJlZj0iI2EiLz4gICAgICAgIDxnIGZpbGw9IiMwMDNjOTgiIG1hc2s9InVybCgjYikiPiAgICAgICAgICAgIDxwYXRoIGQ9Ik0wIDBoMzJ2MzJIMHoiLz4gICAgICAgIDwvZz4gICAgPC9nPjwvc3ZnPg==\"\n             role=\"presentation\"\n             class=\"mm-chip__icon\">\n    </button>\n</div>\n\n",
                styles: [".mm-chip{background-color:inherit;border-radius:20px;overflow:hidden;padding:4px 12px;position:relative}.mm-chip--removable{padding-right:40px}.mm-chip__content{color:#003c98;display:inline-block;font-size:1.14rem;line-height:1.38}.mm-chip__remove-button{-moz-user-select:none;-ms-user-select:none;-webkit-tap-highlight-color:transparent;-webkit-user-select:none;background-color:transparent;border:0;border-radius:50%;cursor:pointer;height:20px;outline:none;padding:0;position:absolute;right:10px;top:calc(50% - 10px);user-select:none;width:20px}.mm-chip__remove-button:focus{background-color:#f3f7ff}.mm-chip__icon{height:100%;width:100%}"]
            }]
    }], function () { return []; }, { removed: [{
            type: Output
        }], removable: [{
            type: Input
        }] }); })();

class MmChipModule {
}
MmChipModule.ɵfac = function MmChipModule_Factory(t) { return new (t || MmChipModule)(); };
MmChipModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmChipModule });
MmChipModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            QaLocatorsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmChipModule, { declarations: function () { return [MmChipComponent]; }, imports: function () { return [CommonModule,
        QaLocatorsModule]; }, exports: function () { return [MmChipComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmChipModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    MmChipComponent
                ],
                imports: [
                    CommonModule,
                    QaLocatorsModule,
                ],
                exports: [
                    MmChipComponent
                ]
            }]
    }], null, null); })();

class MmPaginatorComponent {
    constructor(document) {
        this.document = document;
        this.totalCount = 0;
        this.defaultLimit = 15;
        this.useOnlyPaginatorLinks = false;
        this.hideLoadMoreButton = false;
        this.delta = 2;
        this.sideDelta = 1;
        this.scrollTopOnChange = true;
        this.enableLabel = true;
        this.isBot = false;
        this.showLastPage = true;
        this.paginationChange = new EventEmitter();
        this.offsetVector = 20;
        this.currentPage = 1;
        this.isPaginatorVisible = false;
        this.isLoadMoreVisible = false;
        this._loadMoreLabel = template('Show Next ${limit} Items');
        this.document = document;
    }
    set loadMoreLabel(value) {
        if (isString(value)) {
            this._loadMoreLabel = template(value);
        }
    }
    get loadMoreLabel() {
        return this._loadMoreLabel({ 'limit': this.defaultLimit });
    }
    static generatePagesArray({ currentPage, totalPages, delta, sideDelta, showLastPage }) {
        const HALF = 2;
        const DEFAULT = 1;
        const left = currentPage - delta;
        const right = Number(currentPage) + Number(delta) + DEFAULT;
        let midRange = [];
        let leftRange = [];
        let rightRange = [];
        const hasSingleRange = (HALF * Number(sideDelta) + Number(delta) + DEFAULT) === totalPages;
        if (hasSingleRange) {
            return Array.from({ length: totalPages }, (_value, index) => index + 1);
        }
        midRange = Array.from({ length: totalPages }, (_value, index) => index + 1)
            .filter(page => page && page >= left && page < right);
        const hasMultiRange = midRange.length > 1;
        if (hasMultiRange) {
            const hasLeftRange = midRange[0] > 1;
            if (hasLeftRange) {
                leftRange = Array.from({ length: sideDelta }, (_value, index) => index + 1)
                    .filter(page => page < midRange[0]);
                const hasLeftRangeSeparator = (midRange[0] - 1) > leftRange[leftRange.length - 1];
                if (hasLeftRangeSeparator) {
                    leftRange.push(0);
                }
            }
            const hasRightRange = midRange[midRange.length - 1] < totalPages;
            if (hasRightRange) {
                rightRange = Array.from({ length: sideDelta }, (_value, index) => totalPages - index)
                    .reverse()
                    .filter(page => page > midRange[midRange.length - 1]);
                const hasRightRangeSeparator = midRange[midRange.length - 1] < (rightRange[0] - 1);
                if (hasRightRangeSeparator) {
                    rightRange = showLastPage ? [0, ...rightRange] : [0];
                }
            }
        }
        return [...leftRange, ...midRange, ...rightRange];
    }
    ngOnChanges() {
        const queryParams = this.getQueryParams();
        const { offset, limit } = queryParams;
        this.totalPages = Math.ceil(this.totalCount / this.defaultLimit);
        this.isPaginatorVisible = this.totalPages > 1;
        this.isLoadMoreVisible = !this.hideLoadMoreButton
            && this.calculateLoadMoreVisibility(queryParams, this.totalCount);
        this.currentPage = limit !== this.defaultLimit
            ? Math.floor((limit + offset) / this.defaultLimit)
            : Math.floor((offset / this.defaultLimit) + 1);
        this.pages = MmPaginatorComponent.generatePagesArray({
            currentPage: this.currentPage,
            totalPages: this.totalPages,
            delta: this.delta,
            sideDelta: this.sideDelta,
            showLastPage: this.showLastPage
        });
    }
    onNextPage() {
        if (this.totalPages > this.currentPage) {
            const pagination = this.calculatePagination(this.currentPage + 1);
            this.paginationChange.emit(pagination);
            this.scrollTop();
        }
    }
    onPreviousPage() {
        if (this.currentPage > 1) {
            const pagination = this.calculatePagination(this.currentPage - 1);
            this.paginationChange.emit(pagination);
            this.scrollTop();
        }
    }
    onSelectPage(page) {
        const isSeparator = page === 0;
        if (isSeparator) {
            return;
        }
        if (this.currentPage !== page) {
            const pagination = this.calculatePagination(page);
            this.paginationChange.emit(pagination);
            this.scrollTop();
        }
    }
    onLoadMore() {
        const { offset, limit } = this.getQueryParams();
        this.paginationChange.emit({ offset: offset + this.defaultLimit, limit: limit, loadMore: true });
    }
    getQueryParams() {
        const { offset, limit } = this.queryParams;
        return { offset: +offset || 0, limit: +limit || this.defaultLimit };
    }
    scrollTop() {
        if (this.scrollTopOnChange) {
            this.document.body.scrollTop = 0;
            this.document.documentElement.scrollTop = 0;
        }
    }
    calculatePagination(currentPage) {
        return {
            offset: (currentPage - 1) * this.offsetVector,
            limit: this.defaultLimit,
            loadMore: false
        };
    }
    calculateLoadMoreVisibility(q, totalCount) {
        const { offset, limit } = q;
        return offset + limit < totalCount;
    }
}
MmPaginatorComponent.ɵfac = function MmPaginatorComponent_Factory(t) { return new (t || MmPaginatorComponent)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MmPaginatorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmPaginatorComponent, selectors: [["mm-paginator"]], inputs: { totalCount: "totalCount", defaultLimit: "defaultLimit", useOnlyPaginatorLinks: "useOnlyPaginatorLinks", hideLoadMoreButton: "hideLoadMoreButton", delta: "delta", sideDelta: "sideDelta", scrollTopOnChange: "scrollTopOnChange", enableLabel: "enableLabel", isBot: "isBot", showLastPage: "showLastPage", offsetVector: "offsetVector", loadMoreLabel: "loadMoreLabel", queryParams: "queryParams" }, outputs: { paginationChange: "paginationChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "mm-paginator", 3, "ngClass", "mmTestTarget", 4, "ngIf"], [1, "mm-paginator", 3, "ngClass", "mmTestTarget"], ["class", "mm-paginator-load-more", 3, "mmTestTarget", 4, "ngIf"], [4, "ngIf", "ngIfElse"], ["buttonPaginator", ""], [1, "mm-paginator-load-more", 3, "mmTestTarget"], ["mm-button", "", "color", "secondary", 3, "mmTestTarget", "click", 4, "ngIf"], ["mm-button", "", "color", "secondary", 3, "mmTestTarget", "click"], [1, "mm-paginator-pages", 3, "mmTestTarget"], ["queryParamsHandling", "merge", "mm-button", "", "color", "ghost", "class", "mm-paginator-facet", 3, "routerLink", "queryParams", "mmTestTarget", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["queryParamsHandling", "merge", "mm-button", "", "color", "ghost", 1, "mm-paginator-facet", 3, "routerLink", "queryParams", "mmTestTarget"], [1, "facet-chevron_left"], ["queryParamsHandling", "merge", "class", "mm-paginator__page", 3, "routerLink", "queryParams", "ngClass", "mmTestTarget", 4, "ngIf", "ngIfElse"], ["ellipses", ""], ["queryParamsHandling", "merge", 1, "mm-paginator__page", 3, "routerLink", "queryParams", "ngClass", "mmTestTarget"], [1, "mm-paginator__page", 3, "ngClass"], [1, "facet-chevron_right"], [1, "mm-paginator-pages", 3, "mmTestTarget", "ngClass"], ["mm-button", "", "color", "ghost", "class", "mm-paginator-facet", 3, "mmTestTarget", "click", 4, "ngIf"], ["mm-button", "", "color", "ghost", 1, "mm-paginator-facet", 3, "mmTestTarget", "click"], [1, "mm-paginator__page", 3, "ngClass", "mmTestTarget", "click"]], template: function MmPaginatorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, MmPaginatorComponent_div_0_Template, 5, 7, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isPaginatorVisible);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgClass, ɵngcc3.ɵf, MmButtonComponent, ɵngcc2.NgForOf, ɵngcc7.RouterLinkWithHref], styles: [".mm-paginator{align-items:center;display:flex;flex-flow:column nowrap;font-family:Lato,sans-serif;margin:8px 0;width:100%}.mm-paginator .mm-paginator-facet{padding-left:18px;padding-right:18px}.mm-paginator.links-only{margin:0}.mm-paginator__page{color:#002d72;cursor:pointer;font-family:inherit;font-size:16px;margin:0;padding:5px 15px 0;text-decoration:none}.mm-paginator__page:after{border-bottom:1px solid transparent;content:\"\";display:block;height:0;margin-bottom:0;margin-top:4px;transition:border-color .3s linear}.mm-paginator__page--active:after,.mm-paginator__page:hover:after{border-color:#002866}.mm-paginator__ellipses,.mm-paginator__ellipses:hover{border-color:transparent;cursor:default}.mm-paginator .mm-paginator-pages{align-items:flex-end;display:flex;flex-flow:row nowrap;justify-content:flex-end;margin:8px 0}.mm-paginator .mm-paginator-pages.links-only{margin:3px 0 0}.mm-paginator .facet-chevron_left,.mm-paginator .facet-chevron_right{border-bottom:1px solid #002866;border-right:1px solid #002866;display:inline-block;height:8px;width:8px}.mm-paginator .facet-chevron_right{margin-left:-4px;transform:rotate(-45deg)}.mm-paginator .facet-chevron_left{margin-right:-4px;transform:rotate(135deg)}"], encapsulation: 2, changeDetection: 0 });
MmPaginatorComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MmPaginatorComponent.propDecorators = {
    queryParams: [{ type: Input }],
    totalCount: [{ type: Input }],
    defaultLimit: [{ type: Input }],
    useOnlyPaginatorLinks: [{ type: Input }],
    hideLoadMoreButton: [{ type: Input }],
    loadMoreLabel: [{ type: Input, args: ['loadMoreLabel',] }],
    delta: [{ type: Input }],
    sideDelta: [{ type: Input }],
    scrollTopOnChange: [{ type: Input }],
    enableLabel: [{ type: Input }],
    isBot: [{ type: Input }],
    showLastPage: [{ type: Input }],
    paginationChange: [{ type: Output }],
    offsetVector: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmPaginatorComponent, [{
        type: Component,
        args: [{
                selector: 'mm-paginator',
                template: "<div\n    class=\"mm-paginator\"\n    [ngClass]=\"{'links-only': useOnlyPaginatorLinks}\"\n    [mmTestTarget]=\"'paginator'\"\n    *ngIf=\"isPaginatorVisible\">\n    <div *ngIf=\"enableLabel\"\n         class=\"mm-paginator-load-more\"\n         [mmTestTarget]=\"'paginator-load-more'\">\n        <button *ngIf=\"isLoadMoreVisible\"\n                mm-button\n                color=\"secondary\"\n                (click)=\"onLoadMore()\"\n                [mmTestTarget]=\"'paginator-load-more-button'\">\n            {{ loadMoreLabel }}\n        </button>\n    </div>\n    <ng-container *ngIf=\"isBot; else buttonPaginator\">\n        <div class=\"mm-paginator-pages\"\n             [mmTestTarget]=\"'paginator-pages'\">\n            <a *ngIf=\"currentPage !== pages[0] && !useOnlyPaginatorLinks\"\n               [routerLink]=\"\"\n               [queryParams]=\"{ offset: defaultLimit * (currentPage - 2), limit: defaultLimit }\"\n               queryParamsHandling=\"merge\"\n               mm-button\n               color=\"ghost\"\n               class=\"mm-paginator-facet\"\n               [mmTestTarget]=\"'paginator-facet-left'\">\n                <span class=\"facet-chevron_left\"></span>\n            </a>\n            <ng-container *ngFor=\"let page of pages; let first = first; let i = index;\">\n                <a *ngIf=\"page && page !== currentPage; else ellipses\"\n                   [routerLink]=\"\"\n                   [queryParams]=\"{ offset: defaultLimit * (page - 1), limit: defaultLimit }\"\n                   queryParamsHandling=\"merge\"\n                   class=\"mm-paginator__page\"\n                   [ngClass]=\"{'mm-paginator__page--active': page === currentPage}\"\n                   [mmTestTarget]=\"'paginator-page'\">\n                    {{ page }}\n                </a>\n                <ng-template #ellipses>\n                    <span class=\"mm-paginator__page\"\n                          [ngClass]=\"{'mm-paginator__page--active': page === currentPage, 'mm-paginator__ellipses': !page}\">\n                        {{ page || '...' }}\n                    </span>\n                </ng-template>\n            </ng-container>\n            <a *ngIf=\"currentPage !== pages[pages.length - 1] && !useOnlyPaginatorLinks\"\n               [routerLink]=\"\"\n               [queryParams]=\"{ offset: defaultLimit * currentPage, limit: defaultLimit }\"\n               queryParamsHandling=\"merge\"\n               mm-button\n               color=\"ghost\"\n               class=\"mm-paginator-facet\"\n               [mmTestTarget]=\"'paginator-facet-right'\">\n                <span class=\"facet-chevron_right\"></span>\n            </a>\n        </div>\n    </ng-container>\n    <ng-template #buttonPaginator>\n        <div class=\"mm-paginator-pages\"\n             [mmTestTarget]=\"'paginator-pages'\"\n             [ngClass]=\"{'links-only': useOnlyPaginatorLinks}\">\n            <button *ngIf=\"!useOnlyPaginatorLinks\"\n                    mm-button\n                    color=\"ghost\"\n                    class=\"mm-paginator-facet\"\n                    (click)=\"onPreviousPage()\"\n                    [mmTestTarget]=\"'paginator-facet-left'\">\n                <span class=\"facet-chevron_left\"></span>\n            </button>\n            <ng-container *ngFor=\"let page of pages; let first = first; let i = index;\">\n            <span class=\"mm-paginator__page\"\n                  [ngClass]=\"{'mm-paginator__page--active': page === currentPage, 'mm-paginator__ellipses': !page}\"\n                  (click)=\"onSelectPage(page)\"\n                  [mmTestTarget]=\"'paginator-page'\">\n              {{ page ? page : '...' }}\n            </span>\n            </ng-container>\n            <button *ngIf=\"!useOnlyPaginatorLinks\"\n                    mm-button\n                    color=\"ghost\"\n                    class=\"mm-paginator-facet\"\n                    (click)=\"onNextPage()\"\n                    [mmTestTarget]=\"'paginator-facet-right'\">\n                <span class=\"facet-chevron_right\"></span>\n            </button>\n        </div>\n    </ng-template>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".mm-paginator{align-items:center;display:flex;flex-flow:column nowrap;font-family:Lato,sans-serif;margin:8px 0;width:100%}.mm-paginator .mm-paginator-facet{padding-left:18px;padding-right:18px}.mm-paginator.links-only{margin:0}.mm-paginator__page{color:#002d72;cursor:pointer;font-family:inherit;font-size:16px;margin:0;padding:5px 15px 0;text-decoration:none}.mm-paginator__page:after{border-bottom:1px solid transparent;content:\"\";display:block;height:0;margin-bottom:0;margin-top:4px;transition:border-color .3s linear}.mm-paginator__page--active:after,.mm-paginator__page:hover:after{border-color:#002866}.mm-paginator__ellipses,.mm-paginator__ellipses:hover{border-color:transparent;cursor:default}.mm-paginator .mm-paginator-pages{align-items:flex-end;display:flex;flex-flow:row nowrap;justify-content:flex-end;margin:8px 0}.mm-paginator .mm-paginator-pages.links-only{margin:3px 0 0}.mm-paginator .facet-chevron_left,.mm-paginator .facet-chevron_right{border-bottom:1px solid #002866;border-right:1px solid #002866;display:inline-block;height:8px;width:8px}.mm-paginator .facet-chevron_right{margin-left:-4px;transform:rotate(-45deg)}.mm-paginator .facet-chevron_left{margin-right:-4px;transform:rotate(135deg)}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { totalCount: [{
            type: Input
        }], defaultLimit: [{
            type: Input
        }], useOnlyPaginatorLinks: [{
            type: Input
        }], hideLoadMoreButton: [{
            type: Input
        }], delta: [{
            type: Input
        }], sideDelta: [{
            type: Input
        }], scrollTopOnChange: [{
            type: Input
        }], enableLabel: [{
            type: Input
        }], isBot: [{
            type: Input
        }], showLastPage: [{
            type: Input
        }], paginationChange: [{
            type: Output
        }], offsetVector: [{
            type: Input
        }], loadMoreLabel: [{
            type: Input,
            args: ['loadMoreLabel']
        }], queryParams: [{
            type: Input
        }] }); })();

class MmPaginatorModule {
}
MmPaginatorModule.ɵfac = function MmPaginatorModule_Factory(t) { return new (t || MmPaginatorModule)(); };
MmPaginatorModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmPaginatorModule });
MmPaginatorModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            RouterModule,
            MmButtonModule,
            QaLocatorsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmPaginatorModule, { declarations: function () { return [MmPaginatorComponent]; }, imports: function () { return [CommonModule,
        RouterModule, MmButtonModule, QaLocatorsModule]; }, exports: function () { return [MmPaginatorComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmPaginatorModule, [{
        type: NgModule,
        args: [{
                declarations: [MmPaginatorComponent],
                imports: [
                    CommonModule,
                    RouterModule,
                    MmButtonModule,
                    QaLocatorsModule,
                ],
                exports: [MmPaginatorComponent]
            }]
    }], null, null); })();

class MmSidebarItemComponent {
}
MmSidebarItemComponent.ɵfac = function MmSidebarItemComponent_Factory(t) { return new (t || MmSidebarItemComponent)(); };
MmSidebarItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmSidebarItemComponent, selectors: [["mm-sidebar-item"]], inputs: { link: "link", icon: "icon" }, ngContentSelectors: _c5, decls: 5, vars: 5, consts: [[1, "mm-sidebar-item", 3, "mmTestTarget"], ["routerLinkActive", "mm-sidebar-item--selected", 1, "mm-sidebar-item__link", 3, "mmTestTarget", "routerLink"], [1, "mm-sidebar-item__icon", 3, "svgIcon"], [1, "mm-sidebar-item__content", 3, "mmTestTarget"]], template: function MmSidebarItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "a", 1);
        ɵngcc0.ɵɵelement(2, "mat-icon", 2);
        ɵngcc0.ɵɵelementStart(3, "span", 3);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("mmTestTarget", "sidebar-item");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("mmTestTarget", "sidebar-item-link")("routerLink", ctx.link);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("svgIcon", ctx.icon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("mmTestTarget", "sidebar-item-content");
    } }, directives: [ɵngcc3.ɵf, ɵngcc7.RouterLinkWithHref, ɵngcc7.RouterLinkActive, ɵngcc8.MatIcon], styles: [".mm-sidebar-item[_ngcontent-%COMP%]{align-items:center;background-color:#fff;color:#0064fe;cursor:pointer;display:flex;font-family:Lato,sans-serif;font-size:1.14rem;font-weight:700;line-height:1.25;padding:10px 72px 26px 64px}.mm-sidebar-item[_ngcontent-%COMP%]   .mm-sidebar-item--selected[_ngcontent-%COMP%], .mm-sidebar-item[_ngcontent-%COMP%]:active, .mm-sidebar-item[_ngcontent-%COMP%]:focus, .mm-sidebar-item[_ngcontent-%COMP%]:hover{color:#002866}.mm-sidebar-item[_ngcontent-%COMP%]   .mm-sidebar-item--selected[_ngcontent-%COMP%]   .mm-sidebar-item__icon[_ngcontent-%COMP%]{fill:#002866}.mm-sidebar-item[_ngcontent-%COMP%]     .mm-sidebar-item__link{align-items:center;color:#0064fe;display:flex;text-decoration:none;width:100%}.mm-sidebar-item[_ngcontent-%COMP%]     .mm-sidebar-item__link:active, .mm-sidebar-item[_ngcontent-%COMP%]     .mm-sidebar-item__link:hover{color:#002866;text-decoration:none}.mm-sidebar-item[_ngcontent-%COMP%]     .mm-sidebar-item__link:active .mm-sidebar-item__content, .mm-sidebar-item[_ngcontent-%COMP%]     .mm-sidebar-item__link:hover .mm-sidebar-item__content{display:block;text-decoration:underline}.mm-sidebar-item[_ngcontent-%COMP%]     .mm-sidebar-item__link:active .mm-sidebar-item__icon, .mm-sidebar-item[_ngcontent-%COMP%]     .mm-sidebar-item__link:hover .mm-sidebar-item__icon{fill:#002866}.mm-sidebar-item[_ngcontent-%COMP%]     .mm-sidebar-item__link.active, .mm-sidebar-item[_ngcontent-%COMP%]     .mm-sidebar-item__link.active~{color:#002866}.mm-sidebar-item[_ngcontent-%COMP%]   .mm-sidebar-item__icon[_ngcontent-%COMP%]{fill:#0064fe;font-size:20px;height:20px;line-height:20px;margin-right:14px;width:20px}"] });
MmSidebarItemComponent.propDecorators = {
    link: [{ type: Input }],
    icon: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmSidebarItemComponent, [{
        type: Component,
        args: [{
                selector: 'mm-sidebar-item',
                template: "<div class=\"mm-sidebar-item\"\n     [mmTestTarget]=\"'sidebar-item'\">\n    <a class=\"mm-sidebar-item__link\"\n       [mmTestTarget]=\"'sidebar-item-link'\"\n       routerLinkActive=\"mm-sidebar-item--selected\"\n       [routerLink]=\"link\">\n        <mat-icon svgIcon=\"{{icon}}\"\n                  class=\"mm-sidebar-item__icon\"></mat-icon>\n        <span class=\"mm-sidebar-item__content\"\n              [mmTestTarget]=\"'sidebar-item-content'\">\n            <ng-content></ng-content>\n        </span>\n    </a>\n</div>\n",
                styles: [".mm-sidebar-item{align-items:center;background-color:#fff;color:#0064fe;cursor:pointer;display:flex;font-family:Lato,sans-serif;font-size:1.14rem;font-weight:700;line-height:1.25;padding:10px 72px 26px 64px}.mm-sidebar-item .mm-sidebar-item--selected,.mm-sidebar-item:active,.mm-sidebar-item:focus,.mm-sidebar-item:hover{color:#002866}.mm-sidebar-item .mm-sidebar-item--selected .mm-sidebar-item__icon{fill:#002866}.mm-sidebar-item ::ng-deep .mm-sidebar-item__link{align-items:center;color:#0064fe;display:flex;text-decoration:none;width:100%}.mm-sidebar-item ::ng-deep .mm-sidebar-item__link:active,.mm-sidebar-item ::ng-deep .mm-sidebar-item__link:hover{color:#002866;text-decoration:none}.mm-sidebar-item ::ng-deep .mm-sidebar-item__link:active .mm-sidebar-item__content,.mm-sidebar-item ::ng-deep .mm-sidebar-item__link:hover .mm-sidebar-item__content{display:block;text-decoration:underline}.mm-sidebar-item ::ng-deep .mm-sidebar-item__link:active .mm-sidebar-item__icon,.mm-sidebar-item ::ng-deep .mm-sidebar-item__link:hover .mm-sidebar-item__icon{fill:#002866}.mm-sidebar-item ::ng-deep .mm-sidebar-item__link.active,.mm-sidebar-item ::ng-deep .mm-sidebar-item__link.active~{color:#002866}.mm-sidebar-item .mm-sidebar-item__icon{fill:#0064fe;font-size:20px;height:20px;line-height:20px;margin-right:14px;width:20px}"]
            }]
    }], null, { link: [{
            type: Input
        }], icon: [{
            type: Input
        }] }); })();

class MmSidebarComponent {
}
MmSidebarComponent.ɵfac = function MmSidebarComponent_Factory(t) { return new (t || MmSidebarComponent)(); };
MmSidebarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmSidebarComponent, selectors: [["mm-sidebar"]], contentQueries: function MmSidebarComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MmSidebarItemComponent, 0);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.list = _t);
    } }, ngContentSelectors: _c5, decls: 2, vars: 0, consts: [[1, "mm-sidebar"]], template: function MmSidebarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [".mm-sidebar[_ngcontent-%COMP%]{display:block;min-width:316px;padding-top:36px}"] });
MmSidebarComponent.propDecorators = {
    list: [{ type: ContentChildren, args: [MmSidebarItemComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmSidebarComponent, [{
        type: Component,
        args: [{
                selector: 'mm-sidebar',
                template: `
      <div class="mm-sidebar">
          <ng-content></ng-content>
      </div>
  `,
                styles: [".mm-sidebar{display:block;min-width:316px;padding-top:36px}"]
            }]
    }], null, { list: [{
            type: ContentChildren,
            args: [MmSidebarItemComponent]
        }] }); })();

class MmSidebarDividerComponent {
    constructor() {
        this.base = true;
    }
}
MmSidebarDividerComponent.ɵfac = function MmSidebarDividerComponent_Factory(t) { return new (t || MmSidebarDividerComponent)(); };
MmSidebarDividerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmSidebarDividerComponent, selectors: [["mm-sidebar-divider"]], hostVars: 2, hostBindings: function MmSidebarDividerComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mm-sidebar__divider", ctx.base);
    } }, decls: 1, vars: 0, consts: [[1, "mm-sidebar-divider"]], template: function MmSidebarDividerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
    } }, styles: [".mm-sidebar-divider[_ngcontent-%COMP%]{border-bottom:1px solid #e6e8eb;display:block;height:1px;margin:4px 0 22px}"], changeDetection: 0 });
MmSidebarDividerComponent.propDecorators = {
    base: [{ type: HostBinding, args: ['class.mm-sidebar__divider',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmSidebarDividerComponent, [{
        type: Component,
        args: [{
                selector: 'mm-sidebar-divider',
                template: '<div class="mm-sidebar-divider"></div>',
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".mm-sidebar-divider{border-bottom:1px solid #e6e8eb;display:block;height:1px;margin:4px 0 22px}"]
            }]
    }], function () { return []; }, { base: [{
            type: HostBinding,
            args: ['class.mm-sidebar__divider']
        }] }); })();

class MmSidebarModule {
}
MmSidebarModule.ɵfac = function MmSidebarModule_Factory(t) { return new (t || MmSidebarModule)(); };
MmSidebarModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmSidebarModule });
MmSidebarModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            RouterModule,
            MatIconModule,
            QaLocatorsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmSidebarModule, { declarations: function () { return [MmSidebarComponent, MmSidebarItemComponent, MmSidebarDividerComponent]; }, imports: function () { return [CommonModule,
        RouterModule,
        MatIconModule,
        QaLocatorsModule]; }, exports: function () { return [MmSidebarComponent, MmSidebarItemComponent, MmSidebarDividerComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmSidebarModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    RouterModule,
                    MatIconModule,
                    QaLocatorsModule,
                ],
                exports: [
                    MmSidebarComponent,
                    MmSidebarItemComponent,
                    MmSidebarDividerComponent,
                ],
                declarations: [
                    MmSidebarComponent,
                    MmSidebarItemComponent,
                    MmSidebarDividerComponent,
                ]
            }]
    }], null, null); })();

class MmAccordionItemComponent {
    constructor() {
        this.expanded = false;
        this.selected = new EventEmitter();
    }
    toggleExpanded() {
        this.expanded = !this.expanded;
        this.selected.emit({ expanded: this.expanded });
    }
}
MmAccordionItemComponent.ɵfac = function MmAccordionItemComponent_Factory(t) { return new (t || MmAccordionItemComponent)(); };
MmAccordionItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmAccordionItemComponent, selectors: [["mm-accordion-item"]], inputs: { expanded: "expanded", title: "title" }, outputs: { selected: "selected" }, ngContentSelectors: _c5, decls: 11, vars: 9, consts: [[1, "mm-accordion__item", 3, "mmTestTarget", "ngClass"], [1, "mm-accordion__heading", 3, "mmTestTarget", "click"], [1, "mm-accordion__title", 3, "mmTestTarget"], [1, "mm-accordion__chevron", 3, "mmTestTarget"], [1, "mm-accordion__icon", "mm-accordion__icon--add"], [1, "mm-accordion__icon", "mm-accordion__icon--remove"], [1, "mm-accordion__content", 3, "mmTestTarget"]], template: function MmAccordionItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "dt", 1);
        ɵngcc0.ɵɵlistener("click", function MmAccordionItemComponent_Template_dt_click_1_listener() { return ctx.toggleExpanded(); });
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "mat-icon", 4);
        ɵngcc0.ɵɵtext(6, "add");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "mat-icon", 5);
        ɵngcc0.ɵɵtext(8, "remove");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "dd", 6);
        ɵngcc0.ɵɵprojection(10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("mmTestTarget", "accordion-item")("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c19, ctx.expanded));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("mmTestTarget", "accordion-heading");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("mmTestTarget", "accordion-title");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("mmTestTarget", "accordion-chevron");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("mmTestTarget", "accordion-content");
    } }, directives: [ɵngcc3.ɵf, ɵngcc2.NgClass, ɵngcc8.MatIcon], styles: [".mm-accordion__heading[_ngcontent-%COMP%]{-moz-user-select:none;-ms-user-select:none;-webkit-tap-highlight-color:transparent;-webkit-user-select:none;align-items:center;cursor:pointer;display:flex;height:92px;user-select:none}.mm-accordion__heading[_ngcontent-%COMP%]:focus   .mm-accordion__chevron[_ngcontent-%COMP%]   .mm-accordion__icon[_ngcontent-%COMP%], .mm-accordion__heading[_ngcontent-%COMP%]:focus   .mm-accordion__title[_ngcontent-%COMP%], .mm-accordion__heading[_ngcontent-%COMP%]:hover   .mm-accordion__chevron[_ngcontent-%COMP%]   .mm-accordion__icon[_ngcontent-%COMP%], .mm-accordion__heading[_ngcontent-%COMP%]:hover   .mm-accordion__title[_ngcontent-%COMP%]{color:#0064fe}.mm-accordion__heading[_ngcontent-%COMP%]   .mm-accordion__title[_ngcontent-%COMP%]{color:#002866;flex-grow:1;font-family:Lato,sans-serif;font-size:2.28rem;font-weight:700;height:50px;line-height:50px}.mm-accordion__heading[_ngcontent-%COMP%]   .mm-accordion__chevron[_ngcontent-%COMP%]{width:50px}.mm-accordion__heading[_ngcontent-%COMP%]   .mm-accordion__chevron[_ngcontent-%COMP%]   .mm-accordion__icon[_ngcontent-%COMP%]{color:#002866;font-size:28px;font-weight:900;height:28px;line-height:28px;width:28px}.mm-accordion__heading[_ngcontent-%COMP%]   .mm-accordion__chevron[_ngcontent-%COMP%]   .mm-accordion__icon--add[_ngcontent-%COMP%]{display:block}.mm-accordion__heading[_ngcontent-%COMP%]   .mm-accordion__chevron[_ngcontent-%COMP%]   .mm-accordion__icon--remove[_ngcontent-%COMP%]{display:none}.mm-accordion__content[_ngcontent-%COMP%]{margin:0;padding:20px 0}.mm-accordion__item[_ngcontent-%COMP%]{border-bottom:1px solid #e6e8eb;max-height:92px;overflow:hidden;transition-duration:.5s;transition-timing-function:cubic-bezier(0,1,.5,1)}.mm-accordion__item--active[_ngcontent-%COMP%]{max-height:3000px;overflow:hidden;transition-duration:1.2s;transition-timing-function:ease-in}.mm-accordion__item--active[_ngcontent-%COMP%]   .mm-accordion__chevron[_ngcontent-%COMP%]   .mm-accordion__icon--add[_ngcontent-%COMP%]{display:none}.mm-accordion__item--active[_ngcontent-%COMP%]   .mm-accordion__chevron[_ngcontent-%COMP%]   .mm-accordion__icon--remove[_ngcontent-%COMP%]{display:block}@media only screen and (max-width:768px){.mm-accordion__heading[_ngcontent-%COMP%]{height:54px}.mm-accordion__heading[_ngcontent-%COMP%]   .mm-accordion__title[_ngcontent-%COMP%]{font-size:1.7rem}.mm-accordion__heading[_ngcontent-%COMP%]   .mm-accordion__chevron[_ngcontent-%COMP%]{width:50px}.mm-accordion__heading[_ngcontent-%COMP%]   .mm-accordion__chevron[_ngcontent-%COMP%]   .mm-accordion__icon[_ngcontent-%COMP%]{font-size:26px;font-weight:400;height:26px;line-height:26px;width:26px}.mm-accordion__item[_ngcontent-%COMP%]{max-height:54px;overflow:hidden;transition-duration:.5s;transition-timing-function:cubic-bezier(0,1,.5,1)}.mm-accordion__item--active[_ngcontent-%COMP%]{max-height:3000px;transition-duration:1.2s;transition-timing-function:ease-in}}"] });
MmAccordionItemComponent.propDecorators = {
    expanded: [{ type: Input }],
    title: [{ type: Input }],
    selected: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmAccordionItemComponent, [{
        type: Component,
        args: [{
                selector: 'mm-accordion-item',
                template: "<div class=\"mm-accordion__item\"\n     [mmTestTarget]=\"'accordion-item'\"\n     [ngClass]=\"{'mm-accordion__item--active': expanded}\">\n    <dt class='mm-accordion__heading'\n        [mmTestTarget]=\"'accordion-heading'\"\n        (click)='toggleExpanded()'>\n        <div class=\"mm-accordion__title\"\n             [mmTestTarget]=\"'accordion-title'\">\n            {{title}}\n        </div>\n        <div class='mm-accordion__chevron'\n             [mmTestTarget]=\"'accordion-chevron'\">\n            <mat-icon class=\"mm-accordion__icon mm-accordion__icon--add\">add</mat-icon>\n            <mat-icon class=\"mm-accordion__icon mm-accordion__icon--remove\">remove</mat-icon>\n        </div>\n    </dt>\n    <dd class='mm-accordion__content'\n        [mmTestTarget]=\"'accordion-content'\">\n        <ng-content></ng-content>\n    </dd>\n</div>\n",
                styles: [".mm-accordion__heading{-moz-user-select:none;-ms-user-select:none;-webkit-tap-highlight-color:transparent;-webkit-user-select:none;align-items:center;cursor:pointer;display:flex;height:92px;user-select:none}.mm-accordion__heading:focus .mm-accordion__chevron .mm-accordion__icon,.mm-accordion__heading:focus .mm-accordion__title,.mm-accordion__heading:hover .mm-accordion__chevron .mm-accordion__icon,.mm-accordion__heading:hover .mm-accordion__title{color:#0064fe}.mm-accordion__heading .mm-accordion__title{color:#002866;flex-grow:1;font-family:Lato,sans-serif;font-size:2.28rem;font-weight:700;height:50px;line-height:50px}.mm-accordion__heading .mm-accordion__chevron{width:50px}.mm-accordion__heading .mm-accordion__chevron .mm-accordion__icon{color:#002866;font-size:28px;font-weight:900;height:28px;line-height:28px;width:28px}.mm-accordion__heading .mm-accordion__chevron .mm-accordion__icon--add{display:block}.mm-accordion__heading .mm-accordion__chevron .mm-accordion__icon--remove{display:none}.mm-accordion__content{margin:0;padding:20px 0}.mm-accordion__item{border-bottom:1px solid #e6e8eb;max-height:92px;overflow:hidden;transition-duration:.5s;transition-timing-function:cubic-bezier(0,1,.5,1)}.mm-accordion__item--active{max-height:3000px;overflow:hidden;transition-duration:1.2s;transition-timing-function:ease-in}.mm-accordion__item--active .mm-accordion__chevron .mm-accordion__icon--add{display:none}.mm-accordion__item--active .mm-accordion__chevron .mm-accordion__icon--remove{display:block}@media only screen and (max-width:768px){.mm-accordion__heading{height:54px}.mm-accordion__heading .mm-accordion__title{font-size:1.7rem}.mm-accordion__heading .mm-accordion__chevron{width:50px}.mm-accordion__heading .mm-accordion__chevron .mm-accordion__icon{font-size:26px;font-weight:400;height:26px;line-height:26px;width:26px}.mm-accordion__item{max-height:54px;overflow:hidden;transition-duration:.5s;transition-timing-function:cubic-bezier(0,1,.5,1)}.mm-accordion__item--active{max-height:3000px;transition-duration:1.2s;transition-timing-function:ease-in}}"]
            }]
    }], function () { return []; }, { expanded: [{
            type: Input
        }], selected: [{
            type: Output
        }], title: [{
            type: Input
        }] }); })();

class MmAccordionComponent {
}
MmAccordionComponent.ɵfac = function MmAccordionComponent_Factory(t) { return new (t || MmAccordionComponent)(); };
MmAccordionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmAccordionComponent, selectors: [["mm-accordion"]], ngContentSelectors: _c5, decls: 2, vars: 0, consts: [[1, "mm-accordion"]], template: function MmAccordionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "dl", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmAccordionComponent, [{
        type: Component,
        args: [{
                selector: 'mm-accordion',
                template: `
		<dl class='mm-accordion'>
			<ng-content></ng-content>
		</dl>
	`
            }]
    }], null, null); })();

class MmAccordionModule {
}
MmAccordionModule.ɵfac = function MmAccordionModule_Factory(t) { return new (t || MmAccordionModule)(); };
MmAccordionModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmAccordionModule });
MmAccordionModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            MatIconModule,
            QaLocatorsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmAccordionModule, { declarations: function () { return [MmAccordionItemComponent, MmAccordionComponent]; }, imports: function () { return [CommonModule,
        MatIconModule,
        QaLocatorsModule]; }, exports: function () { return [MmAccordionItemComponent, MmAccordionComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmAccordionModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    MmAccordionItemComponent,
                    MmAccordionComponent
                ],
                exports: [
                    MmAccordionItemComponent,
                    MmAccordionComponent
                ],
                imports: [
                    CommonModule,
                    MatIconModule,
                    QaLocatorsModule,
                ]
            }]
    }], null, null); })();

class MmTableContainerComponent {
}
MmTableContainerComponent.ɵfac = function MmTableContainerComponent_Factory(t) { return new (t || MmTableContainerComponent)(); };
MmTableContainerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmTableContainerComponent, selectors: [["mm-table-container"]], exportAs: ["mmTableContainer"], ngContentSelectors: _c5, decls: 2, vars: 0, consts: [[1, "mm-table-container"]], template: function MmTableContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [".mm-table-container[_ngcontent-%COMP%]{background-color:#fff;min-height:170px;overflow:auto;position:relative;width:100%}.mm-table-container[_ngcontent-%COMP%]::-webkit-scrollbar-track{background-color:#f2f3f5;border-radius:0}.mm-table-container[_ngcontent-%COMP%]::-webkit-scrollbar{background-color:#f2f3f5;height:10px}.mm-table-container[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background-color:#ddd;border-radius:6px;width:6px}.mm-table[_ngcontent-%COMP%]{border-collapse:collapse;position:relative;width:100%}.mm-table[_ngcontent-%COMP%]   .mm-cell[_ngcontent-%COMP%]{border-bottom:1px solid #e6e8eb;color:#002d72;font-family:Lato,sans-serif;font-size:14px;font-weight:400;line-height:1.7;min-width:100%;overflow:hidden;padding:16px;text-overflow:ellipsis;vertical-align:top;white-space:nowrap}.mm-table[_ngcontent-%COMP%]   .mm-cell[_ngcontent-%COMP%]:first-of-type{padding-left:32px}.mm-table[_ngcontent-%COMP%]   .mm-cell[_ngcontent-%COMP%]:last-of-type{padding-right:32px}.mm-table[_ngcontent-%COMP%]   .mm-cell.mm-column-sticky[_ngcontent-%COMP%]{background-color:#fff;padding-right:32px}.mm-table[_ngcontent-%COMP%]   .mm-header-cell[_ngcontent-%COMP%]{border-bottom:2px solid #002866;color:#002d72;cursor:default;font-family:Lato,sans-serif;font-size:14px;font-weight:700;line-height:1.38;overflow:hidden;padding:16px;text-align:left;text-overflow:ellipsis;vertical-align:top;white-space:nowrap;width:50px}.mm-table[_ngcontent-%COMP%]   .mm-header-cell[_ngcontent-%COMP%]:first-of-type{padding-left:32px}.mm-table[_ngcontent-%COMP%]   .mm-header-cell[_ngcontent-%COMP%]:last-of-type{padding-right:32px}.mm-table[_ngcontent-%COMP%]   .mm-header-cell.mm-column-sticky[_ngcontent-%COMP%]{background-color:#fff;padding-right:32px}.mm-table[_ngcontent-%COMP%]   .mm-text-align--left[_ngcontent-%COMP%]{text-align:left}.mm-table[_ngcontent-%COMP%]   .mm-text-align--center[_ngcontent-%COMP%]{text-align:center}.mm-table[_ngcontent-%COMP%]   .mm-text-align--right[_ngcontent-%COMP%], .mm-table[_ngcontent-%COMP%]   .mm-text-align--right[_ngcontent-%COMP%]   .mm-sort-header-button[_ngcontent-%COMP%]{text-align:right}.mm-table[_ngcontent-%COMP%]   .mm-font-weight--light[_ngcontent-%COMP%]{font-weight:400}.mm-table[_ngcontent-%COMP%]   .mm-font-weight--bolder[_ngcontent-%COMP%]{font-weight:700}.mm-table[_ngcontent-%COMP%]   .mm-font-weight--bold[_ngcontent-%COMP%]{font-weight:900}.mm-table[_ngcontent-%COMP%]   .mm-text-color--green[_ngcontent-%COMP%]{color:#34c082}.mm-table[_ngcontent-%COMP%]   .mm-text-color--red[_ngcontent-%COMP%]{color:#de351b}.mm-table[_ngcontent-%COMP%]   .mm-text-color--orange[_ngcontent-%COMP%]{color:#ff9f00}.mm-table[_ngcontent-%COMP%]   .mm-text-color--grey[_ngcontent-%COMP%]{color:#99abc7}.mm-table[_ngcontent-%COMP%]   .mm-text-color--blue[_ngcontent-%COMP%]{color:#0064fe}.mm-table-pagination[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;padding:10px 32px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmTableContainerComponent, [{
        type: Component,
        args: [{
                selector: 'mm-table-container',
                exportAs: 'mmTableContainer',
                template: "<div class=\"mm-table-container\">\n    <ng-content></ng-content>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".mm-table-container{background-color:#fff;min-height:170px;overflow:auto;position:relative;width:100%}.mm-table-container::-webkit-scrollbar-track{background-color:#f2f3f5;border-radius:0}.mm-table-container::-webkit-scrollbar{background-color:#f2f3f5;height:10px}.mm-table-container::-webkit-scrollbar-thumb{background-color:#ddd;border-radius:6px;width:6px}.mm-table{border-collapse:collapse;position:relative;width:100%}.mm-table .mm-cell{border-bottom:1px solid #e6e8eb;color:#002d72;font-family:Lato,sans-serif;font-size:14px;font-weight:400;line-height:1.7;min-width:100%;overflow:hidden;padding:16px;text-overflow:ellipsis;vertical-align:top;white-space:nowrap}.mm-table .mm-cell:first-of-type{padding-left:32px}.mm-table .mm-cell:last-of-type{padding-right:32px}.mm-table .mm-cell.mm-column-sticky{background-color:#fff;padding-right:32px}.mm-table .mm-header-cell{border-bottom:2px solid #002866;color:#002d72;cursor:default;font-family:Lato,sans-serif;font-size:14px;font-weight:700;line-height:1.38;overflow:hidden;padding:16px;text-align:left;text-overflow:ellipsis;vertical-align:top;white-space:nowrap;width:50px}.mm-table .mm-header-cell:first-of-type{padding-left:32px}.mm-table .mm-header-cell:last-of-type{padding-right:32px}.mm-table .mm-header-cell.mm-column-sticky{background-color:#fff;padding-right:32px}.mm-table .mm-text-align--left{text-align:left}.mm-table .mm-text-align--center{text-align:center}.mm-table .mm-text-align--right,.mm-table .mm-text-align--right .mm-sort-header-button{text-align:right}.mm-table .mm-font-weight--light{font-weight:400}.mm-table .mm-font-weight--bolder{font-weight:700}.mm-table .mm-font-weight--bold{font-weight:900}.mm-table .mm-text-color--green{color:#34c082}.mm-table .mm-text-color--red{color:#de351b}.mm-table .mm-text-color--orange{color:#ff9f00}.mm-table .mm-text-color--grey{color:#99abc7}.mm-table .mm-text-color--blue{color:#0064fe}.mm-table-pagination{display:flex;justify-content:flex-end;padding:10px 32px}"]
            }]
    }], null, null); })();

class MmTableEmptyStateTemplateComponent {
}
MmTableEmptyStateTemplateComponent.ɵfac = function MmTableEmptyStateTemplateComponent_Factory(t) { return new (t || MmTableEmptyStateTemplateComponent)(); };
MmTableEmptyStateTemplateComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmTableEmptyStateTemplateComponent, selectors: [["mm-table-empty-state-template"]], exportAs: ["mmTableEmptyStateTemplateComponent"], ngContentSelectors: _c5, decls: 3, vars: 2, consts: [[1, "mm-table-empty-state__wrapper", 3, "mmTestTarget"], [1, "mm-table-empty-state__template", 3, "mmTestTarget"]], template: function MmTableEmptyStateTemplateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("mmTestTarget", "table-empty-state-wrapper");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("mmTestTarget", "table-empty-state-template");
    } }, directives: [ɵngcc3.ɵf], styles: [".mm-table-empty-state__template[_ngcontent-%COMP%]{color:#99abc7;font-size:14px;font-weight:400;text-align:center}.mm-table-empty-state__wrapper[_ngcontent-%COMP%]{left:0;position:absolute;top:82px;width:100%;z-index:5}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmTableEmptyStateTemplateComponent, [{
        type: Component,
        args: [{
                selector: 'mm-table-empty-state-template',
                exportAs: 'mmTableEmptyStateTemplateComponent',
                template: "<div class=\"mm-table-empty-state__wrapper\"\n     [mmTestTarget]=\"'table-empty-state-wrapper'\">\n    <div class=\"mm-table-empty-state__template\"\n         [mmTestTarget]=\"'table-empty-state-template'\">\n        <ng-content></ng-content>\n    </div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".mm-table-empty-state__template{color:#99abc7;font-size:14px;font-weight:400;text-align:center}.mm-table-empty-state__wrapper{left:0;position:absolute;top:82px;width:100%;z-index:5}"]
            }]
    }], null, null); })();

class MmTableLoaderComponent {
}
MmTableLoaderComponent.ɵfac = function MmTableLoaderComponent_Factory(t) { return new (t || MmTableLoaderComponent)(); };
MmTableLoaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmTableLoaderComponent, selectors: [["mm-table-loader"]], exportAs: ["mmTableLoader"], decls: 3, vars: 2, consts: [[1, "mm-table-loader__wrapper", 3, "mmTestTarget"], [1, "mm-table-loader", 3, "mmTestTarget"], ["diameter", "32", "strokeWidth", "2"]], template: function MmTableLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "mat-spinner", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("mmTestTarget", "table-loader-wrapper");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("mmTestTarget", "table-loader");
    } }, directives: [ɵngcc3.ɵf, ɵngcc9.MatSpinner], styles: [".mm-table-loader[_ngcontent-%COMP%]{left:calc(50% - 32px);position:absolute;top:82px;z-index:5}.mm-table-loader__wrapper[_ngcontent-%COMP%]{display:flex;justify-content:center}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmTableLoaderComponent, [{
        type: Component,
        args: [{
                selector: 'mm-table-loader',
                exportAs: 'mmTableLoader',
                template: "<div class=\"mm-table-loader__wrapper\"\n     [mmTestTarget]=\"'table-loader-wrapper'\">\n    <div class=\"mm-table-loader\"\n         [mmTestTarget]=\"'table-loader'\">\n        <mat-spinner diameter=\"32\"\n                     strokeWidth=\"2\"></mat-spinner>\n    </div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".mm-table-loader{left:calc(50% - 32px);position:absolute;top:82px;z-index:5}.mm-table-loader__wrapper{display:flex;justify-content:center}"]
            }]
    }], null, null); })();

class MmTableCustomTemplateComponent {
}
MmTableCustomTemplateComponent.ɵfac = function MmTableCustomTemplateComponent_Factory(t) { return new (t || MmTableCustomTemplateComponent)(); };
MmTableCustomTemplateComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmTableCustomTemplateComponent, selectors: [["mm-table-custom-template"]], inputs: { icon: "icon" }, exportAs: ["mmTableCustomTemplateComponent"], ngContentSelectors: _c5, decls: 5, vars: 3, consts: [[1, "mm-table-custom__wrapper", 3, "mmTestTarget"], [1, "mm-table-custom__icon-wrapper"], [1, "mm-table-custom__icon", 3, "svgIcon"], [1, "mm-table-custom__template", 3, "mmTestTarget"]], template: function MmTableCustomTemplateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "mat-icon", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("mmTestTarget", "table-custom-wrapper");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("svgIcon", ctx.icon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("mmTestTarget", "table-custom-template");
    } }, directives: [ɵngcc3.ɵf, ɵngcc8.MatIcon], styles: [".mm-table-custom__wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;left:0;position:absolute;top:82px;width:100%}.mm-table-custom__template[_ngcontent-%COMP%]{color:#002d72;font-size:1.14rem;font-weight:400;text-align:center;z-index:5}.mm-table-custom__icon-wrapper[_ngcontent-%COMP%]{display:flex;justify-content:center;margin-bottom:22px}.mm-table-custom__icon-wrapper[_ngcontent-%COMP%]   .mm-table-error__icon[_ngcontent-%COMP%]{fill:#002d72;font-size:32px;height:32px;line-height:32px;width:32px}"], changeDetection: 0 });
MmTableCustomTemplateComponent.propDecorators = {
    icon: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmTableCustomTemplateComponent, [{
        type: Component,
        args: [{
                selector: 'mm-table-custom-template',
                exportAs: 'mmTableCustomTemplateComponent',
                template: "<div class=\"mm-table-custom__wrapper\"\n     [mmTestTarget]=\"'table-custom-wrapper'\">\n    <div class=\"mm-table-custom__icon-wrapper\">\n        <mat-icon svgIcon=\"{{icon}}\"\n                  class=\"mm-table-custom__icon\"></mat-icon>\n    </div>\n    <div class=\"mm-table-custom__template\"\n         [mmTestTarget]=\"'table-custom-template'\">\n        <ng-content></ng-content>\n    </div>\n</div>\n\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".mm-table-custom__wrapper{display:flex;flex-direction:column;left:0;position:absolute;top:82px;width:100%}.mm-table-custom__template{color:#002d72;font-size:1.14rem;font-weight:400;text-align:center;z-index:5}.mm-table-custom__icon-wrapper{display:flex;justify-content:center;margin-bottom:22px}.mm-table-custom__icon-wrapper .mm-table-error__icon{fill:#002d72;font-size:32px;height:32px;line-height:32px;width:32px}"]
            }]
    }], null, { icon: [{
            type: Input
        }] }); })();

var MmCellTextColor;
(function (MmCellTextColor) {
    MmCellTextColor["green"] = "green";
    MmCellTextColor["red"] = "red";
    MmCellTextColor["orange"] = "orange";
    MmCellTextColor["grey"] = "grey";
    MmCellTextColor["blue"] = "blue";
    MmCellTextColor["default"] = "default";
})(MmCellTextColor || (MmCellTextColor = {}));
var MmCellTextAlign;
(function (MmCellTextAlign) {
    MmCellTextAlign["left"] = "left";
    MmCellTextAlign["right"] = "right";
    MmCellTextAlign["center"] = "center";
})(MmCellTextAlign || (MmCellTextAlign = {}));
var MmCellFontWeight;
(function (MmCellFontWeight) {
    MmCellFontWeight["light"] = "400";
    MmCellFontWeight["bolder"] = "700";
    MmCellFontWeight["bold"] = "900";
})(MmCellFontWeight || (MmCellFontWeight = {}));
var MmSortableDirection;
(function (MmSortableDirection) {
    MmSortableDirection["asc"] = "asc";
    MmSortableDirection["desc"] = "desc";
})(MmSortableDirection || (MmSortableDirection = {}));

class MmCellDirective extends CdkCell {
    constructor(columnDef, elementRef, renderer) {
        super(columnDef, elementRef);
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.mmTextAlign = MmCellTextAlign.left;
        this.mmFontWeight = MmCellFontWeight.light;
        this.mmTextColor = MmCellTextColor.default;
        this.renderer.addClass(elementRef.nativeElement, `mm-column-${columnDef.cssClassFriendlyName}`);
    }
    ngOnInit() {
        if (this.mmTextAlign) {
            this.renderer.addClass(this.elementRef.nativeElement, `mm-text-align--${this.mmTextAlign}`);
        }
        if (this.mmFontWeight) {
            this.renderer.addClass(this.elementRef.nativeElement, `mm-font-weight--${this.mmFontWeight}`);
        }
        if (this.mmTextColor) {
            this.renderer.addClass(this.elementRef.nativeElement, `mm-text-color--${this.mmTextColor}`);
        }
    }
}
MmCellDirective.ɵfac = function MmCellDirective_Factory(t) { return new (t || MmCellDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc10.CdkColumnDef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
MmCellDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmCellDirective, selectors: [["mmCell"], ["td", "mmCell", ""]], hostAttrs: [1, "mm-cell"], inputs: { mmTextAlign: "mmTextAlign", mmFontWeight: "mmFontWeight", mmTextColor: "mmTextColor" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
MmCellDirective.ctorParameters = () => [
    { type: CdkColumnDef },
    { type: ElementRef },
    { type: Renderer2 }
];
MmCellDirective.propDecorators = {
    mmTextAlign: [{ type: Input }],
    mmFontWeight: [{ type: Input }],
    mmTextColor: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmCellDirective, [{
        type: Directive,
        args: [{
                selector: 'mmCell, td[mmCell]',
                host: {
                    'class': 'mm-cell'
                }
            }]
    }], function () { return [{ type: ɵngcc10.CdkColumnDef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { mmTextAlign: [{
            type: Input
        }], mmFontWeight: [{
            type: Input
        }], mmTextColor: [{
            type: Input
        }] }); })();

class MmCellDefDirective extends CdkCellDef {
}
MmCellDefDirective.ɵfac = function MmCellDefDirective_Factory(t) { return ɵMmCellDefDirective_BaseFactory(t || MmCellDefDirective); };
MmCellDefDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmCellDefDirective, selectors: [["", "mmCellDef", ""]], features: [ɵngcc0.ɵɵProvidersFeature([{ provide: CdkCellDef, useExisting: MmCellDefDirective }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
const ɵMmCellDefDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MmCellDefDirective);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmCellDefDirective, [{
        type: Directive,
        args: [{
                selector: '[mmCellDef]',
                providers: [{ provide: CdkCellDef, useExisting: MmCellDefDirective }]
            }]
    }], null, null); })();

class MmColumnDefDirective extends CdkColumnDef {
}
MmColumnDefDirective.ɵfac = function MmColumnDefDirective_Factory(t) { return ɵMmColumnDefDirective_BaseFactory(t || MmColumnDefDirective); };
MmColumnDefDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmColumnDefDirective, selectors: [["", "mmColumnDef", ""]], inputs: { name: ["mmColumnDef", "name"], sticky: "sticky", stickyEnd: "stickyEnd" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: CdkColumnDef, useExisting: MmColumnDefDirective },
            { provide: 'MmSortHeaderColumnRef', useExisting: MmColumnDefDirective }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
MmColumnDefDirective.propDecorators = {
    name: [{ type: Input, args: ['mmColumnDef',] }],
    sticky: [{ type: Input }],
    stickyEnd: [{ type: Input }]
};
const ɵMmColumnDefDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MmColumnDefDirective);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmColumnDefDirective, [{
        type: Directive,
        args: [{
                selector: '[mmColumnDef]',
                providers: [
                    { provide: CdkColumnDef, useExisting: MmColumnDefDirective },
                    { provide: 'MmSortHeaderColumnRef', useExisting: MmColumnDefDirective }
                ]
            }]
    }], null, { name: [{
            type: Input,
            args: ['mmColumnDef']
        }], sticky: [{
            type: Input
        }], stickyEnd: [{
            type: Input
        }] }); })();

class MmHeaderCellDirective extends CdkHeaderCell {
    constructor(columnDef, elementRef, renderer) {
        super(columnDef, elementRef);
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.renderer.addClass(elementRef.nativeElement, `mm-column-${columnDef.cssClassFriendlyName}`);
    }
    ngOnInit() {
        if (this.mmTextAlign) {
            this.renderer.addClass(this.elementRef.nativeElement, `mm-text-align--${this.mmTextAlign}`);
        }
    }
}
MmHeaderCellDirective.ɵfac = function MmHeaderCellDirective_Factory(t) { return new (t || MmHeaderCellDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc10.CdkColumnDef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
MmHeaderCellDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmHeaderCellDirective, selectors: [["mmHeaderCell"], ["th", "mmHeaderCell", ""]], hostAttrs: [1, "mm-header-cell"], inputs: { mmTextAlign: "mmTextAlign" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
MmHeaderCellDirective.ctorParameters = () => [
    { type: CdkColumnDef },
    { type: ElementRef },
    { type: Renderer2 }
];
MmHeaderCellDirective.propDecorators = {
    mmTextAlign: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmHeaderCellDirective, [{
        type: Directive,
        args: [{
                selector: 'mmHeaderCell, th[mmHeaderCell]',
                host: {
                    'class': 'mm-header-cell'
                }
            }]
    }], function () { return [{ type: ɵngcc10.CdkColumnDef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { mmTextAlign: [{
            type: Input
        }] }); })();

class MmHeaderCellDefDirective extends CdkHeaderCellDef {
}
MmHeaderCellDefDirective.ɵfac = function MmHeaderCellDefDirective_Factory(t) { return ɵMmHeaderCellDefDirective_BaseFactory(t || MmHeaderCellDefDirective); };
MmHeaderCellDefDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmHeaderCellDefDirective, selectors: [["", "mmHeaderCellDef", ""]], features: [ɵngcc0.ɵɵProvidersFeature([{ provide: CdkHeaderCellDef, useExisting: MmHeaderCellDefDirective }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
const ɵMmHeaderCellDefDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MmHeaderCellDefDirective);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmHeaderCellDefDirective, [{
        type: Directive,
        args: [{
                selector: '[mmHeaderCellDef]',
                providers: [{ provide: CdkHeaderCellDef, useExisting: MmHeaderCellDefDirective }]
            }]
    }], null, null); })();

class MmHeaderRowDefDirective extends CdkHeaderRowDef {
}
MmHeaderRowDefDirective.ɵfac = function MmHeaderRowDefDirective_Factory(t) { return ɵMmHeaderRowDefDirective_BaseFactory(t || MmHeaderRowDefDirective); };
MmHeaderRowDefDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmHeaderRowDefDirective, selectors: [["", "mmHeaderRowDef", ""]], inputs: { columns: ["mmHeaderRowDef", "columns"], sticky: ["mmHeaderRowDefSticky", "sticky"] }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: CdkHeaderRowDef, useExisting: MmHeaderRowDefDirective }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
const ɵMmHeaderRowDefDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MmHeaderRowDefDirective);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmHeaderRowDefDirective, [{
        type: Directive,
        args: [{
                selector: '[mmHeaderRowDef]',
                providers: [{ provide: CdkHeaderRowDef, useExisting: MmHeaderRowDefDirective }],
                // tslint:disable-next-line
                inputs: ['columns: mmHeaderRowDef', 'sticky: mmHeaderRowDefSticky']
            }]
    }], null, null); })();

class MmRowDefDirective extends CdkRowDef {
}
MmRowDefDirective.ɵfac = function MmRowDefDirective_Factory(t) { return ɵMmRowDefDirective_BaseFactory(t || MmRowDefDirective); };
MmRowDefDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmRowDefDirective, selectors: [["", "mmRowDef", ""]], inputs: { columns: ["mmRowDefColumns", "columns"], when: ["mmRowDefWhen", "when"] }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: CdkRowDef, useExisting: MmRowDefDirective }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
const ɵMmRowDefDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MmRowDefDirective);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmRowDefDirective, [{
        type: Directive,
        args: [{
                selector: '[mmRowDef]',
                providers: [{ provide: CdkRowDef, useExisting: MmRowDefDirective }],
                // tslint:disable-next-line
                inputs: ['columns: mmRowDefColumns', 'when: mmRowDefWhen']
            }]
    }], null, null); })();

function sortDuplicateSortableIdError(id) {
    return Error(`Cannot have two MmSortables with the same id (${id}).`);
}
function sortHeaderMissingIdError() {
    return Error('MmSortHeader must be provided with a unique id.');
}
function sortInvalidDirectionError(direction) {
    return Error(`${direction} is not a valid sort direction (${MmSortableDirection.asc} or ${MmSortableDirection.desc}).`);
}
function sortHeaderNotContainedWithinSortError() {
    return Error('MatSortHeader must be placed within a parent element with the MatSort directive');
}

class MmSortDirective {
    constructor() {
        this.stateChanges = new Subject();
        this.mmSortStart = MmSortableDirection.asc;
        this.sortables = new Map();
        this._direction = '';
        this.sortChange = new EventEmitter();
    }
    get mmSortDirection() {
        return this._direction;
    }
    set mmSortDirection(value) {
        this.setDirectionValue(value);
    }
    ngOnChanges() {
        this.stateChanges.next();
    }
    ngOnDestroy() {
        this.stateChanges.complete();
    }
    register(sortable) {
        if (!sortable.mmSortHeader) {
            throw sortHeaderMissingIdError();
        }
        if (this.sortables.has(sortable.mmSortHeader)) {
            throw sortDuplicateSortableIdError(sortable.mmSortHeader);
        }
        this.sortables.set(sortable.mmSortHeader, sortable);
    }
    deregister(sortable) {
        this.sortables.delete(sortable.mmSortHeader);
    }
    sort(sortable) {
        if (this.mmSortActive !== sortable.mmSortHeader) {
            this.mmSortActive = sortable.mmSortHeader;
            this.mmSortDirection = sortable.mmSortStart ? sortable.mmSortStart : this.mmSortStart;
        }
        else {
            this.mmSortDirection = this.getNextSortDirection(sortable);
        }
        this.sortChange.emit({ mmSortActive: this.mmSortActive, mmSortDirection: this.mmSortDirection });
    }
    getNextSortDirection(sortable) {
        if (!sortable) {
            return '';
        }
        const sortDirectionCycle = this.getSortDirection(sortable.mmSortStart || this.mmSortStart);
        let nextDirectionIndex = sortDirectionCycle.indexOf(this.mmSortDirection) + 1;
        if (nextDirectionIndex >= sortDirectionCycle.length) {
            nextDirectionIndex = 0;
        }
        return sortDirectionCycle[nextDirectionIndex];
    }
    getSortDirection(mmSortStart) {
        const sortOrder = [MmSortableDirection.asc, MmSortableDirection.desc];
        if (mmSortStart === MmSortableDirection.desc) {
            sortOrder.reverse();
        }
        return sortOrder;
    }
    setDirectionValue(value) {
        if (value && value !== MmSortableDirection.asc && value !== MmSortableDirection.desc) {
            throw sortInvalidDirectionError(value);
        }
        this._direction = value;
    }
}
MmSortDirective.ɵfac = function MmSortDirective_Factory(t) { return new (t || MmSortDirective)(); };
MmSortDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmSortDirective, selectors: [["", "mmSort", ""]], inputs: { mmSortStart: "mmSortStart", mmSortDirection: "mmSortDirection", mmSortActive: "mmSortActive" }, outputs: { sortChange: "sortChange" }, exportAs: ["mmSort"], features: [ɵngcc0.ɵɵNgOnChangesFeature] });
MmSortDirective.propDecorators = {
    mmSortActive: [{ type: Input }],
    mmSortStart: [{ type: Input }],
    mmSortDirection: [{ type: Input }],
    sortChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmSortDirective, [{
        type: Directive,
        args: [{
                selector: '[mmSort]',
                exportAs: 'mmSort'
            }]
    }], function () { return []; }, { mmSortStart: [{
            type: Input
        }], sortChange: [{
            type: Output
        }], mmSortDirection: [{
            type: Input
        }], mmSortActive: [{
            type: Input
        }] }); })();

class MmSortHeaderComponent {
    constructor(changeDetectorRef, sort, mmSortHeaderColumnDef) {
        this.changeDetectorRef = changeDetectorRef;
        this.sort = sort;
        this.mmSortHeaderColumnDef = mmSortHeaderColumnDef;
        this.mmSortStart = MmSortableDirection.asc;
        this.disabled = false;
        this.arrowDirection = '';
        if (!sort) {
            sortHeaderNotContainedWithinSortError();
        }
        this.sortSubscription = merge(sort.sortChange, sort.stateChanges)
            .subscribe(() => {
            if (this.isSorted()) {
                this.updateArrowDirection();
            }
            changeDetectorRef.markForCheck();
        });
    }
    ngOnInit() {
        if (!this.mmSortHeader && this.mmSortHeaderColumnDef) {
            this.mmSortHeader = this.mmSortHeaderColumnDef.name;
        }
        this.direction = this.sort.mmSortDirection;
        this.active = this.sort.mmSortActive;
        this.updateArrowDirection();
        this.sort.register(this);
    }
    ngOnDestroy() {
        this.sort.deregister(this);
        this.sortSubscription.unsubscribe();
    }
    handleClick() {
        if (this.disabled) {
            return;
        }
        this.sort.sort(this);
        this.direction = this.sort.mmSortDirection;
        this.active = this.sort.mmSortActive;
    }
    isSorted() {
        return this.sort.mmSortActive === this.mmSortHeader &&
            (this.sort.mmSortDirection === MmSortableDirection.asc || this.sort.mmSortDirection === MmSortableDirection.desc);
    }
    getArrowDirectionState() {
        return `${this.isSorted() ? 'active-' : ''}${this.arrowDirection}`;
    }
    updateArrowDirection() {
        this.arrowDirection = this.isSorted() ?
            this.sort.mmSortDirection : (this.mmSortStart || this.sort.mmSortStart);
    }
}
MmSortHeaderComponent.ɵfac = function MmSortHeaderComponent_Factory(t) { return new (t || MmSortHeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(MmSortDirective, 8), ɵngcc0.ɵɵdirectiveInject('MmSortHeaderColumnRef', 8)); };
MmSortHeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmSortHeaderComponent, selectors: [["", "mm-sort-header", ""]], hostAttrs: [1, "mm-sort-row"], hostBindings: function MmSortHeaderComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function MmSortHeaderComponent_click_HostBindingHandler() { return ctx.handleClick(); });
    } }, inputs: { mmSortStart: "mmSortStart", disabled: "disabled", mmSortHeader: "mmSortHeader" }, exportAs: ["mmSortHeader"], attrs: _c20, ngContentSelectors: _c5, decls: 3, vars: 8, consts: [[1, "mm-sort-header__container", 3, "mmTestTarget"], ["type", "button", 1, "mm-sort-header__button", 3, "mmTestTarget", "disabled", "ngClass"]], template: function MmSortHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "button", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mm-sort-header-sorted", ctx.isSorted());
        ɵngcc0.ɵɵproperty("mmTestTarget", "sort-header-container");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("disabled", ctx.disabled);
        ɵngcc0.ɵɵproperty("mmTestTarget", "sort-header-button")("disabled", ctx.disabled)("ngClass", ctx.getArrowDirectionState());
    } }, directives: [ɵngcc3.ɵf, ɵngcc2.NgClass], styles: [".mm-sort-header__button[_ngcontent-%COMP%]{background:none;border:0;color:#002d72;cursor:pointer;display:inline-block;font-family:Lato,sans-serif;font-size:14px;font-weight:700;line-height:1.53;outline:0;padding:0 10px 0 0;position:relative;width:100%}.mm-sort-header__button[_ngcontent-%COMP%]::-moz-focus-inner{border:0}.mm-sort-header__button[_ngcontent-%COMP%]:not(.disabled):after{border-color:transparent transparent #ccd5e3;border-style:solid;border-width:0 5px 5px;content:\"\";height:0;position:absolute;right:-10px;top:4px;width:0}.mm-sort-header__button[_ngcontent-%COMP%]:not(.disabled):before{border-color:#ccd5e3 transparent transparent;border-style:solid;border-width:5px 5px 0;content:\"\";height:0;position:absolute;right:-10px;top:12px;width:0}.mm-sort-header__button.active-asc[_ngcontent-%COMP%]:after{border-color:transparent transparent #002866}.mm-sort-header__button.active-desc[_ngcontent-%COMP%]:before{border-color:#002866 transparent transparent}"], changeDetection: 0 });
MmSortHeaderComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: MmSortDirective, decorators: [{ type: Optional }] },
    { type: undefined, decorators: [{ type: Inject, args: ['MmSortHeaderColumnRef',] }, { type: Optional }] }
];
MmSortHeaderComponent.propDecorators = {
    mmSortHeader: [{ type: Input }],
    mmSortStart: [{ type: Input }],
    disabled: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmSortHeaderComponent, [{
        type: Component,
        args: [{
                selector: '[mm-sort-header]',
                exportAs: 'mmSortHeader',
                template: "<div class=\"mm-sort-header__container\"\n     [mmTestTarget]=\"'sort-header-container'\"\n     [class.mm-sort-header-sorted]=\"isSorted()\">\n    <button class=\"mm-sort-header__button\"\n            [mmTestTarget]=\"'sort-header-button'\"\n            type=\"button\"\n            [disabled]=\"disabled\"\n            [class.disabled]=\"disabled\"\n            [ngClass]=\"getArrowDirectionState()\">\n        <ng-content></ng-content>\n    </button>\n</div>\n",
                host: {
                    '(click)': 'handleClick()',
                    'class': 'mm-sort-row'
                },
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".mm-sort-header__button{background:none;border:0;color:#002d72;cursor:pointer;display:inline-block;font-family:Lato,sans-serif;font-size:14px;font-weight:700;line-height:1.53;outline:0;padding:0 10px 0 0;position:relative;width:100%}.mm-sort-header__button::-moz-focus-inner{border:0}.mm-sort-header__button:not(.disabled):after{border-color:transparent transparent #ccd5e3;border-style:solid;border-width:0 5px 5px;content:\"\";height:0;position:absolute;right:-10px;top:4px;width:0}.mm-sort-header__button:not(.disabled):before{border-color:#ccd5e3 transparent transparent;border-style:solid;border-width:5px 5px 0;content:\"\";height:0;position:absolute;right:-10px;top:12px;width:0}.mm-sort-header__button.active-asc:after{border-color:transparent transparent #002866}.mm-sort-header__button.active-desc:before{border-color:#002866 transparent transparent}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: MmSortDirective, decorators: [{
                type: Optional
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: ['MmSortHeaderColumnRef']
            }, {
                type: Optional
            }] }]; }, { mmSortStart: [{
            type: Input
        }], disabled: [{
            type: Input
        }], mmSortHeader: [{
            type: Input
        }] }); })();

class MmHeaderRowComponent extends CdkHeaderRow {
}
MmHeaderRowComponent.ɵfac = function MmHeaderRowComponent_Factory(t) { return ɵMmHeaderRowComponent_BaseFactory(t || MmHeaderRowComponent); };
MmHeaderRowComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmHeaderRowComponent, selectors: [["mm-header-row"], ["tr", "mm-header-row", ""]], hostAttrs: [1, "mm-header-row"], exportAs: ["mmHeaderRow"], features: [ɵngcc0.ɵɵProvidersFeature([{ provide: CdkHeaderRow, useExisting: MmHeaderRowComponent }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 0, consts: [["cdkCellOutlet", ""]], template: function MmHeaderRowComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainer(0, 0);
    } }, directives: [ɵngcc10.CdkCellOutlet], encapsulation: 2, changeDetection: 0 });
const ɵMmHeaderRowComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MmHeaderRowComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmHeaderRowComponent, [{
        type: Component,
        args: [{
                selector: 'mm-header-row, tr[mm-header-row]',
                template: CDK_ROW_TEMPLATE,
                host: {
                    'class': 'mm-header-row'
                },
                changeDetection: ChangeDetectionStrategy.OnPush,
                exportAs: 'mmHeaderRow',
                providers: [{ provide: CdkHeaderRow, useExisting: MmHeaderRowComponent }]
            }]
    }], null, null); })();

class MmRowComponent extends CdkRow {
}
MmRowComponent.ɵfac = function MmRowComponent_Factory(t) { return ɵMmRowComponent_BaseFactory(t || MmRowComponent); };
MmRowComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmRowComponent, selectors: [["mm-row"], ["tr", "mm-row", ""]], hostAttrs: [1, "mm-row"], exportAs: ["mmRow"], features: [ɵngcc0.ɵɵProvidersFeature([{ provide: CdkRow, useExisting: MmRowComponent }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 0, consts: [["cdkCellOutlet", ""]], template: function MmRowComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainer(0, 0);
    } }, directives: [ɵngcc10.CdkCellOutlet], encapsulation: 2, changeDetection: 0 });
const ɵMmRowComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MmRowComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmRowComponent, [{
        type: Component,
        args: [{
                selector: 'mm-row, tr[mm-row]',
                template: CDK_ROW_TEMPLATE,
                host: {
                    'class': 'mm-row'
                },
                changeDetection: ChangeDetectionStrategy.OnPush,
                exportAs: 'mmRow',
                providers: [{ provide: CdkRow, useExisting: MmRowComponent }]
            }]
    }], null, null); })();

class MmTableComponent extends CdkTable {
    constructor() {
        super(...arguments);
        this.stickyCssClass = 'mm-column-sticky';
    }
}
MmTableComponent.ɵfac = function MmTableComponent_Factory(t) { return ɵMmTableComponent_BaseFactory(t || MmTableComponent); };
MmTableComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmTableComponent, selectors: [["mm-table"], ["table", "mm-table", ""]], hostAttrs: [1, "mm-table"], exportAs: ["mmTable"], features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c22, decls: 6, vars: 0, consts: [["headerRowOutlet", ""], ["rowOutlet", ""], ["noDataRowOutlet", ""], ["footerRowOutlet", ""]], template: function MmTableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c21);
        ɵngcc0.ɵɵprojection(0);
        ɵngcc0.ɵɵprojection(1, 1);
        ɵngcc0.ɵɵelementContainer(2, 0);
        ɵngcc0.ɵɵelementContainer(3, 1);
        ɵngcc0.ɵɵelementContainer(4, 2);
        ɵngcc0.ɵɵelementContainer(5, 3);
    } }, directives: [ɵngcc10.HeaderRowOutlet, ɵngcc10.DataRowOutlet, ɵngcc10.NoDataRowOutlet, ɵngcc10.FooterRowOutlet], styles: [".mm-table-container{background-color:#fff;min-height:170px;overflow:auto;position:relative;width:100%}.mm-table-container::-webkit-scrollbar-track{background-color:#f2f3f5;border-radius:0}.mm-table-container::-webkit-scrollbar{background-color:#f2f3f5;height:10px}.mm-table-container::-webkit-scrollbar-thumb{background-color:#ddd;border-radius:6px;width:6px}.mm-table{border-collapse:collapse;position:relative;width:100%}.mm-table .mm-cell{border-bottom:1px solid #e6e8eb;color:#002d72;font-family:Lato,sans-serif;font-size:14px;font-weight:400;line-height:1.7;min-width:100%;overflow:hidden;padding:16px;text-overflow:ellipsis;vertical-align:top;white-space:nowrap}.mm-table .mm-cell:first-of-type{padding-left:32px}.mm-table .mm-cell:last-of-type{padding-right:32px}.mm-table .mm-cell.mm-column-sticky{background-color:#fff;padding-right:32px}.mm-table .mm-header-cell{border-bottom:2px solid #002866;color:#002d72;cursor:default;font-family:Lato,sans-serif;font-size:14px;font-weight:700;line-height:1.38;overflow:hidden;padding:16px;text-align:left;text-overflow:ellipsis;vertical-align:top;white-space:nowrap;width:50px}.mm-table .mm-header-cell:first-of-type{padding-left:32px}.mm-table .mm-header-cell:last-of-type{padding-right:32px}.mm-table .mm-header-cell.mm-column-sticky{background-color:#fff;padding-right:32px}.mm-table .mm-text-align--left{text-align:left}.mm-table .mm-text-align--center{text-align:center}.mm-table .mm-text-align--right,.mm-table .mm-text-align--right .mm-sort-header-button{text-align:right}.mm-table .mm-font-weight--light{font-weight:400}.mm-table .mm-font-weight--bolder{font-weight:700}.mm-table .mm-font-weight--bold{font-weight:900}.mm-table .mm-text-color--green{color:#34c082}.mm-table .mm-text-color--red{color:#de351b}.mm-table .mm-text-color--orange{color:#ff9f00}.mm-table .mm-text-color--grey{color:#99abc7}.mm-table .mm-text-color--blue{color:#0064fe}.mm-table-pagination{display:flex;justify-content:flex-end;padding:10px 32px}"], encapsulation: 2, changeDetection: 0 });
const ɵMmTableComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MmTableComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmTableComponent, [{
        type: Component,
        args: [{
                selector: 'mm-table, table[mm-table]',
                exportAs: 'mmTable',
                template: CDK_TABLE_TEMPLATE,
                host: {
                    'class': 'mm-table'
                },
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                styles: [".mm-table-container{background-color:#fff;min-height:170px;overflow:auto;position:relative;width:100%}.mm-table-container::-webkit-scrollbar-track{background-color:#f2f3f5;border-radius:0}.mm-table-container::-webkit-scrollbar{background-color:#f2f3f5;height:10px}.mm-table-container::-webkit-scrollbar-thumb{background-color:#ddd;border-radius:6px;width:6px}.mm-table{border-collapse:collapse;position:relative;width:100%}.mm-table .mm-cell{border-bottom:1px solid #e6e8eb;color:#002d72;font-family:Lato,sans-serif;font-size:14px;font-weight:400;line-height:1.7;min-width:100%;overflow:hidden;padding:16px;text-overflow:ellipsis;vertical-align:top;white-space:nowrap}.mm-table .mm-cell:first-of-type{padding-left:32px}.mm-table .mm-cell:last-of-type{padding-right:32px}.mm-table .mm-cell.mm-column-sticky{background-color:#fff;padding-right:32px}.mm-table .mm-header-cell{border-bottom:2px solid #002866;color:#002d72;cursor:default;font-family:Lato,sans-serif;font-size:14px;font-weight:700;line-height:1.38;overflow:hidden;padding:16px;text-align:left;text-overflow:ellipsis;vertical-align:top;white-space:nowrap;width:50px}.mm-table .mm-header-cell:first-of-type{padding-left:32px}.mm-table .mm-header-cell:last-of-type{padding-right:32px}.mm-table .mm-header-cell.mm-column-sticky{background-color:#fff;padding-right:32px}.mm-table .mm-text-align--left{text-align:left}.mm-table .mm-text-align--center{text-align:center}.mm-table .mm-text-align--right,.mm-table .mm-text-align--right .mm-sort-header-button{text-align:right}.mm-table .mm-font-weight--light{font-weight:400}.mm-table .mm-font-weight--bolder{font-weight:700}.mm-table .mm-font-weight--bold{font-weight:900}.mm-table .mm-text-color--green{color:#34c082}.mm-table .mm-text-color--red{color:#de351b}.mm-table .mm-text-color--orange{color:#ff9f00}.mm-table .mm-text-color--grey{color:#99abc7}.mm-table .mm-text-color--blue{color:#0064fe}.mm-table-pagination{display:flex;justify-content:flex-end;padding:10px 32px}"]
            }]
    }], null, null); })();

class MmTableModule {
}
MmTableModule.ɵfac = function MmTableModule_Factory(t) { return new (t || MmTableModule)(); };
MmTableModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmTableModule });
MmTableModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CdkTableModule,
            CommonModule,
            MatIconModule,
            MatProgressSpinnerModule,
            QaLocatorsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmTableModule, { declarations: function () { return [MmTableComponent, MmHeaderCellDefDirective, MmHeaderRowDefDirective, MmColumnDefDirective, MmCellDefDirective, MmRowDefDirective, MmHeaderCellDirective, MmCellDirective, MmHeaderRowComponent, MmRowComponent, MmSortDirective, MmSortHeaderComponent, MmTableContainerComponent, MmTableLoaderComponent, MmTableEmptyStateTemplateComponent, MmTableCustomTemplateComponent]; }, imports: function () { return [CdkTableModule,
        CommonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        QaLocatorsModule]; }, exports: function () { return [MmTableComponent, MmHeaderCellDefDirective, MmHeaderRowDefDirective, MmColumnDefDirective, MmCellDefDirective, MmRowDefDirective, MmHeaderCellDirective, MmCellDirective, MmHeaderRowComponent, MmRowComponent, MmSortDirective, MmSortHeaderComponent, MmTableContainerComponent, MmTableLoaderComponent, MmTableEmptyStateTemplateComponent, MmTableCustomTemplateComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmTableModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CdkTableModule,
                    CommonModule,
                    MatIconModule,
                    MatProgressSpinnerModule,
                    QaLocatorsModule,
                ],
                exports: [
                    MmTableComponent,
                    MmHeaderCellDefDirective,
                    MmHeaderRowDefDirective,
                    MmColumnDefDirective,
                    MmCellDefDirective,
                    MmRowDefDirective,
                    MmHeaderCellDirective,
                    MmCellDirective,
                    MmHeaderRowComponent,
                    MmRowComponent,
                    MmSortDirective,
                    MmSortHeaderComponent,
                    MmTableContainerComponent,
                    MmTableLoaderComponent,
                    MmTableEmptyStateTemplateComponent,
                    MmTableCustomTemplateComponent,
                ],
                declarations: [
                    MmTableComponent,
                    MmHeaderCellDefDirective,
                    MmHeaderRowDefDirective,
                    MmColumnDefDirective,
                    MmCellDefDirective,
                    MmRowDefDirective,
                    MmHeaderCellDirective,
                    MmCellDirective,
                    MmHeaderRowComponent,
                    MmRowComponent,
                    MmSortDirective,
                    MmSortHeaderComponent,
                    MmTableContainerComponent,
                    MmTableLoaderComponent,
                    MmTableEmptyStateTemplateComponent,
                    MmTableCustomTemplateComponent,
                ]
            }]
    }], null, null); })();

const IconConfigToken = new InjectionToken('mm-components/icons-config');

class MmIconComponent {
    constructor(iconConfig) {
        this.iconConfig = iconConfig;
        this.stretch = false;
        this.isCurrentColor = true;
    }
    get shouldUseCurrentColor() {
        return this.isCurrentColor;
    }
    get svgUrl() {
        const baseUrl = this.baseUrl || this.iconConfig.baseUrl || '';
        return `${baseUrl}/${this.name}.svg`;
    }
    ngOnInit() {
        this.isFluid = this.type === 'fluid';
    }
}
MmIconComponent.ɵfac = function MmIconComponent_Factory(t) { return new (t || MmIconComponent)(ɵngcc0.ɵɵdirectiveInject(IconConfigToken)); };
MmIconComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmIconComponent, selectors: [["mm-icon"]], hostVars: 4, hostBindings: function MmIconComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("current-color", ctx.shouldUseCurrentColor)("fluid", ctx.isFluid);
    } }, inputs: { stretch: "stretch", isCurrentColor: "isCurrentColor", name: "name", type: "type", baseUrl: "baseUrl", svgStyle: "svgStyle" }, decls: 1, vars: 3, consts: [[3, "src", "stretch", "svgStyle"]], template: function MmIconComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "svg-icon", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("src", ctx.svgUrl)("stretch", ctx.stretch)("svgStyle", ctx.svgStyle);
    } }, directives: [ɵngcc11.SvgIconComponent], styles: ["mm-icon{display:inline-block;height:24px;line-height:0;width:24px}  mm-icon.fluid,   mm-icon svg{display:block;height:100%;width:100%}  mm-icon svg{margin:auto}  mm-icon.current-color svg,   mm-icon.current-color svg circle:not(.nofill),   mm-icon.current-color svg path:not(.nofill),   mm-icon.current-color svg polygon:not(.nofill),   mm-icon.current-color svg rect:not(.nofill){fill:currentColor}"], changeDetection: 0 });
MmIconComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [IconConfigToken,] }] }
];
MmIconComponent.propDecorators = {
    name: [{ type: Input }],
    type: [{ type: Input }],
    baseUrl: [{ type: Input }],
    stretch: [{ type: Input }],
    svgStyle: [{ type: Input }],
    isCurrentColor: [{ type: Input }],
    isFluid: [{ type: HostBinding, args: ['class.fluid',] }],
    shouldUseCurrentColor: [{ type: HostBinding, args: ['class.current-color',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmIconComponent, [{
        type: Component,
        args: [{
                template: "<svg-icon [src]=\"svgUrl\" [stretch]=\"stretch\" [svgStyle]=\"svgStyle\"></svg-icon>\n",
                selector: 'mm-icon',
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: ["::ng-deep mm-icon{display:inline-block;height:24px;line-height:0;width:24px}::ng-deep mm-icon.fluid,::ng-deep mm-icon svg{display:block;height:100%;width:100%}::ng-deep mm-icon svg{margin:auto}::ng-deep mm-icon.current-color svg,::ng-deep mm-icon.current-color svg circle:not(.nofill),::ng-deep mm-icon.current-color svg path:not(.nofill),::ng-deep mm-icon.current-color svg polygon:not(.nofill),::ng-deep mm-icon.current-color svg rect:not(.nofill){fill:currentColor}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [IconConfigToken]
            }] }]; }, { stretch: [{
            type: Input
        }], isCurrentColor: [{
            type: Input
        }], shouldUseCurrentColor: [{
            type: HostBinding,
            args: ['class.current-color']
        }], isFluid: [{
            type: HostBinding,
            args: ['class.fluid']
        }], name: [{
            type: Input
        }], type: [{
            type: Input
        }], baseUrl: [{
            type: Input
        }], svgStyle: [{
            type: Input
        }] }); })();

class MmIconModule {
    static forRoot(configFactory) {
        return {
            ngModule: MmIconModule,
            providers: [
                {
                    provide: IconConfigToken,
                    useFactory: configFactory,
                },
            ],
        };
    }
}
MmIconModule.ɵfac = function MmIconModule_Factory(t) { return new (t || MmIconModule)(); };
MmIconModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmIconModule });
MmIconModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[AngularSvgIconModule.forRoot()]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmIconModule, { declarations: [MmIconComponent], imports: [ɵngcc11.AngularSvgIconModule], exports: [MmIconComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmIconModule, [{
        type: NgModule,
        args: [{
                imports: [AngularSvgIconModule.forRoot()],
                declarations: [MmIconComponent],
                exports: [MmIconComponent]
            }]
    }], null, null); })();

class MmTablePaginationPageEvent {
}

const PAGE_CONTROL_ACTION = {
    nextPage: 'Next Page',
    previousPage: 'Previous Page',
    firstPage: 'First Page',
    lastPage: 'Last Page',
    pageSize: 'Page Size'
};

class MmTablePaginationComponent {
    constructor(changeDetectorRef, activatedRoute, formBuilder, router) {
        this.changeDetectorRef = changeDetectorRef;
        this.activatedRoute = activatedRoute;
        this.formBuilder = formBuilder;
        this.router = router;
        this.disablePageSizeSelection = false;
        this.showFirstLastButtons = true;
        this.itemsPerPageLabel = 'Items per page';
        this.rangeLabel = 'of';
        this.enableJumpToPage = false;
        this.enablePageLinks = false;
        this.page = new EventEmitter();
        this.defaultPageSize = 20;
        this.minimumPageSize = 5;
        this.currentPageIndexValue = 0;
        this.pageSizeOptionsValue = [
            this.minimumPageSize,
            this.defaultPageSize,
        ];
        this.pageSizeTotalValue = 0;
        this.queryParams = { offset: 0, limit: this.pageSizeSelectedOption };
        this.totalPages = Math.ceil(this.pageSizeTotal / this.pageSizeSelectedOption);
    }
    get currentPageIndex() {
        return this.currentPageIndexValue;
    }
    set currentPageIndex(value) {
        this.currentPageIndexValue = Math.max(value, 0);
        this.changeDetectorRef.markForCheck();
    }
    get pageSizeTotal() {
        return this.pageSizeTotalValue;
    }
    set pageSizeTotal(value) {
        this.pageSizeTotalValue = value;
        this.changeDetectorRef.markForCheck();
    }
    get pageSizeSelectedOption() {
        return this.pageSizeValue;
    }
    set pageSizeSelectedOption(value) {
        this.setPageSizeSelectedOption(value);
    }
    get pageSizeOptions() {
        return this.pageSizeOptionsValue;
    }
    set pageSizeOptions(value) {
        this.setPageSizeOptions(value);
    }
    ngOnChanges() {
        this.activatedRoute.queryParams.subscribe((queryParams) => {
            if (queryParams.offset && queryParams.limit) {
                this.currentPageIndexValue = queryParams.offset / queryParams.limit;
                this.changeDetectorRef.markForCheck();
                this.queryParams = {
                    offset: queryParams.offset,
                    limit: queryParams.limit,
                };
            }
            this.totalPages = Math.ceil(this.pageSizeTotal / this.pageSizeSelectedOption);
        });
        this.updateDisplayedPageSizeOptions();
        this.gotoPageForm = this.buildForm();
    }
    get paginationRangeLabel() {
        if (this.pageSizeTotalValue === 0 || this.pageSizeValue === 0) {
            return `0 ${this.rangeLabel} ${this.pageSizeTotalValue}`;
        }
        this.pageSizeTotalValue = Math.max(this.pageSizeTotalValue, 0);
        const startIndex = this.currentPageIndex * this.pageSizeValue;
        const endIndex = startIndex < this.pageSizeTotalValue
            ? Math.min(startIndex + this.pageSizeValue, this.pageSizeTotalValue)
            : startIndex + this.pageSizeValue;
        return `${startIndex + 1} - ${endIndex} ${this.rangeLabel} ${this.pageSizeTotalValue}`;
    }
    nextPage() {
        if (!this.hasNextPage()) {
            return;
        }
        const previousPageIndex = this.currentPageIndex;
        this.currentPageIndex++;
        this.emitPageEvent(previousPageIndex, PAGE_CONTROL_ACTION.nextPage);
    }
    previousPage() {
        if (!this.hasPreviousPage()) {
            return;
        }
        const previousPageIndex = this.currentPageIndex;
        this.currentPageIndex--;
        this.emitPageEvent(previousPageIndex, PAGE_CONTROL_ACTION.previousPage);
    }
    firstPage() {
        if (!this.hasPreviousPage()) {
            return;
        }
        const previousPageIndex = this.currentPageIndex;
        this.currentPageIndex = 0;
        this.emitPageEvent(previousPageIndex, PAGE_CONTROL_ACTION.firstPage);
    }
    lastPage() {
        if (!this.hasNextPage()) {
            return;
        }
        const previousPageIndex = this.currentPageIndex;
        this.currentPageIndex = this.getNumberOfPages() - 1;
        this.emitPageEvent(previousPageIndex, PAGE_CONTROL_ACTION.lastPage);
    }
    getNumberOfPages() {
        if (!this.pageSizeSelectedOption) {
            return 0;
        }
        return Math.ceil(this.pageSizeTotal / this.pageSizeSelectedOption);
    }
    changePageSize(pageSizeSelectedOption) {
        const startIndex = this.currentPageIndex * this.pageSizeSelectedOption;
        const previousPageIndex = this.currentPageIndex;
        this.currentPageIndex =
            Math.floor(startIndex / pageSizeSelectedOption) || 0;
        this.pageSizeSelectedOption = pageSizeSelectedOption;
        this.emitPageEvent(previousPageIndex, PAGE_CONTROL_ACTION.pageSize);
    }
    pageSelect(event) {
        const { limit, offset } = event;
        this.router.navigate(['.'], {
            queryParams: { limit, offset },
            relativeTo: this.activatedRoute,
            queryParamsHandling: 'merge'
        });
    }
    onGotoPageSubmit() {
        if (this.gotoPageForm.valid) {
            const pageNumber = parseFloat(this.gotoPageForm.value.pageNumber);
            const previousPageIndex = this.currentPageIndex;
            this.currentPageIndex = pageNumber - 1;
            this.emitPageEvent(previousPageIndex - 1);
        }
    }
    get nextButtonsDisabled() {
        return this.disabled || !this.hasNextPage();
    }
    get previousButtonsDisabled() {
        return this.disabled || !this.hasPreviousPage();
    }
    hasNextPage() {
        const maxPageIndex = this.getNumberOfPages() - 1;
        return (this.currentPageIndex < maxPageIndex && this.pageSizeSelectedOption !== 0);
    }
    hasPreviousPage() {
        return this.currentPageIndex >= 1 && this.pageSizeSelectedOption !== 0;
    }
    updateDisplayedPageSizeOptions() {
        if (!this.pageSizeSelectedOption) {
            this.pageSizeValue =
                this.pageSizeOptions.length !== 0
                    ? this.pageSizeOptions[0]
                    : this.defaultPageSize;
        }
        this.displayedPageSizeOptions = this.pageSizeOptions.slice();
        if (this.displayedPageSizeOptions.indexOf(this.pageSizeSelectedOption) === -1) {
            this.displayedPageSizeOptions.push(this.pageSizeSelectedOption);
        }
        this.displayedPageSizeOptions.sort((optionA, optionB) => optionA - optionB);
        this.changeDetectorRef.markForCheck();
    }
    emitPageEvent(previousPageIndex, action) {
        this.page.emit({
            previousPageIndex,
            currentPageIndex: this.currentPageIndex,
            pageSizeSelectedOption: this.pageSizeSelectedOption,
            pageSizeTotal: this.pageSizeTotal,
            action: action || ''
        });
    }
    setPageSizeSelectedOption(value) {
        if (value <= 0) {
            console.error('Please provide positive pageSizeSelectedOption value.');
        }
        this.pageSizeValue = Math.max(value, 0);
        this.updateDisplayedPageSizeOptions();
    }
    setPageSizeOptions(value) {
        if (!Array.isArray(value)) {
            console.error('Please provide array for pageSizeOptions.');
        }
        else {
            this.pageSizeOptionsValue = (value || []).map((item) => item);
            this.updateDisplayedPageSizeOptions();
        }
        if (this.pageSizeOptionsValue[0] &&
            this.pageSizeSelectedOption < this.pageSizeOptionsValue[0]) {
            console.error('Please provide pageSizeSelectedOption from options list.');
        }
    }
    buildForm() {
        return this.formBuilder.group({
            pageNumber: [
                '',
                [
                    (control) => Validators.max(this.totalPages)(control),
                    Validators.required,
                ],
            ],
        });
    }
}
MmTablePaginationComponent.ɵfac = function MmTablePaginationComponent_Factory(t) { return new (t || MmTablePaginationComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc7.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.FormBuilder), ɵngcc0.ɵɵdirectiveInject(ɵngcc7.Router)); };
MmTablePaginationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmTablePaginationComponent, selectors: [["mm-table-pagination"]], inputs: { disablePageSizeSelection: "disablePageSizeSelection", showFirstLastButtons: "showFirstLastButtons", itemsPerPageLabel: "itemsPerPageLabel", rangeLabel: "rangeLabel", enableJumpToPage: "enableJumpToPage", enablePageLinks: "enablePageLinks", currentPageIndex: "currentPageIndex", pageSizeTotal: "pageSizeTotal", pageSizeSelectedOption: "pageSizeSelectedOption", pageSizeOptions: "pageSizeOptions" }, outputs: { page: "page" }, exportAs: ["mmTablePagination"], features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 14, vars: 11, consts: [[1, "mm-table-pagination__container"], ["class", "mm-table-pagination__items", 4, "ngIf"], [1, "mm-table-pagination__range"], [1, "mm-table-pagination__range-label", 3, "mmTestTarget"], [1, "mm-table-pagination__button-container"], ["mm-button", "", "color", "ghost", 3, "mmTestTarget", "disabled", "click", 4, "ngIf"], ["mm-button", "", "color", "ghost", 3, "mmTestTarget", "disabled", "click"], ["name", "pagination-chevron-previous", 1, "mm-table-pagination__icon"], [3, "queryParams", "enableLabel", "defaultLimit", "totalCount", "showLastPage", "useOnlyPaginatorLinks", "paginationChange", 4, "ngIf"], ["name", "pagination-chevron-next", 1, "mm-table-pagination__icon"], [4, "ngIf"], [1, "mm-table-pagination__items"], [1, "mm-table-pagination__items-label", 3, "mmTestTarget"], [3, "mmTestTarget", 4, "ngIf"], ["matNativeControl", "", 1, "mm-table-pagination__select", 3, "mmTestTarget", "ngModel", "disabled", "ngModelChange", "change"], ["class", "mm-table-pagination__option", 3, "mmTestTarget", "value", 4, "ngFor", "ngForOf"], [1, "mm-table-pagination__option", 3, "mmTestTarget", "value"], [3, "mmTestTarget"], ["name", "pagination-chevron-first", 1, "mm-table-pagination__icon"], [3, "queryParams", "enableLabel", "defaultLimit", "totalCount", "showLastPage", "useOnlyPaginatorLinks", "paginationChange"], ["name", "pagination-chevron-last", 1, "mm-table-pagination__icon"], [1, "mm-table-pagination__go", 3, "formGroup", "ngSubmit"], [1, "gotopage__field"], ["mmInput", "", "placeholder", "Page", "formControlName", "pageNumber"], ["type", "submit", "mm-button", "", "color", "primary", "size", "small", "raised", "true", 3, "disabled"]], template: function MmTablePaginationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, MmTablePaginationComponent_div_1_Template, 5, 4, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵtemplate(6, MmTablePaginationComponent_button_6_Template, 2, 2, "button", 5);
        ɵngcc0.ɵɵelementStart(7, "button", 6);
        ɵngcc0.ɵɵlistener("click", function MmTablePaginationComponent_Template_button_click_7_listener() { return ctx.previousPage(); });
        ɵngcc0.ɵɵelement(8, "mm-icon", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, MmTablePaginationComponent_mm_paginator_9_Template, 1, 6, "mm-paginator", 8);
        ɵngcc0.ɵɵelementStart(10, "button", 6);
        ɵngcc0.ɵɵlistener("click", function MmTablePaginationComponent_Template_button_click_10_listener() { return ctx.nextPage(); });
        ɵngcc0.ɵɵelement(11, "mm-icon", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, MmTablePaginationComponent_button_12_Template, 2, 2, "button", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(13, MmTablePaginationComponent_ng_container_13_Template, 6, 2, "ng-container", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.disablePageSizeSelection);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("mmTestTarget", "table-pagination-range-label");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.paginationRangeLabel, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showFirstLastButtons);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("mmTestTarget", "table-pagination-previous-page")("disabled", ctx.previousButtonsDisabled);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.enablePageLinks);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("mmTestTarget", "table-pagination-next-page")("disabled", ctx.nextButtonsDisabled);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showFirstLastButtons);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.enableJumpToPage);
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.ɵf, MmButtonComponent, MmIconComponent, ɵngcc1.SelectControlValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.NgModel, ɵngcc2.NgForOf, ɵngcc1.NgSelectOption, ɵngcc1.ɵangular_packages_forms_forms_z, MmPaginatorComponent, ɵngcc1.ɵangular_packages_forms_forms_ba, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, MmFieldComponent, MmInputDirective, ɵngcc1.DefaultValueAccessor, ɵngcc1.FormControlName], styles: [".mm-table-pagination__container[_ngcontent-%COMP%]{box-sizing:border-box;color:#002d72;font-size:1.14rem;font-weight:400;padding:22px 0 22px 34px}.mm-table-pagination__container[_ngcontent-%COMP%], .mm-table-pagination__items[_ngcontent-%COMP%], .mm-table-pagination__range[_ngcontent-%COMP%]{align-items:center;display:flex;justify-content:flex-end}.mm-table-pagination__range-label[_ngcontent-%COMP%]{box-sizing:border-box;line-height:1;min-width:180px;padding:0 30px;text-align:right}.mm-table-pagination__items-label[_ngcontent-%COMP%]{margin-right:20px}.mm-table-pagination__select[_ngcontent-%COMP%]{background:#fff;border:2px solid #e6e8eb;border-radius:3px;color:#002d72;font-family:Lato,sans-serif;font-size:1.14rem;font-weight:400;height:44px;line-height:44px;padding:0 12px 1px}.mm-table-pagination__select[_ngcontent-%COMP%]:focus{outline:none}.mm-table-pagination__option[_ngcontent-%COMP%]{cursor:pointer}.mm-table-pagination__button-container[_ngcontent-%COMP%]{display:flex;width:auto}.mm-table-pagination__button-container[_ngcontent-%COMP%]     .mm-button{height:42px;min-width:42px}.mm-table-pagination__button-container[_ngcontent-%COMP%]     .mm-button:not(.mm-button--icon-button){margin:2px 4px 0;padding:0}.mm-table-pagination__button-container[_ngcontent-%COMP%]     .mm-button:not(.mm-button--icon-button) .mm-button__icon{margin:0}.mm-table-pagination__button-container[_ngcontent-%COMP%]     .mm-button--ghost{color:#002d72}.mm-table-pagination__button-container[_ngcontent-%COMP%]     .mm-button--ghost[disabled]{color:#99abc7!important;cursor:not-allowed}.mm-table-pagination__button-container[_ngcontent-%COMP%]     .mm-button--ghost[disabled]:active, .mm-table-pagination__button-container[_ngcontent-%COMP%]     .mm-button--ghost[disabled]:hover{background:#f2f7ff!important}.mm-table-pagination__go[_ngcontent-%COMP%]{align-items:center;display:flex;flex-flow:row nowrap;margin-right:10px}.mm-table-pagination__go[_ngcontent-%COMP%]   .gotopage__field[_ngcontent-%COMP%]{height:100%;margin:0 10px;width:100px}"], changeDetection: 0 });
MmTablePaginationComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ActivatedRoute },
    { type: FormBuilder },
    { type: Router }
];
MmTablePaginationComponent.propDecorators = {
    currentPageIndex: [{ type: Input }],
    pageSizeTotal: [{ type: Input }],
    pageSizeSelectedOption: [{ type: Input }],
    pageSizeOptions: [{ type: Input }],
    disablePageSizeSelection: [{ type: Input }],
    showFirstLastButtons: [{ type: Input }],
    itemsPerPageLabel: [{ type: Input }],
    rangeLabel: [{ type: Input }],
    enableJumpToPage: [{ type: Input }],
    enablePageLinks: [{ type: Input }],
    page: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmTablePaginationComponent, [{
        type: Component,
        args: [{
                selector: 'mm-table-pagination',
                exportAs: 'mmTablePagination',
                template: "<div class=\"mm-table-pagination__container\">\n    <div *ngIf=\"!disablePageSizeSelection\"\n         class=\"mm-table-pagination__items\">\n        <div class=\"mm-table-pagination__items-label\"\n             [mmTestTarget]=\"'table-pagination-items-label'\">\n            {{itemsPerPageLabel}}\n        </div>\n\n        <div *ngIf=\"displayedPageSizeOptions.length > 1\">\n            <select matNativeControl\n                    class=\"mm-table-pagination__select\"\n                    [mmTestTarget]=\"'table-pagination-select'\"\n                    [(ngModel)]=\"pageSizeSelectedOption\"\n                    [disabled]=\"disabled\"\n                    (change)=\"changePageSize($event?.target?.value)\">\n                <option *ngFor=\"let pageSizeOption of displayedPageSizeOptions\"\n                        class=\"mm-table-pagination__option\"\n                        [mmTestTarget]=\"'table-pagination-option'\"\n                        [value]=\"pageSizeOption\">\n                    {{pageSizeOption}}\n                </option>\n            </select>\n        </div>\n        <div *ngIf=\"displayedPageSizeOptions.length <= 1\"\n             [mmTestTarget]=\"'table-pagination-selected-option'\">{{pageSizeSelectedOption}}</div>\n    </div>\n\n    <div class=\"mm-table-pagination__range\">\n        <div class=\"mm-table-pagination__range-label\"\n             [mmTestTarget]=\"'table-pagination-range-label'\">\n            {{paginationRangeLabel}}\n        </div>\n        <div class=\"mm-table-pagination__button-container\">\n            <button mm-button\n                    color=\"ghost\"\n                    [mmTestTarget]=\"'table-pagination-first-page'\"\n                    (click)=\"firstPage()\"\n                    [disabled]=\"previousButtonsDisabled\"\n                    *ngIf=\"showFirstLastButtons\">\n                <mm-icon name=\"pagination-chevron-first\"\n                         class=\"mm-table-pagination__icon\"></mm-icon>\n            </button>\n            <button mm-button\n                    color=\"ghost\"\n                    [mmTestTarget]=\"'table-pagination-previous-page'\"\n                    (click)=\"previousPage()\"\n                    [disabled]=\"previousButtonsDisabled\">\n                <mm-icon name=\"pagination-chevron-previous\"\n                         class=\"mm-table-pagination__icon\"></mm-icon>\n            </button>\n\n            <mm-paginator \n                    *ngIf=\"enablePageLinks\"\n                    [queryParams]=\"queryParams\"\n                    [enableLabel]=\"false\"\n                    [defaultLimit]=\"pageSizeSelectedOption\"\n                    [totalCount]=\"pageSizeTotal\"\n                    [showLastPage]=\"true\"\n                    (paginationChange)=\"pageSelect($event)\"\n                    [useOnlyPaginatorLinks]=\"true\">\n            </mm-paginator>\n\n            <button mm-button\n                    color=\"ghost\"\n                    [mmTestTarget]=\"'table-pagination-next-page'\"\n                    (click)=\"nextPage()\"\n                    [disabled]=\"nextButtonsDisabled\">\n                <mm-icon name=\"pagination-chevron-next\"\n                         class=\"mm-table-pagination__icon\"></mm-icon>\n            </button>\n            <button mm-button\n                    color=\"ghost\"\n                    [mmTestTarget]=\"'table-pagination-last-page'\"\n                    (click)=\"lastPage()\"\n                    [disabled]=\"nextButtonsDisabled\"\n                    *ngIf=\"showFirstLastButtons\">\n                <mm-icon name=\"pagination-chevron-last\"\n                         class=\"mm-table-pagination__icon\"></mm-icon>\n            </button>\n        </div>\n\n        <ng-container *ngIf=\"enableJumpToPage\"> \n            <form [formGroup]=\"gotoPageForm\" (ngSubmit)=\"onGotoPageSubmit()\"  class=\"mm-table-pagination__go\">\n                <mm-field class=\"gotopage__field\">\n                    <input mmInput placeholder=\"Page\" formControlName=\"pageNumber\" />\n                </mm-field>\n                <button [disabled]=\"gotoPageForm.invalid\" type=\"submit\" mm-button color=\"primary\" size=\"small\" raised=\"true\">\n                    Go\n                </button>\n            </form>\n        </ng-container>\n    </div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".mm-table-pagination__container{box-sizing:border-box;color:#002d72;font-size:1.14rem;font-weight:400;padding:22px 0 22px 34px}.mm-table-pagination__container,.mm-table-pagination__items,.mm-table-pagination__range{align-items:center;display:flex;justify-content:flex-end}.mm-table-pagination__range-label{box-sizing:border-box;line-height:1;min-width:180px;padding:0 30px;text-align:right}.mm-table-pagination__items-label{margin-right:20px}.mm-table-pagination__select{background:#fff;border:2px solid #e6e8eb;border-radius:3px;color:#002d72;font-family:Lato,sans-serif;font-size:1.14rem;font-weight:400;height:44px;line-height:44px;padding:0 12px 1px}.mm-table-pagination__select:focus{outline:none}.mm-table-pagination__option{cursor:pointer}.mm-table-pagination__button-container{display:flex;width:auto}.mm-table-pagination__button-container ::ng-deep .mm-button{height:42px;min-width:42px}.mm-table-pagination__button-container ::ng-deep .mm-button:not(.mm-button--icon-button){margin:2px 4px 0;padding:0}.mm-table-pagination__button-container ::ng-deep .mm-button:not(.mm-button--icon-button) .mm-button__icon{margin:0}.mm-table-pagination__button-container ::ng-deep .mm-button--ghost{color:#002d72}.mm-table-pagination__button-container ::ng-deep .mm-button--ghost[disabled]{color:#99abc7!important;cursor:not-allowed}.mm-table-pagination__button-container ::ng-deep .mm-button--ghost[disabled]:active,.mm-table-pagination__button-container ::ng-deep .mm-button--ghost[disabled]:hover{background:#f2f7ff!important}.mm-table-pagination__go{align-items:center;display:flex;flex-flow:row nowrap;margin-right:10px}.mm-table-pagination__go .gotopage__field{height:100%;margin:0 10px;width:100px}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc7.ActivatedRoute }, { type: ɵngcc1.FormBuilder }, { type: ɵngcc7.Router }]; }, { disablePageSizeSelection: [{
            type: Input
        }], showFirstLastButtons: [{
            type: Input
        }], itemsPerPageLabel: [{
            type: Input
        }], rangeLabel: [{
            type: Input
        }], enableJumpToPage: [{
            type: Input
        }], enablePageLinks: [{
            type: Input
        }], page: [{
            type: Output
        }], currentPageIndex: [{
            type: Input
        }], pageSizeTotal: [{
            type: Input
        }], pageSizeSelectedOption: [{
            type: Input
        }], pageSizeOptions: [{
            type: Input
        }] }); })();

class MmTablePaginationModule {
}
MmTablePaginationModule.ɵfac = function MmTablePaginationModule_Factory(t) { return new (t || MmTablePaginationModule)(); };
MmTablePaginationModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmTablePaginationModule });
MmTablePaginationModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            MatSelectModule,
            MmIconModule,
            QaLocatorsModule,
            MmButtonModule,
            RouterModule,
            ReactiveFormsModule,
            MmFormFieldModule,
            MmPaginatorModule,
            FormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmTablePaginationModule, { declarations: function () { return [MmTablePaginationComponent]; }, imports: function () { return [CommonModule,
        MatSelectModule, MmIconModule, QaLocatorsModule, MmButtonModule, RouterModule,
        ReactiveFormsModule, MmFormFieldModule, MmPaginatorModule, FormsModule]; }, exports: function () { return [MmTablePaginationComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmTablePaginationModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatSelectModule,
                    MmIconModule,
                    QaLocatorsModule,
                    MmButtonModule,
                    RouterModule,
                    ReactiveFormsModule,
                    MmFormFieldModule,
                    MmPaginatorModule,
                    FormsModule
                ],
                exports: [MmTablePaginationComponent],
                declarations: [MmTablePaginationComponent]
            }]
    }], null, null); })();

var MmComponentPositions;
(function (MmComponentPositions) {
    MmComponentPositions["start"] = "start";
    MmComponentPositions["end"] = "end";
    MmComponentPositions["top"] = "top";
    MmComponentPositions["bottom"] = "bottom";
    MmComponentPositions["center"] = "center";
})(MmComponentPositions || (MmComponentPositions = {}));
var MmOverlayPositions;
(function (MmOverlayPositions) {
    MmOverlayPositions["originX"] = "originX";
    MmOverlayPositions["originY"] = "originY";
    MmOverlayPositions["overlayX"] = "overlayX";
    MmOverlayPositions["overlayY"] = "overlayY";
})(MmOverlayPositions || (MmOverlayPositions = {}));
const PositionMap = {
    bottom: new ConnectionPositionPair({ originX: MmComponentPositions.center, originY: MmComponentPositions.bottom }, { overlayX: MmComponentPositions.center, overlayY: MmComponentPositions.top }),
    bottomLeft: new ConnectionPositionPair({ originX: MmComponentPositions.start, originY: MmComponentPositions.bottom }, { overlayX: MmComponentPositions.start, overlayY: MmComponentPositions.top }),
    bottomRight: new ConnectionPositionPair({ originX: MmComponentPositions.end, originY: MmComponentPositions.bottom }, { overlayX: MmComponentPositions.end, overlayY: MmComponentPositions.top }),
    top: new ConnectionPositionPair({ originX: MmComponentPositions.center, originY: MmComponentPositions.top }, { overlayX: MmComponentPositions.center, overlayY: MmComponentPositions.bottom }),
    topLeft: new ConnectionPositionPair({ originX: MmComponentPositions.start, originY: MmComponentPositions.top }, { overlayX: MmComponentPositions.start, overlayY: MmComponentPositions.bottom }),
    topRight: new ConnectionPositionPair({ originX: MmComponentPositions.end, originY: MmComponentPositions.top }, { overlayX: MmComponentPositions.end, overlayY: MmComponentPositions.bottom }),
};
const DefaultComponentPositions = [
    PositionMap.bottom,
    PositionMap.bottomLeft,
    PositionMap.bottomRight,
    PositionMap.top,
    PositionMap.topLeft,
    PositionMap.topRight
];
const DefaultComponentPositionsReverse = [
    PositionMap.top,
    PositionMap.topLeft,
    PositionMap.topRight,
    PositionMap.bottom,
    PositionMap.bottomLeft,
    PositionMap.bottomRight
];
function getPlacementName(position) {
    const keyList = [MmOverlayPositions.originX, MmOverlayPositions.originY, MmOverlayPositions.overlayX,
        MmOverlayPositions.overlayY];
    for (const placement in PositionMap) {
        if (keyList.every(key => position.connectionPair[key] === PositionMap[placement][key])) {
            return placement;
        }
    }
}

class MmMenuComponent {
    constructor(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.prefix = 'mm-menu__placement';
        this.positions = [...DefaultComponentPositions];
        this.classMap = {};
        this.placement = MmComponentPositions.bottom;
        this.visibleSource = new BehaviorSubject(false);
        this.visible$ = this.visibleSource.asObservable();
        this.mmOverlayClassName = '';
        this.mmOverlayStyle = {};
        this.visibleChange = new EventEmitter();
    }
    set mmVisible(value) {
        const visible = !!value;
        if (this.visibleSource.value !== visible) {
            this.visibleSource.next(visible);
            this.visibleChange.emit(visible);
        }
    }
    get mmVisible() {
        return this.visibleSource.value;
    }
    set mmPlacement(value) {
        if (value !== this.placement) {
            this.placement = value;
            this.positions = [PositionMap[this.mmPlacement], ...this.positions];
        }
    }
    get mmPlacement() {
        return this.placement;
    }
    ngOnChanges() {
        this.updatePosition();
    }
    updatePosition() {
        if (this.overlay && this.overlay.overlayRef) {
            this.overlay.overlayRef.updatePosition();
        }
    }
    onPositionChange(position) {
        this.placement = getPlacementName(position);
        this.updateClassMap();
        this.changeDetectorRef.detectChanges();
    }
    updateClassMap() {
        this.classMap = {
            [this.mmOverlayClassName]: true,
            [`${this.prefix}-${this.placement}`]: true
        };
    }
    setOverlayOrigin(origin) {
        this.overlayOrigin = origin;
    }
    show() {
        this.mmVisible = true;
    }
    hide() {
        this.mmVisible = false;
    }
}
MmMenuComponent.ɵfac = function MmMenuComponent_Factory(t) { return new (t || MmMenuComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
MmMenuComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmMenuComponent, selectors: [["mm-menu"]], viewQuery: function MmMenuComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c23, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.overlay = _t.first);
    } }, inputs: { mmOverlayClassName: "mmOverlayClassName", mmOverlayStyle: "mmOverlayStyle", mmVisible: "mmVisible", mmPlacement: "mmPlacement" }, outputs: { visibleChange: "visibleChange" }, exportAs: ["MmMenuComponent"], features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 0, template: function MmMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, MmMenuComponent_ng_template_0_Template, 0, 0, "ng-template");
    } }, encapsulation: 2, changeDetection: 0 });
MmMenuComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
MmMenuComponent.propDecorators = {
    overlay: [{ type: ViewChild, args: ['overlay',] }],
    mmOverlayClassName: [{ type: Input }],
    mmOverlayStyle: [{ type: Input }],
    mmVisible: [{ type: Input }],
    mmPlacement: [{ type: Input }],
    visibleChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmMenuComponent, [{
        type: Component,
        args: [{
                selector: 'mm-menu',
                exportAs: 'MmMenuComponent',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-template></ng-template>'
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { mmOverlayClassName: [{
            type: Input
        }], mmOverlayStyle: [{
            type: Input
        }], visibleChange: [{
            type: Output
        }], mmVisible: [{
            type: Input
        }], mmPlacement: [{
            type: Input
        }], overlay: [{
            type: ViewChild,
            args: ['overlay']
        }] }); })();

class MmContextualMenuComponent extends MmMenuComponent {
    constructor() {
        super(...arguments);
        this.prefix = 'mm-contextual-menu__placement';
    }
    closeContextualMenu() {
        super.hide();
    }
}
MmContextualMenuComponent.ɵfac = function MmContextualMenuComponent_Factory(t) { return ɵMmContextualMenuComponent_BaseFactory(t || MmContextualMenuComponent); };
MmContextualMenuComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmContextualMenuComponent, selectors: [["mm-contextual-menu"]], inputs: { mmContent: "mmContent" }, exportAs: ["mmContextualMenuComponent"], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 6, consts: [["cdkConnectedOverlay", "", "mmConnectedOverlay", "", 3, "cdkConnectedOverlayHasBackdrop", "cdkConnectedOverlayOrigin", "cdkConnectedOverlayPositions", "cdkConnectedOverlayOpen", "backdropClick", "detach", "positionChange"], ["overlay", "cdkConnectedOverlay"], [1, "mm-contextual-menu", 3, "mmTestTarget", "ngClass", "ngStyle", "click"], [1, "mm-contextual-menu__arrow"], [1, "mm-contextual-menu__content", 3, "mmTestTarget"], [4, "mmTemplateOutlet"]], template: function MmContextualMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, MmContextualMenuComponent_ng_template_0_Template, 4, 5, "ng-template", 0, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵpipe(2, "async");
        ɵngcc0.ɵɵlistener("backdropClick", function MmContextualMenuComponent_Template_ng_template_backdropClick_0_listener() { return ctx.hide(); })("detach", function MmContextualMenuComponent_Template_ng_template_detach_0_listener() { return ctx.hide(); })("positionChange", function MmContextualMenuComponent_Template_ng_template_positionChange_0_listener($event) { return ctx.onPositionChange($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("cdkConnectedOverlayHasBackdrop", ctx.hasBackdrop)("cdkConnectedOverlayOrigin", ctx.overlayOrigin)("cdkConnectedOverlayPositions", ctx.positions)("cdkConnectedOverlayOpen", ɵngcc0.ɵɵpipeBind1(2, 4, ctx.visible$));
    } }, directives: function () { return [ɵngcc12.CdkConnectedOverlay, MmConnectedOverlayDirective, ɵngcc3.ɵf, ɵngcc2.NgClass, ɵngcc2.NgStyle, MmTemplateOutletDirective]; }, pipes: function () { return [ɵngcc2.AsyncPipe]; }, styles: [".mm-contextual-menu[_ngcontent-%COMP%]{box-sizing:border-box;left:0;margin:0;padding:0;position:relative;top:0;z-index:1030}.mm-contextual-menu__placement-top[_ngcontent-%COMP%], .mm-contextual-menu__placement-topLeft[_ngcontent-%COMP%], .mm-contextual-menu__placement-topRight[_ngcontent-%COMP%]{padding-bottom:12px}.mm-contextual-menu__placement-topLeft[_ngcontent-%COMP%]{left:-10px}.mm-contextual-menu__placement-topRight[_ngcontent-%COMP%]{left:auto;right:-10px}.mm-contextual-menu__placement-bottom[_ngcontent-%COMP%], .mm-contextual-menu__placement-bottomLeft[_ngcontent-%COMP%], .mm-contextual-menu__placement-bottomRight[_ngcontent-%COMP%]{padding-top:12px}.mm-contextual-menu__placement-bottomLeft[_ngcontent-%COMP%]{left:-10px}.mm-contextual-menu__placement-bottomRight[_ngcontent-%COMP%]{left:auto;right:-10px}.mm-contextual-menu__content[_ngcontent-%COMP%]{background-color:#fff;box-shadow:0 4px 16px 0 rgba(0,45,114,.11);min-width:220px}.mm-contextual-menu__arrow[_ngcontent-%COMP%]{border-color:transparent transparent #fff;border-style:solid;border-width:0 10px 10px;display:block;height:0;position:absolute;width:0}.mm-contextual-menu__placement-top[_ngcontent-%COMP%]   .mm-contextual-menu__arrow[_ngcontent-%COMP%], .mm-contextual-menu__placement-topLeft[_ngcontent-%COMP%]   .mm-contextual-menu__arrow[_ngcontent-%COMP%], .mm-contextual-menu__placement-topRight[_ngcontent-%COMP%]   .mm-contextual-menu__arrow[_ngcontent-%COMP%]{border-color:#fff transparent transparent;border-width:10px 10px 0;bottom:3px}.mm-contextual-menu__placement-top[_ngcontent-%COMP%]   .mm-contextual-menu__arrow[_ngcontent-%COMP%]{left:calc(50% - 10px)}.mm-contextual-menu__placement-topLeft[_ngcontent-%COMP%]   .mm-contextual-menu__arrow[_ngcontent-%COMP%]{left:12px}.mm-contextual-menu__placement-topRight[_ngcontent-%COMP%]   .mm-contextual-menu__arrow[_ngcontent-%COMP%]{right:12px}.mm-contextual-menu__placement-bottom[_ngcontent-%COMP%]   .mm-contextual-menu__arrow[_ngcontent-%COMP%], .mm-contextual-menu__placement-bottomLeft[_ngcontent-%COMP%]   .mm-contextual-menu__arrow[_ngcontent-%COMP%], .mm-contextual-menu__placement-bottomRight[_ngcontent-%COMP%]   .mm-contextual-menu__arrow[_ngcontent-%COMP%]{border-color:transparent transparent #fff;border-width:0 10px 10px;top:3px}.mm-contextual-menu__placement-bottom[_ngcontent-%COMP%]   .mm-contextual-menu__arrow[_ngcontent-%COMP%]{left:calc(50% - 10px)}.mm-contextual-menu__placement-bottomLeft[_ngcontent-%COMP%]   .mm-contextual-menu__arrow[_ngcontent-%COMP%]{left:12px}.mm-contextual-menu__placement-bottomRight[_ngcontent-%COMP%]   .mm-contextual-menu__arrow[_ngcontent-%COMP%]{right:12px}"], changeDetection: 0 });
MmContextualMenuComponent.propDecorators = {
    mmContent: [{ type: Input }]
};
const ɵMmContextualMenuComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MmContextualMenuComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmContextualMenuComponent, [{
        type: Component,
        args: [{
                selector: 'mm-contextual-menu',
                exportAs: 'mmContextualMenuComponent',
                template: "<ng-template #overlay=\"cdkConnectedOverlay\"\n             cdkConnectedOverlay\n             mmConnectedOverlay\n             [cdkConnectedOverlayHasBackdrop]=\"hasBackdrop\"\n             [cdkConnectedOverlayOrigin]=\"overlayOrigin\"\n             (backdropClick)=\"hide()\"\n             (detach)=\"hide()\"\n             (positionChange)=\"onPositionChange($event)\"\n             [cdkConnectedOverlayPositions]=\"positions\"\n             [cdkConnectedOverlayOpen]=\"visible$ | async\">\n    <div class=\"mm-contextual-menu\"\n         [mmTestTarget]=\"'contextual-menu'\"\n         [ngClass]=\"classMap\"\n         [ngStyle]=\"mmOverlayStyle\"\n         (click)=\"closeContextualMenu()\">\n        <div class=\"mm-contextual-menu__arrow\"></div>\n        <div class=\"mm-contextual-menu__content\"\n             [mmTestTarget]=\"'contextual-menu-content'\">\n            <ng-container *mmTemplateOutlet=\"mmContent\">\n                {{ mmContent }}\n            </ng-container>\n        </div>\n    </div>\n</ng-template>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".mm-contextual-menu{box-sizing:border-box;left:0;margin:0;padding:0;position:relative;top:0;z-index:1030}.mm-contextual-menu__placement-top,.mm-contextual-menu__placement-topLeft,.mm-contextual-menu__placement-topRight{padding-bottom:12px}.mm-contextual-menu__placement-topLeft{left:-10px}.mm-contextual-menu__placement-topRight{left:auto;right:-10px}.mm-contextual-menu__placement-bottom,.mm-contextual-menu__placement-bottomLeft,.mm-contextual-menu__placement-bottomRight{padding-top:12px}.mm-contextual-menu__placement-bottomLeft{left:-10px}.mm-contextual-menu__placement-bottomRight{left:auto;right:-10px}.mm-contextual-menu__content{background-color:#fff;box-shadow:0 4px 16px 0 rgba(0,45,114,.11);min-width:220px}.mm-contextual-menu__arrow{border-color:transparent transparent #fff;border-style:solid;border-width:0 10px 10px;display:block;height:0;position:absolute;width:0}.mm-contextual-menu__placement-top .mm-contextual-menu__arrow,.mm-contextual-menu__placement-topLeft .mm-contextual-menu__arrow,.mm-contextual-menu__placement-topRight .mm-contextual-menu__arrow{border-color:#fff transparent transparent;border-width:10px 10px 0;bottom:3px}.mm-contextual-menu__placement-top .mm-contextual-menu__arrow{left:calc(50% - 10px)}.mm-contextual-menu__placement-topLeft .mm-contextual-menu__arrow{left:12px}.mm-contextual-menu__placement-topRight .mm-contextual-menu__arrow{right:12px}.mm-contextual-menu__placement-bottom .mm-contextual-menu__arrow,.mm-contextual-menu__placement-bottomLeft .mm-contextual-menu__arrow,.mm-contextual-menu__placement-bottomRight .mm-contextual-menu__arrow{border-color:transparent transparent #fff;border-width:0 10px 10px;top:3px}.mm-contextual-menu__placement-bottom .mm-contextual-menu__arrow{left:calc(50% - 10px)}.mm-contextual-menu__placement-bottomLeft .mm-contextual-menu__arrow{left:12px}.mm-contextual-menu__placement-bottomRight .mm-contextual-menu__arrow{right:12px}"]
            }]
    }], null, { mmContent: [{
            type: Input
        }] }); })();

var MmMenuTrigger;
(function (MmMenuTrigger) {
    MmMenuTrigger["click"] = "click";
    MmMenuTrigger["hover"] = "hover";
})(MmMenuTrigger || (MmMenuTrigger = {}));

class MmMenuDirective {
    constructor(elementRef, hostView, resolver, platform, menu) {
        this.elementRef = elementRef;
        this.hostView = hostView;
        this.resolver = resolver;
        this.platform = platform;
        this.menu = menu;
        this.factory = this.resolver.resolveComponentFactory(MmMenuComponent);
        this.needProxyProperties = [
            'mmContent',
            'mmOverlayClassName',
            'mmOverlayStyle',
            'mmPlacement',
            'hasBackdrop',
        ];
        this.destroy$ = new Subject();
    }
    onWindowScroll() {
        this.hide();
    }
    ngOnChanges(changes) {
        this.updateProxies(changes);
    }
    ngOnInit() {
        if (!this.menu) {
            const menuComponent = this.hostView.createComponent(this.factory);
            this.menu = menuComponent.instance;
            this.hasBackdrop = this.mmTrigger !== MmMenuTrigger.hover;
            this.needProxyProperties.forEach(property => this.updateCompValue(property, this[property]));
        }
        this.menu.setOverlayOrigin(this);
    }
    ngAfterViewInit() {
        this.setupEventListeners();
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    setupEventListeners() {
        // The mouse events shouldn't be bound on mobile devices, because they can prevent the
        // first tap from firing its click event or can cause the tooltip to open for clicks.
        const shouldApplyHoverTrigger = (this.mmTrigger === MmMenuTrigger.hover
            && !this.platform.IOS
            && !this.platform.ANDROID);
        if (shouldApplyHoverTrigger) {
            this.subscribeToHoverEvent();
        }
        else {
            this.subscribeToClickEvent();
        }
    }
    subscribeToClickEvent() {
        fromEvent(this.elementRef.nativeElement, 'click').pipe(takeUntil(this.destroy$)).subscribe(() => this.show());
    }
    subscribeToHoverEvent() {
        const originRef = this.menu.overlayOrigin.elementRef.nativeElement;
        const open$ = fromEvent(this.elementRef.nativeElement, 'mouseenter').pipe(filter(() => !this.menu.mmVisible), switchMap((enterEvent) => {
            return fromEvent(document, 'mousemove').pipe(startWith(enterEvent), filter(event => originRef.contains(event['target'])));
        }), share());
        open$.pipe(takeUntil(this.destroy$))
            .subscribe(() => this.show());
        const close$ = fromEvent(document, 'mousemove').pipe(debounceTime(100), filter(() => this.menu.mmVisible), filter((event) => {
            const target = event['target'];
            const menuRef = this.menu.overlay.overlayRef.overlayElement;
            return !(originRef.contains(target) || menuRef.contains(target));
        }));
        open$.pipe(takeUntil(this.destroy$), switchMapTo(close$)).subscribe(() => this.hide());
    }
    updateCompValue(key, value) {
        if (value) {
            this.menu[key] = value;
        }
    }
    show() {
        this.menu.show();
    }
    hide() {
        if (this.menu) {
            this.menu.hide();
        }
    }
    updateProxies(changes) {
        if (this.menu) {
            Object.keys(changes).forEach(key => {
                const change = changes[key];
                if (change) {
                    this.updateCompValue(key, change.currentValue);
                }
            });
            this.menu.changeDetectorRef.markForCheck();
        }
    }
}
MmMenuDirective.ɵfac = function MmMenuDirective_Factory(t) { return new (t || MmMenuDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc13.Platform), ɵngcc0.ɵɵdirectiveInject(MmMenuComponent, 8)); };
MmMenuDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmMenuDirective, selectors: [["", "mmMenu", ""]], hostBindings: function MmMenuDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("scroll", function MmMenuDirective_scroll_HostBindingHandler($event) { return ctx.onWindowScroll($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { mmContent: "mmContent", mmOverlayClassName: "mmOverlayClassName", mmOverlayStyle: "mmOverlayStyle", mmPlacement: "mmPlacement", mmTrigger: "mmTrigger" }, exportAs: ["mmMenu"], features: [ɵngcc0.ɵɵNgOnChangesFeature] });
MmMenuDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: ViewContainerRef },
    { type: ComponentFactoryResolver },
    { type: Platform },
    { type: MmMenuComponent, decorators: [{ type: Optional }] }
];
MmMenuDirective.propDecorators = {
    mmContent: [{ type: Input }],
    mmOverlayClassName: [{ type: Input }],
    mmOverlayStyle: [{ type: Input }],
    mmPlacement: [{ type: Input }],
    mmTrigger: [{ type: Input }],
    onWindowScroll: [{ type: HostListener, args: ['window:scroll', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmMenuDirective, [{
        type: Directive,
        args: [{
                selector: '[mmMenu]',
                exportAs: 'mmMenu'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc13.Platform }, { type: MmMenuComponent, decorators: [{
                type: Optional
            }] }]; }, { onWindowScroll: [{
            type: HostListener,
            args: ['window:scroll', ['$event']]
        }], mmContent: [{
            type: Input
        }], mmOverlayClassName: [{
            type: Input
        }], mmOverlayStyle: [{
            type: Input
        }], mmPlacement: [{
            type: Input
        }], mmTrigger: [{
            type: Input
        }] }); })();

class MmContextualMenuDirective extends MmMenuDirective {
    constructor() {
        super(...arguments);
        this.factory = this.resolver.resolveComponentFactory(MmContextualMenuComponent);
    }
}
MmContextualMenuDirective.ɵfac = function MmContextualMenuDirective_Factory(t) { return ɵMmContextualMenuDirective_BaseFactory(t || MmContextualMenuDirective); };
MmContextualMenuDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmContextualMenuDirective, selectors: [["", "mmContextualMenu", ""]], exportAs: ["mmContextualMenu"], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
const ɵMmContextualMenuDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MmContextualMenuDirective);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmContextualMenuDirective, [{
        type: Directive,
        args: [{
                selector: '[mmContextualMenu]',
                exportAs: 'mmContextualMenu'
            }]
    }], null, null); })();

class MmConnectedOverlayDirective {
    constructor(cdkConnectedOverlay) {
        this.cdkConnectedOverlay = cdkConnectedOverlay;
        this.cdkConnectedOverlay.backdropClass = 'mm-overlay-backdrop--transparent';
    }
}
MmConnectedOverlayDirective.ɵfac = function MmConnectedOverlayDirective_Factory(t) { return new (t || MmConnectedOverlayDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc12.CdkConnectedOverlay)); };
MmConnectedOverlayDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmConnectedOverlayDirective, selectors: [["", "cdkConnectedOverlay", "", "mmConnectedOverlay", ""]], exportAs: ["mmConnectedOverlay"] });
MmConnectedOverlayDirective.ctorParameters = () => [
    { type: CdkConnectedOverlay }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmConnectedOverlayDirective, [{
        type: Directive,
        args: [{
                selector: '[cdkConnectedOverlay][mmConnectedOverlay]',
                exportAs: 'mmConnectedOverlay'
            }]
    }], function () { return [{ type: ɵngcc12.CdkConnectedOverlay }]; }, null); })();

class MmOverlayModule {
}
MmOverlayModule.ɵfac = function MmOverlayModule_Factory(t) { return new (t || MmOverlayModule)(); };
MmOverlayModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmOverlayModule });
MmOverlayModule.ɵinj = ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmOverlayModule, { declarations: [MmConnectedOverlayDirective], exports: [MmConnectedOverlayDirective] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmOverlayModule, [{
        type: NgModule,
        args: [{
                declarations: [MmConnectedOverlayDirective],
                exports: [MmConnectedOverlayDirective]
            }]
    }], null, null); })();

class MmTemplateOutletDirective {
    constructor(viewContainer) {
        this.viewContainer = viewContainer;
        this.inputTemplate = null;
        this.inputViewRef = null;
    }
    set mmTemplateOutlet(value) {
        this.inputTemplate = value;
        this.updateView();
    }
    updateView() {
        if (!this.inputViewRef) {
            this.viewContainer.clear();
            if (this.inputTemplate) {
                this.inputViewRef = this.viewContainer.createEmbeddedView(this.inputTemplate);
            }
        }
    }
}
MmTemplateOutletDirective.ɵfac = function MmTemplateOutletDirective_Factory(t) { return new (t || MmTemplateOutletDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
MmTemplateOutletDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmTemplateOutletDirective, selectors: [["", "mmTemplateOutlet", ""]], inputs: { mmTemplateOutlet: "mmTemplateOutlet" }, exportAs: ["mmTemplateOutlet"] });
MmTemplateOutletDirective.ctorParameters = () => [
    { type: ViewContainerRef }
];
MmTemplateOutletDirective.propDecorators = {
    mmTemplateOutlet: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmTemplateOutletDirective, [{
        type: Directive,
        args: [{
                selector: '[mmTemplateOutlet]',
                exportAs: 'mmTemplateOutlet'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }]; }, { mmTemplateOutlet: [{
            type: Input
        }] }); })();

class MmMenuModule {
}
MmMenuModule.ɵfac = function MmMenuModule_Factory(t) { return new (t || MmMenuModule)(); };
MmMenuModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmMenuModule });
MmMenuModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            OverlayModule,
            MmOverlayModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmMenuModule, { declarations: function () { return [MmMenuComponent, MmMenuDirective, MmTemplateOutletDirective]; }, imports: function () { return [CommonModule,
        OverlayModule, MmOverlayModule]; }, exports: function () { return [MmMenuComponent, MmMenuDirective, MmTemplateOutletDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmMenuModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    MmMenuComponent,
                    MmMenuDirective,
                    MmTemplateOutletDirective
                ],
                exports: [
                    MmMenuComponent,
                    MmMenuDirective,
                    MmTemplateOutletDirective
                ],
                imports: [
                    CommonModule,
                    OverlayModule,
                    MmOverlayModule
                ],
                entryComponents: [MmMenuComponent]
            }]
    }], null, null); })();

class MmContextualMenuItemComponent {
    constructor(renderer, elementRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
    }
    set disabled(isDisabled) {
        const pointerEventsValue = isDisabled ? 'none' : 'auto';
        this.renderer.setStyle(this.elementRef.nativeElement, 'pointer-events', pointerEventsValue);
        this._disabled = isDisabled;
    }
    get disabled() {
        return this._disabled;
    }
    get classNames() {
        return {
            'mm-contextual-menu-item': true,
            [`mm-contextual-menu-item--${this.color}`]: this.color,
            'mm-contextual-menu-item--disabled': this.disabled,
        };
    }
    onClick(event) {
        if (this.disabled) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
}
MmContextualMenuItemComponent.ɵfac = function MmContextualMenuItemComponent_Factory(t) { return new (t || MmContextualMenuItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MmContextualMenuItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmContextualMenuItemComponent, selectors: [["mm-contextual-menu-item"]], hostBindings: function MmContextualMenuItemComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function MmContextualMenuItemComponent_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } }, inputs: { disabled: "disabled", color: "color" }, ngContentSelectors: _c5, decls: 2, vars: 1, consts: [[3, "ngClass"]], template: function MmContextualMenuItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.classNames);
    } }, directives: [ɵngcc2.NgClass], styles: [".mm-contextual-menu-item[_ngcontent-%COMP%]{align-items:center;border-bottom:1px solid #e6e8eb;color:#0064fe;cursor:pointer;display:flex;font-family:Lato,sans-serif;font-size:1.14rem;font-weight:400;line-height:1.38;padding:9px 26px}.mm-contextual-menu-item[_ngcontent-%COMP%]:active, .mm-contextual-menu-item[_ngcontent-%COMP%]:focus, .mm-contextual-menu-item[_ngcontent-%COMP%]:hover{background-color:#f2f7ff;color:#002866}.mm-contextual-menu-item.mm-contextual-menu-item--active[_ngcontent-%COMP%]{color:#002866;font-weight:700}.mm-contextual-menu-item.mm-contextual-menu-item--warning[_ngcontent-%COMP%]{color:#e55d49}.mm-contextual-menu-item.mm-contextual-menu-item--disabled[_ngcontent-%COMP%]{color:#9099a6;font-weight:400;pointer-events:none}.mm-contextual-menu-item.mm-contextual-menu-item--disabled[_ngcontent-%COMP%]     a, .mm-contextual-menu-item.mm-contextual-menu-item--disabled[_ngcontent-%COMP%]     button{color:#9099a6;text-decoration:none}"], changeDetection: 0 });
MmContextualMenuItemComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
MmContextualMenuItemComponent.propDecorators = {
    color: [{ type: Input }],
    disabled: [{ type: Input }],
    onClick: [{ type: HostListener, args: ['click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmContextualMenuItemComponent, [{
        type: Component,
        args: [{
                selector: 'mm-contextual-menu-item',
                template: "<div [ngClass]=\"classNames\">\n    <ng-content></ng-content>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".mm-contextual-menu-item{align-items:center;border-bottom:1px solid #e6e8eb;color:#0064fe;cursor:pointer;display:flex;font-family:Lato,sans-serif;font-size:1.14rem;font-weight:400;line-height:1.38;padding:9px 26px}.mm-contextual-menu-item:active,.mm-contextual-menu-item:focus,.mm-contextual-menu-item:hover{background-color:#f2f7ff;color:#002866}.mm-contextual-menu-item.mm-contextual-menu-item--active{color:#002866;font-weight:700}.mm-contextual-menu-item.mm-contextual-menu-item--warning{color:#e55d49}.mm-contextual-menu-item.mm-contextual-menu-item--disabled{color:#9099a6;font-weight:400;pointer-events:none}.mm-contextual-menu-item.mm-contextual-menu-item--disabled ::ng-deep a,.mm-contextual-menu-item.mm-contextual-menu-item--disabled ::ng-deep button{color:#9099a6;text-decoration:none}"]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { disabled: [{
            type: Input
        }], onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], color: [{
            type: Input
        }] }); })();

class MmContextualMenuModule {
}
MmContextualMenuModule.ɵfac = function MmContextualMenuModule_Factory(t) { return new (t || MmContextualMenuModule)(); };
MmContextualMenuModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmContextualMenuModule });
MmContextualMenuModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            RouterModule,
            MatIconModule,
            OverlayModule,
            MmOverlayModule,
            MmMenuModule,
            QaLocatorsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmContextualMenuModule, { declarations: function () { return [MmContextualMenuDirective, MmContextualMenuComponent, MmContextualMenuItemComponent]; }, imports: function () { return [CommonModule,
        RouterModule,
        MatIconModule,
        OverlayModule, MmOverlayModule, MmMenuModule, QaLocatorsModule]; }, exports: function () { return [MmContextualMenuDirective, MmContextualMenuComponent, MmContextualMenuItemComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmContextualMenuModule, [{
        type: NgModule,
        args: [{
                entryComponents: [MmContextualMenuComponent],
                exports: [
                    MmContextualMenuDirective,
                    MmContextualMenuComponent,
                    MmContextualMenuItemComponent
                ],
                declarations: [
                    MmContextualMenuDirective,
                    MmContextualMenuComponent,
                    MmContextualMenuItemComponent
                ],
                imports: [
                    CommonModule,
                    RouterModule,
                    MatIconModule,
                    OverlayModule,
                    MmOverlayModule,
                    MmMenuModule,
                    QaLocatorsModule,
                ]
            }]
    }], null, null); })();

class MmHeaderMenuComponent extends MmMenuComponent {
    constructor() {
        super(...arguments);
        this.prefix = 'mm-header-menu__placement';
    }
    closeHeaderMenu() {
        super.hide();
    }
}
MmHeaderMenuComponent.ɵfac = function MmHeaderMenuComponent_Factory(t) { return ɵMmHeaderMenuComponent_BaseFactory(t || MmHeaderMenuComponent); };
MmHeaderMenuComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmHeaderMenuComponent, selectors: [["mm-header-menu"]], inputs: { mmContent: "mmContent" }, exportAs: ["mmHeaderMenuComponent"], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 6, consts: [["cdkConnectedOverlay", "", "mmConnectedOverlay", "", 3, "cdkConnectedOverlayHasBackdrop", "cdkConnectedOverlayOrigin", "cdkConnectedOverlayPositions", "cdkConnectedOverlayOpen", "backdropClick", "detach", "positionChange"], ["overlay", "cdkConnectedOverlay"], [1, "mm-header-menu", 3, "mmTestTarget", "ngClass", "ngStyle", "click"], [1, "mm-header-menu__arrow"], [1, "mm-header-menu__content", 3, "mmTestTarget"], [4, "mmTemplateOutlet"]], template: function MmHeaderMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, MmHeaderMenuComponent_ng_template_0_Template, 4, 5, "ng-template", 0, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵpipe(2, "async");
        ɵngcc0.ɵɵlistener("backdropClick", function MmHeaderMenuComponent_Template_ng_template_backdropClick_0_listener() { return ctx.hide(); })("detach", function MmHeaderMenuComponent_Template_ng_template_detach_0_listener() { return ctx.hide(); })("positionChange", function MmHeaderMenuComponent_Template_ng_template_positionChange_0_listener($event) { return ctx.onPositionChange($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("cdkConnectedOverlayHasBackdrop", ctx.hasBackdrop)("cdkConnectedOverlayOrigin", ctx.overlayOrigin)("cdkConnectedOverlayPositions", ctx.positions)("cdkConnectedOverlayOpen", ɵngcc0.ɵɵpipeBind1(2, 4, ctx.visible$));
    } }, directives: [ɵngcc12.CdkConnectedOverlay, MmConnectedOverlayDirective, ɵngcc3.ɵf, ɵngcc2.NgClass, ɵngcc2.NgStyle, MmTemplateOutletDirective], pipes: [ɵngcc2.AsyncPipe], styles: [".mm-header-menu[_ngcontent-%COMP%]{box-sizing:border-box;left:0;margin:0;padding:0;position:relative;top:0;z-index:1030}.mm-header-menu__placement-top[_ngcontent-%COMP%], .mm-header-menu__placement-topLeft[_ngcontent-%COMP%], .mm-header-menu__placement-topRight[_ngcontent-%COMP%]{padding-bottom:12px}.mm-header-menu__placement-topLeft[_ngcontent-%COMP%]{left:-10px}.mm-header-menu__placement-topRight[_ngcontent-%COMP%]{left:auto;right:-10px}.mm-header-menu__placement-bottom[_ngcontent-%COMP%], .mm-header-menu__placement-bottomLeft[_ngcontent-%COMP%], .mm-header-menu__placement-bottomRight[_ngcontent-%COMP%]{padding-top:12px}.mm-header-menu__placement-bottomLeft[_ngcontent-%COMP%]{left:-10px}.mm-header-menu__placement-bottomRight[_ngcontent-%COMP%]{left:auto;right:-10px}.mm-header-menu__content[_ngcontent-%COMP%]{background-color:#fff;box-shadow:0 4px 16px 0 rgba(0,45,114,.11);box-sizing:border-box;max-width:320px;min-width:256px;padding:8px 0}.mm-header-menu__arrow[_ngcontent-%COMP%]{border-color:transparent transparent #fff;border-style:solid;border-width:0 10px 10px;display:block;height:0;position:absolute;width:0}.mm-header-menu__placement-top[_ngcontent-%COMP%]   .mm-header-menu__arrow[_ngcontent-%COMP%], .mm-header-menu__placement-topLeft[_ngcontent-%COMP%]   .mm-header-menu__arrow[_ngcontent-%COMP%], .mm-header-menu__placement-topRight[_ngcontent-%COMP%]   .mm-header-menu__arrow[_ngcontent-%COMP%]{border-color:#fff transparent transparent;border-width:10px 10px 0;bottom:3px}.mm-header-menu__placement-top[_ngcontent-%COMP%]   .mm-header-menu__arrow[_ngcontent-%COMP%]{left:calc(50% - 10px)}.mm-header-menu__placement-topLeft[_ngcontent-%COMP%]   .mm-header-menu__arrow[_ngcontent-%COMP%]{left:12px}.mm-header-menu__placement-topRight[_ngcontent-%COMP%]   .mm-header-menu__arrow[_ngcontent-%COMP%]{right:12px}.mm-header-menu__placement-bottom[_ngcontent-%COMP%]   .mm-header-menu__arrow[_ngcontent-%COMP%], .mm-header-menu__placement-bottomLeft[_ngcontent-%COMP%]   .mm-header-menu__arrow[_ngcontent-%COMP%], .mm-header-menu__placement-bottomRight[_ngcontent-%COMP%]   .mm-header-menu__arrow[_ngcontent-%COMP%]{border-color:transparent transparent #fff;border-width:0 10px 10px;top:3px}.mm-header-menu__placement-bottom[_ngcontent-%COMP%]   .mm-header-menu__arrow[_ngcontent-%COMP%]{left:calc(50% - 10px)}.mm-header-menu__placement-bottomLeft[_ngcontent-%COMP%]   .mm-header-menu__arrow[_ngcontent-%COMP%]{left:12px}.mm-header-menu__placement-bottomRight[_ngcontent-%COMP%]   .mm-header-menu__arrow[_ngcontent-%COMP%]{right:12px}"], changeDetection: 0 });
MmHeaderMenuComponent.propDecorators = {
    mmContent: [{ type: Input }]
};
const ɵMmHeaderMenuComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MmHeaderMenuComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmHeaderMenuComponent, [{
        type: Component,
        args: [{
                selector: 'mm-header-menu',
                exportAs: 'mmHeaderMenuComponent',
                template: "<ng-template #overlay=\"cdkConnectedOverlay\"\n             cdkConnectedOverlay\n             mmConnectedOverlay\n             [cdkConnectedOverlayHasBackdrop]=\"hasBackdrop\"\n             [cdkConnectedOverlayOrigin]=\"overlayOrigin\"\n             (backdropClick)=\"hide()\"\n             (detach)=\"hide()\"\n             (positionChange)=\"onPositionChange($event)\"\n             [cdkConnectedOverlayPositions]=\"positions\"\n             [cdkConnectedOverlayOpen]=\"visible$ | async\">\n    <div class=\"mm-header-menu\"\n         [mmTestTarget]=\"'header-menu'\"\n         [ngClass]=\"classMap\"\n         [ngStyle]=\"mmOverlayStyle\"\n         (click)=\"closeHeaderMenu()\">\n        <div class=\"mm-header-menu__arrow\"></div>\n        <div class=\"mm-header-menu__content\"\n             [mmTestTarget]=\"'header-menu-content'\">\n            <ng-container *mmTemplateOutlet=\"mmContent\">\n                {{ mmContent }}\n            </ng-container>\n        </div>\n    </div>\n</ng-template>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".mm-header-menu{box-sizing:border-box;left:0;margin:0;padding:0;position:relative;top:0;z-index:1030}.mm-header-menu__placement-top,.mm-header-menu__placement-topLeft,.mm-header-menu__placement-topRight{padding-bottom:12px}.mm-header-menu__placement-topLeft{left:-10px}.mm-header-menu__placement-topRight{left:auto;right:-10px}.mm-header-menu__placement-bottom,.mm-header-menu__placement-bottomLeft,.mm-header-menu__placement-bottomRight{padding-top:12px}.mm-header-menu__placement-bottomLeft{left:-10px}.mm-header-menu__placement-bottomRight{left:auto;right:-10px}.mm-header-menu__content{background-color:#fff;box-shadow:0 4px 16px 0 rgba(0,45,114,.11);box-sizing:border-box;max-width:320px;min-width:256px;padding:8px 0}.mm-header-menu__arrow{border-color:transparent transparent #fff;border-style:solid;border-width:0 10px 10px;display:block;height:0;position:absolute;width:0}.mm-header-menu__placement-top .mm-header-menu__arrow,.mm-header-menu__placement-topLeft .mm-header-menu__arrow,.mm-header-menu__placement-topRight .mm-header-menu__arrow{border-color:#fff transparent transparent;border-width:10px 10px 0;bottom:3px}.mm-header-menu__placement-top .mm-header-menu__arrow{left:calc(50% - 10px)}.mm-header-menu__placement-topLeft .mm-header-menu__arrow{left:12px}.mm-header-menu__placement-topRight .mm-header-menu__arrow{right:12px}.mm-header-menu__placement-bottom .mm-header-menu__arrow,.mm-header-menu__placement-bottomLeft .mm-header-menu__arrow,.mm-header-menu__placement-bottomRight .mm-header-menu__arrow{border-color:transparent transparent #fff;border-width:0 10px 10px;top:3px}.mm-header-menu__placement-bottom .mm-header-menu__arrow{left:calc(50% - 10px)}.mm-header-menu__placement-bottomLeft .mm-header-menu__arrow{left:12px}.mm-header-menu__placement-bottomRight .mm-header-menu__arrow{right:12px}"]
            }]
    }], null, { mmContent: [{
            type: Input
        }] }); })();

class MmHeaderMenuDirective extends MmMenuDirective {
    constructor() {
        super(...arguments);
        this.factory = this.resolver.resolveComponentFactory(MmHeaderMenuComponent);
    }
}
MmHeaderMenuDirective.ɵfac = function MmHeaderMenuDirective_Factory(t) { return ɵMmHeaderMenuDirective_BaseFactory(t || MmHeaderMenuDirective); };
MmHeaderMenuDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmHeaderMenuDirective, selectors: [["", "mmHeaderMenu", ""]], exportAs: ["mmHeaderMenu"], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
const ɵMmHeaderMenuDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MmHeaderMenuDirective);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmHeaderMenuDirective, [{
        type: Directive,
        args: [{
                selector: '[mmHeaderMenu]',
                exportAs: 'mmHeaderMenu'
            }]
    }], null, null); })();

class MmHeaderMenuItemComponent {
}
MmHeaderMenuItemComponent.ɵfac = function MmHeaderMenuItemComponent_Factory(t) { return new (t || MmHeaderMenuItemComponent)(); };
MmHeaderMenuItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmHeaderMenuItemComponent, selectors: [["mm-header-menu-item"]], inputs: { link: "link" }, ngContentSelectors: _c5, decls: 4, vars: 4, consts: [[1, "mm-header-menu-item", 3, "mmTestTarget"], ["routerLinkActive", "mm-header-menu-item--selected", 1, "mm-header-menu-item__link", 3, "mmTestTarget", "routerLink"], [1, "mm-header-menu-item__content", 3, "mmTestTarget"]], template: function MmHeaderMenuItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "a", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("mmTestTarget", "header-menu-item");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("mmTestTarget", "header-menu-item-link")("routerLink", ctx.link);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("mmTestTarget", "header-menu-item-content");
    } }, directives: [ɵngcc3.ɵf, ɵngcc7.RouterLinkWithHref, ɵngcc7.RouterLinkActive], styles: [".mm-header-menu-item[_ngcontent-%COMP%]{background-color:#fff;box-sizing:border-box;color:#0064fe;cursor:pointer;font-family:Lato,sans-serif;font-size:1.14rem;font-weight:700;line-height:1.25;padding:10px 20px 10px 28px}.mm-header-menu-item[_ngcontent-%COMP%]   .mm-header-menu-item--selected[_ngcontent-%COMP%], .mm-header-menu-item[_ngcontent-%COMP%]:active, .mm-header-menu-item[_ngcontent-%COMP%]:focus, .mm-header-menu-item[_ngcontent-%COMP%]:hover{color:#002866}.mm-header-menu-item[_ngcontent-%COMP%]   .mm-header-menu-item--selected[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .mm-header-menu-item[_ngcontent-%COMP%]   .mm-header-menu-item--selected[_ngcontent-%COMP%]   mm-icon[_ngcontent-%COMP%]{fill:#002866}.mm-header-menu-item[_ngcontent-%COMP%]     .mm-header-menu-item__link{color:#0064fe;display:flex;text-decoration:none;width:100%}.mm-header-menu-item[_ngcontent-%COMP%]     .mm-header-menu-item__link .mm-header-menu-item__content{padding-left:34px;position:relative}.mm-header-menu-item[_ngcontent-%COMP%]     .mm-header-menu-item__link .mm-header-menu-item__content mat-icon, .mm-header-menu-item[_ngcontent-%COMP%]     .mm-header-menu-item__link .mm-header-menu-item__content mm-icon{fill:#0064fe;font-size:20px;height:20px;left:0;line-height:20px;position:absolute;top:0;width:20px}.mm-header-menu-item[_ngcontent-%COMP%]     .mm-header-menu-item__link:active, .mm-header-menu-item[_ngcontent-%COMP%]     .mm-header-menu-item__link:hover{color:#002866}.mm-header-menu-item[_ngcontent-%COMP%]     .mm-header-menu-item__link:active .mm-header-menu-item__content, .mm-header-menu-item[_ngcontent-%COMP%]     .mm-header-menu-item__link:hover .mm-header-menu-item__content{text-decoration:underline}.mm-header-menu-item[_ngcontent-%COMP%]     .mm-header-menu-item__link:active .mm-header-menu-item__content mat-icon, .mm-header-menu-item[_ngcontent-%COMP%]     .mm-header-menu-item__link:active .mm-header-menu-item__content mm-icon, .mm-header-menu-item[_ngcontent-%COMP%]     .mm-header-menu-item__link:hover .mm-header-menu-item__content mat-icon, .mm-header-menu-item[_ngcontent-%COMP%]     .mm-header-menu-item__link:hover .mm-header-menu-item__content mm-icon{text-decoration:none}.mm-header-menu-item[_ngcontent-%COMP%]     .mm-header-menu-item__link.active, .mm-header-menu-item[_ngcontent-%COMP%]     .mm-header-menu-item__link.active~{color:#002866}"] });
MmHeaderMenuItemComponent.propDecorators = {
    link: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmHeaderMenuItemComponent, [{
        type: Component,
        args: [{
                selector: 'mm-header-menu-item',
                template: "<div class=\"mm-header-menu-item\"\n     [mmTestTarget]=\"'header-menu-item'\">\n    <a\n      class=\"mm-header-menu-item__link\"\n      [mmTestTarget]=\"'header-menu-item-link'\"\n      routerLinkActive=\"mm-header-menu-item--selected\"\n      [routerLink]=\"link\"\n    >\n      <span\n        class=\"mm-header-menu-item__content\"\n        [mmTestTarget]=\"'header-menu-item-content'\"\n      >\n        <ng-content></ng-content>\n      </span>\n    </a>\n</div>\n",
                styles: [".mm-header-menu-item{background-color:#fff;box-sizing:border-box;color:#0064fe;cursor:pointer;font-family:Lato,sans-serif;font-size:1.14rem;font-weight:700;line-height:1.25;padding:10px 20px 10px 28px}.mm-header-menu-item .mm-header-menu-item--selected,.mm-header-menu-item:active,.mm-header-menu-item:focus,.mm-header-menu-item:hover{color:#002866}.mm-header-menu-item .mm-header-menu-item--selected mat-icon,.mm-header-menu-item .mm-header-menu-item--selected mm-icon{fill:#002866}.mm-header-menu-item ::ng-deep .mm-header-menu-item__link{color:#0064fe;display:flex;text-decoration:none;width:100%}.mm-header-menu-item ::ng-deep .mm-header-menu-item__link .mm-header-menu-item__content{padding-left:34px;position:relative}.mm-header-menu-item ::ng-deep .mm-header-menu-item__link .mm-header-menu-item__content mat-icon,.mm-header-menu-item ::ng-deep .mm-header-menu-item__link .mm-header-menu-item__content mm-icon{fill:#0064fe;font-size:20px;height:20px;left:0;line-height:20px;position:absolute;top:0;width:20px}.mm-header-menu-item ::ng-deep .mm-header-menu-item__link:active,.mm-header-menu-item ::ng-deep .mm-header-menu-item__link:hover{color:#002866}.mm-header-menu-item ::ng-deep .mm-header-menu-item__link:active .mm-header-menu-item__content,.mm-header-menu-item ::ng-deep .mm-header-menu-item__link:hover .mm-header-menu-item__content{text-decoration:underline}.mm-header-menu-item ::ng-deep .mm-header-menu-item__link:active .mm-header-menu-item__content mat-icon,.mm-header-menu-item ::ng-deep .mm-header-menu-item__link:active .mm-header-menu-item__content mm-icon,.mm-header-menu-item ::ng-deep .mm-header-menu-item__link:hover .mm-header-menu-item__content mat-icon,.mm-header-menu-item ::ng-deep .mm-header-menu-item__link:hover .mm-header-menu-item__content mm-icon{text-decoration:none}.mm-header-menu-item ::ng-deep .mm-header-menu-item__link.active,.mm-header-menu-item ::ng-deep .mm-header-menu-item__link.active~{color:#002866}"]
            }]
    }], null, { link: [{
            type: Input
        }] }); })();

class MmHeaderMenuDividerComponent {
}
MmHeaderMenuDividerComponent.ɵfac = function MmHeaderMenuDividerComponent_Factory(t) { return new (t || MmHeaderMenuDividerComponent)(); };
MmHeaderMenuDividerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmHeaderMenuDividerComponent, selectors: [["mm-header-menu-divider"]], decls: 1, vars: 0, consts: [[1, "mm-menu-divider"]], template: function MmHeaderMenuDividerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
    } }, styles: [".mm-menu-divider[_ngcontent-%COMP%]{border-bottom:1px solid #e6e8eb;display:block;height:1px;margin:5px 0}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmHeaderMenuDividerComponent, [{
        type: Component,
        args: [{
                selector: 'mm-header-menu-divider',
                template: '<div class="mm-menu-divider"></div>',
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".mm-menu-divider{border-bottom:1px solid #e6e8eb;display:block;height:1px;margin:5px 0}"]
            }]
    }], null, null); })();

class MmHeaderMenuModule {
}
MmHeaderMenuModule.ɵfac = function MmHeaderMenuModule_Factory(t) { return new (t || MmHeaderMenuModule)(); };
MmHeaderMenuModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmHeaderMenuModule });
MmHeaderMenuModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            RouterModule,
            OverlayModule,
            MmOverlayModule,
            MmMenuModule,
            QaLocatorsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmHeaderMenuModule, { declarations: function () { return [MmHeaderMenuDirective, MmHeaderMenuComponent, MmHeaderMenuItemComponent, MmHeaderMenuDividerComponent]; }, imports: function () { return [CommonModule,
        RouterModule,
        OverlayModule, MmOverlayModule, MmMenuModule, QaLocatorsModule]; }, exports: function () { return [MmHeaderMenuDirective, MmHeaderMenuComponent, MmHeaderMenuItemComponent, MmHeaderMenuDividerComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmHeaderMenuModule, [{
        type: NgModule,
        args: [{
                entryComponents: [MmHeaderMenuComponent],
                exports: [
                    MmHeaderMenuDirective,
                    MmHeaderMenuComponent,
                    MmHeaderMenuItemComponent,
                    MmHeaderMenuDividerComponent
                ],
                declarations: [
                    MmHeaderMenuDirective,
                    MmHeaderMenuComponent,
                    MmHeaderMenuItemComponent,
                    MmHeaderMenuDividerComponent
                ],
                imports: [
                    CommonModule,
                    RouterModule,
                    OverlayModule,
                    MmOverlayModule,
                    MmMenuModule,
                    QaLocatorsModule,
                ]
            }]
    }], null, null); })();

var MmTooltipTrigger;
(function (MmTooltipTrigger) {
    MmTooltipTrigger["click"] = "click";
    MmTooltipTrigger["hover"] = "hover";
})(MmTooltipTrigger || (MmTooltipTrigger = {}));
var MmTooltipPlacement;
(function (MmTooltipPlacement) {
    MmTooltipPlacement["bottom"] = "bottom";
    MmTooltipPlacement["top"] = "top";
})(MmTooltipPlacement || (MmTooltipPlacement = {}));
var MmTooltipColor;
(function (MmTooltipColor) {
    MmTooltipColor["white"] = "white";
    MmTooltipColor["blue"] = "blue";
})(MmTooltipColor || (MmTooltipColor = {}));
const DEFAULT_HIDE_DELAY = 100;
const DEFAULT_TOUCHEND_HIDE_DELAY = 1500;
const MM_TOOLTIP_OPTIONS_DEFAULT = {
    placement: MmTooltipPlacement.bottom,
    delay: 0,
    showDelay: 0,
    hideDelay: DEFAULT_HIDE_DELAY,
    touchendHideDelay: DEFAULT_TOUCHEND_HIDE_DELAY,
    trigger: MmTooltipTrigger.hover,
    tooltipColor: MmTooltipColor.blue,
    tooltipClass: ''
};
const MM_TOOLTIP_VIEWPORT_MARGIN = 10;
const MM_TOOLTIP_SELECTOR = '.mm-tooltip';
const MM_TOOLTIP_PANEL_CLASS = 'mm-tooltip-panel';
const MM_TOOLTIP_X_CENTER = 'center';
const MM_TOOLTIP_LONGPRESS_DELAY = 500;

const mmTooltipAnimations = {
    tooltipState: trigger('state', [
        state('initial, void, hidden', style({ opacity: 0, transform: 'scale(0)' })),
        state('visible', style({ transform: 'scale(1)' })),
        transition('* => visible', animate('300ms cubic-bezier(0, 0, 0.2, 1)', keyframes([
            style({ opacity: 0, transform: 'scale(0)', offset: 0 }),
            style({ opacity: 0.5, transform: 'scale(0.99)', offset: 0.5 }),
            style({ opacity: 1, transform: 'scale(1)', offset: 1 })
        ]))),
        transition('* => hidden', animate('150ms cubic-bezier(0, 0, 0.2, 1)', style({ opacity: 0 }))),
    ])
};

class MmTooltipComponent {
    constructor(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.placement = MmTooltipPlacement.bottom;
        this.color = MmTooltipColor.blue;
        this.visibility = "initial" /* initial */;
        this.showTimeoutId = null;
        this.hideTimeoutId = null;
        this.closeOnInteraction = false;
        this.onHide = new Subject();
    }
    set tooltipContent(tooltipContent) {
        if (tooltipContent instanceof TemplateRef) {
            this.templateRef = tooltipContent;
            this.withStringContent = false;
        }
        else {
            this.templateRef = this.nopTemplate;
            this.message = tooltipContent;
            this.withStringContent = true;
        }
    }
    get tooltipClasses() {
        return [
            `mm-tooltip--${this.placement}`,
            `mm-tooltip--${this.color}`,
            this.className,
        ];
    }
    get isVisible() {
        return this.visibility === "visible" /* visible */;
    }
    get isActive() {
        return this.isVisible && !this.showTimeoutId && !this.hideTimeoutId;
    }
    ngOnDestroy() {
        if (this.showTimeoutId) {
            clearTimeout(this.showTimeoutId);
        }
        if (this.hideTimeoutId) {
            clearTimeout(this.hideTimeoutId);
        }
        this.onHide.complete();
    }
    afterHidden() {
        return this.onHide.asObservable();
    }
    show(delay) {
        if (this.hideTimeoutId) {
            clearTimeout(this.hideTimeoutId);
            this.hideTimeoutId = null;
        }
        this.closeOnInteraction = true;
        this.showTimeoutId = setTimeout(() => {
            this.showTimeoutId = null;
            this.visibility = "visible" /* visible */;
            this.markForCheck();
        }, delay);
    }
    hide(delay) {
        if (this.showTimeoutId) {
            clearTimeout(this.showTimeoutId);
            this.showTimeoutId = null;
        }
        this.hideTimeoutId = setTimeout(() => {
            this.hideTimeoutId = null;
            this.visibility = "hidden" /* hidden */;
            this.markForCheck();
        }, delay);
    }
    handleBodyInteraction() {
        if (this.closeOnInteraction) {
            this.hide(0);
        }
    }
    animationStart() {
        this.closeOnInteraction = false;
    }
    animationDone(event) {
        const toState = event.toState;
        if (toState === "hidden" /* hidden */ && !this.isVisible) {
            this.onHide.next();
        }
        if (toState === "visible" /* visible */ || toState === "hidden" /* hidden */) {
            this.closeOnInteraction = true;
        }
    }
    markForCheck() {
        this.changeDetectorRef.markForCheck();
    }
    detectChanges() {
        this.changeDetectorRef.detectChanges();
    }
}
MmTooltipComponent.ɵfac = function MmTooltipComponent_Factory(t) { return new (t || MmTooltipComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
MmTooltipComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmTooltipComponent, selectors: [["mm-tooltip"]], viewQuery: function MmTooltipComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c24, 3);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.nopTemplate = _t.first);
    } }, hostAttrs: ["aria-hidden", "true"], hostVars: 2, hostBindings: function MmTooltipComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function MmTooltipComponent_click_HostBindingHandler() { return ctx.handleBodyInteraction(); }, false, ɵngcc0.ɵɵresolveBody);
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("zoom", ctx.isVisible ? 1 : null);
    } }, inputs: { placement: "placement", color: "color", tooltipContent: "tooltipContent", className: "className" }, decls: 4, vars: 5, consts: [[1, "mm-tooltip", 3, "ngClass", "mmTestTarget"], [4, "ngIf", "ngIfElse"], ["blankTemplate", ""]], template: function MmTooltipComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("@state.start", function MmTooltipComponent_Template_div_animation_state_start_0_listener() { return ctx.animationStart(); })("@state.done", function MmTooltipComponent_Template_div_animation_state_done_0_listener($event) { return ctx.animationDone($event); });
        ɵngcc0.ɵɵtemplate(1, MmTooltipComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, MmTooltipComponent_ng_template_2_Template, 0, 0, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.tooltipClasses)("@state", ctx.visibility)("mmTestTarget", "mm-tooltip");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.withStringContent)("ngIfElse", ctx.templateRef);
    } }, directives: [ɵngcc2.NgClass, ɵngcc3.ɵf, ɵngcc2.NgIf], styles: [".mm-tooltip-panel{pointer-events:none!important}.mm-tooltip{background-color:#cce0ff;border-radius:2px;box-sizing:border-box;color:#002866;font-size:.92rem;line-height:1.38;max-width:304px;min-width:152px;padding:12px 16px;position:relative}.mm-tooltip:after{border-style:solid;content:\"\";left:50%;margin-left:-8px;position:absolute}.mm-tooltip.mm-tooltip--top{margin-bottom:10px}.mm-tooltip.mm-tooltip--top:after{border-color:#cce0ff transparent transparent;border-width:8px 8px 0;top:100%}.mm-tooltip.mm-tooltip--bottom{margin-top:10px}.mm-tooltip.mm-tooltip--bottom:after{border-color:transparent transparent #cce0ff;border-width:0 8px 8px;bottom:100%}.mm-tooltip.mm-tooltip--white{background-color:#fff;box-shadow:0 4px 16px 0 rgba(0,45,114,.11)}.mm-tooltip.mm-tooltip--white.mm-tooltip--top:after{border-color:#fff transparent transparent}.mm-tooltip.mm-tooltip--white.mm-tooltip--bottom:after{border-color:transparent transparent #fff}"], encapsulation: 2, data: { animation: [mmTooltipAnimations.tooltipState] }, changeDetection: 0 });
MmTooltipComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
MmTooltipComponent.propDecorators = {
    tooltipContent: [{ type: Input }],
    placement: [{ type: Input }],
    color: [{ type: Input }],
    className: [{ type: Input }],
    nopTemplate: [{ type: ViewChild, args: ['blankTemplate', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmTooltipComponent, [{
        type: Component,
        args: [{
                selector: 'mm-tooltip',
                template: "<div class=\"mm-tooltip\"\n     [ngClass]=\"tooltipClasses\"\n     [@state]=\"visibility\"\n     (@state.start)=\"animationStart()\"\n     (@state.done)=\"animationDone($event)\"\n     [mmTestTarget]=\"'mm-tooltip'\">\n    <ng-container *ngIf=\"withStringContent else templateRef\">\n        {{ message }}\n    </ng-container>\n</div>\n\n<ng-template #blankTemplate></ng-template>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                animations: [mmTooltipAnimations.tooltipState],
                host: {
                    // Forces the element to have a layout in IE and Edge. This fixes issues where the element
                    // won't be rendered if the animations are disabled or there is no web animations polyfill.
                    '[style.zoom]': 'isVisible ? 1 : null',
                    '(body:click)': 'this.handleBodyInteraction()',
                    'aria-hidden': 'true'
                },
                styles: [".mm-tooltip-panel{pointer-events:none!important}.mm-tooltip{background-color:#cce0ff;border-radius:2px;box-sizing:border-box;color:#002866;font-size:.92rem;line-height:1.38;max-width:304px;min-width:152px;padding:12px 16px;position:relative}.mm-tooltip:after{border-style:solid;content:\"\";left:50%;margin-left:-8px;position:absolute}.mm-tooltip.mm-tooltip--top{margin-bottom:10px}.mm-tooltip.mm-tooltip--top:after{border-color:#cce0ff transparent transparent;border-width:8px 8px 0;top:100%}.mm-tooltip.mm-tooltip--bottom{margin-top:10px}.mm-tooltip.mm-tooltip--bottom:after{border-color:transparent transparent #cce0ff;border-width:0 8px 8px;bottom:100%}.mm-tooltip.mm-tooltip--white{background-color:#fff;box-shadow:0 4px 16px 0 rgba(0,45,114,.11)}.mm-tooltip.mm-tooltip--white.mm-tooltip--top:after{border-color:#fff transparent transparent}.mm-tooltip.mm-tooltip--white.mm-tooltip--bottom:after{border-color:transparent transparent #fff}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { placement: [{
            type: Input
        }], color: [{
            type: Input
        }], tooltipContent: [{
            type: Input
        }], className: [{
            type: Input
        }], nopTemplate: [{
            type: ViewChild,
            args: ['blankTemplate', { static: true }]
        }] }); })();

const MM_TOOLTIP_OPTIONS = new InjectionToken('MnTooltipOptions');

const SCROLL_THROTTLE_MS = 20;
const MM_TOOLTIP_SCROLL_STRATEGY = new InjectionToken('mm-tooltip-scroll-strategy');
function MM_TOOLTIP_SCROLL_STRATEGY_FACTORY(overlay) {
    return () => overlay.scrollStrategies.reposition({
        scrollThrottle: SCROLL_THROTTLE_MS
    });
}
const MM_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER = {
    provide: MM_TOOLTIP_SCROLL_STRATEGY,
    deps: [Overlay],
    useFactory: MM_TOOLTIP_SCROLL_STRATEGY_FACTORY,
};

const passiveListenerOptions = normalizePassiveListenerOptions({ passive: true });
class MmTooltipDirective {
    constructor(initOptions, overlay, overlayPositionBuilder, scrollDispatcher, elementRef, viewContainerRef, platform, focusMonitor, ngZone, scrollStrategy) {
        this.initOptions = initOptions;
        this.overlay = overlay;
        this.overlayPositionBuilder = overlayPositionBuilder;
        this.scrollDispatcher = scrollDispatcher;
        this.elementRef = elementRef;
        this.viewContainerRef = viewContainerRef;
        this.platform = platform;
        this.focusMonitor = focusMonitor;
        this.ngZone = ngZone;
        this.scrollStrategy = scrollStrategy;
        this._disabled = false;
        this._touchGestures = "auto" /* auto */;
        this.destroyed = new Subject();
        this.passiveListeners = new Map();
        this.handleKeydown = (event) => {
            if (this.tooltipInstance && this.tooltipInstance.isActive && event.key === 'Escape' && !hasModifierKey(event)) {
                event.preventDefault();
                event.stopPropagation();
                this.ngZone.run(() => this.hide(0));
            }
        };
        this.options = initOptions;
    }
    set options(value) {
        if (value) {
            const moduleOptions = this.initOptions || {};
            this._options = Object.assign(Object.assign({}, moduleOptions), value);
        }
    }
    get options() {
        return this._options;
    }
    set delay(value) {
        if (value) {
            this._delay = value;
        }
    }
    get delay() {
        return this.getOption('delay');
    }
    set showDelay(value) {
        if (value) {
            this._showDelay = value;
        }
    }
    get showDelay() {
        return this.getOption('delay') || this.getOption('showDelay');
    }
    set hideDelay(value) {
        if (value) {
            this._hideDelay = value;
        }
    }
    get hideDelay() {
        return this.getOption('hideDelay');
    }
    set placement(value) {
        if (!value) {
            return;
        }
        const placementPrev = this.placement;
        this._placement = value;
        if (this.placement !== placementPrev) {
            if (this.overlayRef) {
                this.updatePosition();
                if (this.tooltipInstance) {
                    this.tooltipInstance.show(0);
                }
                this.overlayRef.updatePosition();
            }
        }
    }
    get placement() {
        return this.getOption('placement');
    }
    set tooltipClass(value) {
        if (value) {
            this._tooltipClass = value;
        }
    }
    get tooltipClass() {
        return this.getOption('tooltipClass');
    }
    set tooltipColor(value) {
        if (value) {
            this._tooltipColor = value;
        }
    }
    get tooltipColor() {
        return this.getOption('tooltipColor');
    }
    set trigger(value) {
        if (value) {
            const triggerPrev = this.trigger;
            this._trigger = value;
            if (this.trigger !== triggerPrev) {
                this.hide();
                this.removeListeners();
                this.setupPointerEvents();
            }
        }
    }
    get trigger() {
        return this.getOption('trigger');
    }
    set disabled(value) {
        this._disabled = Boolean(value);
        if (this._disabled) {
            this.hide();
        }
    }
    get disabled() {
        return this._disabled;
    }
    /**
     * How touch gestures should be handled by the tooltip. On touch devices the tooltip directive
     * uses a long press gesture to show and hide, however it can conflict with the native browser
     * gestures. To work around the conflict, Angular Material disables native gestures on the
     * trigger, but that might not be desirable on particular elements (e.g. inputs and draggable
     * elements). The different values for this option configure the touch event handling as follows:
     * - `auto` - Enables touch gestures for all elements, but tries to avoid conflicts with native
     *   browser gestures on particular elements. In particular, it allows text selection on inputs
     *   and textareas, and preserves the native browser dragging on elements marked as `draggable`.
     * - `on` - Enables touch gestures for all elements and disables native
     *   browser gestures with no exceptions.
     * - `off` - Disables touch gestures. Note that this will prevent the tooltip from
     *   showing on touch devices.
     */
    set touchGestures(value) {
        if (value) {
            this._touchGestures = value;
        }
    }
    get touchGestures() {
        return this._touchGestures;
    }
    get touchendHideDelay() {
        return this.getOption('touchendHideDelay');
    }
    getOption(name) {
        const attributeParamName = `_${name}`;
        if (this[attributeParamName] !== undefined) {
            return this[attributeParamName];
        }
        if (this.options && this.options[name] !== undefined) {
            return this.options[name];
        }
        return MM_TOOLTIP_OPTIONS_DEFAULT[name];
    }
    ngOnInit() {
        this.setupFocusEvent();
        this.setupKeydownEvent();
        this.setupPointerEvents();
    }
    ngOnDestroy() {
        if (this.overlayRef) {
            this.overlayRef.dispose();
            this.tooltipInstance = null;
        }
        this.removeListeners();
        this.destroyed.next();
        this.destroyed.complete();
        this.focusMonitor.stopMonitoring(this.elementRef);
        this.elementRef.nativeElement.removeEventListener('keydown', this.handleKeydown);
    }
    show() {
        if (this.disabled || (this.tooltipInstance && this.tooltipInstance.isActive)) {
            return;
        }
        const overlayRef = this.createOverlay();
        this.detach();
        this.tooltipPortal = this.tooltipPortal || new ComponentPortal(MmTooltipComponent, this.viewContainerRef);
        this.tooltipInstance = overlayRef.attach(this.tooltipPortal).instance;
        this.tooltipInstance.afterHidden().pipe(takeUntil(this.destroyed)).subscribe(() => this.detach());
        this.updateStyles();
        this.updateMessage();
        this.tooltipInstance.show(this.showDelay);
    }
    updateStyles() {
        if (this.tooltipInstance) {
            this.tooltipInstance.placement = this.placement;
            this.tooltipInstance.color = this.tooltipColor;
            this.tooltipInstance.className = this.tooltipClass;
            this.tooltipInstance.markForCheck();
        }
    }
    updateMessage() {
        // Must wait for the message to be painted to the tooltip so that the overlay can properly
        // calculate the correct positioning based on the size of the text.
        if (this.tooltipInstance) {
            this.tooltipInstance.tooltipContent = this.tooltipValue;
            this.tooltipInstance.markForCheck();
            this.ngZone.onMicrotaskEmpty.asObservable().pipe(take(1), takeUntil(this.destroyed)).subscribe(() => {
                if (this.tooltipInstance) {
                    this.overlayRef.updatePosition();
                }
            });
        }
    }
    hide(delay) {
        if (this.tooltipInstance) {
            this.tooltipInstance.hide(typeof delay === 'number' ? delay : this.hideDelay);
        }
    }
    setupFocusEvent() {
        this.focusMonitor.monitor(this.elementRef).pipe(takeUntil(this.destroyed)).subscribe((origin) => {
            if (!origin) {
                this.ngZone.run(() => this.hide(0));
            }
            else if (origin === 'keyboard') {
                this.ngZone.run(() => this.show());
            }
        });
    }
    setupKeydownEvent() {
        this.ngZone.runOutsideAngular(() => {
            this.elementRef.nativeElement.addEventListener('keydown', this.handleKeydown);
        });
    }
    setupPointerEvents() {
        // The mouse events shouldn't be bound on mobile devices, because they can prevent the
        // first tap from firing its click event or can cause the tooltip to open for clicks.
        if (!this.platform.IOS && !this.platform.ANDROID) {
            if (this.trigger === MmTooltipTrigger.hover) {
                this.passiveListeners
                    .set('mouseenter', () => this.show())
                    .set('mouseleave', () => this.hide());
            }
            else {
                this.passiveListeners
                    .set('click', () => {
                    if (!this.tooltipInstance) {
                        this.show();
                    }
                });
            }
        }
        else if (this.touchGestures !== "off" /* off */) {
            this.disableNativeGesturesIfNecessary();
            const touchendListener = () => {
                clearTimeout(this.touchstartTimeout);
                this.hide(this.touchendHideDelay);
            };
            this.passiveListeners
                .set('touchend', touchendListener)
                .set('touchcancel', touchendListener)
                .set('touchstart', () => {
                // Note that it's important that we don't `preventDefault` here,
                // because it can prevent click events from firing on the element.
                clearTimeout(this.touchstartTimeout);
                this.touchstartTimeout = setTimeout(() => this.show(), MM_TOOLTIP_LONGPRESS_DELAY);
            });
        }
        this.passiveListeners.forEach((listener, event) => {
            this.elementRef.nativeElement.addEventListener(event, listener, passiveListenerOptions);
        });
    }
    disableNativeGesturesIfNecessary() {
        const gestures = this.touchGestures;
        if (gestures !== "off" /* off */) {
            const element = this.elementRef.nativeElement;
            const style = element.style;
            // If gestures are set to `auto`, we don't disable text selection on inputs and
            // textareas, because it prevents the user from typing into them on iOS Safari.
            if (gestures === "on" /* on */ || (element.nodeName !== 'INPUT' && element.nodeName !== 'TEXTAREA')) {
                style.userSelect = style.msUserSelect = style.webkitUserSelect =
                    style.MozUserSelect = 'none';
            }
            // If we have `auto` gestures and the element uses native HTML dragging,
            // we don't set `-webkit-user-drag` because it prevents the native behavior.
            if (gestures === "on" /* on */ || !element.draggable) {
                style.webkitUserDrag = 'none';
            }
            style.touchAction = 'none';
            style.webkitTapHighlightColor = 'transparent';
        }
    }
    removeListeners() {
        this.passiveListeners.forEach((listener, event) => {
            this.elementRef.nativeElement.removeEventListener(event, listener, passiveListenerOptions);
        });
        this.passiveListeners.clear();
    }
    createOverlay() {
        if (this.overlayRef) {
            return this.overlayRef;
        }
        const scrollableAncestors = this.scrollDispatcher.getAncestorScrollContainers(this.elementRef);
        const strategy = this.overlay.position()
            .flexibleConnectedTo(this.elementRef)
            .withTransformOriginOn(MM_TOOLTIP_SELECTOR)
            .withFlexibleDimensions(false)
            .withViewportMargin(MM_TOOLTIP_VIEWPORT_MARGIN);
        strategy.withScrollableContainers(scrollableAncestors);
        strategy.positionChanges.pipe(takeUntil(this.destroyed)).subscribe((change) => {
            if (this.tooltipInstance) {
                const placement = change.connectionPair.originY;
                if (this.tooltipInstance.placement !== placement) {
                    this.tooltipInstance.placement = placement;
                    this.tooltipInstance.detectChanges();
                }
                if (change.scrollableViewProperties.isOverlayClipped && this.tooltipInstance.isVisible) {
                    this.ngZone.run(() => this.hide(0));
                }
            }
        });
        this.overlayRef = this.overlay.create({
            positionStrategy: strategy,
            panelClass: MM_TOOLTIP_PANEL_CLASS,
            scrollStrategy: this.scrollStrategy()
        });
        this.updatePosition();
        this.overlayRef.detachments()
            .pipe(takeUntil(this.destroyed))
            .subscribe(() => this.detach());
        return this.overlayRef;
    }
    updatePosition() {
        const position = this.overlayRef.getConfig().positionStrategy;
        const origin = this.getOriginPosition();
        const overlay = this.getOverlayPosition();
        position.withPositions([
            Object.assign(Object.assign({}, origin.main), overlay.main),
            Object.assign(Object.assign({}, origin.fallback), overlay.fallback)
        ]);
    }
    getOriginPosition() {
        const main = {
            originX: MM_TOOLTIP_X_CENTER,
            originY: this.placement
        };
        const fallback = {
            originX: MM_TOOLTIP_X_CENTER,
            originY: this.placement === MmTooltipPlacement.top ? MmTooltipPlacement.bottom : MmTooltipPlacement.top
        };
        return { main, fallback };
    }
    getOverlayPosition() {
        const main = {
            overlayX: MM_TOOLTIP_X_CENTER,
            overlayY: this.placement === MmTooltipPlacement.top ? MmTooltipPlacement.bottom : MmTooltipPlacement.top
        };
        const fallback = {
            overlayX: MM_TOOLTIP_X_CENTER,
            overlayY: this.placement
        };
        return { main, fallback };
    }
    detach() {
        if (this.overlayRef && this.overlayRef.hasAttached()) {
            this.overlayRef.detach();
        }
        this.tooltipInstance = null;
    }
}
MmTooltipDirective.ɵfac = function MmTooltipDirective_Factory(t) { return new (t || MmTooltipDirective)(ɵngcc0.ɵɵdirectiveInject(MM_TOOLTIP_OPTIONS, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc12.Overlay), ɵngcc0.ɵɵdirectiveInject(ɵngcc12.OverlayPositionBuilder), ɵngcc0.ɵɵdirectiveInject(ɵngcc12.ScrollDispatcher), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc13.Platform), ɵngcc0.ɵɵdirectiveInject(ɵngcc14.FocusMonitor), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(MM_TOOLTIP_SCROLL_STRATEGY)); };
MmTooltipDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmTooltipDirective, selectors: [["", "mmTooltip", ""]], hostAttrs: [1, "mm-tooltip-trigger"], inputs: { options: ["mmTooltipOptions", "options"], delay: ["mmTooltipDelay", "delay"], showDelay: ["mmTooltipShowDelay", "showDelay"], hideDelay: ["mmTooltipHideDelay", "hideDelay"], placement: ["mmTooltipPlacement", "placement"], tooltipClass: ["mmTooltipClass", "tooltipClass"], tooltipColor: ["mmTooltipColor", "tooltipColor"], trigger: ["mmTooltipTrigger", "trigger"], disabled: ["mmTooltipDisabled", "disabled"], touchGestures: ["mmTooltipTouchGestures", "touchGestures"], tooltipValue: ["mmTooltip", "tooltipValue"] } });
MmTooltipDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [MM_TOOLTIP_OPTIONS,] }] },
    { type: Overlay },
    { type: OverlayPositionBuilder },
    { type: ScrollDispatcher },
    { type: ElementRef },
    { type: ViewContainerRef },
    { type: Platform },
    { type: FocusMonitor },
    { type: NgZone },
    { type: undefined, decorators: [{ type: Inject, args: [MM_TOOLTIP_SCROLL_STRATEGY,] }] }
];
MmTooltipDirective.propDecorators = {
    tooltipValue: [{ type: Input, args: ['mmTooltip',] }],
    options: [{ type: Input, args: ['mmTooltipOptions',] }],
    delay: [{ type: Input, args: ['mmTooltipDelay',] }],
    showDelay: [{ type: Input, args: ['mmTooltipShowDelay',] }],
    hideDelay: [{ type: Input, args: ['mmTooltipHideDelay',] }],
    placement: [{ type: Input, args: ['mmTooltipPlacement',] }],
    tooltipClass: [{ type: Input, args: ['mmTooltipClass',] }],
    tooltipColor: [{ type: Input, args: ['mmTooltipColor',] }],
    trigger: [{ type: Input, args: ['mmTooltipTrigger',] }],
    disabled: [{ type: Input, args: ['mmTooltipDisabled',] }],
    touchGestures: [{ type: Input, args: ['mmTooltipTouchGestures',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmTooltipDirective, [{
        type: Directive,
        args: [{
                selector: '[mmTooltip]',
                host: {
                    class: 'mm-tooltip-trigger'
                }
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [MM_TOOLTIP_OPTIONS]
            }] }, { type: ɵngcc12.Overlay }, { type: ɵngcc12.OverlayPositionBuilder }, { type: ɵngcc12.ScrollDispatcher }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc13.Platform }, { type: ɵngcc14.FocusMonitor }, { type: ɵngcc0.NgZone }, { type: undefined, decorators: [{
                type: Inject,
                args: [MM_TOOLTIP_SCROLL_STRATEGY]
            }] }]; }, { options: [{
            type: Input,
            args: ['mmTooltipOptions']
        }], delay: [{
            type: Input,
            args: ['mmTooltipDelay']
        }], showDelay: [{
            type: Input,
            args: ['mmTooltipShowDelay']
        }], hideDelay: [{
            type: Input,
            args: ['mmTooltipHideDelay']
        }], placement: [{
            type: Input,
            args: ['mmTooltipPlacement']
        }], tooltipClass: [{
            type: Input,
            args: ['mmTooltipClass']
        }], tooltipColor: [{
            type: Input,
            args: ['mmTooltipColor']
        }], trigger: [{
            type: Input,
            args: ['mmTooltipTrigger']
        }], disabled: [{
            type: Input,
            args: ['mmTooltipDisabled']
        }], touchGestures: [{
            type: Input,
            args: ['mmTooltipTouchGestures']
        }], tooltipValue: [{
            type: Input,
            args: ['mmTooltip']
        }] }); })();

class MmTooltipModule {
    static forRoot(initOptions) {
        return {
            ngModule: MmTooltipModule,
            providers: [
                {
                    provide: MM_TOOLTIP_OPTIONS,
                    useValue: initOptions,
                },
            ],
        };
    }
}
MmTooltipModule.ɵfac = function MmTooltipModule_Factory(t) { return new (t || MmTooltipModule)(); };
MmTooltipModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmTooltipModule });
MmTooltipModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [
        MM_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER,
    ], imports: [[
            CommonModule,
            OverlayModule,
            QaLocatorsModule,
            RouterModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmTooltipModule, { declarations: function () { return [MmTooltipDirective, MmTooltipComponent]; }, imports: function () { return [CommonModule,
        OverlayModule,
        QaLocatorsModule,
        RouterModule]; }, exports: function () { return [MmTooltipDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmTooltipModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    MmTooltipDirective,
                    MmTooltipComponent,
                ],
                imports: [
                    CommonModule,
                    OverlayModule,
                    QaLocatorsModule,
                    RouterModule,
                ],
                exports: [
                    MmTooltipDirective,
                ],
                providers: [
                    MM_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER,
                ],
                entryComponents: [
                    MmTooltipComponent,
                ]
            }]
    }], null, null); })();

const MmDialogData = new InjectionToken('MmDialogData');
const MmDialogDefaultOptions = new InjectionToken('mm-dialog-default-options');
const MmDialogScrollStrategy = new InjectionToken('mm-dialog-scroll-strategy');
const MmDialogScrollStrategyProvider = {
    provide: MmDialogScrollStrategy,
    deps: [Overlay],
    useFactory: MmDialogScrollStrategyFactory,
};
function MmDialogScrollStrategyFactory(overlay) {
    return () => overlay.scrollStrategies.block();
}

var MmDialogSize;
(function (MmDialogSize) {
    MmDialogSize["medium"] = "medium";
    MmDialogSize["large"] = "large";
    MmDialogSize["content"] = "content";
    MmDialogSize["fit"] = "fit";
})(MmDialogSize || (MmDialogSize = {}));
class MmDialogConfig {
    constructor() {
        this.hasBackdrop = true;
        this.autoFocus = true;
        this.restoreFocus = true;
        this.backdropClass = '';
        this.backdropDisableClose = false;
        this.dialogSize = MmDialogSize.medium;
        this.dialogHasOffsets = true;
        this.data = null;
        this.closeOnNavigation = true;
    }
}

var MmDialogAnimationState;
(function (MmDialogAnimationState) {
    MmDialogAnimationState["void"] = "void";
    MmDialogAnimationState["enter"] = "enter";
    MmDialogAnimationState["exit"] = "exit";
    MmDialogAnimationState["none"] = "none";
})(MmDialogAnimationState || (MmDialogAnimationState = {}));
var MmDialogAnimationPhaseName;
(function (MmDialogAnimationPhaseName) {
    MmDialogAnimationPhaseName["start"] = "start";
    MmDialogAnimationPhaseName["done"] = "done";
})(MmDialogAnimationPhaseName || (MmDialogAnimationPhaseName = {}));
const animationBody = [
    state(`${MmDialogAnimationState.void}, ${MmDialogAnimationState.exit}`, style({ opacity: 0, transform: 'scale(0.7)' })),
    state(`${MmDialogAnimationState.enter}`, style({ transform: `${MmDialogAnimationState.none}` })),
    transition(`* => ${MmDialogAnimationState.enter}`, animate('150ms cubic-bezier(0, 0, 0.2, 1)', style({ transform: `${MmDialogAnimationState.none}`, opacity: 1 }))),
    transition(`* => ${MmDialogAnimationState.void}, * => ${MmDialogAnimationState.exit}`, animate('75ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({ opacity: 0 }))),
];
const MmDialogAnimations = {
    dialogContainer: trigger('dialogContainer', animationBody)
};

const SELECTOR_NAME = 'mm-dialog-container';
class MmDialogContainerComponent extends BasePortalOutlet {
    constructor(elementRef, focusTrapFactory, changeDetectorRef, document, config, focusMonitor) {
        super();
        this.elementRef = elementRef;
        this.focusTrapFactory = focusTrapFactory;
        this.changeDetectorRef = changeDetectorRef;
        this.document = document;
        this.config = config;
        this.focusMonitor = focusMonitor;
        this.state = MmDialogAnimationState.enter;
        this.dialogStateChanged = new EventEmitter();
        this.elementFocusedBeforeDialogWasOpened = null;
        this.closeInteractionType = null;
    }
    attachComponentPortal(portal) {
        if (this.portalOutlet.hasAttached()) {
            this.throwMmDialogContentAlreadyAttachedError();
        }
        this.setupFocusTrap();
        return this.portalOutlet.attachComponentPortal(portal);
    }
    attachTemplatePortal(portal) {
        if (this.portalOutlet.hasAttached()) {
            this.throwMmDialogContentAlreadyAttachedError();
        }
        this.setupFocusTrap();
        return this.portalOutlet.attachTemplatePortal(portal);
    }
    onDialogClose(event) {
        if (event.toState === 'enter') {
            this.trapFocus();
        }
        else if (event.toState === 'exit') {
            this.restoreFocus();
        }
        this.dialogStateChanged.emit(event);
    }
    onDialogOpen(event) {
        this.dialogStateChanged.emit(event);
    }
    onDialogExit() {
        this.state = MmDialogAnimationState.exit;
        this.changeDetectorRef.markForCheck();
    }
    throwMmDialogContentAlreadyAttachedError() {
        throw Error('Attempting to attach dialog content after content is already attached');
    }
    containsFocus() {
        const element = this.elementRef.nativeElement;
        const activeElement = this.document.activeElement;
        return element === activeElement || element.contains(activeElement);
    }
    setupFocusTrap() {
        if (!this.focusTrap) {
            this.focusTrap = this.focusTrapFactory.create(this.elementRef.nativeElement);
        }
        if (this.document) {
            this.elementFocusedBeforeDialogWasOpened = this.document.activeElement;
            if (this.elementRef.nativeElement.focus) {
                Promise.resolve().then(() => this.elementRef.nativeElement.focus());
            }
        }
    }
    trapFocus() {
        if (this.config.autoFocus) {
            this.focusTrap.focusInitialElementWhenReady();
        }
        else if (!this.containsFocus()) {
            this.elementRef.nativeElement.focus();
        }
    }
    restoreFocus() {
        const previousElement = this.elementFocusedBeforeDialogWasOpened;
        if (this.config.restoreFocus && previousElement && typeof previousElement.focus === 'function') {
            const activeElement = this.document.activeElement;
            const element = this.elementRef.nativeElement;
            if (!activeElement || activeElement === this.document.body || activeElement === element ||
                element.contains(activeElement)) {
                if (this.focusMonitor) {
                    this.focusMonitor.focusVia(previousElement, this.closeInteractionType);
                    this.closeInteractionType = null;
                }
                else {
                    previousElement.focus();
                }
            }
        }
        if (this.focusTrap) {
            this.focusTrap.destroy();
        }
    }
}
MmDialogContainerComponent.ɵfac = function MmDialogContainerComponent_Factory(t) { return new (t || MmDialogContainerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc14.FocusTrapFactory), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DOCUMENT, 8), ɵngcc0.ɵɵdirectiveInject(MmDialogConfig), ɵngcc0.ɵɵdirectiveInject(ɵngcc14.FocusMonitor)); };
MmDialogContainerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmDialogContainerComponent, selectors: [["mm-dialog-container"]], viewQuery: function MmDialogContainerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(CdkPortalOutlet, 3);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.portalOutlet = _t.first);
    } }, hostAttrs: [1, "mm-dialog-container"], hostVars: 12, hostBindings: function MmDialogContainerComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵsyntheticHostListener("@dialogContainer.start", function MmDialogContainerComponent_animation_dialogContainer_start_HostBindingHandler($event) { return ctx.onDialogOpen($event); })("@dialogContainer.done", function MmDialogContainerComponent_animation_dialogContainer_done_HostBindingHandler($event) { return ctx.onDialogClose($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("id", ctx.id);
        ɵngcc0.ɵɵsyntheticHostProperty("@dialogContainer", ctx.state);
        ɵngcc0.ɵɵclassProp("mm-dialog-container--no-offsets", !ctx.config.dialogHasOffsets)("mm-dialog-container--large", ctx.config.dialogSize === "large")("mm-dialog-container--medium", ctx.config.dialogSize === "medium")("mm-dialog-container--content-size", ctx.config.dialogSize === "content")("mm-dialog-container--fit", ctx.config.dialogSize === "fit");
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 0, consts: [["cdkPortalOutlet", ""]], template: function MmDialogContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, MmDialogContainerComponent_ng_template_0_Template, 0, 0, "ng-template", 0);
    } }, directives: [ɵngcc5.CdkPortalOutlet], styles: [".mm-overlay-backdrop--blue{background:#002d72}.cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:.9}.mm-dialog-container{background-color:#fff;box-shadow:0 2px 24px 0 rgba(0,40,102,.05);min-height:100px;width:480px}.mm-dialog-container.mm-dialog-container--content-size{width:unset}.mm-dialog-container.mm-dialog-container--fit{height:100%;width:100%}@media only screen and (min-width:768px){.mm-dialog-container.mm-dialog-container--large{min-width:564px}.mm-dialog-container.mm-dialog-container--large .mm-dialog-title{border-bottom:1px solid #e6e8eb}.mm-dialog-container.mm-dialog-container--large .mm-dialog-title .mm-dialog-title__close{padding-top:18px}.mm-dialog-container.mm-dialog-container--large .mm-dialog-content .mm-dialog-content__wrapper{padding-bottom:12px;padding-top:22px}.mm-dialog-container.mm-dialog-container--large .mm-dialog-footer{border-top:1px solid #e6e8eb;padding-top:20px}.mm-dialog-container.mm-dialog-container--no-offsets .mm-dialog-content .mm-dialog-content__wrapper{padding:0!important}}@media only screen and (max-width:768px){.mm-dialog-container{min-height:100px;width:100vw}.mm-dialog-container .mm-dialog-content{display:none}}"], encapsulation: 2, data: { animation: [MmDialogAnimations.dialogContainer] } });
MmDialogContainerComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: FocusTrapFactory },
    { type: ChangeDetectorRef },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DOCUMENT,] }] },
    { type: MmDialogConfig },
    { type: FocusMonitor }
];
MmDialogContainerComponent.propDecorators = {
    portalOutlet: [{ type: ViewChild, args: [CdkPortalOutlet, { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmDialogContainerComponent, [{
        type: Component,
        args: [{
                selector: SELECTOR_NAME,
                template: "<ng-template cdkPortalOutlet></ng-template>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.Default,
                animations: [MmDialogAnimations.dialogContainer],
                host: {
                    'class': SELECTOR_NAME,
                    '[class.mm-dialog-container--no-offsets]': '!config.dialogHasOffsets',
                    '[class.mm-dialog-container--large]': 'config.dialogSize === "large"',
                    '[class.mm-dialog-container--medium]': 'config.dialogSize === "medium"',
                    '[class.mm-dialog-container--content-size]': 'config.dialogSize === "content"',
                    '[class.mm-dialog-container--fit]': 'config.dialogSize === "fit"',
                    '[attr.id]': 'id',
                    '[@dialogContainer]': 'state',
                    '(@dialogContainer.start)': 'onDialogOpen($event)',
                    '(@dialogContainer.done)': 'onDialogClose($event)'
                },
                styles: [".mm-overlay-backdrop--blue{background:#002d72}.cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:.9}.mm-dialog-container{background-color:#fff;box-shadow:0 2px 24px 0 rgba(0,40,102,.05);min-height:100px;width:480px}.mm-dialog-container.mm-dialog-container--content-size{width:unset}.mm-dialog-container.mm-dialog-container--fit{height:100%;width:100%}@media only screen and (min-width:768px){.mm-dialog-container.mm-dialog-container--large{min-width:564px}.mm-dialog-container.mm-dialog-container--large .mm-dialog-title{border-bottom:1px solid #e6e8eb}.mm-dialog-container.mm-dialog-container--large .mm-dialog-title .mm-dialog-title__close{padding-top:18px}.mm-dialog-container.mm-dialog-container--large .mm-dialog-content .mm-dialog-content__wrapper{padding-bottom:12px;padding-top:22px}.mm-dialog-container.mm-dialog-container--large .mm-dialog-footer{border-top:1px solid #e6e8eb;padding-top:20px}.mm-dialog-container.mm-dialog-container--no-offsets .mm-dialog-content .mm-dialog-content__wrapper{padding:0!important}}@media only screen and (max-width:768px){.mm-dialog-container{min-height:100px;width:100vw}.mm-dialog-container .mm-dialog-content{display:none}}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc14.FocusTrapFactory }, { type: ɵngcc0.ChangeDetectorRef }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: MmDialogConfig }, { type: ɵngcc14.FocusMonitor }]; }, { portalOutlet: [{
            type: ViewChild,
            args: [CdkPortalOutlet, { static: true }]
        }] }); })();

class MmDialogRefService {
    constructor(overlayRef, containerInstance, id) {
        this.overlayRef = overlayRef;
        this.containerInstance = containerInstance;
        this.id = id;
        this.componentUniqueId = `mm-dialog-${v4()}`;
        this.backdropDisableClose = this.containerInstance.config.backdropDisableClose;
        this.afterOpened$ = new Subject();
        this.afterClosed$ = new Subject();
        this.beforeClosed$ = new Subject();
        containerInstance.id = id || this.componentUniqueId;
        containerInstance.dialogStateChanged.pipe(filter((event) => {
            return event.phaseName === MmDialogAnimationPhaseName.done && event.toState === MmDialogAnimationState.enter;
        }), take(1)).subscribe(() => {
            this.afterOpened$.next();
            this.afterOpened$.complete();
        });
        containerInstance.dialogStateChanged.pipe(filter((event) => {
            return event.phaseName === MmDialogAnimationPhaseName.done && event.toState === MmDialogAnimationState.exit;
        }), take(1)).subscribe(() => this.overlayRef.dispose());
        overlayRef.detachments().subscribe(() => {
            this.beforeClosed$.next(this.result);
            this.beforeClosed$.complete();
            this.afterClosed$.next(this.result);
            this.afterClosed$.complete();
            this.componentInstance = null;
            this.overlayRef.dispose();
        });
    }
    close(dialogResult) {
        this.result = dialogResult;
        this.containerInstance.dialogStateChanged.pipe()
            .subscribe(() => {
            this.beforeClosed$.next(dialogResult);
            this.beforeClosed$.complete();
            this.overlayRef.detachBackdrop();
        });
        this.containerInstance.onDialogExit();
    }
    afterOpened() {
        return this.afterOpened$.asObservable();
    }
    afterClosed() {
        return this.afterClosed$.asObservable();
    }
    beforeClosed() {
        return this.beforeClosed$.asObservable();
    }
    backdropClick() {
        return this.overlayRef.backdropClick();
    }
    updatePosition(position) {
        const strategy = this.getPositionStrategy();
        if (position && (position.left || position.right)) {
            position.left ? strategy.left(position.left) : strategy.right(position.right);
        }
        else {
            strategy.centerHorizontally();
        }
        if (position && (position.top || position.bottom)) {
            position.top ? strategy.top(position.top) : strategy.bottom(position.bottom);
        }
        else {
            strategy.centerVertically();
        }
        this.overlayRef.updatePosition();
        return this;
    }
    afterOpen() {
        return this.afterOpened();
    }
    beforeClose() {
        return this.beforeClosed();
    }
    getPositionStrategy() {
        return this.overlayRef.getConfig().positionStrategy;
    }
}

class MmDialogService {
    constructor(overlay, injector, defaultOptions, scrollStrategy, parentDialog) {
        this.overlay = overlay;
        this.injector = injector;
        this.defaultOptions = defaultOptions;
        this.parentDialog = parentDialog;
        this.openDialogsAtThisLevel = [];
        this.afterAllClosedAtThisLevel$ = new Subject();
        this.afterOpenedAtThisLevel$ = new Subject();
        this.mmContainerClassName = 'mm-dialog-container';
        this.afterAllClosed = defer(() => this.openDialogs.length ?
            this.afterAllDialogsClosed :
            this.afterAllDialogsClosed.pipe(startWith(undefined)));
        this.scrollStrategy = scrollStrategy;
    }
    ngOnDestroy() {
        this.closeDialogs(this.openDialogsAtThisLevel);
        this.afterAllClosedAtThisLevel$.complete();
        this.afterOpenedAtThisLevel$.complete();
    }
    get openDialogs() {
        return this.parentDialog ? this.parentDialog.openDialogs : this.openDialogsAtThisLevel;
    }
    get afterOpened() {
        return this.parentDialog ? this.parentDialog.afterOpened : this.afterOpenedAtThisLevel$;
    }
    get afterOpen() {
        return this.afterOpened;
    }
    get afterAllDialogsClosed() {
        const parent = this.parentDialog;
        return parent ? parent.afterAllDialogsClosed : this.afterAllClosedAtThisLevel$;
    }
    open(componentOrTemplateRef, config) {
        config = this.applyConfigDefaults(config, this.defaultOptions || new MmDialogConfig());
        if (config.id && this.getDialogById(config.id)) {
            throw Error(`Dialog with id ${config.id} exists already. The dialog id must be unique.`);
        }
        const overlayRef = this.createOverlay(config);
        const dialogContainer = this.attachDialogContainer(overlayRef, config);
        const dialogRef = this.attachDialogContent(componentOrTemplateRef, dialogContainer, overlayRef, config);
        this.openDialogs.push(dialogRef);
        dialogRef.afterClosed().subscribe(() => this.removeOpenDialog(dialogRef));
        this.afterOpened.next(dialogRef);
        return dialogRef;
    }
    applyConfigDefaults(config, defaultOptions) {
        return Object.assign(Object.assign({}, defaultOptions), config);
    }
    closeAll() {
        this.closeDialogs(this.openDialogs);
    }
    getDialogById(id) {
        return this.openDialogs.find(dialog => dialog.id === id);
    }
    getClosestDialog(element, openDialogs) {
        let parent = element.nativeElement.parentElement;
        while (parent && !parent.classList.contains(this.mmContainerClassName)) {
            parent = parent.parentElement;
        }
        return parent ? openDialogs.find(dialog => dialog.id === parent.id) : null;
    }
    createOverlay(config) {
        const overlayConfig = this.getOverlayConfig(config);
        return this.overlay.create(overlayConfig);
    }
    getOverlayConfig(dialogConfig) {
        const state = new OverlayConfig({
            positionStrategy: this.overlay.position().global(),
            scrollStrategy: dialogConfig.scrollStrategy || this.scrollStrategy(),
            hasBackdrop: dialogConfig.hasBackdrop,
            backdropClass: 'mm-overlay-backdrop--blue',
            disposeOnNavigation: dialogConfig.closeOnNavigation,
            panelClass: dialogConfig.panelClass,
            width: dialogConfig.width,
            height: dialogConfig.height,
        });
        if (dialogConfig.backdropClass) {
            state.backdropClass = dialogConfig.backdropClass;
        }
        return state;
    }
    attachDialogContainer(overlay, config) {
        const userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
        const injector = new PortalInjector(userInjector || this.injector, new WeakMap([
            [MmDialogConfig, config]
        ]));
        const containerPortal = new ComponentPortal(MmDialogContainerComponent, config.viewContainerRef, injector);
        const containerRef = overlay.attach(containerPortal);
        return containerRef.instance;
    }
    attachDialogContent(componentOrTemplateRef, dialogContainer, overlayRef, config) {
        const dialogRef = new MmDialogRefService(overlayRef, dialogContainer, config.id);
        if (config.hasBackdrop) {
            overlayRef.backdropClick().subscribe(() => {
                if (!dialogRef.backdropDisableClose) {
                    dialogRef.close();
                }
            });
        }
        if (componentOrTemplateRef instanceof TemplateRef) {
            dialogContainer.attachTemplatePortal(new TemplatePortal(componentOrTemplateRef, null, { $implicit: config.data, dialogRef }));
        }
        else {
            const injector = this.createInjector(config, dialogRef, dialogContainer);
            const contentRef = dialogContainer.attachComponentPortal(new ComponentPortal(componentOrTemplateRef, undefined, injector));
            dialogRef.componentInstance = contentRef.instance;
        }
        dialogRef.updatePosition(config.position);
        return dialogRef;
    }
    createInjector(config, dialogRef, dialogContainer) {
        const userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
        const injectionTokens = new WeakMap([
            [MmDialogContainerComponent, dialogContainer],
            [MmDialogData, config.data],
            [MmDialogRefService, dialogRef]
        ]);
        return new PortalInjector(userInjector || this.injector, injectionTokens);
    }
    removeOpenDialog(dialogRef) {
        const index = this.openDialogs.indexOf(dialogRef);
        if (index > -1) {
            this.openDialogs.splice(index, 1);
            if (!this.openDialogs.length) {
                this.afterAllDialogsClosed.next();
            }
        }
    }
    closeDialogs(dialogs) {
        let i = dialogs.length;
        while (i--) {
            dialogs[i].close();
        }
    }
}
MmDialogService.ɵfac = function MmDialogService_Factory(t) { return new (t || MmDialogService)(ɵngcc0.ɵɵinject(ɵngcc12.Overlay), ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(MmDialogDefaultOptions, 8), ɵngcc0.ɵɵinject(MmDialogScrollStrategy), ɵngcc0.ɵɵinject(MmDialogService, 12)); };
MmDialogService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: MmDialogService, factory: MmDialogService.ɵfac });
MmDialogService.ctorParameters = () => [
    { type: Overlay },
    { type: Injector },
    { type: MmDialogConfig, decorators: [{ type: Optional }, { type: Inject, args: [MmDialogDefaultOptions,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [MmDialogScrollStrategy,] }] },
    { type: MmDialogService, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmDialogService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc12.Overlay }, { type: ɵngcc0.Injector }, { type: MmDialogConfig, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [MmDialogDefaultOptions]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [MmDialogScrollStrategy]
            }] }, { type: MmDialogService, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, null); })();

class MmDialogCloseDirective {
    constructor(dialogRef, elementRef, dialog) {
        this.dialogRef = dialogRef;
        this.elementRef = elementRef;
        this.dialog = dialog;
    }
    onClick() {
        this.dialogRef.close(this.dialogResult);
    }
    ngOnInit() {
        if (!this.dialogRef) {
            this.dialogRef = this.dialog.getClosestDialog(this.elementRef, this.dialog.openDialogs);
        }
    }
    ngOnChanges(changes) {
        const proxiedChange = changes['mmDialogClose'];
        if (proxiedChange) {
            this.dialogResult = proxiedChange.currentValue;
        }
    }
}
MmDialogCloseDirective.ɵfac = function MmDialogCloseDirective_Factory(t) { return new (t || MmDialogCloseDirective)(ɵngcc0.ɵɵdirectiveInject(MmDialogRefService, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(MmDialogService)); };
MmDialogCloseDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MmDialogCloseDirective, selectors: [["button", "mmDialogClose", ""]], hostAttrs: ["type", "button"], hostBindings: function MmDialogCloseDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function MmDialogCloseDirective_click_HostBindingHandler() { return ctx.onClick(); });
    } }, inputs: { mmDialogClose: "mmDialogClose" }, exportAs: ["mmDialogClose"], features: [ɵngcc0.ɵɵNgOnChangesFeature] });
MmDialogCloseDirective.ctorParameters = () => [
    { type: MmDialogRefService, decorators: [{ type: Optional }] },
    { type: ElementRef },
    { type: MmDialogService }
];
MmDialogCloseDirective.propDecorators = {
    mmDialogClose: [{ type: Input, args: ['mmDialogClose',] }],
    onClick: [{ type: HostListener, args: ['click',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmDialogCloseDirective, [{
        type: Directive,
        args: [{
                selector: 'button[mmDialogClose]',
                exportAs: 'mmDialogClose',
                host: {
                    'type': 'button'
                }
            }]
    }], function () { return [{ type: MmDialogRefService, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }, { type: MmDialogService }]; }, { onClick: [{
            type: HostListener,
            args: ['click']
        }], mmDialogClose: [{
            type: Input,
            args: ['mmDialogClose']
        }] }); })();

class MmDialogTitleComponent {
    constructor(dialogRef, elementRef, dialog) {
        this.dialogRef = dialogRef;
        this.elementRef = elementRef;
        this.dialog = dialog;
        this.disableCloseIcon = false;
        this.isUnderlined = false;
    }
    ngOnInit() {
        if (!this.dialogRef) {
            this.dialogRef = this.dialog.getClosestDialog(this.elementRef, this.dialog.openDialogs);
        }
    }
}
MmDialogTitleComponent.ɵfac = function MmDialogTitleComponent_Factory(t) { return new (t || MmDialogTitleComponent)(ɵngcc0.ɵɵdirectiveInject(MmDialogRefService, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(MmDialogService)); };
MmDialogTitleComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmDialogTitleComponent, selectors: [["mm-dialog-title"]], inputs: { disableCloseIcon: "disableCloseIcon", isUnderlined: "isUnderlined" }, exportAs: ["mmDialogTitle"], ngContentSelectors: _c5, decls: 4, vars: 4, consts: [[1, "mm-dialog-title"], [1, "mm-dialog-title__content", 3, "mmTestTarget"], ["class", "mm-dialog-title__close", 4, "ngIf"], [1, "mm-dialog-title__close"], ["mmDialogClose", "", 1, "mm-dialog-title__button", 3, "mmTestTarget"], ["xmlns", "http://www.w3.org/2000/svg", "width", "32", "height", "32", "viewBox", "0 0 32 32", 1, "mm-dialog-title__icon"], ["id", "a", "d", "M17.885 16l9.724-9.724a1.332 1.332 0 0 0 0-1.885 1.332 1.332 0 0 0-1.885 0L16 14.115 6.276 4.39a1.332 1.332 0 0 0-1.885 0 1.332 1.332 0 0 0 0 1.885L14.115 16 4.39 25.724A1.332 1.332 0 0 0 5.334 28c.341 0 .682-.13.942-.39L16 17.884l9.724 9.724a1.33 1.33 0 0 0 1.885 0 1.332 1.332 0 0 0 0-1.885L17.885 16z"]], template: function MmDialogTitleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, MmDialogTitleComponent_div_3_Template, 4, 1, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("isUnderlined", ctx.isUnderlined);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("mmTestTarget", "dialog-title");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.disableCloseIcon);
    } }, directives: [ɵngcc3.ɵf, ɵngcc2.NgIf, MmDialogCloseDirective], styles: [".mm-dialog-title[_ngcontent-%COMP%]{align-items:flex-start;display:flex;justify-content:space-between}.mm-dialog-title.isUnderlined[_ngcontent-%COMP%]{border-bottom:1px solid #e6e8eb}.mm-dialog-title[_ngcontent-%COMP%]   .mm-dialog-title__content[_ngcontent-%COMP%]{box-sizing:border-box;color:#002866;font-family:Lato,sans-serif;font-size:1.14rem;font-weight:700;line-height:1.53;overflow-wrap:break-word;padding:14px 0 12px 26px;white-space:pre-wrap;width:calc(100% - 44px)}.mm-dialog-title[_ngcontent-%COMP%]   .mm-dialog-title__close[_ngcontent-%COMP%]{box-sizing:border-box;display:flex;justify-content:center;padding-top:12px;width:44px}.mm-dialog-title[_ngcontent-%COMP%]   .mm-dialog-title__close[_ngcontent-%COMP%]   .mm-dialog-title__button[_ngcontent-%COMP%]{background:transparent;border:0;cursor:pointer;outline:none;padding:0;vertical-align:middle}.mm-dialog-title[_ngcontent-%COMP%]   .mm-dialog-title__close[_ngcontent-%COMP%]   .mm-dialog-title__icon[_ngcontent-%COMP%]{fill:#001432;font-size:20px;height:20px;line-height:20px;width:20px}"] });
MmDialogTitleComponent.ctorParameters = () => [
    { type: MmDialogRefService, decorators: [{ type: Optional }] },
    { type: ElementRef },
    { type: MmDialogService }
];
MmDialogTitleComponent.propDecorators = {
    disableCloseIcon: [{ type: Input }],
    isUnderlined: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmDialogTitleComponent, [{
        type: Component,
        args: [{
                selector: 'mm-dialog-title',
                exportAs: 'mmDialogTitle',
                template: "<div class=\"mm-dialog-title\"\n     [class.isUnderlined]=\"isUnderlined\">\n    <div class=\"mm-dialog-title__content\"\n         [mmTestTarget]=\"'dialog-title'\">\n        <ng-content></ng-content>\n    </div>\n    <div class=\"mm-dialog-title__close\"\n         *ngIf=\"!disableCloseIcon\">\n        <button mmDialogClose\n                class=\"mm-dialog-title__button\"\n                [mmTestTarget]=\"'dialog-button-close'\">\n            <svg class=\"mm-dialog-title__icon\"\n                 xmlns=\"http://www.w3.org/2000/svg\"\n                 width=\"32\"\n                 height=\"32\"\n                 viewBox=\"0 0 32 32\">\n                <path id=\"a\"\n                      d=\"M17.885 16l9.724-9.724a1.332 1.332 0 0 0 0-1.885 1.332 1.332 0 0 0-1.885 0L16 14.115 6.276 4.39a1.332 1.332 0 0 0-1.885 0 1.332 1.332 0 0 0 0 1.885L14.115 16 4.39 25.724A1.332 1.332 0 0 0 5.334 28c.341 0 .682-.13.942-.39L16 17.884l9.724 9.724a1.33 1.33 0 0 0 1.885 0 1.332 1.332 0 0 0 0-1.885L17.885 16z\"/>\n            </svg>\n        </button>\n    </div>\n</div>\n",
                styles: [".mm-dialog-title{align-items:flex-start;display:flex;justify-content:space-between}.mm-dialog-title.isUnderlined{border-bottom:1px solid #e6e8eb}.mm-dialog-title .mm-dialog-title__content{box-sizing:border-box;color:#002866;font-family:Lato,sans-serif;font-size:1.14rem;font-weight:700;line-height:1.53;overflow-wrap:break-word;padding:14px 0 12px 26px;white-space:pre-wrap;width:calc(100% - 44px)}.mm-dialog-title .mm-dialog-title__close{box-sizing:border-box;display:flex;justify-content:center;padding-top:12px;width:44px}.mm-dialog-title .mm-dialog-title__close .mm-dialog-title__button{background:transparent;border:0;cursor:pointer;outline:none;padding:0;vertical-align:middle}.mm-dialog-title .mm-dialog-title__close .mm-dialog-title__icon{fill:#001432;font-size:20px;height:20px;line-height:20px;width:20px}"]
            }]
    }], function () { return [{ type: MmDialogRefService, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }, { type: MmDialogService }]; }, { disableCloseIcon: [{
            type: Input
        }], isUnderlined: [{
            type: Input
        }] }); })();

class MmDialogContentComponent {
}
MmDialogContentComponent.ɵfac = function MmDialogContentComponent_Factory(t) { return new (t || MmDialogContentComponent)(); };
MmDialogContentComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmDialogContentComponent, selectors: [["mm-dialog-content"]], ngContentSelectors: _c5, decls: 3, vars: 1, consts: [[1, "mm-dialog-content", 3, "mmTestTarget"], [1, "mm-dialog-content__wrapper"]], template: function MmDialogContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("mmTestTarget", "dialog-content");
    } }, directives: [ɵngcc3.ɵf], styles: [".mm-dialog-content[_ngcontent-%COMP%]   .mm-dialog-content__wrapper[_ngcontent-%COMP%]{color:#002866;font-family:Lato,sans-serif;font-size:14px;font-weight:400;line-height:1.7;max-height:calc(100vh - 180px);overflow:auto;padding:12px 26px 10px}.mm-dialog-content[_ngcontent-%COMP%]   .mm-dialog-content__wrapper[_ngcontent-%COMP%]::-webkit-scrollbar-track{background-color:#e6e8eb;border-radius:0}.mm-dialog-content[_ngcontent-%COMP%]   .mm-dialog-content__wrapper[_ngcontent-%COMP%]::-webkit-scrollbar{background-color:#e6e8eb;width:10px}.mm-dialog-content[_ngcontent-%COMP%]   .mm-dialog-content__wrapper[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background-color:#ccd0d6;border-radius:6px;width:6px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmDialogContentComponent, [{
        type: Component,
        args: [{
                selector: 'mm-dialog-content',
                template: "<div class=\"mm-dialog-content\"\n     [mmTestTarget]=\"'dialog-content'\">\n    <div class=\"mm-dialog-content__wrapper\">\n        <ng-content></ng-content>\n    </div>\n</div>\n",
                styles: [".mm-dialog-content .mm-dialog-content__wrapper{color:#002866;font-family:Lato,sans-serif;font-size:14px;font-weight:400;line-height:1.7;max-height:calc(100vh - 180px);overflow:auto;padding:12px 26px 10px}.mm-dialog-content .mm-dialog-content__wrapper::-webkit-scrollbar-track{background-color:#e6e8eb;border-radius:0}.mm-dialog-content .mm-dialog-content__wrapper::-webkit-scrollbar{background-color:#e6e8eb;width:10px}.mm-dialog-content .mm-dialog-content__wrapper::-webkit-scrollbar-thumb{background-color:#ccd0d6;border-radius:6px;width:6px}"]
            }]
    }], null, null); })();

class MmDialogFooterComponent {
}
MmDialogFooterComponent.ɵfac = function MmDialogFooterComponent_Factory(t) { return new (t || MmDialogFooterComponent)(); };
MmDialogFooterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmDialogFooterComponent, selectors: [["mm-dialog-footer"]], ngContentSelectors: _c5, decls: 2, vars: 0, consts: [[1, "mm-dialog-footer"]], template: function MmDialogFooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [".mm-dialog-footer[_ngcontent-%COMP%]{align-items:center;display:flex;justify-content:flex-end;padding:11px 26px 20px}.mm-dialog-footer[_ngcontent-%COMP%]     .mm-button{width:224px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmDialogFooterComponent, [{
        type: Component,
        args: [{
                selector: 'mm-dialog-footer',
                template: "<div class=\"mm-dialog-footer\">\n    <ng-content></ng-content>\n</div>\n",
                styles: [".mm-dialog-footer{align-items:center;display:flex;justify-content:flex-end;padding:11px 26px 20px}.mm-dialog-footer ::ng-deep .mm-button{width:224px}"]
            }]
    }], null, null); })();

class MmDialogModule {
}
MmDialogModule.ɵfac = function MmDialogModule_Factory(t) { return new (t || MmDialogModule)(); };
MmDialogModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmDialogModule });
MmDialogModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [
        MmDialogService,
        MmDialogScrollStrategyProvider,
    ], imports: [[
            CommonModule,
            OverlayModule,
            PortalModule,
            QaLocatorsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmDialogModule, { declarations: function () { return [MmDialogContainerComponent, MmDialogCloseDirective, MmDialogTitleComponent, MmDialogFooterComponent, MmDialogContentComponent]; }, imports: function () { return [CommonModule,
        OverlayModule,
        PortalModule,
        QaLocatorsModule]; }, exports: function () { return [MmDialogContainerComponent, MmDialogCloseDirective, MmDialogTitleComponent, MmDialogContentComponent, MmDialogFooterComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmDialogModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    OverlayModule,
                    PortalModule,
                    QaLocatorsModule,
                ],
                exports: [
                    MmDialogContainerComponent,
                    MmDialogCloseDirective,
                    MmDialogTitleComponent,
                    MmDialogContentComponent,
                    MmDialogFooterComponent,
                ],
                declarations: [
                    MmDialogContainerComponent,
                    MmDialogCloseDirective,
                    MmDialogTitleComponent,
                    MmDialogFooterComponent,
                    MmDialogContentComponent,
                ],
                providers: [
                    MmDialogService,
                    MmDialogScrollStrategyProvider,
                ],
                entryComponents: [MmDialogContainerComponent]
            }]
    }], null, null); })();

const DEFAULT_SPINNER_CONFIG = {
    minSize: 16,
    minStrokeWidth: 1,
    maxSize: 80,
    maxStrokeWidth: 2,
    defaultSize: 32,
    defaultStrokeWidth: 2,
    defaultColor: 'blue',
};
const MmSpinnerConfigService = new InjectionToken('mm-spinner-config');

class MmSpinnerComponent {
    constructor(mmSpinnerConfig) {
        this.mmSpinnerConfig = mmSpinnerConfig;
        this.size = this.mmSpinnerConfig.defaultSize;
        this.strokeWidth = this.mmSpinnerConfig.defaultStrokeWidth;
        this.color = this.mmSpinnerConfig.defaultColor;
    }
    ngOnInit() {
        this.validateInputs();
    }
    validateInputs() {
        const strokeWidth = Number(this.strokeWidth);
        if (strokeWidth < this.mmSpinnerConfig.minStrokeWidth) {
            this.strokeWidth = this.mmSpinnerConfig.minStrokeWidth;
        }
        else if (strokeWidth > this.mmSpinnerConfig.maxStrokeWidth) {
            this.strokeWidth = this.mmSpinnerConfig.maxStrokeWidth;
        }
        const size = this.size;
        if (size < this.mmSpinnerConfig.minSize) {
            this.size = this.mmSpinnerConfig.minSize;
        }
        else if (size > this.mmSpinnerConfig.maxSize) {
            this.size = this.mmSpinnerConfig.maxSize;
        }
    }
}
MmSpinnerComponent.ɵfac = function MmSpinnerComponent_Factory(t) { return new (t || MmSpinnerComponent)(ɵngcc0.ɵɵdirectiveInject(MmSpinnerConfigService)); };
MmSpinnerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmSpinnerComponent, selectors: [["mm-spinner"]], inputs: { size: "size", strokeWidth: "strokeWidth", color: "color" }, decls: 1, vars: 3, consts: [[1, "mm-spinner__container", 3, "diameter", "ngClass", "strokeWidth"]], template: function MmSpinnerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "mat-spinner", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("diameter", ctx.size)("ngClass", "mm-spinner__color-" + ctx.color)("strokeWidth", ctx.strokeWidth);
    } }, directives: [ɵngcc9.MatSpinner, ɵngcc2.NgClass], styles: [".mm-spinner__color-grey[_ngcontent-%COMP%]     circle{stroke:#e6e8eb}.mm-spinner__color-blue[_ngcontent-%COMP%]     circle{stroke:#0064fe}.mm-spinner__color-metro-blue[_ngcontent-%COMP%]     circle{stroke:#002d72}.mm-spinner__color-white[_ngcontent-%COMP%]     circle{stroke:#fff}"], changeDetection: 0 });
MmSpinnerComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [MmSpinnerConfigService,] }] }
];
MmSpinnerComponent.propDecorators = {
    size: [{ type: Input }],
    strokeWidth: [{ type: Input }],
    color: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmSpinnerComponent, [{
        type: Component,
        args: [{
                selector: 'mm-spinner',
                template: "<mat-spinner\n        [diameter]=\"size\"\n        [ngClass]=\"'mm-spinner__color-'+ color\"\n        [strokeWidth]=\"strokeWidth\"\n        class=\"mm-spinner__container\">\n</mat-spinner>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".mm-spinner__color-grey ::ng-deep circle{stroke:#e6e8eb}.mm-spinner__color-blue ::ng-deep circle{stroke:#0064fe}.mm-spinner__color-metro-blue ::ng-deep circle{stroke:#002d72}.mm-spinner__color-white ::ng-deep circle{stroke:#fff}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [MmSpinnerConfigService]
            }] }]; }, { size: [{
            type: Input
        }], strokeWidth: [{
            type: Input
        }], color: [{
            type: Input
        }] }); })();

const ɵ0$1 = DEFAULT_SPINNER_CONFIG;
class MmSpinnerModule {
    static withConfig(config) {
        return {
            ngModule: MmSpinnerModule,
            providers: [
                { provide: MmSpinnerConfigService, useValue: Object.assign({}, DEFAULT_SPINNER_CONFIG, config) },
            ],
        };
    }
}
MmSpinnerModule.ɵfac = function MmSpinnerModule_Factory(t) { return new (t || MmSpinnerModule)(); };
MmSpinnerModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmSpinnerModule });
MmSpinnerModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [
        { provide: MmSpinnerConfigService, useValue: ɵ0$1 },
    ], imports: [[
            CommonModule,
            MatProgressSpinnerModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmSpinnerModule, { declarations: function () { return [MmSpinnerComponent]; }, imports: function () { return [CommonModule,
        MatProgressSpinnerModule]; }, exports: function () { return [MmSpinnerComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmSpinnerModule, [{
        type: NgModule,
        args: [{
                declarations: [MmSpinnerComponent],
                imports: [
                    CommonModule,
                    MatProgressSpinnerModule,
                ],
                providers: [
                    { provide: MmSpinnerConfigService, useValue: ɵ0$1 },
                ],
                exports: [MmSpinnerComponent]
            }]
    }], null, null); })();

var HorizontalPositions;
(function (HorizontalPositions) {
    HorizontalPositions["start"] = "start";
    HorizontalPositions["center"] = "center";
    HorizontalPositions["end"] = "end";
})(HorizontalPositions || (HorizontalPositions = {}));

var VerticalPositions;
(function (VerticalPositions) {
    VerticalPositions["top"] = "top";
    VerticalPositions["bottom"] = "bottom";
})(VerticalPositions || (VerticalPositions = {}));

class MmPopoverRef {
    constructor(overlay, content, data) {
        this.overlay = overlay;
        this.content = content;
        this.data = data;
        this.afterClosed = new Subject();
        this.afterClosed$ = this.afterClosed.asObservable();
        overlay.backdropClick().subscribe(() => {
            this._close('backdropClick', null);
        });
    }
    close(data) {
        this._close('close', data);
    }
    _close(type, data) {
        this.overlay.dispose();
        this.afterClosed.next({
            type,
            data
        });
        this.afterClosed.complete();
    }
}

var RenderMethods;
(function (RenderMethods) {
    RenderMethods["text"] = "text";
    RenderMethods["template"] = "template";
    RenderMethods["component"] = "component";
})(RenderMethods || (RenderMethods = {}));

class PopoverComponent {
    constructor(popoverRef) {
        this.popoverRef = popoverRef;
        this.renderMethod = RenderMethods.component;
        this.renderMethods = RenderMethods;
        this.isStringContent = false;
    }
    ngOnInit() {
        this.content = this.popoverRef.content;
        if (typeof this.content === 'string') {
            this.renderMethod = RenderMethods.text;
            this.isStringContent = true;
        }
        if (this.content instanceof TemplateRef) {
            this.renderMethod = RenderMethods.template;
            this.context = {
                close: this.popoverRef.close.bind(this.popoverRef)
            };
        }
    }
}
PopoverComponent.ɵfac = function PopoverComponent_Factory(t) { return new (t || PopoverComponent)(ɵngcc0.ɵɵdirectiveInject(MmPopoverRef)); };
PopoverComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PopoverComponent, selectors: [["ng-component"]], decls: 5, vars: 7, consts: [[1, "popover", 3, "ngClass"], [3, "ngSwitch"], [3, "innerHTML", 4, "ngSwitchCase"], [4, "ngSwitchCase"], [3, "innerHTML"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngComponentOutlet"]], template: function PopoverComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementContainerStart(1, 1);
        ɵngcc0.ɵɵtemplate(2, PopoverComponent_div_2_Template, 1, 1, "div", 2);
        ɵngcc0.ɵɵtemplate(3, PopoverComponent_ng_container_3_Template, 2, 2, "ng-container", 3);
        ɵngcc0.ɵɵtemplate(4, PopoverComponent_ng_container_4_Template, 2, 1, "ng-container", 3);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c25, ctx.isStringContent));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.renderMethod);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.renderMethods.text);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.renderMethods.template);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.renderMethods.component);
    } }, directives: [ɵngcc2.NgClass, ɵngcc2.NgSwitch, ɵngcc2.NgSwitchCase, ɵngcc2.NgTemplateOutlet, ɵngcc2.NgComponentOutlet], styles: [".popover[_ngcontent-%COMP%]{background-color:#fff;border:1px solid #e5e8eb;color:#0064fe;font-size:1.14rem;padding:10px 0}.popover__text-content[_ngcontent-%COMP%]{padding:10px}"] });
PopoverComponent.ctorParameters = () => [
    { type: MmPopoverRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PopoverComponent, [{
        type: Component,
        args: [{
                template: "<div class=\"popover\" [ngClass]=\"{'popover__text-content': isStringContent}\">\n  <ng-container [ngSwitch]=\"renderMethod\">\n\n    <div *ngSwitchCase=\"renderMethods.text\" [innerHTML]=\"content\"></div>\n\n    <ng-container *ngSwitchCase=\"renderMethods.template\">\n      <ng-container *ngTemplateOutlet=\"content; context: context\"></ng-container>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"renderMethods.component\">\n      <ng-container *ngComponentOutlet=\"content\"></ng-container>\n    </ng-container>\n\n  </ng-container>\n</div>\n",
                styles: [".popover{background-color:#fff;border:1px solid #e5e8eb;color:#0064fe;font-size:1.14rem;padding:10px 0}.popover__text-content{padding:10px}"]
            }]
    }], function () { return [{ type: MmPopoverRef }]; }, null); })();

class MmPopoverService {
    constructor(overlay, injector) {
        this.overlay = overlay;
        this.injector = injector;
    }
    open({ origin, content, data, width, height, offsetX = 0, offsetY = 0 }) {
        const overlayRef = this.overlay.create(this.getOverlayConfig({ origin, width, height,
            offset: { offsetX, offsetY } }));
        const popoverRef = new MmPopoverRef(overlayRef, content, data);
        const injector = this.createInjector(popoverRef, this.injector);
        overlayRef.attach(new ComponentPortal(PopoverComponent, null, injector));
        return popoverRef;
    }
    createInjector(popoverRef, injector) {
        const tokens = new WeakMap([[MmPopoverRef, popoverRef]]);
        return new PortalInjector(injector, tokens);
    }
    getOverlayConfig({ origin, width, height, offset }) {
        return new OverlayConfig({
            hasBackdrop: true,
            width,
            height,
            backdropClass: 'mm-popover-backdrop',
            positionStrategy: this.getOverlayPosition(origin, offset),
            scrollStrategy: this.overlay.scrollStrategies.reposition()
        });
    }
    getOverlayPosition(origin, { offsetX, offsetY }) {
        const positionStrategy = this.overlay.position()
            .flexibleConnectedTo(origin)
            .withPositions(this.getDefaultPositions())
            .withDefaultOffsetX(offsetX)
            .withDefaultOffsetY(offsetY)
            .withFlexibleDimensions(false)
            .withPush(false);
        return positionStrategy;
    }
    getDefaultPositions() {
        return [
            {
                originX: HorizontalPositions.end,
                originY: VerticalPositions.bottom,
                overlayX: HorizontalPositions.end,
                overlayY: VerticalPositions.top,
            },
            {
                originX: HorizontalPositions.start,
                originY: VerticalPositions.bottom,
                overlayX: HorizontalPositions.start,
                overlayY: VerticalPositions.top,
            },
            {
                originX: HorizontalPositions.end,
                originY: VerticalPositions.top,
                overlayX: HorizontalPositions.end,
                overlayY: VerticalPositions.bottom,
            },
            {
                originX: HorizontalPositions.start,
                originY: VerticalPositions.top,
                overlayX: HorizontalPositions.start,
                overlayY: VerticalPositions.bottom,
            },
        ];
    }
}
MmPopoverService.ɵfac = function MmPopoverService_Factory(t) { return new (t || MmPopoverService)(ɵngcc0.ɵɵinject(ɵngcc12.Overlay), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
MmPopoverService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: MmPopoverService, factory: MmPopoverService.ɵfac });
MmPopoverService.ctorParameters = () => [
    { type: Overlay },
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmPopoverService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc12.Overlay }, { type: ɵngcc0.Injector }]; }, null); })();

class MmPopoverModule {
}
MmPopoverModule.ɵfac = function MmPopoverModule_Factory(t) { return new (t || MmPopoverModule)(); };
MmPopoverModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmPopoverModule });
MmPopoverModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [MmPopoverService], imports: [[CommonModule, OverlayModule], OverlayModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmPopoverModule, { declarations: function () { return [PopoverComponent]; }, imports: function () { return [CommonModule, OverlayModule]; }, exports: function () { return [OverlayModule]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmPopoverModule, [{
        type: NgModule,
        args: [{
                declarations: [PopoverComponent],
                imports: [CommonModule, OverlayModule],
                providers: [MmPopoverService],
                exports: [OverlayModule],
                entryComponents: [PopoverComponent]
            }]
    }], null, null); })();

class ViewValuePipe {
    transform(value, key) {
        if (!value) {
            return value;
        }
        return !!key ? value[key] : value;
    }
}
ViewValuePipe.ɵfac = function ViewValuePipe_Factory(t) { return new (t || ViewValuePipe)(); };
ViewValuePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "viewValue", type: ViewValuePipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ViewValuePipe, [{
        type: Pipe,
        args: [{
                name: 'viewValue'
            }]
    }], null, null); })();

const optionsInViewByDefault = 7;
class MmSelectComponent {
    constructor(changeDetectorRef, viewValuePipe, elementRef, document) {
        this.changeDetectorRef = changeDetectorRef;
        this.viewValuePipe = viewValuePipe;
        this.elementRef = elementRef;
        this.document = document;
        this.placeholder = 'None';
        this.options = [];
        this.isEventPropogated = false;
        this.searchThrottling = 300;
        this.noResultsText = 'No results found.';
        this.selectionChanged = new EventEmitter();
        this.searchControl = new FormControl('');
        this.selectedValues = [];
        this.visibleOptions = optionsInViewByDefault;
        this._value = null;
        this.destroy$ = new Subject();
        this.closed$ = new Subject();
        this.onChange = () => {
        };
        this.onTouched = () => {
        };
    }
    set value(value) {
        if (!this.multiple) {
            this.searchControl.patchValue(this.viewValuePipe.transform(value, this.displayedProperty));
        }
        this._value = value;
        this.changeDetectorRef.markForCheck();
    }
    get value() {
        return this._value;
    }
    onBlur() {
        this.onTouched();
    }
    ngOnInit() {
        if (this.isSearchable) {
            this.searchControl.valueChanges.pipe(debounceTime(this.searchThrottling), distinctUntilChanged(), takeUntil(this.destroy$)).subscribe(this.search.bind(this));
        }
    }
    ngOnChanges(changes) {
        if (changes.options) {
            if (isEqual(changes.options.currentValue, changes.options.previousValue)) {
                return;
            }
            this.options = changes.options.currentValue || [];
            this.originalOptions = [...this.options];
            this.changeOptionsViewHeight();
            this.serializeOptions();
            if (this.keyProperty) {
                this.writeKeyPropertyValue(this.value);
            }
            if (this.multiple) {
                this.sortOptions();
                this.initMultiSelect();
            }
        }
        if (changes.value) {
            if (isEqual(changes.value.currentValue, changes.value.previousValue)) {
                return;
            }
            if (this.multiple) {
                this.initMultiSelect();
            }
            if (this.keyProperty) {
                const value = get(changes, 'value.currentValue', this.value);
                this.writeKeyPropertyValue(value);
            }
        }
    }
    serializeOptions() {
        if (this.keyProperty && isEmpty(this.serializedOptions)) {
            this.serializedOptions = this.options.reduce((acc, cur) => {
                return Object.assign(Object.assign({}, acc), { [cur[this.keyProperty]]: cur });
            }, {});
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.changeDetectorRef.markForCheck();
    }
    writeValue(value) {
        if (this.keyProperty) {
            this.writeKeyPropertyValue(value);
        }
        else {
            this.value = value;
        }
        if (this.multiple) {
            this.initMultiSelect();
        }
    }
    writeKeyPropertyValue(value) {
        if (!this.multiple) {
            this.value = value && !isEmpty(this.serializedOptions)
                ? this.serializedOptions[value]
                : value;
            return;
        }
        const shouldMapValue = isArray(value) && value.length && !isEmpty(this.serializedOptions);
        if (shouldMapValue) {
            this.value = value.map(v => this.serializedOptions[v]).filter(Boolean);
        }
        else {
            this.value = value;
        }
    }
    ngOnDestroy() {
        this.closed$.complete();
        this.destroy$.next();
        this.destroy$.complete();
    }
    toggleMenu(event) {
        if (!this.isEventPropogated) {
            event.stopPropagation();
        }
        this.isOpened ? this.close() : this.open();
    }
    open() {
        if (!this.isOpened) {
            if (this.multiple) {
                this.updateOptions();
            }
            this.isOpened = true;
            fromEvent(this.document, 'click')
                .pipe(takeUntil(this.closed$))
                .subscribe((event) => this.onClickOutside(event.target));
        }
    }
    close() {
        this.isOpened = false;
        this.onTouched();
        if (this.multiple && this.isSearchable) {
            this.searchControl.reset('');
        }
        this.closed$.next();
        this.changeDetectorRef.markForCheck();
    }
    isOptionSelected(option) {
        if (!this.multiple) {
            return isEqual(this.value, option);
        }
    }
    onSelect(event, option) {
        event.stopPropagation();
        this.changeValue(option);
        this.selectionChanged.emit(option);
        if (this.multiple) {
            this.onMultipleSelect(option);
        }
        else {
            this.close();
        }
    }
    onTagRemove(event, tag) {
        if (!this.isEventPropogated) {
            event.stopPropagation();
        }
        this.selectedValues = this.selectedValues.filter(value => !isEqual(value, tag));
        this.options = [...this.options, tag];
        this.originalOptions = [...this.options];
        this.changeOptionsViewHeight();
        this.onValueChanged(this.selectedValues);
    }
    onMultipleSelect(option) {
        this.excludeOption(option);
        this.changeOptionsViewHeight();
        if (this.isSearchable) {
            this.inputEl.nativeElement.focus();
        }
        if (!this.options.length) {
            this.close();
        }
    }
    search(value) {
        if (value != null) {
            const key = this.displayedProperty;
            this.options = this.originalOptions
                .filter(option => ((key && option[key]) || option).toLowerCase().includes(value.toLowerCase()));
            this.changeOptionsViewHeight();
            this.changeDetectorRef.markForCheck();
        }
    }
    changeValue(chosenValue) {
        let value = chosenValue;
        if (this.multiple) {
            this.selectedValues = [...(this.value || []), chosenValue];
            value = this.selectedValues;
        }
        this.onValueChanged(value);
    }
    onValueChanged(value) {
        this.value = value;
        if (this.keyProperty) {
            this.onChangeKeyPropertyValue(value);
        }
        else {
            this.onChange(value);
        }
        if (this.multiple) {
            this.sortOptions();
        }
    }
    onChangeKeyPropertyValue(value) {
        const nextValue = !this.multiple
            ? value[this.keyProperty]
            : value.map(o => o[this.keyProperty]);
        this.onChange(nextValue);
    }
    excludeOption(option) {
        this.options = this.options.filter(o => !isEqual(o, option));
        this.originalOptions = this.originalOptions.filter(o => !isEqual(o, option));
    }
    initMultiSelect() {
        if (Array.isArray(this.value) && this.options && this.options.length) {
            this.selectedValues = [...this.value];
            this.updateOptions();
            this.changeOptionsViewHeight();
            this.changeDetectorRef.markForCheck();
        }
    }
    /* Applies only for multi select */
    sortOptions() {
        this.options = this.options.slice().sort((a, b) => {
            const valueA = this.viewValuePipe.transform(a, this.displayedProperty).toLowerCase();
            const valueB = this.viewValuePipe.transform(b, this.displayedProperty).toLowerCase();
            if (valueA < valueB) {
                return -1;
            }
        });
    }
    updateOptions() {
        this.selectedValues.forEach(this.excludeOption.bind(this));
    }
    changeOptionsViewHeight() {
        const availableOptionsCount = this.options.length;
        requestAnimationFrame(() => {
            this.visibleOptions = (availableOptionsCount < optionsInViewByDefault)
                ? availableOptionsCount
                : optionsInViewByDefault;
            this.changeDetectorRef.markForCheck();
        });
    }
    onClickOutside(target) {
        if (!this.elementRef.nativeElement.contains(target)) {
            this.close();
        }
    }
}
MmSelectComponent.ɵfac = function MmSelectComponent_Factory(t) { return new (t || MmSelectComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ViewValuePipe), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MmSelectComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MmSelectComponent, selectors: [["mm-select"]], viewQuery: function MmSelectComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c26, 3);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputEl = _t.first);
    } }, hostBindings: function MmSelectComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("blur", function MmSelectComponent_blur_HostBindingHandler() { return ctx.onBlur(); });
    } }, inputs: { placeholder: "placeholder", options: "options", isEventPropogated: "isEventPropogated", searchThrottling: "searchThrottling", noResultsText: "noResultsText", value: "value", disabled: "disabled", className: "className", isSearchable: "isSearchable", multiple: "multiple", optionTmpl: "optionTmpl", displayedProperty: "displayedProperty", keyProperty: "keyProperty" }, outputs: { selectionChanged: "selectionChanged" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NG_VALUE_ACCESSOR, useExisting: MmSelectComponent, multi: true },
            ViewValuePipe,
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 8, vars: 19, consts: [[1, "mm-select", 3, "ngClass", "mmTestId"], [1, "mm-select-control"], ["class", "mm-select-tag", 3, "mmTestTarget", 4, "ngFor", "ngForOf"], [1, "mm-select-control__input", 3, "formControl", "ngClass", "placeholder", "readonly", "mmTestTarget", "focus"], ["inputElement", ""], ["type", "button", 1, "mm-select-control__toggle", 3, "mmTestTarget"], [1, "mm-select-control__icon", 3, "name", "ngClass", "click"], ["class", "mm-select-menu-wrapper", 4, "ngIf"], [1, "mm-select-tag", 3, "mmTestTarget"], [1, "mm-select-tag__text"], ["type", "button", 1, "mm-select-tag__close-btn", 3, "mmTestTarget", "click"], [3, "name"], [1, "mm-select-menu-wrapper"], [1, "mm-select-menu"], ["class", "mm-option mm-option--not-found", 4, "ngIf"], [1, "virtual-scroll-viewport", 3, "itemSize"], ["class", "mm-option", 3, "mmTestTarget", "id", "ngClass", "click", 4, "cdkVirtualFor", "cdkVirtualForOf"], [1, "mm-option", "mm-option--not-found"], [1, "mm-option", 3, "mmTestTarget", "id", "ngClass", "click"], [3, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function MmSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, MmSelectComponent_div_2_Template, 6, 7, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "input", 3, 4);
        ɵngcc0.ɵɵlistener("focus", function MmSelectComponent_Template_input_focus_3_listener() { return ctx.open(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "button", 5);
        ɵngcc0.ɵɵelementStart(6, "mm-icon", 6);
        ɵngcc0.ɵɵlistener("click", function MmSelectComponent_Template_mm_icon_click_6_listener($event) { return ctx.toggleMenu($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, MmSelectComponent_div_7_Template, 5, 5, "div", 7);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(12, _c29, ctx.className, ctx.disabled))("mmTestId", "MM_SELECT.COMPONENT");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.selectedValues);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControl", ctx.searchControl)("ngClass", ɵngcc0.ɵɵpureFunction1(15, _c30, ctx.multiple && !!(ctx.selectedValues == null ? null : ctx.selectedValues.length)))("placeholder", !(ctx.selectedValues == null ? null : ctx.selectedValues.length) ? ctx.placeholder : "")("readonly", !ctx.isSearchable)("mmTestTarget", "select-input");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("mmTestTarget", "select-toggle-button");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("name", "chevron-down")("ngClass", ɵngcc0.ɵɵpureFunction1(17, _c31, ctx.isOpened));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isOpened);
    } }, directives: [ɵngcc2.NgClass, ɵngcc3.ɵa, ɵngcc2.NgForOf, ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlDirective, ɵngcc3.ɵf, MmIconComponent, ɵngcc2.NgIf, ɵngcc15.CdkVirtualScrollViewport, ɵngcc15.CdkFixedSizeVirtualScroll, ɵngcc15.CdkVirtualForOf, ɵngcc2.NgTemplateOutlet], pipes: [ViewValuePipe], styles: [".mm-select[_ngcontent-%COMP%]{background-color:#fff;position:relative;width:100%}.mm-select.disabled[_ngcontent-%COMP%]{background-color:#f2f3f5;pointer-events:none}.mm-select.disabled[_ngcontent-%COMP%]   .mm-select-control__input[_ngcontent-%COMP%]{color:#667284}.mm-select-menu-wrapper[_ngcontent-%COMP%]{position:relative}.mm-select-control[_ngcontent-%COMP%]{border:1px solid #ccd5e3;border-radius:2px;box-sizing:border-box;display:flex;flex-wrap:wrap;min-height:40px;padding-left:20px;padding-right:50px;padding-top:3px;position:relative}.mm-select-control[_ngcontent-%COMP%]:focus-within{border-color:#66a2fe}.mm-select-control__input[_ngcontent-%COMP%]{background:transparent;border:none;color:#002d72;font-size:1.14rem;font-style:normal;outline:none;padding-right:15px;width:100%}.mm-select-control__input--small[_ngcontent-%COMP%]{flex:1;min-width:50px}.mm-select-control__input[_ngcontent-%COMP%]::-moz-placeholder{color:#6681aa;font-size:1.14rem;font-style:italic}.mm-select-control__input[_ngcontent-%COMP%]::-ms-input-placeholder{color:#6681aa;font-size:1.14rem;font-style:italic}.mm-select-control__input[_ngcontent-%COMP%]::placeholder{color:#6681aa;font-size:1.14rem;font-style:italic}.mm-select-control__input[_ngcontent-%COMP%]:-moz-read-only{cursor:default}.mm-select-control__input[_ngcontent-%COMP%]:read-only{cursor:default}.mm-select-control__toggle[_ngcontent-%COMP%]{background-color:transparent;border:none;cursor:pointer;display:flex;height:20px;outline:none;padding:0;position:absolute;right:15px;top:calc(50% - 12px);width:20px}.mm-select-control__icon[_ngcontent-%COMP%]{color:#002d72;transition:transform .2s}.mm-select-control__icon--chevron-up[_ngcontent-%COMP%]{transform:rotate(180deg)}.mm-select-menu[_ngcontent-%COMP%]{background-color:#fff;border:1px solid #ccd5e3;border-top-color:transparent;box-sizing:border-box;left:0;position:absolute;top:0;width:100%;z-index:999}.mm-option[_ngcontent-%COMP%]{color:#002866;cursor:pointer;font-size:1.14rem;padding:10px 24px}.mm-option--not-found[_ngcontent-%COMP%]{cursor:default;text-align:center}.mm-option--selected[_ngcontent-%COMP%], .mm-option[_ngcontent-%COMP%]:hover:not(.mm-option--not-found), .mm-select-tag[_ngcontent-%COMP%]{background-color:#f2f7ff}.mm-select-tag[_ngcontent-%COMP%]{align-items:flex-start;color:#002d72;display:inline-flex;font-size:.92rem;line-height:1.53;margin-bottom:3px;margin-right:5px;padding:5px 8px}.mm-select-tag__text[_ngcontent-%COMP%]{margin-right:15px}.mm-select-tag__close-btn[_ngcontent-%COMP%]{background-color:transparent;border:none;color:#33578e;cursor:pointer;height:20px;margin-top:-2px;outline:none;padding:0;width:20px}.virtual-scroll-viewport[_ngcontent-%COMP%]{max-height:320px}.virtual-scroll-viewport[_ngcontent-%COMP%]::-webkit-scrollbar{background-color:#f2f5f8;width:10px}.virtual-scroll-viewport[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background-color:#ccd5e3;border-radius:6px}"], changeDetection: 0 });
MmSelectComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ViewValuePipe },
    { type: ElementRef },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MmSelectComponent.propDecorators = {
    placeholder: [{ type: Input }],
    className: [{ type: Input }],
    isSearchable: [{ type: Input }],
    multiple: [{ type: Input }],
    options: [{ type: Input }],
    optionTmpl: [{ type: Input }],
    displayedProperty: [{ type: Input }],
    keyProperty: [{ type: Input }],
    disabled: [{ type: Input }],
    isEventPropogated: [{ type: Input }],
    searchThrottling: [{ type: Input }],
    noResultsText: [{ type: Input }],
    value: [{ type: Input }],
    selectionChanged: [{ type: Output }],
    inputEl: [{ type: ViewChild, args: ['inputElement', { static: true },] }],
    onBlur: [{ type: HostListener, args: ['blur',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmSelectComponent, [{
        type: Component,
        args: [{
                selector: 'mm-select',
                template: "<div class=\"mm-select\"\n     [ngClass]=\"{ className: className, disabled: disabled }\"\n     [mmTestId]=\"'MM_SELECT.COMPONENT'\">\n    <div class=\"mm-select-control\">\n        <div *ngFor=\"let tag of selectedValues\" class=\"mm-select-tag\" [mmTestTarget]=\"'select-tag'\">\n            <span class=\"mm-select-tag__text\">{{tag | viewValue: displayedProperty}}</span>\n            <button (click)=\"onTagRemove($event, tag)\"\n                    [mmTestTarget]=\"'remove-tag-button'\"\n                    class=\"mm-select-tag__close-btn\"\n                    type=\"button\">\n                <mm-icon [name]=\"'cross'\"></mm-icon>\n            </button>\n        </div>\n        <!--suppress HtmlFormInputWithoutLabel -->\n        <input #inputElement\n               (focus)=\"open()\"\n               [formControl]=\"searchControl\"\n               [ngClass]=\"{'mm-select-control__input--small': multiple && !!selectedValues?.length}\"\n               [placeholder]=\"!selectedValues?.length ? placeholder : ''\"\n               [readonly]=\"!isSearchable\"\n               [mmTestTarget]=\"'select-input'\"\n               class=\"mm-select-control__input\">\n        <button class=\"mm-select-control__toggle\"\n                [mmTestTarget]=\"'select-toggle-button'\"\n                type=\"button\">\n            <mm-icon (click)=\"toggleMenu($event)\"\n                     [name]=\"'chevron-down'\"\n                     [ngClass]=\"{'mm-select-control__icon--chevron-up': isOpened}\"\n                     class=\"mm-select-control__icon\"></mm-icon>\n        </button>\n    </div>\n    <div *ngIf=\"isOpened\" class=\"mm-select-menu-wrapper\">\n        <div class=\"mm-select-menu\">\n            <div *ngIf=\"!options?.length\" class=\"mm-option mm-option--not-found\">\n                {{noResultsText}}\n            </div>\n            <cdk-virtual-scroll-viewport [itemSize]=\"30\"\n                                         [style.height.px]=\"visibleOptions * 47\"\n                                         class=\"virtual-scroll-viewport\">\n                <div (click)=\"onSelect($event, option)\"\n                     [mmTestTarget]=\"'select-option'\"\n                     *cdkVirtualFor=\"let option of options; let i = index\"\n                     [id]=\"'mm-option-' + (option.id || i)\"\n                     [ngClass]=\"{'mm-option--selected': isOptionSelected(option)}\"\n                     class=\"mm-option\">\n                    <ng-template\n                            [ngIf]=\"!optionTmpl\">{{option | viewValue: displayedProperty}}</ng-template>\n\n                    <ng-template *ngTemplateOutlet=\"optionTmpl; context: {$implicit: option}\">\n                    </ng-template>\n                </div>\n            </cdk-virtual-scroll-viewport>\n        </div>\n    </div>\n</div>\n",
                providers: [
                    { provide: NG_VALUE_ACCESSOR, useExisting: MmSelectComponent, multi: true },
                    ViewValuePipe,
                ],
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".mm-select{background-color:#fff;position:relative;width:100%}.mm-select.disabled{background-color:#f2f3f5;pointer-events:none}.mm-select.disabled .mm-select-control__input{color:#667284}.mm-select-menu-wrapper{position:relative}.mm-select-control{border:1px solid #ccd5e3;border-radius:2px;box-sizing:border-box;display:flex;flex-wrap:wrap;min-height:40px;padding-left:20px;padding-right:50px;padding-top:3px;position:relative}.mm-select-control:focus-within{border-color:#66a2fe}.mm-select-control__input{background:transparent;border:none;color:#002d72;font-size:1.14rem;font-style:normal;outline:none;padding-right:15px;width:100%}.mm-select-control__input--small{flex:1;min-width:50px}.mm-select-control__input::-moz-placeholder{color:#6681aa;font-size:1.14rem;font-style:italic}.mm-select-control__input::-ms-input-placeholder{color:#6681aa;font-size:1.14rem;font-style:italic}.mm-select-control__input::placeholder{color:#6681aa;font-size:1.14rem;font-style:italic}.mm-select-control__input:-moz-read-only{cursor:default}.mm-select-control__input:read-only{cursor:default}.mm-select-control__toggle{background-color:transparent;border:none;cursor:pointer;display:flex;height:20px;outline:none;padding:0;position:absolute;right:15px;top:calc(50% - 12px);width:20px}.mm-select-control__icon{color:#002d72;transition:transform .2s}.mm-select-control__icon--chevron-up{transform:rotate(180deg)}.mm-select-menu{background-color:#fff;border:1px solid #ccd5e3;border-top-color:transparent;box-sizing:border-box;left:0;position:absolute;top:0;width:100%;z-index:999}.mm-option{color:#002866;cursor:pointer;font-size:1.14rem;padding:10px 24px}.mm-option--not-found{cursor:default;text-align:center}.mm-option--selected,.mm-option:hover:not(.mm-option--not-found),.mm-select-tag{background-color:#f2f7ff}.mm-select-tag{align-items:flex-start;color:#002d72;display:inline-flex;font-size:.92rem;line-height:1.53;margin-bottom:3px;margin-right:5px;padding:5px 8px}.mm-select-tag__text{margin-right:15px}.mm-select-tag__close-btn{background-color:transparent;border:none;color:#33578e;cursor:pointer;height:20px;margin-top:-2px;outline:none;padding:0;width:20px}.virtual-scroll-viewport{max-height:320px}.virtual-scroll-viewport::-webkit-scrollbar{background-color:#f2f5f8;width:10px}.virtual-scroll-viewport::-webkit-scrollbar-thumb{background-color:#ccd5e3;border-radius:6px}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ViewValuePipe }, { type: ɵngcc0.ElementRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { placeholder: [{
            type: Input
        }], options: [{
            type: Input
        }], isEventPropogated: [{
            type: Input
        }], searchThrottling: [{
            type: Input
        }], noResultsText: [{
            type: Input
        }], selectionChanged: [{
            type: Output
        }], value: [{
            type: Input
        }], onBlur: [{
            type: HostListener,
            args: ['blur']
        }], disabled: [{
            type: Input
        }], className: [{
            type: Input
        }], isSearchable: [{
            type: Input
        }], multiple: [{
            type: Input
        }], optionTmpl: [{
            type: Input
        }], displayedProperty: [{
            type: Input
        }], keyProperty: [{
            type: Input
        }], inputEl: [{
            type: ViewChild,
            args: ['inputElement', { static: true }]
        }] }); })();

class MmSelectModule {
}
MmSelectModule.ɵfac = function MmSelectModule_Factory(t) { return new (t || MmSelectModule)(); };
MmSelectModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MmSelectModule });
MmSelectModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            MmIconModule,
            ReactiveFormsModule,
            ScrollingModule,
            QaLocatorsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MmSelectModule, { declarations: function () { return [MmSelectComponent, ViewValuePipe]; }, imports: function () { return [CommonModule, MmIconModule, ReactiveFormsModule,
        ScrollingModule,
        QaLocatorsModule]; }, exports: function () { return [MmSelectComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MmSelectModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    MmSelectComponent,
                    ViewValuePipe,
                ],
                imports: [
                    CommonModule,
                    MmIconModule,
                    ReactiveFormsModule,
                    ScrollingModule,
                    QaLocatorsModule
                ],
                exports: [
                    MmSelectComponent,
                ]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ALERT_CONTEXT_DATA, MM_BREAKPOINTS, MmAccordionComponent, MmAccordionItemComponent, MmAccordionModule, MmAlertComponent, MmAlertContentAlign, MmAlertMode, MmAlertModule, MmAlertService, MmAlertSize, MmAlertType, MmAlertWrapperComponent, MmButtonComponent, MmButtonModule, MmCellDefDirective, MmCellDirective, MmCheckboxComponent, MmCheckboxModule, MmChipComponent, MmChipModule, MmColumnDefDirective, MmContextualMenuComponent, MmContextualMenuDirective, MmContextualMenuItemComponent, MmContextualMenuModule, MmDialogCloseDirective, MmDialogConfig, MmDialogContainerComponent, MmDialogContentComponent, MmDialogData, MmDialogFooterComponent, MmDialogModule, MmDialogRefService, MmDialogService, MmDialogSize, MmDialogTitleComponent, MmErrorComponent, MmFieldComponent, MmFlexAlignDirective, MmFlexDirective, MmFlexLayoutModule, MmFlexOffsetDirective, MmFlexOrderDirective, MmFormFieldModule, MmHeaderCellDefDirective, MmHeaderCellDirective, MmHeaderMenuComponent, MmHeaderMenuDirective, MmHeaderMenuDividerComponent, MmHeaderMenuItemComponent, MmHeaderMenuModule, MmHeaderRowComponent, MmHeaderRowDefDirective, MmHintComponent, MmIconComponent, MmIconModule, MmInputDirective, MmLabelComponent, MmLayoutAlignDirective, MmLayoutDirective, MmLayoutGapDirective, MmListDirective, MmListModule, MmMenuTrigger, MmPaginatorComponent, MmPaginatorModule, MmPopoverModule, MmPopoverRef, MmPopoverService, MmQuantityPickerComponent, MmQuantityPickerModule, MmRadioComponent, MmRadioGroupComponent, MmRadioGroupItemComponent, MmRadioGroupModule, MmRadioModule, MmRowComponent, MmRowDefDirective, MmSelectComponent, MmSelectModule, MmShowHideDirective, MmSidebarComponent, MmSidebarDividerComponent, MmSidebarItemComponent, MmSidebarModule, MmSortDirective, MmSortHeaderComponent, MmSortableDirection, MmSpinnerComponent, MmSpinnerConfigService, MmSpinnerModule, MmSwitchComponent, MmSwitchModule, MmTableComponent, MmTableContainerComponent, MmTableCustomTemplateComponent, MmTableEmptyStateTemplateComponent, MmTableLoaderComponent, MmTableModule, MmTablePaginationComponent, MmTablePaginationModule, MmTablePaginationPageEvent, MmTextareaDirective, MmToggleComponent, MmToggleGroupComponent, MmToggleModule, MmTooltipColor, MmTooltipComponent, MmTooltipDirective, MmTooltipModule, MmTooltipPlacement, MmTooltipTrigger, SanitizePipe, SharedModule, MmDialogDefaultOptions as ɵb, MmDialogScrollStrategy as ɵc, MmDialogScrollStrategyProvider as ɵd, MmDialogScrollStrategyFactory as ɵe, DEFAULT_SPINNER_CONFIG as ɵf, MmRadioItemCommonComponent as ɵg, MmRadioGroupCommonComponent as ɵh, MmRadioGroupCommonModule as ɵi, MmInputBase as ɵj, IconConfigToken as ɵk, MmMenuDirective as ɵm, MmMenuComponent as ɵn, MmOverlayModule as ɵo, MmConnectedOverlayDirective as ɵp, MmMenuModule as ɵq, MmTemplateOutletDirective as ɵr, MmDialogAnimationState as ɵs, MmDialogAnimations as ɵt, PopoverComponent as ɵu, ViewValuePipe as ɵw };

//# sourceMappingURL=metromarkets-components.js.map